
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("KcDWk", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dPJCf = parcelRequire("dPJCf");

const $0cb26f4daa528aad$var$RELEASE_UNUSED_DELAY_TIME = 10000; // 10 sec
const $0cb26f4daa528aad$var$ssredMacros = new Map();
const $0cb26f4daa528aad$var$usedMacros = new Set();
function $0cb26f4daa528aad$export$6e21e394d708bb62() {
    $0cb26f4daa528aad$var$ssredMacros.clear();
}
function $0cb26f4daa528aad$export$f700dfca474a9730() {
    setTimeout($0cb26f4daa528aad$var$releaseUnused, $0cb26f4daa528aad$var$RELEASE_UNUSED_DELAY_TIME);
}
function $0cb26f4daa528aad$var$releaseUnused() {
    for (const macroId of $0cb26f4daa528aad$var$ssredMacros.keys())if (!$0cb26f4daa528aad$var$usedMacros.has(macroId)) $0cb26f4daa528aad$var$ssredMacros.delete(macroId);
}
function $0cb26f4daa528aad$export$be7b16c53ead6686(macroId) {
    const $ = (0, $bDgLe.c)(3);
    const transitionId = (0, $dPJCf.useTransitionId)();
    $0cb26f4daa528aad$var$usedMacros.add(macroId);
    let t0;
    if ($[0] !== macroId || $[1] !== transitionId) {
        t0 = !transitionId ? $0cb26f4daa528aad$var$ssredMacros.get(macroId) : undefined;
        $[0] = macroId;
        $[1] = transitionId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
function $0cb26f4daa528aad$export$e4c99b90ba7f5231(macroId) {
    if (!$0cb26f4daa528aad$var$ssredMacros.has(macroId)) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const ele = document.querySelector(`[data-fabric-macro="${macroId}"][data-skate-created]`);
        if (ele) $0cb26f4daa528aad$var$ssredMacros.set(macroId, ele);
    }
}
module.exports["releaseSSRedLegacyMacros"] = $0cb26f4daa528aad$export$6e21e394d708bb62;
module.exports["releaseUnusedSSRedLegacyMacrosWithDelay"] = $0cb26f4daa528aad$export$f700dfca474a9730;
module.exports["useSSRedLegacyMacroElement"] = $0cb26f4daa528aad$export$be7b16c53ead6686;
module.exports["collectSSRedLegacyMacro"] = $0cb26f4daa528aad$export$e4c99b90ba7f5231;

});

parcelRegister("eqB7W", function(module, exports) {
/**
 * @generated SignedSource<<22eaf22285fbb2298f99cb28b255ac51>>
 * @relayHash 0338e1ad9a17b74a51ceb84d72bc7c61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e3efc04c3bd70f0dd085cb5ca373f071edfe850c1e5c8170567f9dc326950578
const $ea367f38360527c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "adf"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "containedRender"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": "RENDERER",
            "kind": "LocalArgument",
            "name": "mode"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "adf",
                    "variableName": "adf"
                },
                {
                    "kind": "Variable",
                    "name": "containedRender",
                    "variableName": "containedRender"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "mode",
                    "variableName": "mode"
                }
            ],
            "concreteType": "MacroBody",
            "kind": "LinkedField",
            "name": "macroBodyRenderer",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "kind": "ScalarField",
                    "name": "representation"
                },
                {
                    "concreteType": "EmbeddedMediaToken",
                    "kind": "LinkedField",
                    "name": "mediaToken",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "token"
                        }
                    ]
                },
                {
                    "concreteType": "WebResourceDependencies",
                    "kind": "LinkedField",
                    "name": "webResourceDependencies",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contexts"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "keys"
                        },
                        {
                            "concreteType": "WebResourceTags",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "js"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "css"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LegacyMacroRendererQueryBodyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LegacyMacroRendererQueryBodyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0338e1ad9a17b74a51ceb84d72bc7c61",
            "id": "e3efc04c3bd70f0dd085cb5ca373f071edfe850c1e5c8170567f9dc326950578",
            "metadata": {},
            "name": "LegacyMacroRendererQueryBodyQuery",
            "operationKind": "query",
            "text": "query LegacyMacroRendererQueryBodyQuery($adf:String!,$containedRender:Boolean=false,$contentId:ID,$mode:ContentRendererMode=RENDERER)@allowHigherTimeout{macroBodyRenderer(adf:$adf,containedRender:$containedRender,contentId:$contentId,mode:$mode){value,representation,mediaToken{token},webResourceDependencies{contexts,keys,tags{js,css}}}}"
        }
    };
}();
$ea367f38360527c0$var$node.hash = "dd7355924ba42269bd10c6f111b4c390";
var $ea367f38360527c0$export$2e2bcd8739ae039 = $ea367f38360527c0$var$node;
module.exports["default"] = $ea367f38360527c0$export$2e2bcd8739ae039;

});

parcelRegister("b1ypt", function(module, exports) {
/**
 * @generated SignedSource<<a4778ef260605ff96ee2878d84555cf5>>
 * @relayHash 7c8c189489482af15da56d7272f26902
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 86a2842e0d619c071cdb54f54bfddd7fbf88609a4d8bb58a0e80aca743392a64
const $dc795461fa782a5a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "adf"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "containedRender"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": "RENDERER",
            "kind": "LocalArgument",
            "name": "mode"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "adf",
                    "variableName": "adf"
                },
                {
                    "kind": "Variable",
                    "name": "containedRender",
                    "variableName": "containedRender"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "mode",
                    "variableName": "mode"
                }
            ],
            "concreteType": "HtmlDocument",
            "kind": "LinkedField",
            "name": "contentRenderer",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "concreteType": "WebResourceDependencies",
                    "kind": "LinkedField",
                    "name": "webResourceDependencies",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contexts"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "keys"
                        },
                        {
                            "concreteType": "WebResourceTags",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "js"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "css"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LegacyMacroRendererQueryContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LegacyMacroRendererQueryContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7c8c189489482af15da56d7272f26902",
            "id": "86a2842e0d619c071cdb54f54bfddd7fbf88609a4d8bb58a0e80aca743392a64",
            "metadata": {},
            "name": "LegacyMacroRendererQueryContentQuery",
            "operationKind": "query",
            "text": "query LegacyMacroRendererQueryContentQuery($adf:String!,$containedRender:Boolean=false,$contentId:ID!,$mode:ContentRendererMode=RENDERER){contentRenderer(adf:$adf,containedRender:$containedRender,contentId:$contentId,mode:$mode){html,webResourceDependencies{contexts,keys,tags{js,css}}}}"
        }
    };
}();
$dc795461fa782a5a$var$node.hash = "83bbd0a93f53839a47ac4b3d948ad643";
var $dc795461fa782a5a$export$2e2bcd8739ae039 = $dc795461fa782a5a$var$node;
module.exports["default"] = $dc795461fa782a5a$export$2e2bcd8739ae039;

});

parcelRegister("ld6xp", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");


var $9wGTI = parcelRequire("9wGTI");


var $ceVeI = parcelRequire("ceVeI");

function $1a525e6db77527ad$export$93a875f36a027067() {
    const blocklist = (0, $1xpoY.default).getStringList('confluence_frontend_macros_query_blocklist', [
        'jirachart',
        'jiraroadmap',
        'ui-button',
        'contentbylabel',
        'excerpt-include',
        'tasks-report-macro',
        'blog-posts',
        'section',
        'table-filter',
        'children',
        'pagetree',
        'detailssummary',
        'decisionreport'
    ]);
    return String(blocklist).split(',');
}
function $1a525e6db77527ad$export$824576ea659aac84() {
    if (!(0, $9wGTI.fg)('cc_rewrite_macros_minimize_duplicative_query_work')) return $1a525e6db77527ad$export$93a875f36a027067();
    return Array.from(new Set([
        ...$1a525e6db77527ad$export$93a875f36a027067(),
        ...(0, $ceVeI.MIGRATED_MACRO_EXTENSION_KEYS).filter((0, $ceVeI.isMigratedMacroImplEnabled))
    ]));
}
function $1a525e6db77527ad$export$7db8fb5cfdd051ff() {
    if (!(0, $9wGTI.fg)('cc_rewrite_macros_minimize_duplicative_query_work')) return $1a525e6db77527ad$export$93a875f36a027067();
    return $1a525e6db77527ad$export$93a875f36a027067().filter((extensionKey)=>!(0, $ceVeI.isMigratedMacroImplEnabled)(extensionKey));
}
function $1a525e6db77527ad$export$32e19dd05a214cc0(extensionKey, isNested2pBodiedExtension = false) {
    return !isNested2pBodiedExtension && !$1a525e6db77527ad$export$824576ea659aac84().includes(extensionKey || '');
}
module.exports["getEffectiveMultiMacroQueryBlocklist"] = $1a525e6db77527ad$export$824576ea659aac84;
module.exports["getLegacyIndividualMacroQueryKeys"] = $1a525e6db77527ad$export$7db8fb5cfdd051ff;
module.exports["canUseMultiMacroQuery"] = $1a525e6db77527ad$export$32e19dd05a214cc0;

});

parcelRegister("92uc5", function(module, exports) {

var $gHCIk = parcelRequire("gHCIk");

const $0aecfdd3c11bee35$export$e4b2a3005b630bc8 = ({ content: content, contentId: contentId })=>{
    const contentValue = content || [];
    const contentDocument = {
        type: 'doc',
        content: Array.isArray(contentValue) ? contentValue : [
            contentValue
        ],
        version: 1
    };
    const contentDocumentAdf = (0, $gHCIk.serializeExtensionADF)(contentDocument);
    return {
        content: contentDocumentAdf,
        from: 'atlas_doc_format',
        to: 'storage',
        contentId: contentId
    };
};
module.exports["getContentConverterVariables"] = $0aecfdd3c11bee35$export$e4b2a3005b630bc8;

});

parcelRegister("8mIlz", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");


var $6mEZ3 = parcelRequire("6mEZ3");


var $gHCIk = parcelRequire("gHCIk");

const $c41a024b478ea6bf$var$getContentId = (adf, contentId)=>{
    const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
    return parentId || contentId;
};
const $c41a024b478ea6bf$export$99dbcdf31bb91f29 = ({ adf: adf, node: node, mode: mode = 'RENDERER', contentId: contentId })=>{
    const extensionADF = adf || (0, $6mEZ3.extensionToADF)(node);
    const isMacroContentAndBody = (0, $1xpoY.default).getBoolean('confluence_frontend_macro_adf_frontend_render', true);
    return {
        adf: (0, $gHCIk.serializeExtensionADF)(extensionADF),
        mode: mode.toUpperCase(),
        contentId: isMacroContentAndBody ? $c41a024b478ea6bf$var$getContentId(extensionADF, contentId) : contentId,
        isMacroContentAndBody: isMacroContentAndBody
    };
};
module.exports["getMacroQueryVariables"] = $c41a024b478ea6bf$export$99dbcdf31bb91f29;

});

parcelRegister("6Cce7", function(module, exports) {
/**
 * @generated SignedSource<<9e6f3b9ddc07475a4d0d7fa8551ae498>>
 * @relayHash 449b252c30e0e1ea61274ed95f3aaf56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf4577ec63e0557a0bf6492075dab1680c0c0b275f759aefa582c2b782658477
const $a5cfbccb9473c362$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "content"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "from"
    }, v3 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "spaceKeyContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "to"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "content",
                    "variableName": "content"
                },
                {
                    "kind": "Variable",
                    "name": "contentIdContext",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "from",
                    "variableName": "from"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKeyContext",
                    "variableName": "spaceKeyContext"
                },
                {
                    "kind": "Variable",
                    "name": "to",
                    "variableName": "to"
                }
            ],
            "concreteType": "ConfluenceBody",
            "kind": "LinkedField",
            "name": "contentConverter",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentConverterQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentConverterQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "449b252c30e0e1ea61274ed95f3aaf56",
            "id": "bf4577ec63e0557a0bf6492075dab1680c0c0b275f759aefa582c2b782658477",
            "metadata": {},
            "name": "ContentConverterQuery",
            "operationKind": "query",
            "text": "query ContentConverterQuery($content:String!,$contentId:ID!,$from:String!,$to:String!,$spaceKeyContext:String=\"\"){contentConverter(from:$from,to:$to,content:$content,contentIdContext:$contentId,spaceKeyContext:$spaceKeyContext){value}}"
        }
    };
}();
$a5cfbccb9473c362$var$node.hash = "6980f8893393c2f02dae03f9d79f696a";
var $a5cfbccb9473c362$export$2e2bcd8739ae039 = $a5cfbccb9473c362$var$node;


const $266b70085156c92e$export$ef5feff44649e0e4 = (0, $a5cfbccb9473c362$export$2e2bcd8739ae039);
module.exports["ContentConverterQuery"] = $266b70085156c92e$export$ef5feff44649e0e4;

});

parcelRegister("gK2Sc", function(module, exports) {
/**
 * @generated SignedSource<<f261c6422bc0e51ef43295fde66cbff9>>
 * @relayHash e23669c0fb21cd7d29d3286af24de527
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba9848110df649fd9aac398146b239179affdd14268275b02ba61106daf8723a
const $f52a228c3dcb9a85$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blocklist"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": "RENDERER",
        "kind": "LocalArgument",
        "name": "mode"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "refetchToken"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticAfter"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticFirst"
    }, v9 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v10 = {
        "concreteType": "PageInfoV2",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "macroId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ], v14 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "blocklist",
                    "variableName": "blocklist"
                },
                v9 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "refetchToken",
                    "variableName": "refetchToken"
                }
            ],
            "concreteType": "MacroConnection",
            "kind": "LinkedField",
            "name": "macros",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "concreteType": "Macro",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v11 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "mode",
                                    "variableName": "mode"
                                }
                            ],
                            "concreteType": "RenderedMacro",
                            "kind": "LinkedField",
                            "name": "renderedMacro",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appKey"
                                },
                                v12 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "macroRenderedRepresentation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "macroBodyStorage"
                                },
                                {
                                    "concreteType": "WebResourceDependenciesV2",
                                    "kind": "LinkedField",
                                    "name": "webResource",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "contexts"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "keys"
                                        },
                                        {
                                            "concreteType": "SuperBatchWebResourcesV2",
                                            "kind": "LinkedField",
                                            "name": "superbatch",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "metatags"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "WebResourceTagsV2",
                                            "kind": "LinkedField",
                                            "name": "tags",
                                            "plural": false,
                                            "selections": v13 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "WebResourceUrisV2",
                                            "kind": "LinkedField",
                                            "name": "uris",
                                            "plural": false,
                                            "selections": v13 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "EmbeddedMediaTokenV2",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "staticMacros",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "staticAfter"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                v9 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "staticFirst"
                }
            ],
            "concreteType": "ConfluenceStaticMacroRenderedConnection",
            "kind": "LinkedField",
            "name": "confluence_staticMacros",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "concreteType": "ConfluenceStaticMacroRendered",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceStaticMacroRenderError",
                            "kind": "LinkedField",
                            "name": "error",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "code"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "multiMacroQueryWithAppKeyQuery",
            "selections": v14 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "multiMacroQueryWithAppKeyQuery",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "e23669c0fb21cd7d29d3286af24de527",
            "id": "ba9848110df649fd9aac398146b239179affdd14268275b02ba61106daf8723a",
            "metadata": {},
            "name": "multiMacroQueryWithAppKeyQuery",
            "operationKind": "query",
            "text": "query multiMacroQueryWithAppKeyQuery($contentId:ID!,$cloudId:ID!,$mode:MacroRendererMode=RENDERER,$blocklist:[String!],$first:Int,$after:String,$staticFirst:Int,$staticAfter:String,$refetchToken:String)@allowHigherTimeout{macros(contentId:$contentId,blocklist:$blocklist,first:$first,after:$after,refetchToken:$refetchToken){pageInfo{hasNextPage,endCursor},nodes{macroId,contentId,renderedMacro(mode:$mode){appKey,value,macroRenderedRepresentation,macroBodyStorage,webResource{contexts,keys,superbatch{metatags},tags{css,data,js},uris{css,data,js}},mediaToken{token}}}},staticMacros:confluence_staticMacros(contentId:$contentId,cloudId:$cloudId,first:$staticFirst,after:$staticAfter)@optIn(to:[\"AskInCcApiPlatformBeforeUsing\"]){pageInfo{hasNextPage,endCursor},nodes{macroId,value,error{code}}}}"
        }
    };
}();
$f52a228c3dcb9a85$var$node.hash = "30199419199e9df3d9ba7ccb94678264";
var $f52a228c3dcb9a85$export$2e2bcd8739ae039 = $f52a228c3dcb9a85$var$node;
module.exports["default"] = $f52a228c3dcb9a85$export$2e2bcd8739ae039;

});

parcelRegister("k9wGn", function(module, exports) {
const $838c444502c02117$export$cc438a848c487501 = 'nativeEmbedDepth';
const $838c444502c02117$export$8de1a2f5887e1625 = 2;
const $838c444502c02117$export$5deb91d6dd3decbb = ()=>{
    if (typeof window === 'undefined') return 0;
    const raw = new URLSearchParams(window.location.search).get($838c444502c02117$export$cc438a848c487501);
    if (raw === null) return 0;
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed >= 0 ? Math.floor(parsed) : 0;
};
const $838c444502c02117$export$de0f33c023e33ebd = [
    'left',
    'center',
    'right',
    'wrap-left',
    'wrap-right'
];
const $838c444502c02117$export$11a9886c2819741 = 'center';
const $838c444502c02117$export$1770a45a9210903c = {
    url: undefined,
    alwaysShowTitle: false,
    alignment: $838c444502c02117$export$11a9886c2819741,
    borderColor: undefined,
    borderSize: undefined,
    displayText: undefined,
    height: 600,
    isMaxWidth: false,
    aspectRatio: 1,
    remixAppId: undefined,
    width: undefined
};
const $838c444502c02117$export$98d307a8fd081b69 = {
    ASK_ROVO: 'askRovo',
    REMIX: 'remix',
    REMIX_VARIANT: 'remixVariant',
    SUMMARISE: 'summarise',
    REFRESH: 'refresh',
    EDIT: 'edit',
    EMBED: 'embed',
    BORDER: 'border',
    ALIGNMENT: 'alignment',
    OPEN_IN_NEW_WINDOW: 'openInNewWindow',
    /** Opens the embed's fullscreen preview dialog. */ EXPAND: 'expand',
    EDIT_URL: 'editUrl',
    ALWAYS_SHOW_TITLE: 'alwaysShowTitle',
    SET_EMBED_TYPE: 'setEmbedType',
    /**
	 * Copies the native-embed node to the clipboard.
	 */ COPY: 'copy',
    /**
	 * @private
	 * @deprecated Use `COPY` instead. `COPY_LINK` is a deprecated alias for `COPY` and will be removed in a future release.
	 */ COPY_LINK: 'copyLink',
    DELETE: 'delete',
    SEPARATOR: 'separator'
};
const $838c444502c02117$export$8637b4cdcb7cc177 = [
    'onAlignmentClick',
    'onAppearanceClick',
    'onAskRovoClick',
    'onSummariseClick',
    'onChangeBorderClick',
    'onCopyClick',
    'onCopyLinkClick',
    'onDeleteClick',
    'onEditClick',
    'onEditUrlClick',
    'onExpandClick',
    'onOpenInNewWindowClick',
    'onRefreshClick',
    'onSetEmbedTypeClick',
    'onShowTitleClick'
];
module.exports["EMBED_DEPTH_QUERY_PARAM"] = $838c444502c02117$export$cc438a848c487501;
module.exports["MAX_EMBED_DEPTH"] = $838c444502c02117$export$8de1a2f5887e1625;
module.exports["getCurrentEmbedDepth"] = $838c444502c02117$export$5deb91d6dd3decbb;
module.exports["ALIGNMENT_VALUES"] = $838c444502c02117$export$de0f33c023e33ebd;
module.exports["NATIVE_EMBED_PARAMETER_DEFAULTS"] = $838c444502c02117$export$1770a45a9210903c;
module.exports["BUILTIN_TOOLBAR_KEYS"] = $838c444502c02117$export$98d307a8fd081b69;
module.exports["EDITOR_TOOLBAR_HANDLER_KEYS"] = $838c444502c02117$export$8637b4cdcb7cc177;

});

parcelRegister("ljOiP", function(module, exports) {

var $k9wGn = parcelRequire("k9wGn");

const $a2a11cb02df7dc54$var$getMacroParamsRecord = (parameters)=>{
    if (!parameters?.macroParams || typeof parameters.macroParams !== 'object') return {};
    return parameters.macroParams;
};
const $a2a11cb02df7dc54$var$unwrapMacroParamValue = (macroParamValue)=>{
    if (macroParamValue && typeof macroParamValue === 'object' && 'value' in macroParamValue) return macroParamValue.value;
    return macroParamValue;
};
const $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS = {
    alignment: (value)=>(0, $k9wGn.ALIGNMENT_VALUES).includes(value)
};
/**
 * Explicitly declares the intended primitive type for each parameter key.
 * This is necessary for keys whose default value is `undefined` (e.g. `url`, `width`),
 * because `typeof undefined === 'undefined'` gives no type information for deserialization.
 */ const $a2a11cb02df7dc54$var$PARAMETER_TYPES = {
    alignment: 'string',
    alwaysShowTitle: 'boolean',
    aspectRatio: 'number',
    borderColor: 'string',
    borderSize: 'number',
    displayText: 'string',
    height: 'number',
    isMaxWidth: 'boolean',
    remixAppId: 'string',
    url: 'string',
    width: 'number'
};
const $a2a11cb02df7dc54$var$parseFromDefault = (defaultValue, value, explicitType)=>{
    const resolvedType = explicitType ?? typeof defaultValue;
    if (resolvedType === 'boolean') {
        if (typeof value === 'boolean') return value;
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
    if (resolvedType === 'number') {
        const parsed = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    // String-like values
    return typeof value === 'string' ? value : undefined;
};
const $a2a11cb02df7dc54$var$serializeParameterValue = (key, value)=>{
    const validator = $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS[key];
    if (validator && !validator(value)) return undefined;
    return value === undefined ? undefined : String(value);
};
const $a2a11cb02df7dc54$var$deserializeParameterValue = (key, value)=>{
    const parsedValue = $a2a11cb02df7dc54$var$parseFromDefault((0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key], value, $a2a11cb02df7dc54$var$PARAMETER_TYPES[key]);
    const validator = $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS[key];
    if (parsedValue === undefined) return undefined;
    if (validator && !validator(parsedValue)) return undefined;
    return parsedValue;
};
const $a2a11cb02df7dc54$export$c77521bc1ca83dcc = (parameters, key)=>{
    const macroParams = $a2a11cb02df7dc54$var$getMacroParamsRecord(parameters);
    if (!(key in macroParams)) return (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key];
    const value = $a2a11cb02df7dc54$var$unwrapMacroParamValue(macroParams[key]);
    const parsedValue = $a2a11cb02df7dc54$var$deserializeParameterValue(key, value);
    return parsedValue === undefined ? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key] : parsedValue;
};
/** Matches the version id embedded in a legacy `/remix/ui/{id}` embed URL. */ const $a2a11cb02df7dc54$var$REMIX_UI_ID_RE = /\/remix\/ui\/([\w-]+)/;
const $a2a11cb02df7dc54$export$1c0ae1ea8042d693 = ({ storedRemixAppId: storedRemixAppId, url: url })=>storedRemixAppId || (url ? url.match($a2a11cb02df7dc54$var$REMIX_UI_ID_RE)?.[1] ?? undefined : undefined);
function $a2a11cb02df7dc54$export$1d5e65f36fbcdb49(parameters, key) {
    if (key) return $a2a11cb02df7dc54$export$c77521bc1ca83dcc(parameters, key);
    return Object.fromEntries(Object.keys((0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)).map((defaultKey)=>[
            defaultKey,
            $a2a11cb02df7dc54$export$c77521bc1ca83dcc(parameters, defaultKey)
        ]));
}
const $a2a11cb02df7dc54$export$98091b65241a3a6 = (parameters, update)=>{
    return $a2a11cb02df7dc54$export$60752c4a8a24d484(parameters, update);
};
const $a2a11cb02df7dc54$export$60752c4a8a24d484 = (parameters, updates)=>{
    const currentParameters = parameters ?? {};
    const currentMacroParams = $a2a11cb02df7dc54$var$getMacroParamsRecord(parameters);
    const wrappedUpdates = Object.fromEntries(Object.entries(updates).map(([key, value])=>[
            key,
            $a2a11cb02df7dc54$var$serializeParameterValue(key, value)
        ]).filter(([, value])=>value !== undefined).map(([key, value])=>[
            key,
            {
                value: value
            }
        ]));
    return {
        ...currentParameters,
        macroParams: {
            ...currentMacroParams,
            ...wrappedUpdates
        }
    };
};
const $a2a11cb02df7dc54$export$46a0fc3fddbe8c3b = (config)=>config;
module.exports["getParameter"] = $a2a11cb02df7dc54$export$c77521bc1ca83dcc;
module.exports["resolveRemixVersionId"] = $a2a11cb02df7dc54$export$1c0ae1ea8042d693;
module.exports["getParameters"] = $a2a11cb02df7dc54$export$1d5e65f36fbcdb49;
module.exports["setParameter"] = $a2a11cb02df7dc54$export$98091b65241a3a6;
module.exports["setParameters"] = $a2a11cb02df7dc54$export$60752c4a8a24d484;
module.exports["createEditorToolbarActions"] = $a2a11cb02df7dc54$export$46a0fc3fddbe8c3b;

});

parcelRegister("2Vug6", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");

const $e8ed4dc9830c4b79$export$c2c01e3edfc7c01f = '760 / 600';
const $e8ed4dc9830c4b79$export$2dd05db6133b6a99 = ({ manifest: manifest, parameters: parameters, placeholderId: placeholderId })=>{
    const { alignment: alignment, aspectRatio: aspectRatio, height: height, width: width } = (0, $ljOiP.getParameters)(parameters);
    const effectiveWidth = width ?? manifest?.parameterDefaults?.width;
    // `getParameters` always supplies default values, so inspect raw macroParams to distinguish
    // stored dimensions from package defaults. This prevents the default aspectRatio from affecting
    // older embeds that never persisted original dimensions.
    const macroParams = parameters?.macroParams;
    const heightExplicitlyStored = !!macroParams?.height;
    const aspectRatioExplicitlyStored = !!macroParams?.aspectRatio;
    const effectiveHeightRaw = heightExplicitlyStored ? height : manifest?.parameterDefaults?.height ?? null;
    const effectiveHeight = aspectRatioExplicitlyStored && aspectRatio != null && aspectRatio > 0 && effectiveWidth != null && !heightExplicitlyStored ? Math.round(effectiveWidth / aspectRatio) : effectiveHeightRaw ?? height;
    const lockAspectRatio = typeof manifest?.lockResizeAspectRatio === 'function' ? manifest.lockResizeAspectRatio() : manifest?.lockResizeAspectRatio ?? true;
    return {
        alignment: alignment,
        effectiveHeight: effectiveHeight,
        effectiveWidth: effectiveWidth,
        hasEmbedBorder: manifest?.uiConfig?.showBorder ?? true,
        lockAspectRatio: lockAspectRatio,
        placeholderId: placeholderId
    };
};
module.exports["NATIVE_EMBED_INITIAL_LAYOUT_FALLBACK_ASPECT_RATIO"] = $e8ed4dc9830c4b79$export$c2c01e3edfc7c01f;
module.exports["resolveNativeEmbedInitialLayout"] = $e8ed4dc9830c4b79$export$2dd05db6133b6a99;

});

parcelRegister("c2p9O", function(module, exports) {
/**
 * Injected by the extension UI via Global; also exported for consumers who inject styles elsewhere.
 */ /* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles -- Native embed placement must target renderer/editor ancestor wrappers that the embed component does not own. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Extension container override requires :has and !important

var $lOiVq = parcelRequire("lOiVq");

const $35959f819cab4a83$var$wrapGap = "var(--ds-space-150, 12px)";
const $35959f819cab4a83$var$noWrapGap = "var(--ds-space-300, 24px)";
const $35959f819cab4a83$export$4f468ea4dd4fc462 = /*#__PURE__*/ (0, $lOiVq.css)({
    // Remove margin on extension-overflow-wrapper when it contains a native embed to prevent width overflow.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target overflow wrapper by data attribute
    '.extension-overflow-wrapper:has([data-native-embed-alignment])': {
        margin: '0 !important'
    },
    // The renderer sets overflow-x:auto on .ak-renderer-extension-overflow-container, which clips a
    // pixel-resized native embed that is wider than the text column and prevents centering from
    // working (the scroll container also becomes the reference for the 50% offset). Override to
    // visible so the embed can break out symmetrically on both sides, exactly as images do.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target overflow container by data attribute
    '.ak-renderer-extension-overflow-container:has([data-native-embed-alignment])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- !important string requires type cast incompatible with the CSSProperties type
        overflowX: 'visible !important'
    },
    // For a center-aligned embed with an explicit pixel width, the outer .ak-renderer-extension
    // wrapper's width is set directly as an inline style by the native embed useEffect (to override
    // the renderer's own inline style="width:100%"). These CSS rules apply the centering transforms
    // on that same wrapper — now that it has the exact pixel width, margin-left:50% +
    // translateX(-50%) breaks it out symmetrically, exactly as MediaSingle does for images.
    // max-width:100cqw prevents overflow beyond the container while still allowing
    // the embed to break out of the narrow layout column (unlike 100% which would
    // clamp to the ~760px parent).
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target renderer extension wrapper by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="center"]):has([data-native-embed-width])': {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space -- geometric centering offset, not a spacing value
        marginLeft: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '100cqw'
    },
    // Before the async native embed UI mounts, no effect is available to size the renderer's outer
    // extension wrapper. Shrink-wrap it to the placeholder's persisted width so alignment and text
    // wrapping are correct on first paint. Top-level embeds may break out to the renderer container;
    // nested embeds clamp to their immediate layout/table/extension parent.
    // The renderer's inner wrapper is normally an inline-size query container. Inline-size containment
    // contributes zero intrinsic width, which collapses a fit-content extension wrapper to 0px. Turn
    // that containment off only while an explicit-width placeholder is mounted; the native embed UI
    // restores the normal renderer path once it loads and imperatively sizes the outer wrapper.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target the renderer-owned size container by the shared placeholder marker
    '.ak-renderer-extension-inner-wrapper:has([data-native-embed-initial-placeholder="true"][data-native-embed-width])': {
        containerType: 'normal'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target the renderer-owned wrapper by the shared native embed placeholder marker
    '.ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width])': {
        width: 'fit-content !important',
        maxWidth: '100cqw'
    },
    // The editor loading path intentionally keeps its outer extension container at 100% width.
    // Align the already-sized placeholder frame within that container until the native embed UI
    // mounts and takes ownership of the outer wrapper's persisted width.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target the editor loading frame through its shared placeholder metadata
    '[data-native-embed-initial-placeholder="true"][data-native-embed-alignment="center"] > [data-testid="native-embed-initial-placeholder"]': {
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target the editor loading frame through its shared placeholder metadata
    '[data-native-embed-initial-placeholder="true"][data-native-embed-alignment="right"] > [data-testid="native-embed-initial-placeholder"]': {
        marginLeft: 'auto'
    },
    // Some renderer variants omit data-top-level even for top-level extensions. Mirror the native
    // embed runtime's DOM nesting detection instead: table cells/headers, expands, layouts, enclosing
    // extensions, sync blocks, and panels clamp the placeholder to the immediate containing node.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Mirror native embed runtime nesting ancestors before its mounting effect is available
    'td .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), th .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), [data-node-type="expand"] .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), [data-layout-section] .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), .ak-renderer-extension .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), [data-bodied-sync-block] .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), .ak-editor-panel .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width])': {
        maxWidth: '100%'
    },
    // Width: 100% when no explicit width set; fit-content when data-native-embed-width is set.
    // Combined selectors cover both .extension-container (editor) and .ak-renderer-extension (renderer)
    // which use different wrapper class names for the same structural element.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment]):not(:has([data-native-embed-width])), .ak-renderer-extension:has([data-native-embed-alignment]):not(:has([data-native-embed-width]))': {
        width: '100% !important',
        marginLeft: '0 !important',
        marginRight: '0 !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Match editor/renderer wrapper clipping and selected-node ring to the native embed frame radius.
    // Borderless experiences keep the smaller core wrapper radius so their iframe content is not clipped
    // to a framed shape they do not visually own.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by the resolved showBorder value
    '.extension-container:has([data-native-embed-show-border="true"]), .ak-renderer-extension:has([data-native-embed-show-border="true"])': {
        borderRadius: "var(--ds-radius-xlarge, 12px)"
    },
    // In the editor, the --native-embed-width CSS variable is set on .extension-container by the
    // resize plugin. When the embed is nested inside another node (e.g. a table cell or expand),
    // data-native-embed-nested is present and we use maxWidth so the embed shrinks with the parent.
    // When the embed is top-level (not nested), we use width so it takes the exact pixel size.
    // In the renderer, width is set directly as an inline style on .ak-renderer-extension (overriding
    // the renderer's own inline style="width:100%"), so no CSS variable rule is needed for the renderer.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target nested extension container by data attribute on the container itself
    '.extension-container[data-native-embed-nested]:has([data-native-embed-alignment]):has([data-native-embed-width])': {
        maxWidth: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // The second selector adds an ID-level specificity bump so this rule also wins in full-width mode
    // (Confluence "wide" page width), where the editor applies `width: 100% !important` to
    // `.extension-container.block` via a rule scoped under
    // `.fabric-editor--full-width-mode:not(:has(#chromeless-editor))` with specificity (1, 3, 0).
    // Without the second selector, the native embed's (0, 3, 0) rule loses the cascade battle.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Second selector matches specificity of editor-core's full-width-mode rule; own ID won't work as our div is inside .extension-container, not an ancestor
    '.extension-container:not([data-native-embed-nested]):has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) .extension-container.block:not([data-native-embed-nested]):has([data-native-embed-alignment]):has([data-native-embed-width])': {
        width: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Layout column resizing can temporarily rebuild column content before the
    // native embed plugin re-syncs data-native-embed-nested. Fall back to the
    // actual layout-column DOM ancestry so an embed in a column still shrinks to
    // the column instead of taking its stored pixel width.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- DOM ancestry fallback for transient missing data-native-embed-nested
    '.ProseMirror [data-layout-column] .extension-container:has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) [data-layout-column] .extension-container.block:has([data-native-embed-alignment]):has([data-native-embed-width])': {
        width: 'auto !important',
        maxWidth: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Panel divider resizing can temporarily rebuild panel content before the
    // native embed plugin re-syncs data-native-embed-nested. Support both the
    // panel wrapper used by the old style and the content wrapper introduced by
    // the new style, but only while the native embed containment kill switch is off.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- DOM ancestry fallback for transient missing data-native-embed-nested
    '.ProseMirror .ak-editor-panel .extension-container:has([data-native-embed-panel-resize-containment="true"]):has([data-native-embed-alignment]):has([data-native-embed-width]), .ProseMirror .ak-editor-panel__content .extension-container:has([data-native-embed-panel-resize-containment="true"]):has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) .ak-editor-panel .extension-container.block:has([data-native-embed-panel-resize-containment="true"]):has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) .ak-editor-panel__content .extension-container.block:has([data-native-embed-panel-resize-containment="true"]):has([data-native-embed-alignment]):has([data-native-embed-width])': {
        width: 'auto !important',
        maxWidth: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Override the extension wrapper's width so alignment margins take effect.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="left"]), .ak-renderer-extension:has([data-native-embed-alignment="left"])': {
        margin: `${$35959f819cab4a83$var$noWrapGap} auto ${$35959f819cab4a83$var$noWrapGap} 0 !important`,
        overflow: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="center"]), .ak-renderer-extension:has([data-native-embed-alignment="center"])': {
        margin: `${$35959f819cab4a83$var$noWrapGap} 0 !important`,
        position: 'relative',
        left: '50%',
        transform: 'translateX(-50%)',
        marginLeft: '0 !important',
        marginRight: '0 !important'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="right"]), .ak-renderer-extension:has([data-native-embed-alignment="right"])': {
        margin: `${$35959f819cab4a83$var$noWrapGap} 0 ${$35959f819cab4a83$var$noWrapGap} auto !important`,
        overflow: 'auto'
    },
    // wrap-left / wrap-right: float + margin like MediaSingle so text wraps around the embed.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="wrap-left"])': {
        float: 'left',
        margin: `${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} auto !important`,
        maxWidth: `calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$35959f819cab4a83$var$wrapGap})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="wrap-left"])': {
        float: 'left',
        margin: `${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} auto !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="wrap-right"])': {
        float: 'right',
        margin: `${$35959f819cab4a83$var$wrapGap} auto ${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} !important`,
        maxWidth: `calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$35959f819cab4a83$var$wrapGap})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="wrap-right"])': {
        float: 'right',
        margin: `${$35959f819cab4a83$var$wrapGap} auto ${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} !important`
    },
    // Suppress the hover box-shadow on the extension container for all native embeds.
    // Native embeds provide their own chrome so the generic extension hover ring is not appropriate.
    // The selection ring (from .ak-editor-selected-node) is also applied as a box-shadow,
    // and would be incorrectly hidden on hover without the :not() guard.
    // Using :not(.ak-editor-selected-node *) avoids coupling to the intermediate DOM structure.
    // In the renderer there is no selection ring so the :not() guard is not needed.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrapper hover by data attribute
    '.extension-container:has([data-native-embed-alignment]):not(.ak-editor-selected-node *):hover': {
        boxShadow: 'none !important'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target renderer extension wrapper hover by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment]):hover': {
        boxShadow: 'none !important'
    },
    // Suppress the selection ring (box-shadow from .ak-editor-selected-node) for database embeds.
    // Database embeds use appearance="minimal" with no content border, so the selection ring
    // creates a jarring visual effect around a borderless embed.
    // The box-shadow is applied by editor-core to `.extension-container` via the selector:
    //   `.extensionView-content-wrap.ak-editor-selected-node > span > .extension-container`
    // We target `.extension-container` directly using :has() to check for the experience attribute
    // on the inner div, matching regardless of the intermediate DOM structure.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension-container for database embeds when selected
    '.extension-container:has([data-native-embed-experience="database"])': {
        boxShadow: 'none !important'
    }
}); /* eslint-enable @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-important-styles */ 
module.exports["nativeEmbedAlignmentStyles"] = $35959f819cab4a83$export$4f468ea4dd4fc462;

});

parcelRegister("7yhDb", function(module, exports) {
$parcel$export(module.exports, "resolveNativeEmbedInitialLayout", () => (parcelRequire("2Vug6")).resolveNativeEmbedInitialLayout);
/* initial-placeholder.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $2Vug6 = parcelRequire("2Vug6");


var $c2p9O = parcelRequire("c2p9O");

const $00899cff5c3558ef$var$placeholderFrameStyles = null;
const $00899cff5c3558ef$var$borderedPlaceholderFrameStyles = null;
const $00899cff5c3558ef$var$borderlessPlaceholderFrameStyles = null;
const $00899cff5c3558ef$export$608c5cf5128f3cea = ({ effectiveHeight: effectiveHeight, effectiveWidth: effectiveWidth, hasEmbedBorder: hasEmbedBorder = true, lockAspectRatio: lockAspectRatio, placeholderId: placeholderId, testId: testId = 'native-embed-initial-placeholder' })=>{
    const placeholderStyle = {
        width: effectiveWidth ? `${effectiveWidth}px` : '100%',
        height: lockAspectRatio ? 'auto' : `${effectiveHeight}px`,
        aspectRatio: lockAspectRatio ? effectiveWidth && effectiveHeight ? `${effectiveWidth} / ${effectiveHeight}` : (0, $2Vug6.NATIVE_EMBED_INITIAL_LAYOUT_FALLBACK_ASPECT_RATIO) : undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        ...placeholderId && {
            'data-ssr-placeholder': placeholderId
        },
        style: placeholderStyle,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _24h04i2Njc _1EqgXlN91d _0KLXrunmFW",
            hasEmbedBorder ? "_0bjKvDyzSk _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67" : "_0bjKvDKxmn"
        ])
    });
};
const $00899cff5c3558ef$export$5337b94b2c29c93 = ({ firstPaint: firstPaint = false, manifest: manifest, parameters: parameters, placeholderId: placeholderId, testId: testId })=>{
    const { alignment: alignment, effectiveHeight: effectiveHeight, effectiveWidth: effectiveWidth, hasEmbedBorder: hasEmbedBorder, lockAspectRatio: lockAspectRatio, placeholderId: resolvedPlaceholderId } = (0, $2Vug6.resolveNativeEmbedInitialLayout)({
        manifest: manifest,
        parameters: parameters,
        placeholderId: placeholderId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-native-embed-alignment": alignment,
        "data-native-embed-first-paint-placeholder": firstPaint ? 'true' : undefined,
        "data-native-embed-initial-placeholder": "true",
        "data-native-embed-width": effectiveWidth,
        "data-native-embed-show-border": hasEmbedBorder ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOiVq.Global), {
        styles: (0, $c2p9O.nativeEmbedAlignmentStyles)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($00899cff5c3558ef$export$608c5cf5128f3cea, {
        effectiveHeight: effectiveHeight,
        effectiveWidth: effectiveWidth,
        hasEmbedBorder: hasEmbedBorder,
        lockAspectRatio: lockAspectRatio,
        placeholderId: resolvedPlaceholderId,
        testId: testId
    }));
};
module.exports["NativeEmbedInitialPlaceholderFrame"] = $00899cff5c3558ef$export$608c5cf5128f3cea;
module.exports["NativeEmbedInitialPlaceholder"] = $00899cff5c3558ef$export$5337b94b2c29c93;

});

parcelRegister("F4YLX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/* placeholder.tsx generated by @compiled/babel-plugin v3.0.1 */ /**
 * `RedactionPlaceholder` — a correctly-sized, inline stand-in rendered while the
 * redaction extension handler / `ScribbleBar` component is still resolving.
 *
 * The redaction node is rendered through the async extension pipeline
 * (`render: async () => RedactionMarker`), so there is a brief window before the
 * real `ScribbleBar` mounts. Without a sized placeholder the node collapses to
 * empty text (and can briefly wrap), then jumps to the final scribble width once
 * it mounts, producing a visible layout shift. This placeholder reserves the
 * exact inline footprint the `ScribbleBar` will occupy so the surrounding text
 * never moves; the scribble simply fades in over the reserved box.
 *
 * The box dimensions here MUST stay in sync with the `ScribbleBar` container in
 * `./index.tsx` (`height`, `aspectRatio`, `display`, `verticalAlign`,
 * `borderRadius`). Any change to the bar's size must be mirrored here.
 */ 
var $hekY6 = parcelRequire("hekY6");




const $5955146ac6e17026$var$styles = {
    placeholder: "_0bjKvDcjp5 _3iDTPbccYA _0jFU0VMmFU _3v5uP0RvL4 _1RrJLit2nV _0KLXruDMqu _20VacPYbGa"
}; /**
    * Inline, non-interactive placeholder that reserves the `ScribbleBar` footprint
    * during load. Hidden from assistive tech since it carries no meaning on its own
    * (the mounted bar provides the accessible label).
    */ 
const $5955146ac6e17026$export$4ca97fdf3f5cdc9e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "guard-redaction-placeholder",
        "aria-hidden": "true",
        // extension chrome does not flash around the placeholder and then vanish when
        // the bar mounts.
        "data-inline-extension-layout": "flow",
        className: (0, $hekY6.default)([
            $5955146ac6e17026$var$styles.placeholder
        ])
    });



var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

const $87886bfe56e46f2e$export$8889efa109dce9d4 = ()=>(0, $9wGTI.fg)('confluence_redaction_shared_scribble') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5955146ac6e17026$export$4ca97fdf3f5cdc9e), null) : null;

const $87886bfe56e46f2e$export$2e83ac12275e5b95 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "jDbpB",
    name: "TourableRedactionExtensionLoader",
    loader: async ()=>(await (parcelRequire("fgA8n"))).TourableRedactionExtension,
    loading: $87886bfe56e46f2e$export$8889efa109dce9d4
});
module.exports["TourableRedactionExtensionLoader"] = $87886bfe56e46f2e$export$2e83ac12275e5b95;

});

parcelRegister("fgA8n", function(module, exports) {

let $b1d4611dc33958ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1d4611dc33958ff$var$load("5AfWB").then(()=>parcelRequire('jubPE'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("jibmA", function(module, exports) {

var $60cDW = parcelRequire("60cDW");

const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = typeof window !== 'undefined' && window.location ? window.location.hostname : (0, $60cDW.getSSRRenderInputs)().host;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        // Resolve against the current host so relative URLs (e.g. /browse/ABC-1) parse correctly.
        urlObject = url && new URL(url, windowHostname ? `https://${windowHostname}` : undefined);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("h0UOA", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $jibmA = parcelRequire("jibmA");

const $f3a2ccfb73948f5b$export$68bee16d64211457 = (0, $dOBRD.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        link: {
            onClick (e, url) {
                const isInlineComment = e.target instanceof Element && e.target.matches('[data-mark-annotation-type="inlineComment"]');
                if (isInlineComment) return;
                const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
                if ((0, $jibmA.isExternalLink)(url)) {
                    e.preventDefault();
                    window.open(url, '_blank', 'noopener, noreferrer');
                } else if (details?.href && details.href === url) {
                    e.preventDefault();
                    routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
                }
            }
        }
    } : undefined);
module.exports["createLinkEventHandler"] = $f3a2ccfb73948f5b$export$68bee16d64211457;

});

parcelRegister("fuLIO", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $cozmU = parcelRequire("cozmU");


var $3KymM = parcelRequire("3KymM");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $gXfti = parcelRequire("gXfti");


var $422HI = parcelRequire("422HI");


var $bavCP = parcelRequire("bavCP");


var $1xpoY = parcelRequire("1xpoY");


var $eczvQ = parcelRequire("eczvQ");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $6mEZ3 = parcelRequire("6mEZ3");


var $8pcS0 = parcelRequire("8pcS0");


var $kRAnY = parcelRequire("kRAnY");


var $ld6xp = parcelRequire("ld6xp");


var $iKSlH = parcelRequire("iKSlH");


var $gHCIk = parcelRequire("gHCIk");


var $92uc5 = parcelRequire("92uc5");


var $6Cce7 = parcelRequire("6Cce7");


var $eqB7W = parcelRequire("eqB7W");


var $b1ypt = parcelRequire("b1ypt");


var $hp2SH = parcelRequire("hp2SH");


var $7W8i8 = parcelRequire("7W8i8");


var $5kjCz = parcelRequire("5kjCz");

// Code taken from https://github.com/podefr/react-debounce-render/tree/master aka react-debounce-render package
// In order to prevent a new package from being added to the AFM project, the code was copied and pasted here since it is lightweight.




var $55fM8 = parcelRequire("55fM8");


var $aH9xZ = parcelRequire("aH9xZ");

const $3dbf040db5bfac2c$export$437fb41b7a687949 = (ComponentToDebounce, wait, debounceArgs)=>{
    class DebouncedContainer extends (0, $cozmU.Component) {
        shouldComponentUpdate() {
            this.updateDebounced();
            return false;
        }
        componentWillUnmount() {
            this.updateDebounced.cancel();
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentToDebounce, this.props);
        }
        constructor(...args){
            super(...args);
            // eslint-disable-next-line react/sort-comp
            this.updateDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(this.forceUpdate, wait, debounceArgs);
        }
    }
    DebouncedContainer.displayName = `debounceRender(${ComponentToDebounce.displayName || ComponentToDebounce.name || 'Component'})`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aH9xZ)))(DebouncedContainer, ComponentToDebounce);
};



var $bQm3c = parcelRequire("bQm3c");


var $c0rhi = parcelRequire("c0rhi");




const $71fb7e5ab8464496$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    highlightedPageIncludeRenderedError: {
        id: "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.highlightedPageIncludeError",
        defaultMessage: "Unable to render { include }"
    },
    nonhighlightedPageIncludeRenderedError: {
        id: "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.nonhighlightedPageIncludeRenderedError",
        defaultMessage: " Already included page \u201C{pageTitle}\u201D, stopping."
    }
});


/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ /* eslint-disable check-react-ssr-usage/guard-browser-globals -- Pre-existing browser-global usage; this component renders client-side. */ 



var $9DHhW = parcelRequire("9DHhW");


var $b8pma = parcelRequire("b8pma");


var $ah4BL = parcelRequire("ah4BL");


var $dPlMJ = parcelRequire("dPlMJ");


var $jAI8J = parcelRequire("jAI8J");

parcelRequire("itU2t");
var $czge2 = parcelRequire("czge2");





var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jNKuq = parcelRequire("jNKuq");


var $3DNeP = parcelRequire("3DNeP");





var $8Lx5S = parcelRequire("8Lx5S");


var $cpjd2 = parcelRequire("cpjd2");


var $brpfO = parcelRequire("brpfO");


var $hEeUR = parcelRequire("hEeUR");


var $989nU = parcelRequire("989nU");


var $KcDWk = parcelRequire("KcDWk");


var $bYtfC = parcelRequire("bYtfC");


var $iaRmR = parcelRequire("iaRmR");


var $8wppk = parcelRequire("8wppk");


var $6AplS = parcelRequire("6AplS");


var $hMRhJ = parcelRequire("hMRhJ");


var $5LTS4 = parcelRequire("5LTS4");


var $hHZWk = parcelRequire("hHZWk");








var $bX5uj = parcelRequire("bX5uj");


var $8eAX8 = parcelRequire("8eAX8");


var $fgbpl = parcelRequire("fgbpl");





var $1eD4P = parcelRequire("1eD4P");


var $3Btfb = parcelRequire("3Btfb");


var $giS6h = parcelRequire("giS6h");


var $8cOoD = parcelRequire("8cOoD");

/* eslint-disable no-console */ 





class $172ec9aa4291f34d$export$65a835712c7fb845 {
    static init(hostAPI, logger) {
        if (this.macroActions === null) {
            const getMacroId = (arg)=>{
                const macroId = arg?._context?.extension?.options?.productContext?.['macro.id'];
                if (!macroId) throw new Error('No macro ID found in the call.');
                return macroId;
            };
            const getEditorAction = (methodName, macroId)=>{
                const cachedMacro = this.macrosCache.get(macroId);
                if (typeof cachedMacro?.actions?.[methodName] !== 'function') throw new Error('Failed to execute this method. Please ensure that you are calling this method from within a multi-body extension inside your Connect application.');
                return cachedMacro.actions[methodName];
            };
            const assertNotReadonly = (macroId)=>{
                const cachedMacro = this.macrosCache.get(macroId);
                if (cachedMacro && cachedMacro.readonly) throw new Error('This method is not allowed in view mode');
                return true;
            };
            /**
       * Adding extra param to function ({returnPromise: true}) to let Connect know that
       * it returns Promise
       */ const prepareModuleFunction = (moduleFn)=>{
                return Object.assign(moduleFn, {
                    returnsPromise: true
                });
            };
            this.macroActions = {
                addBody: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const addChild = getEditorAction('addChild', macroId);
                        return Promise.resolve(addChild());
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                removeBody: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || typeof args[0] !== 'number') throw new Error('The removeBody method expects an index number as its argument.');
                        const [index, context] = args;
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const removeChild = getEditorAction('removeChild', macroId);
                        return Promise.resolve(removeChild(index));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                showBody: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || typeof args[0]?.body !== 'number' || typeof args[0]?.frame !== 'number') throw new Error('The showBody method expects an object with body and frame properties as its argument.');
                        const [indexes, context] = args;
                        const macroId = getMacroId(context);
                        const changeActive = getEditorAction('changeActive', macroId);
                        return Promise.resolve(changeActive(indexes.body, {
                            selection: 'end'
                        }));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                getBodyCount: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        const getChildrenCount = getEditorAction('getChildrenCount', macroId);
                        return Promise.resolve(getChildrenCount());
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                getParameters: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        const cachedMacro = this.macrosCache.get(macroId);
                        if (!cachedMacro) throw new Error('Failed to execute this method. Please ensure that you are calling this method from within a multi-body extension inside your Connect application.');
                        return Promise.resolve(JSON.parse(cachedMacro.parameters));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                updateParameters: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || !args[0] || typeof args[0] !== 'object') throw new Error('The updateParameters method expects an object with macro parameters as its argument.');
                        const [parameters, context] = args;
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const updateParameters = getEditorAction('updateParameters', macroId);
                        // The platform `updateParameters` now spreads its argument directly
                        // into `node.attrs.parameters` (instead of nesting it under
                        // `macroParams`). Behind the Native Tabs feature gate we use
                        // the new shape; outside the gate we wrap the Connect macro's
                        // parameters in `{ macroParams }` so the final node-attr shape
                        // matches the pre-change behaviour and existing Connect macros
                        // keep working.
                        const payload = (0, $6mKj3.expVal)('confluence_native_tabs_experiment', 'isEnabled', false) ? parameters : {
                            macroParams: parameters
                        };
                        return Promise.resolve(updateParameters(payload));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                })
            };
        }
        if (!hostAPI.isModuleDefined(this.macroName)) hostAPI.defineModule(this.macroName, this.macroActions);
    }
    static register(macroId, macroParams, editorActions, readonly) {
        if (!this.macrosCache.has(macroId)) this.macrosCache.set(macroId, {
            actions: editorActions,
            parameters: macroParams,
            readonly: readonly
        });
    }
    static deregister(macroId) {
        if (this.macrosCache.has(macroId)) this.macrosCache.delete(macroId);
    }
    static cleanCache() {
        this.macrosCache.clear();
    }
}
$172ec9aa4291f34d$export$65a835712c7fb845.macroName = 'macro';
$172ec9aa4291f34d$export$65a835712c7fb845.macroActions = null;
$172ec9aa4291f34d$export$65a835712c7fb845.macrosCache = new Map();
const $172ec9aa4291f34d$export$f3a2903499008e78 = async ({ logger: logger })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            if (!connectHost) {
                logger.error`ConnectHost is not available to init macro module`;
                resolve();
                return;
            }
            $172ec9aa4291f34d$export$65a835712c7fb845.init(connectHost, logger);
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for macro module!`;
            resolve();
        });
    });
};






var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


const $24172b2397b2d142$export$13124d26de07dad1 = ({ macroId: macroId, macroParams: macroParams, editorActions: editorActions, readonly: readonly = false })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!editorActions) {
            (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`No editor actions has been provided to MultiBodiedExtensionHandler for macro ${macroId}.`), {
                attribution: (0, $3IBnw.Attribution).ECOSYSTEM
            });
            return;
        }
        (0, $172ec9aa4291f34d$export$65a835712c7fb845).register(macroId, macroParams, editorActions, readonly);
        return ()=>{
            (0, $172ec9aa4291f34d$export$65a835712c7fb845).deregister(macroId);
        };
    }, [
        macroId,
        macroParams,
        editorActions,
        readonly
    ]);
    return null;
};



var $bDgLe = parcelRequire("bDgLe");





var $9kbTQ = parcelRequire("9kbTQ");


var $9rgEf = parcelRequire("9rgEf");








var $dwS6P = parcelRequire("dwS6P");

// The legacy server-side TOC plugin looks for this class and mutates the DOM via jQuery.
// We use it only to find the original server-rendered node, then replace that node entirely
// with a neutral mount node so the legacy plugin no longer owns the DOM subtree.
const $dc91df7f3e8c95ce$var$LEGACY_TOC_SELECTOR = '.client-side-toc-macro[data-macro-id]';
// This selector is for the replacement mount node we create ourselves after swapping out the
// legacy server-rendered TOC node. It lets subsequent effect runs find and reuse the
// frontend-owned node instead of trying to replace the original server-rendered TOC again.
const $dc91df7f3e8c95ce$var$HYDRATED_TOC_MOUNT_SELECTOR = '[data-fe-toc-mount="true"][data-macro-id]';
/**
 * Walk the migrated section ADF to find the nested TOC node that matches the server-rendered
 * TOC node we discovered in the DOM. That lets us preserve the original TOC params when we
 * re-render it on the frontend.
 */ const $dc91df7f3e8c95ce$var$findNestedTocNodeByMacroId = (node, macroId)=>{
    if (!node || !macroId) return null;
    const nodeMacroId = node?.attrs?.parameters?.macroMetadata?.macroId?.value;
    if (node?.attrs?.extensionKey === 'toc' && nodeMacroId === macroId) return node;
    for (const child of node?.content || []){
        const nestedMatch = $dc91df7f3e8c95ce$var$findNestedTocNodeByMacroId(child, macroId);
        if (nestedMatch) return nestedMatch;
    }
    const nestedContent = node?.attrs?.parameters?.nestedContent;
    if (nestedContent) return $dc91df7f3e8c95ce$var$findNestedTocNodeByMacroId(nestedContent, macroId);
    return null;
};
const $dc91df7f3e8c95ce$export$37d8cb6da62a6bbd = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { container: container, sectionNode: sectionNode, contentId: contentId, spaceKey: spaceKey, references: references } = t0;
    const fullPageDocument = (0, $cozmU.useContext)((0, $9rgEf.PageDocumentContext));
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [tocMounts, setTocMounts] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[1] !== container || $[2] !== fullPageDocument || $[3] !== sectionNode) {
        t2 = ()=>{
            if (!container || !fullPageDocument) {
                setTocMounts([]);
                return;
            }
            const nextTocMounts = [];
            container.querySelectorAll(`${$dc91df7f3e8c95ce$var$LEGACY_TOC_SELECTOR}, ${$dc91df7f3e8c95ce$var$HYDRATED_TOC_MOUNT_SELECTOR}`).forEach((tocElement)=>{
                const macroId = tocElement.dataset.macroId || "";
                const tocNode = $dc91df7f3e8c95ce$var$findNestedTocNodeByMacroId(sectionNode, macroId);
                if (!macroId || !tocNode) return;
                let mountNode;
                if (tocElement.dataset.feTocMount === "true") mountNode = tocElement;
                else {
                    mountNode = document.createElement("div");
                    mountNode.dataset.feTocMount = "true";
                    mountNode.dataset.macroId = macroId;
                    tocElement.parentNode?.replaceChild(mountNode, tocElement);
                }
                nextTocMounts.push({
                    macroId: macroId,
                    mountNode: mountNode,
                    tocNode: tocNode
                });
            });
            setTocMounts(nextTocMounts);
        };
        t3 = [
            container,
            fullPageDocument,
            sectionNode
        ];
        $[1] = container;
        $[2] = fullPageDocument;
        $[3] = sectionNode;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useLayoutEffect)(t2, t3);
    if (!fullPageDocument || tocMounts.length === 0) return null;
    let t4;
    if ($[6] !== cloudId || $[7] !== contentId || $[8] !== fullPageDocument || $[9] !== references || $[10] !== spaceKey || $[11] !== tocMounts || $[12] !== userId) {
        let t5;
        if ($[14] !== cloudId || $[15] !== contentId || $[16] !== fullPageDocument || $[17] !== references || $[18] !== spaceKey || $[19] !== userId) {
            t5 = (t6)=>{
                const { macroId: macroId_0, mountNode: mountNode_0, tocNode: tocNode_0 } = t6;
                const macroDefaultProps = {
                    node: tocNode_0,
                    references: references,
                    contentId: contentId || "",
                    spaceKey: spaceKey || "",
                    mode: (0, $5kjCz.RENDERER),
                    extensionKey: "toc",
                    attributes: {
                        macroId: macroId_0,
                        extensionKey: "toc"
                    }
                };
                return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dwS6P.TableOfContentsLoader), {
                    adf: fullPageDocument,
                    cloudId: cloudId || "",
                    userId: userId || "",
                    macroDefaultProps: macroDefaultProps,
                    isInEditMode: false
                }), mountNode_0, macroId_0);
            };
            $[14] = cloudId;
            $[15] = contentId;
            $[16] = fullPageDocument;
            $[17] = references;
            $[18] = spaceKey;
            $[19] = userId;
            $[20] = t5;
        } else t5 = $[20];
        t4 = tocMounts.map(t5);
        $[6] = cloudId;
        $[7] = contentId;
        $[8] = fullPageDocument;
        $[9] = references;
        $[10] = spaceKey;
        $[11] = tocMounts;
        $[12] = userId;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[21] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t4);
        $[21] = t4;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
};



var $gnzsm = parcelRequire("gnzsm");








var $isuYJ = parcelRequire("isuYJ");





var $euF5O = parcelRequire("euF5O");

/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $hekY6 = parcelRequire("hekY6");







const $0508843a879c075e$var$wrapperStyles = null;
const $0508843a879c075e$var$labelStyles = null;
const $0508843a879c075e$var$bodyStyles = null;
function $0508843a879c075e$export$414b5225f50e455b({ macroTitle: macroTitle, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _313842NHnM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_2OUyjtcDWF _2C2kUQKxmn _1Lz9loKxmn _41LZZBMRGa _2XsHFM5zaO _0adFHsFQfX _2Zuz6QFQfX _1ZnuxbFQfX _0Of8r2Ll21 _1wydGWLl21 _1mT5xdWVPG _2IhTonOHDs"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, macroTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _4FKVYE1Y8M _4bt5LAYvD1 _2WAcuGYvD1 _2OUyjtcDWF _2XsHFMFQfX _0adFHsFQfX _1DCdHi2ADO _313842Va5s _1EqgXlN91d"
        ])
    }, children));
}


const $e8626124813ef422$var$AC_NS = 'ac-xml-namespace';
/**
 * Parses macroBodyStorage XML and returns the document.
 * Wraps in a root element with namespace declarations so ac:/ri: prefixed tags are valid XML.
 */ function $e8626124813ef422$var$parseStorageXml(storageXml) {
    if (!storageXml) return null;
    try {
        const wrapped = `<root xmlns:ac="${$e8626124813ef422$var$AC_NS}" xmlns:ri="${$e8626124813ef422$var$AC_NS}">${storageXml}</root>`;
        const doc = new DOMParser().parseFromString(wrapped, 'text/xml');
        // DOMParser does not throw on parse errors — it returns a document containing
        // a <parsererror> element. Detect and discard these silently.
        if (doc.querySelector('parsererror')) return null;
        return doc;
    } catch  {
        return null;
    }
}
/**
 * Recursively renders a storage XML node as React nodes.
 * - <ac:structured-macro> → <UnknownMacroPlaceholder> with recursive children
 * - <ac:parameter> → skipped (metadata, not body content)
 * - <ac:rich-text-body> / <ac:plain-text-body> → recurse into children
 * - Text/CDATA nodes → plain text string
 * - Everything else → recurse into children
 */ function $e8626124813ef422$var$renderStorageNode(node, key) {
    // TEXT_NODE (3) and CDATA_SECTION_NODE (4) both contain plain text content
    if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.CDATA_SECTION_NODE) return node.textContent?.trim() || null;
    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    const el = node;
    // Skip parameter nodes — metadata only, not body content
    if (el.localName === 'parameter') return null;
    // Structured macro → render as a nested UnknownMacroPlaceholder
    if (el.localName === 'structured-macro') {
        const macroName = el.getAttributeNS($e8626124813ef422$var$AC_NS, 'name') ?? 'unknown';
        const children = $e8626124813ef422$var$renderStorageChildren(el);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0508843a879c075e$export$414b5225f50e455b), {
            key: key,
            macroTitle: macroName
        }, children);
    }
    // For all other elements (rich-text-body, plain-text-body, p, etc.) recurse into children
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        key: key
    }, $e8626124813ef422$var$renderStorageChildren(el));
}
function $e8626124813ef422$var$renderStorageChildren(node) {
    const children = [];
    node.childNodes.forEach((child, i)=>{
        const rendered = $e8626124813ef422$var$renderStorageNode(child, i);
        if (rendered !== null) children.push(rendered);
    });
    return children.length ? children : null;
}
/**
 * Builds React children for the Nth top-level <ac:structured-macro> in the storage document.
 * macroBodyStorage is the body content of the outer macro — each top-level structured-macro
 * in it corresponds to one wysiwyg-unknown-macro img in the rendered HTML, in document order.
 * If there are no top-level structured-macros (plain body content), render everything directly.
 */ function $e8626124813ef422$var$buildBodyForImg(doc, imgIndex) {
    const topLevelMacros = [];
    doc.documentElement.childNodes.forEach((child)=>{
        if (child.nodeType === Node.ELEMENT_NODE && child.localName === 'structured-macro') topLevelMacros.push(child);
    });
    if (topLevelMacros.length > 0) {
        const macro = topLevelMacros[imgIndex];
        if (!macro) return null;
        return $e8626124813ef422$var$renderStorageChildren(macro);
    }
    // No top-level structured-macros — storage is plain body content, render directly.
    // Only for the first img (index 0) since there's only one body.
    if (imgIndex === 0) return $e8626124813ef422$var$renderStorageChildren(doc.documentElement);
    return null;
}
/**
 * Extracts the macro name from a wysiwyg-unknown-macro img src URL.
 * The src contains a `name=` query parameter with the macro name.
 * Returns null if not found
 */ function $e8626124813ef422$var$getMacroNameFromImg(img) {
    try {
        const url = new URL(img.src, window.location.origin);
        return url.searchParams.get('name');
    } catch  {
        return null;
    }
}
function $e8626124813ef422$export$1172566723f24fd4({ container: container, macroBodyStorage: macroBodyStorage }) {
    const { shouldRenderUnknownMacro: shouldRenderUnknownMacro } = (0, $cozmU.useContext)((0, $euF5O.LegacyMacroRendererContext));
    const [portalTargets, setPortalTargets] = (0, $cozmU.useState)([]);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldRenderUnknownMacro || !container || !macroBodyStorage) return;
        const imgs = container.querySelectorAll('img.wysiwyg-unknown-macro');
        if (!imgs.length) return;
        const doc = $e8626124813ef422$var$parseStorageXml(macroBodyStorage);
        if (!doc) return;
        const targets = [];
        imgs.forEach((img, imgIndex)=>{
            const title = $e8626124813ef422$var$getMacroNameFromImg(img);
            if (!title) return;
            const body = $e8626124813ef422$var$buildBodyForImg(doc, imgIndex);
            if (body === null) return;
            // Replace each img with a div that becomes the portal target.
            // This preserves the surrounding HTML tree structure completely.
            const placeholder = document.createElement('div');
            img.replaceWith(placeholder);
            targets.push({
                el: placeholder,
                title: title,
                body: body
            });
        });
        setPortalTargets(targets);
        return ()=>{
            setPortalTargets([]);
        };
    }, [
        container,
        macroBodyStorage,
        shouldRenderUnknownMacro
    ]);
    if (!portalTargets.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, portalTargets.map(({ el: el, title: title, body: body }, i)=>/*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0508843a879c075e$export$414b5225f50e455b), {
            macroTitle: title
        }, body), el, String(i))));
}
const $e8626124813ef422$export$e4c5b8a9a19b7cc1 = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_unknown_macro_lcm_view_mode', 'isEnabled', true), $e8626124813ef422$export$1172566723f24fd4, ()=>null);






var $1i7uI = parcelRequire("1i7uI");





var $gEtAQ = parcelRequire("gEtAQ");

const $b1fc10dfab719594$var$extractExtensionKey = (extensionId)=>{
    const split = extensionId.split('__');
    if (split.length === 3) return split[1];
    return 'UNKOWN_EXTENSION_KEY';
};
const $b1fc10dfab719594$var$sendReferenceData = (references, extensionId, createAnalyticsEvent)=>{
    const eventName = 'data_provider';
    const addonFilter = {
        id: extensionId
    };
    const eventData = {
        eventData: references
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: (0, $gEtAQ.isViewPage)() ? 'viewPageScreen' : 'editPageScreen',
            action: 'broadcasted',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: $b1fc10dfab719594$var$extractExtensionKey(extensionId)
            }
        }
    });
    analyticsEvent.fire();
    // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).connectHost.broadcastEvent(eventName, addonFilter, eventData);
};
const $b1fc10dfab719594$export$b2f0fd57401a56fe = ({ references: references, macroContainer: macroContainer })=>{
    const [extensionId, setExtensionId] = (0, $cozmU.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensionId && Array.isArray(references) && references.length > 0) $b1fc10dfab719594$var$sendReferenceData(references, extensionId, createAnalyticsEvent);
    }, [
        references,
        extensionId,
        createAnalyticsEvent
    ]);
    const listeningForInitialization = (0, $cozmU.useCallback)((event)=>{
        if (event.data?.type !== 'event_query' || !event.data?.eid || !event.data?.args?.includes?.('data_provider')) return;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const iframeEl = document.getElementById(event.data.eid);
        if (iframeEl && macroContainer?.contains?.(iframeEl)) setExtensionId(event.data.eid);
    }, [
        macroContainer,
        setExtensionId
    ]);
    // Starts listening for macro initialization
    (0, $cozmU.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).addEventListener('message', listeningForInitialization);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).removeEventListener('message', listeningForInitialization);
        };
    }, [
        listeningForInitialization
    ]);
    return null;
};









var $iMnC5 = parcelRequire("iMnC5");


var $lMGh1 = parcelRequire("lMGh1");





var $hUS75 = parcelRequire("hUS75");

const $bd422ab26f8348d3$export$99a6d9338f38339e = ({ error: error, mode: mode, extensionKey: extensionKey, node: node, contentId: contentId })=>{
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hUS75.MacroExperienceStop), {
        extensionKey: extensionKey,
        error: error || Error(`Unable to render ${extensionKey}`),
        mode: mode,
        attributes: attributes,
        contentId: contentId,
        name: (0, $5kjCz.getExperienceName)(mode, node),
        source: "LegacyMacroRendererError"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: 5,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 200,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: "var(--ds-space-050, 4px)"
        },
        "data-testid": "legacy-macro-renderer-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "fabric-extension-legacy-macro-renderer.legacymacrorenderer.error",
        defaultMessage: "Failed to get macro details"
    }))));
};



var $aQw7y = parcelRequire("aQw7y");







const $622a0e8eee3d2f68$var$canOpenInNewTab = (href)=>{
    if (!href) // e.g., "Refresh" link in jira issue macro
    return false;
    const url = new URL(href);
    if (url.origin !== window.location.origin) return true;
    else if (url.pathname.includes('/wiki/rest/api')) return false;
    else if (url.pathname.includes('changes.action')) // e.g., "Show More" link in the recently updated macro
    return false;
    else if (url.pathname.includes('confirmattachmentremoval.action')) // e.g., "Delete" link in the attachments macro
    return false;
    else if (url.pathname.includes('.action')) // Most .action links should open in a new tab
    return true;
    else return true;
};
const $622a0e8eee3d2f68$export$5f4b0c82ca04cc0c = (extensionKey, container, isEditor)=>{
    const extensionsToOpenLinksInNewTab = (0, $cozmU.useMemo)(()=>{
        const extensionSet = new Set();
        if (!isEditor) return extensionSet;
        const allowlist = (0, $1xpoY.default).getStringList('confluence_frontend_macro_links_new_tab_allowlist', []);
        allowlist.map((ext)=>ext.trim().toLowerCase()).forEach((ext)=>ext && extensionSet.add(ext));
        return extensionSet;
    }, [
        isEditor
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Short circuit if we're not in the editor or the container is falsey
        if (!isEditor || !container) return;
        // Only intercept links in the FF allowlist
        if (!extensionsToOpenLinksInNewTab?.has(extensionKey.toLowerCase())) return;
        function interceptLinkClick(ev) {
            const anchor = ev?.target;
            // Only intercept clicks on anchor tags
            if (anchor?.tagName !== 'A') return;
            if (!$622a0e8eee3d2f68$var$canOpenInNewTab(anchor.href)) return;
            ev.preventDefault();
            window.open(anchor.href, '_blank', 'noopener, noreferrer');
        }
        container.addEventListener('click', interceptLinkClick);
        return ()=>{
            // Remove the event listener when the component unmounts
            container.removeEventListener('click', interceptLinkClick);
        };
    }, [
        container,
        extensionsToOpenLinksInNewTab,
        extensionKey,
        isEditor
    ]);
};





const $4e3f9bd15d15e68b$var$observedContainers = new WeakSet();
function $4e3f9bd15d15e68b$export$4fda4c6da8145997(container, shimUrl) {
    $4e3f9bd15d15e68b$var$observedContainers.add(container);
    const rewrite = (anchor)=>{
        for(let parent = anchor.parentElement; parent && parent !== container; parent = parent.parentElement){
            if ($4e3f9bd15d15e68b$var$observedContainers.has(parent)) return;
        }
        const href = anchor.getAttribute('href');
        if (!container.contains(anchor) || !href || href.startsWith('#') || anchor.target === '_self' || anchor.closest('.ProseMirror, [contenteditable="true"], [data-smart-link-container]')) return;
        const converted = shimUrl(anchor.href);
        if (converted !== anchor.href) anchor.setAttribute('href', converted);
    };
    const scan = (node)=>{
        if (node instanceof HTMLAnchorElement) rewrite(node);
        node.querySelectorAll('a[href]').forEach(rewrite);
    };
    const observer = new MutationObserver((records)=>{
        const added = new Set();
        const changed = new Set();
        for (const record of records)if (record.type === 'attributes' && record.target instanceof HTMLAnchorElement) changed.add(record.target);
        else record.addedNodes.forEach((node)=>{
            if (node instanceof Element && container.contains(node)) added.add(node);
        });
        for (const node of added){
            let parent = node.parentElement;
            while(parent && parent !== container && !added.has(parent))parent = parent.parentElement;
            if (!parent || !added.has(parent)) scan(node);
        }
        changed.forEach(rewrite);
    });
    observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            'href'
        ]
    });
    scan(container);
    return ()=>{
        observer.disconnect();
        $4e3f9bd15d15e68b$var$observedContainers.delete(container);
    };
}
function $4e3f9bd15d15e68b$export$be33a9338c4b74cc({ container: container, shimUrl: shimUrl, enabled: enabled }) {
    (0, $cozmU.useEffect)(()=>{
        if (!container || !enabled) return;
        return $4e3f9bd15d15e68b$export$4fda4c6da8145997(container, shimUrl);
    }, [
        container,
        shimUrl,
        enabled
    ]);
}


/**
 * Extract all data-wrm-key attribute values from webresource.tags.js.
 * Handles script tags like <script ... data-wrm-key="confluence.web.resources:event" ...></script>
 * and returns a string[] of the keys (e.g. ["confluence.web.resources:event", "confluence.web.resources:connect-helper", ...]).
 */ const $7466b2401803d953$export$c00afb1bef80592 = (tagsJs)=>{
    if (!tagsJs || typeof tagsJs !== 'string') return [];
    const keys = [];
    const pattern = /data-wrm-key=["']([^"']+)["']/g;
    let match;
    while((match = pattern.exec(tagsJs)) !== null)keys.push(match[1]);
    return keys;
};









var $8nJmU = parcelRequire("8nJmU");


var $irVI7 = parcelRequire("irVI7");




const $1b852b955f0d2b30$var$containsIframe = (macroRenderedOutput)=>/<iframe(?:\s|>)/i.test(macroRenderedOutput);
const $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience = (track)=>{
    try {
        track();
    } catch  {
    // Telemetry must never block or alter macro rendering behaviour.
    }
};
const $1b852b955f0d2b30$export$7437d350c23fca93 = new class ConnectStaticMacroExperienceTrackerSupport {
    isTrackable(data) {
        const outputContainsIframe = typeof data?.macroRenderedOutput === 'string' ? $1b852b955f0d2b30$var$containsIframe(data.macroRenderedOutput) : false;
        return Boolean(data?.isConnectMacro && data?.macroRenderedOutput && !outputContainsIframe);
    }
    start(data) {
        $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_RENDER_EXPERIENCE),
                attributes: {
                    contentId: data?.contentId,
                    extensionKey: data?.extensionKey,
                    macroId: data?.macroId
                }
            });
        });
    }
    succeed() {
        $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_RENDER_EXPERIENCE)
            });
        });
    }
    fail(error) {
        $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_RENDER_EXPERIENCE),
                error: error
            });
        });
    }
    abort(reason) {
        $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_RENDER_EXPERIENCE),
                reason: reason
            });
        });
    }
}();


const $551fe95be1481ef7$export$8af47b3ba0f9b00e = ({ contentId: contentId, delayedOutput: delayedOutput, extensionKey: extensionKey, isConnectMacro: isConnectMacro, isRendererMode: isRendererMode, macroId: macroId, macroOutput: macroOutput, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR })=>{
    const connectStaticMacroRenderExperienceResolved = (0, $cozmU.useRef)(false);
    const officeMacroRenderExperienceResolved = (0, $cozmU.useRef)(false);
    const isUsingServerRenderedMacroOutput = Boolean(macroRenderedOutputFromSSR || macroOutput);
    const hasOfficeMacroRenderedOutput = Boolean(delayedOutput || macroRenderedOutputFromSSR || macroOutput);
    (0, $cozmU.useEffect)(()=>{
        if (connectStaticMacroRenderExperienceResolved.current || !isRendererMode || isUsingServerRenderedMacroOutput) return;
        const connectStaticMacroRenderData = {
            contentId: contentId,
            extensionKey: extensionKey,
            macroId: macroId,
            isConnectMacro: isConnectMacro,
            macroRenderedOutput: delayedOutput
        };
        if (!(0, $6mKj3.expVal)('confluence_frontend_macro_slo_metrics', 'isEnabled', false)) return;
        let shouldTrackConnectStaticMacroRender = false;
        try {
            shouldTrackConnectStaticMacroRender = (0, $1b852b955f0d2b30$export$7437d350c23fca93).isTrackable(connectStaticMacroRenderData);
        } catch  {
            shouldTrackConnectStaticMacroRender = false;
        }
        if (!shouldTrackConnectStaticMacroRender) return;
        try {
            (0, $1b852b955f0d2b30$export$7437d350c23fca93).start(connectStaticMacroRenderData);
            (0, $1b852b955f0d2b30$export$7437d350c23fca93).succeed();
        } catch  {
        // Telemetry must never block or alter macro rendering behaviour.
        } finally{
            connectStaticMacroRenderExperienceResolved.current = true;
        }
    }, [
        contentId,
        delayedOutput,
        extensionKey,
        isConnectMacro,
        isRendererMode,
        isUsingServerRenderedMacroOutput,
        macroId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (officeMacroRenderExperienceResolved.current || !isRendererMode || !(0, $6mKj3.expVal)('confluence_frontend_macro_slo_metrics', 'isEnabled', false)) return;
        const officeMacroRenderData = {
            macroName: extensionKey
        };
        let shouldTrackOfficeMacroRender = false;
        try {
            shouldTrackOfficeMacroRender = (0, $8nJmU.OfficeMacroExperienceTrackerSupport).isTrackable(officeMacroRenderData);
        } catch  {
            shouldTrackOfficeMacroRender = false;
        }
        if (!shouldTrackOfficeMacroRender) return;
        if (!hasOfficeMacroRenderedOutput) return;
        try {
            (0, $8nJmU.OfficeMacroExperienceTrackerSupport).start(officeMacroRenderData);
            (0, $8nJmU.OfficeMacroExperienceTrackerSupport).succeed();
        } catch  {
        // Telemetry must never block or alter macro rendering behaviour.
        } finally{
            officeMacroRenderExperienceResolved.current = true;
        }
    }, [
        extensionKey,
        hasOfficeMacroRenderedOutput,
        isRendererMode
    ]);
};


// The rendered HTML currently outputs a div that contains a macro id attribute
// `data-macro-id="XYZ"`. We can parse that and get the ID
const $34a09ee48ab537fd$var$idFromStorageFormat = /data-macro-id="([0-9a-fA-F-]+?)"/;
// this will be fallback pattern in case div does not contain the macro id attribute.
// Parse in from data variable in the script tag.Pattern looks like `\\\"macro.id\\\":\\\"XYZ\\\"`
const $34a09ee48ab537fd$var$idFromADF = /macro\.id\\":\\"([0-9a-fA-F-]+?)\\"/;
const $34a09ee48ab537fd$var$originFromOutput = /"origin"\s*:\s*"(https?:\/\/[^"]+)"/;
const $34a09ee48ab537fd$var$logger = (0, $7W8i8.getLogger)('LegacyMacroRenderer');
const $34a09ee48ab537fd$var$Overlay = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "legacy-macro-overlay",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            bottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            cursor: 'default',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            zIndex: 2
        }
    });
/**
 * CEMS-919 and HOT-84603
 * ---------
 * Current implementation of the Team Calendars Plugin does not account for
 * a SPA transition. It only loads the calendars once and forgets about
 * re-initializing them once the page is unmounted. For this, we need to
 * invoke the assets when necessary and initialize the calendars. Also reference:
 * confluence-frontend-server/src/components/ContentBody/ContentBodyDefaultComponent.js
 * @private
 */ const $34a09ee48ab537fd$var$initializeCalendarIfNeeded = async (extensionKey, isBodied, macroRenderedOutput)=>{
    const isCalendarMacro = extensionKey === 'calendar' || isBodied && macroRenderedOutput?.includes('data-macro-name="calendar"');
    if (!isCalendarMacro || (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) return;
    (0, $cpjd2.requireLegacyWRM)((0, $8eAX8.teamCalendarWRM)(), ()=>{
        try {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- runs only inside the client-only requireLegacyWRM success callback
            window.require('tc/init-resources').requireResources();
        } catch (err) {
            $34a09ee48ab537fd$var$logger.error(err);
        }
    }, ()=>{
        $34a09ee48ab537fd$var$logger.error`Error loading team calendar WRM!`;
    });
};
const $34a09ee48ab537fd$var$getMacroId = (adf, macroRenderedOutput)=>{
    // The `localId` fallback is only used for included-content TOC heading links;
    // gate it so all other legacy-macro id resolution matches prior behaviour.
    const idFromNode = (0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true) ? adf?.attrs?.parameters?.macroMetadata?.macroId?.value || adf?.attrs?.localId : adf?.attrs?.parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    let matches = $34a09ee48ab537fd$var$idFromStorageFormat.exec(macroRenderedOutput || '');
    if (matches?.[1]) return matches[1];
    matches = $34a09ee48ab537fd$var$idFromADF.exec(macroRenderedOutput || '');
    if (matches?.[1]) return matches[1];
    $34a09ee48ab537fd$var$logger.error`Cannot find macro id from ${macroRenderedOutput}`;
    return '';
};
const $34a09ee48ab537fd$export$f72fde323a57bd3e = (macroRenderedOutput)=>{
    const matches = $34a09ee48ab537fd$var$originFromOutput.exec(macroRenderedOutput || '');
    return matches?.[1] || '';
};
const $34a09ee48ab537fd$var$getConnectAddonKeyFromMacroOutput = (macroRenderedOutput)=>typeof macroRenderedOutput === 'string' ? macroRenderedOutput.match(/"addon_key"\s*:\s*"([^"]+)"/)?.[1] ?? macroRenderedOutput.match(/addon_key\\":\\"([^"]+)\\"/)?.[1] : undefined;
const $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM = [
    'include',
    'contentbylabel',
    'children',
    'content-report-table',
    'index',
    'pagetree',
    'tasks-report-macro',
    'recently-updated-dashboard',
    'recently-updated',
    'toc'
];
const $34a09ee48ab537fd$var$UFO3PSegmentWrapper = ({ children: children, extensionKey: extensionKey })=>{
    const isFirstPartyExtension = (0, $cozmU.useMemo)(()=>{
        const trimmedExtensions = new Set((0, $1xpoY.default).getString('confluence_1p_extensions', '').split(',').map((item)=>item.trim()));
        return trimmedExtensions.has(extensionKey);
    }, [
        extensionKey
    ]);
    if (isFirstPartyExtension) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
        name: `extension-${extensionKey}`
    }, children);
};
const $34a09ee48ab537fd$export$a5c44bbb70ae7ae6 = (0, $3Btfb.withNavigationPolicy)(({ adf: adf, macroRepresentation: macroRepresentation, macroRenderedOutput: macroRenderedOutput, mode: mode, node: node, contentId: contentId, attributes: attributes, experienceName: experienceName, featureFlags: featureFlags, webresource: webresource, body: body, parameters: parameters, navigationPolicy: navigationPolicy, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, providers: providers, mediaToken: mediaToken, noOverlay: noOverlay, isWithinEditor: isWithinEditor, isPreviewMode: isPreviewMode, appKey: appKey, isConnectMacro: isConnectMacro, macroBodyStorage: macroBodyStorage, getHeadingLinkPath: getHeadingLinkPath })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isInline = adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE);
    const isMultiBodied = adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE);
    const extensionKey = adf?.attrs?.extensionKey || '';
    const scriptContainer = (0, $cozmU.useRef)(null);
    if (!macroRenderedOutput) macroRenderedOutput = '';
    if (extensionKey && macroRenderedOutput) {
        // If a Tiny page with Style Macro gets converted to Fabric, need to Scope the CSS
        // When in edit mode, the <style> tag don't have data-macro-name="style" attribute, so need to pass a different regex
        if (extensionKey === 'style') macroRenderedOutput = (0, $6AplS.scopeCSS)(macroRenderedOutput, (0, $6AplS.mainContentSelector), /(<style[^>]*>)((.|\n|\r)*?)(<\/style>)/gm).contentWithScopedCSS;
        else // Other extensionKeys could have nested Style Macro
        macroRenderedOutput = (0, $6AplS.scopeCSS)(macroRenderedOutput, (0, $6AplS.mainContentSelector)).contentWithScopedCSS;
    }
    const { viewportHeight: viewportHeight } = (0, $bYtfC.useConnectExtensionViewportSize)(node);
    const shouldHideOverlay = (0, $aQw7y.useShouldHideOverlay)(extensionKey, (0, $fgbpl.isBodiedExtension)(adf.type));
    /**
   * Callback to be triggered when web resources are resolved.
   * This is to make sure certain macros e.g. Gadget Macro only to render output after web resources loaded.
   * For more context of the issue: https://hello.atlassian.net/wiki/spaces/~462393321/pages/1007234825/Debugging+Legacy+Jira+gadgets+within+Connie
   * https://jira.atlassian.com/browse/CONFCLOUD-70573
   */ const [delayedOutput, setDelayedOutput] = (0, $cozmU.useState)(extensionKey === 'gadget' ? '' : macroRenderedOutput);
    const [container, setContainer] = (0, $cozmU.useState)(null);
    const embeddedProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    (0, $4e3f9bd15d15e68b$export$be33a9338c4b74cc)({
        container: container,
        shimUrl: navigationPolicy.shimUrl,
        enabled: Boolean(navigationPolicy.routePolicy && embeddedProps?.navigationPolicy?.shimUrl && mode === (0, $5kjCz.RENDERER) && !isWithinEditor && $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM.includes(extensionKey) && (0, $9wGTI.fg)('confluence_ep_shim_macro_links_v2'))
    });
    const [isMacroResourcesLoaded, setIsMacroResourcesLoaded] = (0, $cozmU.useState)(false);
    const unknownMacroPortals = (0, $e8626124813ef422$export$e4c5b8a9a19b7cc1)({
        container: container,
        macroBodyStorage: macroBodyStorage ?? null
    });
    const { eventHandlers: externalLinkEventHandlers, onSetLinkTarget: onSetLinkTarget } = (0, $jNKuq.useExternalLinkHandlers)();
    // Patch links in the raw server-rendered HTML, which bypass the ADF renderer.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!container || !(container instanceof HTMLElement) || macroRepresentation === 'atlas_doc_format' || !(0, $6mKj3.expValEquals)('confluence_legacy_macro_external_links_new_tab', 'isEnabled', true)) return;
        (0, $3DNeP.ensureExternalLinksOpenInNewTab)(container);
    }, [
        container,
        delayedOutput,
        macroRepresentation
    ]);
    // Variables for temporarily measuring rendered macro heights
    const isRendererExtension = mode === (0, $5kjCz.RENDERER) && adf.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    const isMacroLoaded = container && isMacroResourcesLoaded && delayedOutput;
    (0, $cozmU.useEffect)(()=>{
        if (container) {
            const loadMacroResources = async ()=>{
                const isDPModuleDefined = (0, $8cOoD.checkIsDPModuleDefined)();
                if (!isDPModuleDefined) {
                    const isViewPage = mode === (0, $5kjCz.RENDERER);
                    await (0, $8cOoD.loadDataProviderModule)({
                        logger: $34a09ee48ab537fd$var$logger,
                        isViewPage: isViewPage,
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                }
                if (isMultiBodied) await (0, $172ec9aa4291f34d$export$f3a2903499008e78)({
                    logger: $34a09ee48ab537fd$var$logger
                });
                await (0, $8eAX8.loadMacroWebResources)(webresource, macroRenderedOutputFromSSR, macroOutput, ()=>{
                    if (delayedOutput !== macroRenderedOutput) setDelayedOutput(macroRenderedOutput);
                }, scriptContainer?.current);
                setIsMacroResourcesLoaded(true);
            };
            loadMacroResources();
            (0, $brpfO.evalLegacyConnectInlineScripts)(container);
            $34a09ee48ab537fd$var$initializeCalendarIfNeeded(extensionKey, (0, $fgbpl.isBodiedExtension)(adf.type), macroRenderedOutput);
        }
    }, [
        webresource,
        extensionKey,
        macroRenderedOutput,
        delayedOutput,
        container,
        scriptContainer,
        macroRenderedOutputFromSSR,
        macroOutput,
        mode,
        createAnalyticsEvent,
        isMultiBodied,
        adf.type
    ]);
    (0, $cozmU.useEffect)(()=>{
        /**
     * Our goal here is to measure the height of the connect macro after its iframe content has finished rendering.
     * The iframe load event would be insufficient and we can't be specific on when the content in the iframe is done
     * rendering since it'd rely on the vendor using ACJS to communicate this. At best we approximate by waiting for
     * resources to have been loaded and waiting a reasonable amount of time to check. We will also restrict this
     * to view mode and avoid multi-bodied or inline macros.
     */ if (isMacroLoaded && isRendererExtension && (0, $9wGTI.fg)('confluence_content_macro_measurements')) {
            const timer = setTimeout(()=>{
                // Target the connect iframe to prevent measuring macros in other extension points
                const connectIframe = container.querySelector('iframe');
                if (connectIframe) {
                    const { height: height } = connectIframe.getBoundingClientRect();
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            source: 'legacyMacroRenderer',
                            action: 'render',
                            actionSubject: 'connectMacro',
                            attributes: {
                                extensionKey: extensionKey,
                                height: height
                            }
                        }
                    }).fire();
                }
            }, 10000);
            return ()=>clearTimeout(timer);
        }
    }, [
        container,
        extensionKey,
        createAnalyticsEvent,
        isMacroLoaded,
        isRendererExtension
    ]);
    // Add instrumentation for WRM keys from data-wrm-key in webresource.tags.js
    // If extension is dependent on WRM resources, store WRM keys and extension key in window.__WRM_KEYS__
    (0, $cozmU.useEffect)(()=>{
        const wrmKeys = (0, $7466b2401803d953$export$c00afb1bef80592)(webresource?.tags?.js ?? null) || [];
        if (window && wrmKeys.length > 0) {
            if (!window.__WRM_KEYS__) window.__WRM_KEYS__ = {};
            const existingJsKeys = window.__WRM_KEYS__['js'] ?? [];
            const existingExtensionKeys = window.__WRM_KEYS__['extension'] ?? [];
            window.__WRM_KEYS__['js'] = [
                ...new Set([
                    ...existingJsKeys,
                    ...wrmKeys
                ])
            ];
            window.__WRM_KEYS__['extension'] = [
                ...new Set([
                    ...existingExtensionKeys,
                    extensionKey
                ])
            ];
        }
    }, [
        webresource,
        extensionKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (appKey && window) {
            if (!window.__APP_KEYS__) window.__APP_KEYS__ = [];
            window.__APP_KEYS__ = [
                ...new Set([
                    ...window.__APP_KEYS__,
                    appKey
                ])
            ];
        }
    }, [
        appKey
    ]);
    (0, $622a0e8eee3d2f68$export$5f4b0c82ca04cc0c)(extensionKey ?? '', container, mode === (0, $5kjCz.EDITOR) || isWithinEditor);
    const macroId = $34a09ee48ab537fd$var$getMacroId(adf, macroRenderedOutput);
    const macroOrigin = $34a09ee48ab537fd$export$f72fde323a57bd3e(macroRenderedOutput);
    (0, $551fe95be1481ef7$export$8af47b3ba0f9b00e)({
        contentId: contentId,
        delayedOutput: delayedOutput,
        extensionKey: extensionKey,
        isConnectMacro: isConnectMacro,
        isRendererMode: mode === (0, $5kjCz.RENDERER),
        macroId: macroId,
        macroOutput: macroOutput,
        macroRenderedOutputFromSSR: macroRenderedOutputFromSSR
    });
    const ssredElement = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isSiteAdmin = (0, $8Lx5S.useIsAdmin)();
    const connectAppKey = typeof appKey === 'string' && appKey.length > 0 && appKey !== 'unknown' ? appKey : $34a09ee48ab537fd$var$getConnectAddonKeyFromMacroOutput(macroRenderedOutput);
    const connectEosBanner = connectAppKey && (0, $9wGTI.fg)('customer-messaging-iframe-banner-enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dPlMJ.ConnectEosBanner), {
        appKey: connectAppKey,
        cloudId: cloudId,
        moduleType: "dynamicContentMacros",
        isSystemApp: (0, $jAI8J.isSystemApp)(connectAppKey),
        isSiteAdmin: isSiteAdmin
    }) : null;
    (0, $cozmU.useEffect)(()=>{
        // `appKey` from the GraphQL response can be the sentinel string "unknown"
        // (or empty/undefined). Fall back to the Connect `addon_key` parsed from
        // the rendered macro payload — that is the identifier embedded FAUS uses
        // to build the `fetchAppKeyFromEmbeddedFAUS_<addon_key>` channel name.
        const isValidAppKey = typeof appKey === 'string' && appKey.length > 0 && appKey !== 'unknown';
        const addonKeyCandidate = $34a09ee48ab537fd$var$getConnectAddonKeyFromMacroOutput(macroRenderedOutput);
        const bridgeIdentifier = isValidAppKey ? appKey : addonKeyCandidate;
        const hasBridgeIdentifier = typeof bridgeIdentifier === 'string' && bridgeIdentifier.length > 0;
        if (!(0, $9wGTI.fg)('forge_nbm_set_frame_ancestors') || !hasBridgeIdentifier) return undefined;
        let cleanupListener;
        let observer;
        const registerWithIframeWindow = (iframe)=>{
            const targetWindow = iframe?.contentWindow;
            if (!targetWindow) return false;
            cleanupListener?.();
            cleanupListener = (0, $8wppk.registerEmbeddedFausAppKeyListener)(bridgeIdentifier, macroOrigin, macroId, targetWindow);
            return Boolean(cleanupListener);
        };
        const attachIframeLoadListener = (iframe)=>{
            const onLoad = ()=>{
                registerWithIframeWindow(iframe);
            };
            iframe.addEventListener('load', onLoad);
            return ()=>iframe.removeEventListener('load', onLoad);
        };
        let cleanupIframeLoadListener;
        const existingIframe = container instanceof HTMLElement ? container.querySelector('iframe') : null;
        if (existingIframe) {
            registerWithIframeWindow(existingIframe);
            cleanupIframeLoadListener = attachIframeLoadListener(existingIframe);
        } else if (container instanceof HTMLElement) {
            observer = new MutationObserver(()=>{
                const iframe = container.querySelector('iframe');
                if (registerWithIframeWindow(iframe)) {
                    observer?.disconnect();
                    observer = undefined;
                    if (iframe) {
                        cleanupIframeLoadListener?.();
                        cleanupIframeLoadListener = attachIframeLoadListener(iframe);
                    }
                }
            });
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            observer?.disconnect();
            cleanupIframeLoadListener?.();
            cleanupListener?.();
        };
    }, [
        container,
        macroId,
        appKey,
        macroOrigin,
        macroRenderedOutput
    ]);
    const nodeProps = {
        ref: setContainer
    };
    const macroDataProps = {
        'data-fabric-macro': macroId,
        'data-macro-body': body || '',
        'data-macro-parameters': parameters || '',
        'data-node-type': extensionKey === 'include' ? 'include' : undefined
    };
    // Use parent id if the macro source is different than the current page
    const getContentId = (adf, contentId)=>{
        const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
        return parentId || contentId;
    };
    const { getExtensionHandlers: getExtensionHandlers } = providers;
    const effectiveContentId = getContentId(adf, contentId);
    const extensionHandlers = getExtensionHandlers ? getExtensionHandlers({
        adf: macroRepresentation == 'atlas_doc_format' ? macroRenderedOutputFromSSR || macroOutput || macroRenderedOutput : adf,
        contentId: effectiveContentId,
        spaceKey: spaceKey,
        macroRenderedOutput: macroRenderedOutputFromSSR || macroOutput || macroRenderedOutput,
        shouldIncludeMacroWithReferencesHandlers: true,
        referentialityDataSourceProvider: new (0, $czge2.DataSourceProvider)(),
        mediaToken: mediaToken
    }) : {};
    // Migrated server "section" macros render as legacy HTML on view pages, so the any nested TOCs
    // are getting incorrect headings which is considered a migration blocker.
    // As a quick fix, we hydrate this case by replacing server rendered HTML with our frontend TOC.
    const shouldHydrateNestedLegacyToc = mode === (0, $5kjCz.RENDERER) && extensionKey === 'section';
    const elementProps = {
        adf: adf,
        isInline: isInline,
        contentId: effectiveContentId,
        mode: mode,
        extensionKey: extensionKey,
        nodeProps: nodeProps,
        macroRepresentation: macroRepresentation,
        macroDataProps: macroDataProps,
        macroRenderedOutput: delayedOutput,
        extensionHandlers: extensionHandlers,
        mediaToken: mediaToken,
        headingIdPrefix: extensionKey === 'include' && (0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true) ? macroId : undefined,
        ssredElement: ssredElement,
        delayIframe: false,
        height: viewportHeight
    };
    if (mode === (0, $5kjCz.RENDERER) || mode === (0, $5kjCz.PDF)) {
        try {
            const macroId = attributes?.macroId ? attributes.macroId : '';
            const type = attributes?.type ? attributes.type : 'none';
            // on view page it will send macro load event
            // it will help to alert in case of multiple rendering of macro
            // event name: macro renderer (client)
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'renderer',
                    actionSubject: 'macro',
                    source: 'legacyMacroRenderer',
                    attributes: {
                        mode: mode,
                        extensionKey: extensionKey,
                        macroId: macroId,
                        contentId: contentId,
                        type: type
                    }
                }
            }).fire();
        } catch (err) {
            $34a09ee48ab537fd$var$logger.error`An error occurred while firing the analytics event for legacyMacroRendererComponent: ${err}`;
        }
        const finalExtensionKey = attributes?.extensionKey || extensionKey;
        /**
     * https://product-fabric.atlassian.net/browse/CCP-1798
     * If macroRenderedOutputFromSSR or macroOuput are passed as a prop, they will be used for SPA rehydration (rather
     * than the MacroContentQuery). macroRenderedOutputFromSSR / macroOutput already have JS/CSS coming from ContentUnifiedQuery,
     * so here we use the base components of LegacyMacroRendererComponent, but instead
     * render FabricLegacyMacrosServerRenderer, which sets JS/CSS internally.
     * https://product-fabric.atlassian.net/browse/DLRN-3182
     * If macroOutput exists, it contains the full html (as a string) required to render the macro.
     */ if (macroRenderedOutputFromSSR || macroOutput) {
            const macroDefaultProps = {
                node: node,
                references: references,
                contentId: effectiveContentId,
                spaceKey: spaceKey || '',
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                isConnectMacro: isConnectMacro
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
                extensionKey: finalExtensionKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
                name: "LegacyMacroRendererComponentResourcesSSR",
                hold: !isMacroResourcesLoaded
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1fc10dfab719594$export$b2f0fd57401a56fe), {
                references: references,
                macroContainer: container
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
                extensionKey: finalExtensionKey,
                contentId: contentId,
                node: node
            }), connectEosBanner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $989nU.FabricLegacyMacrosServerRenderer), {
                renderedByProvider: true,
                macroRenderedOutput: macroRenderedOutputFromSSR,
                macroDefaultProps: macroDefaultProps,
                containerRef: setContainer,
                macroOutput: macroOutput
            }), shouldHydrateNestedLegacyToc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc91df7f3e8c95ce$export$37d8cb6da62a6bbd), {
                container: container,
                sectionNode: adf,
                contentId: effectiveContentId,
                spaceKey: spaceKey,
                references: references
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHZWk.LegacyUserElementsHover), {
                node: container
            }), // WS-3295 - DO NOT REMOVE THIS LOADER
            // We need to load the legacy editor here to allow users to create/edit/view comments with the attachments macro
            extensionKey === 'attachments' && !isPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Consumer, null, ({ EditorLoaderLoader: EditorLoaderLoader })=>{
                // isWithinEditor will be true if the attachments macro is within a macro
                // that itself is being rendered in the editor, e.g., excerpt-include.
                return !isWithinEditor && !isPreviewMode && EditorLoaderLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorLoaderLoader, null);
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
                name: experienceName,
                contentId: contentId,
                extensionKey: extensionKey,
                mode: mode,
                attributes: attributes
            })));
        }
        // TODO: Detect TeamCalendar macro and enusre hold timing is correct for it
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
            extensionKey: finalExtensionKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "LegacyMacroRendererComponentResourcesNonSSR",
            hold: !isMacroResourcesLoaded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1fc10dfab719594$export$b2f0fd57401a56fe), {
            references: references,
            macroContainer: container
        }), isMultiBodied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24172b2397b2d142$export$13124d26de07dad1), {
            macroId: macroId,
            macroParams: parameters,
            editorActions: multiBodiedExtensionActions,
            readonly: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: `${webresource?.tags?.css || ''}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                display: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
            extensionKey: finalExtensionKey,
            contentId: contentId,
            node: node
        }), connectEosBanner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
            renderedByProvider: true,
            ...elementProps,
            macroRenderedOutput: $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM.includes(extensionKey) ? navigationPolicy.shimHtmlUrls(delayedOutput) : delayedOutput
        }), unknownMacroPortals, shouldHydrateNestedLegacyToc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc91df7f3e8c95ce$export$37d8cb6da62a6bbd), {
            container: container,
            sectionNode: adf,
            contentId: effectiveContentId,
            spaceKey: spaceKey,
            references: references
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHZWk.LegacyUserElementsHover), {
            node: container
        }), // WS-3295 - DO NOT REMOVE THIS LOADER
        // We need to load the legacy editor here to allow users to create/edit/view comments with the attachments macro
        extensionKey === 'attachments' && !isPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Consumer, null, ({ EditorLoaderLoader: EditorLoaderLoader })=>{
            // isWithinEditor will be true if the attachments macro is within a macro
            // that itself is being rendered in the editor, e.g., excerpt-include.
            return !isWithinEditor && EditorLoaderLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorLoaderLoader, null);
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: "js-container",
            ref: scriptContainer,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                display: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes
        })));
    }
    let parsedDelayedOutput;
    let parseError;
    let component;
    try {
        if (macroRepresentation === 'atlas_doc_format') {
            parsedDelayedOutput = JSON.parse(delayedOutput);
            component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
                document: parsedDelayedOutput,
                contentId: getContentId(adf, contentId),
                featureFlags: featureFlags ?? {},
                extensionHandlers: extensionHandlers,
                mediaToken: mediaToken,
                appearance: "full-width",
                eventHandlers: externalLinkEventHandlers,
                onSetLinkTarget: onSetLinkTarget,
                allowHeadingAnchorLinks: extensionKey === 'include' && (0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true) ? {
                    allowNestedHeaderLinks: true,
                    getHeadingLink: (headingId)=>(0, $gnzsm.createHeadingLink)(getHeadingLinkPath, headingId) ?? (typeof window !== 'undefined' ? new URL(`#${encodeURIComponent(headingId)}`, window.location.href).toString() : `#${encodeURIComponent(headingId)}`)
                } : undefined,
                headingIdPrefix: extensionKey === 'include' && (0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true) ? macroId : undefined
            });
        }
    } catch (e) {
        parseError = e;
        $34a09ee48ab537fd$var$logger.error`An error occurred while parsing adf output: ${delayedOutput}`;
        component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd422ab26f8348d3$export$99a6d9338f38339e), {
            error: parseError,
            node: node,
            mode: mode,
            extensionKey: extensionKey,
            contentId: contentId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
        extensionKey: extensionKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "LegacyMacroRendererComponentResourcesFabric",
        hold: !isMacroResourcesLoaded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: `${webresource?.tags?.css || ''}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }), isMultiBodied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24172b2397b2d142$export$13124d26de07dad1), {
        macroId: macroId,
        macroParams: parameters,
        editorActions: multiBodiedExtensionActions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
        renderedByProvider: true,
        ...elementProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: viewportHeight && (0, $9wGTI.fg)('confluence_connect_macro_preset_height') ? {
            minHeight: `${viewportHeight}px`
        } : null
    }, noOverlay || shouldHideOverlay || isMultiBodied ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$var$Overlay, null), connectEosBanner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1fc10dfab719594$export$b2f0fd57401a56fe), {
        references: references,
        macroContainer: container
    }), macroRepresentation === 'atlas_doc_format' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "macro-adf-renderer",
        ref: setContainer
    }, component) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: setContainer,
        dangerouslySetInnerHTML: {
            __html: `${delayedOutput}`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        key: "js-container",
        ref: scriptContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    })));
});
const $34a09ee48ab537fd$export$b43db7dd8b06a124 = (props)=>{
    const rendererExtensionProviders = (0, $cozmU.useContext)((0, $hMRhJ.RendererExtensionContext));
    const classicEditorExtensionProviders = (0, $cozmU.useContext)((0, $giS6h.ClassicEditorContext));
    const isWithinEditor = classicEditorExtensionProviders?.isWithinEditor ?? false;
    const providers = {
        ...classicEditorExtensionProviders,
        ...rendererExtensionProviders
    };
    const propsWithProviders = {
        ...props,
        providers: providers,
        isWithinEditor: isWithinEditor,
        getHeadingLinkPath: props.getHeadingLinkPath ?? classicEditorExtensionProviders?.getHeadingLinkPath
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$export$a5c44bbb70ae7ae6, propsWithProviders);
};









const $3ff9e0546f2c245a$export$1b5865c105cfe12d = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    listOfRenderedPageIncludeNodes: []
});


/**
 * Checks whether an extension node is a plain text macro or not.
 *
 * The node at this point may not indicate what it's content type is, so a
 * reliable way is to check for the `__bodyContent` property, which exists
 * on plain text macros.
 *
 * @param node Extension node to check
 */ const $b65e5cf2eec587a5$var$isPlainTextMacro = (node)=>node.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) && Boolean(node?.parameters?.macroParams?.__bodyContent);
/**
 * All bodied extensions are rich text.
 *
 * @param node Extension node to check
 */ const $b65e5cf2eec587a5$var$isRichTextMacro = (node)=>node.type === (0, $8pcS0.BODIED_EXTENSION_TYPE);
const $b65e5cf2eec587a5$var$convertADFContentToStorageQuery = async (contentId, content)=>{
    const result = await (0, $c0rhi.queryInterop)({
        query: (0, $6Cce7.ContentConverterQuery),
        variables: (0, $92uc5.getContentConverterVariables)({
            content: content,
            contentId: contentId
        }),
        __callerPackage__: "fabric-extension-legacy-macro-renderer"
    });
    return result.data?.contentConverter?.value ?? '';
};
function $b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView({ isInEditorRendererView: isInEditorRendererView, node: node, extensionKey: extensionKey }) {
    return isInEditorRendererView && (0, $kRAnY.is2PBodiedExtension)({
        extensionKey: extensionKey,
        extensionType: node.type
    });
}
function $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension({ contentId: contentId, node: node, extensionKey: extensionKey }) {
    const hasParent = !!node?.parameters?.macroParams?._parentId?.value;
    const hasSameParent = node?.parameters?.macroParams?._parentId?.value === contentId;
    return (0, $kRAnY.is2PBodiedExtension)({
        extensionKey: extensionKey,
        extensionType: node.type
    }) && hasParent && !!contentId && !hasSameParent;
}
function $b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(props) {
    const { extensionKey: extensionKey } = props;
    return Boolean(!(0, $ld6xp.canUseMultiMacroQuery)(extensionKey, $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension(props)) || $b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView(props));
}
class $b65e5cf2eec587a5$export$a7d233751dc2a8c9 extends (0, $cozmU.Component) {
    componentDidMount() {
        this.setMacroData();
        this.setUFOEventMacroDisplayStatus();
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.contentId !== nextProps.contentId || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.props?.node?.parameters, nextProps?.node?.parameters) || (nextProps.references || this.props.references) && this.props.references !== nextProps.references || this.state.hasBodyBeenFetched !== nextState.hasBodyBeenFetched || this.state.body !== nextState.body;
    }
    componentDidUpdate() {
        this.setMacroData();
    }
    componentWillUnmount() {
        const { node: node, mode: mode, contentId: contentId } = this.props;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        (0, $5kjCz.stopJIRAMacro)(mode, contentId, name, attributes);
    }
    /**
   * Parses the rich text macro's body and sets the state with it.
   */ async setRichTextMacroBody() {
        const { contentId: contentId, node: node } = this.props;
        // Get the ADF content of the node
        const content = node?.content || [];
        try {
            // Unfortunately, vendor add ons expect storage format. We need to convert
            // the ADF to the appropriate format.
            let body;
            // only use conversion query in two scenarios
            //   1. if not using macros query where body storage format is already provided.
            //   2. If macro is using in editor renderer view, we need to update the body for this singular macro
            //      using the multi macro query would refetch for all macros on the page, re-rendering them all.
            if ($b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(this.props)) body = await $b65e5cf2eec587a5$var$convertADFContentToStorageQuery(contentId, content);
            this.setState({
                body: body,
                hasBodyBeenFetched: true
            });
        } catch (error) {
            this.logger.error`${error}`; //tslint:disable-line
        }
    }
    /**
   * Parses the plain text macro's body and sets the state with it.
   *
   * Even though it's plain text, we don't actually need to set state. This
   * could be done in the renderer, but because we're converting rich text
   * macro's body to storage format, the mechanism for passing in the body is
   * `this.setState`. This will change in the future if we start passing
   * adf in our `getMacroBody` calls (and then this can be cleaned up).
   */ setPlainTextMacroBody() {
        const { node: node } = this.props;
        const body = node?.parameters?.macroParams?.__bodyContent?.value || '';
        this.setState({
            body: body,
            hasBodyBeenFetched: true
        });
    }
    setMacroData() {
        const { node: node } = this.props;
        // 1. Node is null, which means we won't render anything.
        // 2. If macro is using in editor renderer view, we need to refetch the body on update
        //    because the parameters might have changed due to user interaction in the macros edit mode.
        if (!node || $b65e5cf2eec587a5$var$isRichTextMacro(node) && this.state.hasBodyBeenFetched && !$b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView(this.props)) return;
        if ($b65e5cf2eec587a5$var$isPlainTextMacro(node)) this.setPlainTextMacroBody();
        else if ($b65e5cf2eec587a5$var$isRichTextMacro(node)) this.setRichTextMacroBody();
        else // It's neither, so just render the component
        this.setState({
            hasBodyBeenFetched: true
        });
    }
    setUFOEventMacroDisplayStatus() {
        const extensionKey = this.props.extensionKey;
        if (!extensionKey) return;
        const parts = extensionKey.split('-');
        const pascalCaseString = parts.map((part)=>{
            if (part.length === 0) return '';
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        }).join('');
        (0, $gXfti.addUFOCustomData)({
            [`is${pascalCaseString}MacroDisplayed`]: true
        });
    }
    // Use parent id if the macro source is different than the current page.
    // Critical for having the include-page macro load properly
    getContentId(adf, contentId) {
        const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
        return parentId || contentId;
    }
    render() {
        const mode = window.location.pathname.startsWith('/wiki/pdf/') ? 'pdf' : this.props.mode;
        const { hasBodyBeenFetched: hasBodyBeenFetched } = this.state;
        const node = this.props.node;
        if (!node) return null;
        if (!hasBodyBeenFetched) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
            node: node
        });
        const adf = (0, $6mEZ3.extensionToADF)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $euF5O.LegacyMacroRendererContext).Consumer, null, ({ shouldRefetchMacroQuery: shouldRefetchMacroQuery })=>// In edit mode the editor renders this component outside of the main app, therefore
            // the Apollo client has to be provided here too
            // only use the multi macro query if this macro is not inside another, such as a page include
            // since that means it will not have been fetched by the multi macro query
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3KymM.ApolloProvider), {
                client: (0, $hp2SH.getApolloClient)()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
                value: (0, $fGzMp.getExperienceTracker)()
            }, this.determineQuery({
                ...this.props,
                mode: mode,
                adf: adf,
                shouldRefetchMacroQuery: shouldRefetchMacroQuery
            }))));
    }
    constructor(_props){
        super(_props);
        this.logger = (0, $7W8i8.getLogger)('LegacyMacroRendererQuery');
        /**
     * Return a query for both contentRenderer and macroBodyRenderer.
     */ this.getQueryForMacroContentAndBodyForPossibleFrontendRendering = ({ adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, shouldRefetchMacroQuery: shouldRefetchMacroQuery, noOverlay: noOverlay, isPreviewMode: isPreviewMode })=>{
            const renderPageIncludeError = (pageTitle)=>{
                return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: "error"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $71fb7e5ab8464496$export$a7357cdd1f0b0168).highlightedPageIncludeRenderedError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $71fb7e5ab8464496$export$a7357cdd1f0b0168).nonhighlightedPageIncludeRenderedError,
                    values: {
                        pageTitle: pageTitle
                    }
                })));
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $eqB7W.default),
                variables: {
                    adf: (0, $gHCIk.serializeExtensionADF)(adf),
                    // The template editor passes a "0" as contentId by default,
                    // in this scenario we do NOT want to pass a contentId at all into the query.
                    // Not passing the correct contentId can make some macros fail to load
                    ...contentId !== '0' ? {
                        contentId: this.getContentId(adf, contentId)
                    } : {},
                    mode: mode && mode.toUpperCase()
                },
                // Used when multiple instances of PageContentRenderer cause conflicting IDs in macroRenderedOutput. This forces
                // a refetch when rendering subsequent PageContentRenderer instances so that a new ID is present in
                // macroRenderedOutput. 'cache-first' is Apollo's default fetchPolicy.
                fetchPolicy: shouldRefetchMacroQuery ? 'no-cache' : 'cache-first',
                // Some macros take a long time to render, they should not hold up the rendering of other things
                context: {
                    throttle: true,
                    allowOnExternalPage: true
                },
                skip: Boolean(macroRenderedOutputFromSSR) || Boolean(macroOutput),
                __callerPackage__: "fabric-extension-legacy-macro-renderer"
            }, ({ data: data, loading: loading, error: error })=>{
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRenderedOutput: data?.macroBodyRenderer?.value,
                    macroRepresentation: data?.macroBodyRenderer?.representation || 'view',
                    mediaToken: data?.macroBodyRenderer?.mediaToken?.token,
                    node: node,
                    webresource: data?.macroBodyRenderer?.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode,
                    isConnectMacro: this.props.isConnectMacro
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    showSpinner: !!data,
                    node: node
                });
                if (error || !data || !data.macroBodyRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd422ab26f8348d3$export$99a6d9338f38339e), {
                    error: error,
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // Make it possible to execute AC JS functions locally.
                // The hostOrigin should match browser host
                let macroRenderedOutput = data.macroBodyRenderer?.value;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ff9e0546f2c245a$export$1b5865c105cfe12d).Consumer, null, ({ listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes })=>{
                    const { isCircularRef: isCircularRef, prevPageTitle: prevPageTitle } = $b65e5cf2eec587a5$export$ddad0aee336d9e1(listOfRenderedPageIncludeNodes);
                    if (isCircularRef) return renderPageIncludeError(prevPageTitle);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b65e5cf2eec587a5$var$PageIncludeContextProvider, {
                        contentId: contentId,
                        node: this.props.node,
                        listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                        contentId: contentId,
                        experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                        adf: adf,
                        attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                        references: references,
                        multiBodiedExtensionActions: multiBodiedExtensionActions,
                        macroRenderedOutput: macroRenderedOutput,
                        macroRepresentation: data.macroBodyRenderer?.representation || 'view',
                        mediaToken: data?.macroBodyRenderer?.mediaToken?.token,
                        node: node,
                        webresource: data.macroBodyRenderer?.webResourceDependencies,
                        mode: mode,
                        body: this.state.body,
                        parameters: (0, $6mEZ3.getParametersString)(node),
                        featureFlags: featureFlags,
                        spaceKey: spaceKey,
                        noOverlay: noOverlay,
                        isPreviewMode: isPreviewMode,
                        isConnectMacro: this.props.isConnectMacro
                    }));
                });
            });
        };
        this.getQueryForMacroContentFromBackend = ({ adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, shouldRefetchMacroQuery: shouldRefetchMacroQuery, noOverlay: noOverlay, isPreviewMode: isPreviewMode })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $b1ypt.default),
                variables: {
                    adf: (0, $gHCIk.serializeExtensionADF)(adf),
                    contentId: contentId,
                    mode: mode && mode.toUpperCase()
                },
                // Used when multiple instances of PageContentRenderer cause conflicting IDs in macroRenderedOutput. This forces
                // a refetch when rendering subsequent PageContentRenderer instances so that a new ID is present in
                // macroRenderedOutput. 'cache-first' is Apollo's default fetchPolicy.
                fetchPolicy: shouldRefetchMacroQuery ? 'no-cache' : 'cache-first',
                // Some macros take a long time to render, they should not hold up the rendering of other things
                context: {
                    throttle: true,
                    allowOnExternalPage: true
                },
                skip: Boolean(macroRenderedOutputFromSSR) || Boolean(macroOutput),
                __callerPackage__: "fabric-extension-legacy-macro-renderer"
            }, ({ data: data, loading: loading, error: error })=>{
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: data?.contentRenderer?.html,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: "view",
                    webresource: data?.contentRenderer?.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode,
                    isConnectMacro: this.props.isConnectMacro
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    showSpinner: !!data,
                    node: node
                });
                if (error || !data || !data.contentRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd422ab26f8348d3$export$99a6d9338f38339e), {
                    error: error,
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // Make it possible to execute AC JS functions locally.
                // The hostOrigin should match browser host
                let contentRenderedHtml = data.contentRenderer.html;
                // assume we have data here
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: contentRenderedHtml,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: "view",
                    webresource: data.contentRenderer.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode,
                    isConnectMacro: this.props.isConnectMacro
                });
            });
        };
        this.getQueryForMacros = (args)=>{
            const { adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, noOverlay: noOverlay, isConnectMacro: isConnectMacro } = args;
            const macroId = node.parameters?.macroMetadata?.macroId?.value;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKSlH.MultiMacroQuerySubscriber), {
                contentId: contentId,
                macroId: macroId
            }, ({ renderedMacro: renderedMacro, loading: loading, error: error, complete: complete })=>{
                // if the multi macro query is complete and there were no errors
                // that means we are inserting a new macro in the editor or have
                // just published the page in which case the new macro data
                // will not be available on the backend to render yet so use
                // the old queries to render instead
                if (complete && !renderedMacro && !error) return this.determineQuery(args, true);
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: renderedMacro?.value,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: renderedMacro?.macroRenderedRepresentation || 'view',
                    webresource: renderedMacro?.webResource,
                    mode: mode,
                    body: renderedMacro?.macroBodyStorage || this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    noOverlay: noOverlay,
                    mediaToken: renderedMacro?.mediaToken?.token,
                    appKey: renderedMacro?.appKey,
                    isConnectMacro: isConnectMacro,
                    macroBodyStorage: renderedMacro?.macroBodyStorage ?? null
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    node: node
                });
                if (error || !renderedMacro) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd422ab26f8348d3$export$99a6d9338f38339e), {
                    error: new (0, $422HI.ApolloErrorInterop)({
                        errorMessage: `error rendering legacy macro: {$extensionKey}`
                    }),
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // Make it possible to execute AC JS functions locally.
                // The hostOrigin should match browser host
                const macroRenderedOutput = renderedMacro?.value;
                // assume we have data here
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34a09ee48ab537fd$export$b43db7dd8b06a124), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: macroRenderedOutput,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: renderedMacro?.macroRenderedRepresentation || 'view',
                    webresource: renderedMacro?.webResource,
                    mode: mode,
                    body: renderedMacro?.macroBodyStorage || this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    noOverlay: noOverlay,
                    mediaToken: renderedMacro?.mediaToken?.token,
                    appKey: renderedMacro?.appKey,
                    isConnectMacro: isConnectMacro,
                    macroBodyStorage: renderedMacro?.macroBodyStorage ?? null
                });
            });
        };
        this.getReferencedContentId = (node)=>{
            return node?.parameters?.macroParams?._referencedContentId?.value || undefined;
        };
        this.determineQuery = (props, doNotUseMultiMacro = false)=>{
            const { extensionKey: extensionKey, node: node } = props;
            if (!doNotUseMultiMacro && (!node?.parameters?.macroParams?._parentId || node.parameters.macroParams._parentId.value === this.props.contentId) && (0, $ld6xp.canUseMultiMacroQuery)(extensionKey, $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension(props))) return this.getQueryForMacros(props);
            const editorMacroADFRendering = (0, $1xpoY.default).getBoolean('confluence_frontend_macro_adf_frontend_render', true);
            return editorMacroADFRendering ? this.getQueryForMacroContentAndBodyForPossibleFrontendRendering(props) : this.getQueryForMacroContentFromBackend(props);
        };
        const state = {
            body: '',
            hasBodyBeenFetched: false
        };
        // Check condition upfront to avoid unnecessary state updates
        // Otherwise it will make component to always render the shadow which breaks SSR result
        // Basically repeat of setMacroData logic for the initial render
        const { node: _node } = _props;
        if ($b65e5cf2eec587a5$var$isPlainTextMacro(_node)) {
            state.body = _node?.parameters?.macroParams?.__bodyContent?.value || '';
            state.hasBodyBeenFetched = true;
        } else if ($b65e5cf2eec587a5$var$isRichTextMacro(_node)) {
            if (!$b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(_props)) state.hasBodyBeenFetched = true;
        } else state.hasBodyBeenFetched = true;
        this.state = state;
    }
}
const $b65e5cf2eec587a5$export$ddad0aee336d9e1 = (listOfRenderedPageIncludeNodes)=>{
    if (listOfRenderedPageIncludeNodes?.length) {
        // Keep reference so that we can render the previous page title in error message
        let prevRenderedNode;
        const pageIncludeNodeIds = new Set();
        let pageIncludeNodeAlreadyRendered = false;
        for (const pageIncludeNode of listOfRenderedPageIncludeNodes){
            if (pageIncludeNode?.extensionKey !== 'include') continue;
            prevRenderedNode = pageIncludeNode;
            const id = pageIncludeNode?.parameters?.macroMetadata?.macroId?.value;
            if (id) {
                if (pageIncludeNodeIds.has(id)) {
                    pageIncludeNodeAlreadyRendered = true;
                    break;
                } else pageIncludeNodeIds.add(id);
            }
        }
        // indicate that this page has already been included, to avoid infinite loop
        if (pageIncludeNodeAlreadyRendered) {
            const prevReferencedNodePageTitle = prevRenderedNode?.parameters?.macroParams?.['']?.value;
            return {
                isCircularRef: true,
                prevPageTitle: prevReferencedNodePageTitle
            };
        }
    }
    return {
        isCircularRef: false,
        prevPageTitle: null
    };
};
const $b65e5cf2eec587a5$var$PageIncludeContextProvider = ({ contentId: contentId, node: node, listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes, children: children })=>{
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const renderedPageIncludeNodes = [
            ...listOfRenderedPageIncludeNodes,
            {
                ...node,
                parentContentId: contentId
            }
        ];
        return {
            listOfRenderedPageIncludeNodes: renderedPageIncludeNodes
        };
    }, [
        listOfRenderedPageIncludeNodes,
        node,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ff9e0546f2c245a$export$1b5865c105cfe12d).Provider, {
        value: contextValue
    }, children);
};
const $b65e5cf2eec587a5$export$1609bcb5ce6c9dd9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b65e5cf2eec587a5$export$a7d233751dc2a8c9, {
        featureFlags: featureFlags,
        ...props
    });
}, (prevProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevProps, nextProps));
const $b65e5cf2eec587a5$export$c0b18e27c7eefe80 = (0, $3dbf040db5bfac2c$export$437fb41b7a687949)($b65e5cf2eec587a5$export$1609bcb5ce6c9dd9, 10000);
module.exports["LegacyMacroRendererQuery"] = $b65e5cf2eec587a5$export$1609bcb5ce6c9dd9;
module.exports["DebouncedLegacyMacroRendererQuery"] = $b65e5cf2eec587a5$export$c0b18e27c7eefe80;

});

parcelRegister("kRAnY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j0gZR = parcelRequire("j0gZR");

const $ecf08ec6a3fe0bb1$export$3edb28f707c97620 = ({ extensionKey: extensionKey, extensionType: extensionType })=>(0, $j0gZR.is1PMacro)(extensionKey || '') && extensionType === 'bodiedExtension';
const $ecf08ec6a3fe0bb1$export$99128e639bf2cee5 = ({ extensionKey: extensionKey, extensionType: extensionType })=>!(0, $j0gZR.is1PMacro)(extensionKey || '') && extensionType === 'bodiedExtension';
const $ecf08ec6a3fe0bb1$export$8166325a9a095a58 = ({ getExtensionHandlers: getExtensionHandlers, isLivePage: isLivePage, contentId: contentId, spaceKey: spaceKey, getHeadingLinkPath: getHeadingLinkPath })=>{
    return (0, $cozmU.useMemo)(()=>{
        if (isLivePage) return {
            rendererExtensionHandlers: getExtensionHandlers?.({
                contentId: contentId,
                spaceKey: spaceKey,
                isInEditorRendererView: true,
                getHeadingLinkPath: getHeadingLinkPath
            }),
            isAllowedToUseRendererView: (node)=>{
                return $ecf08ec6a3fe0bb1$export$99128e639bf2cee5({
                    extensionKey: node.attrs?.extensionKey,
                    extensionType: node.type
                });
            },
            showUpdated1PBodiedExtensionUI: (node)=>$ecf08ec6a3fe0bb1$export$3edb28f707c97620({
                    extensionKey: node.attrs?.extensionKey,
                    extensionType: node.type
                })
        };
        return undefined;
    }, [
        getExtensionHandlers,
        isLivePage,
        contentId,
        spaceKey,
        getHeadingLinkPath
    ]);
};
module.exports["is2PBodiedExtension"] = $ecf08ec6a3fe0bb1$export$99128e639bf2cee5;
module.exports["useExtensionRendererViewOptions"] = $ecf08ec6a3fe0bb1$export$8166325a9a095a58;

});

parcelRegister("j0gZR", function(module, exports) {
const $fa4d787503d7b919$export$1bf1a639d38d3f44 = (macro)=>$fa4d787503d7b919$export$4b1d56e1a5f9d339.has(macro);
const $fa4d787503d7b919$export$4b1d56e1a5f9d339 = new Set([
    'toc',
    'children',
    'livesearch',
    'recently-updated',
    'details',
    'jlol',
    'jira',
    'pagetree',
    'anchor',
    'contentbylabel',
    'create-from-template',
    'roadmap',
    'blog-posts',
    'excerpt',
    'attachments',
    'profile',
    'include',
    'content-report-table',
    'detailssummary',
    'tasks-report-macro',
    'excerpt-include',
    'iframe',
    'listlabels',
    'profile-picture',
    'change-history',
    'pagetreesearch',
    'widget',
    'decisionreport',
    'viewpdf',
    'contributors',
    'gadget',
    'popular-labels',
    'jirachart',
    'toc-zone',
    'portfolioforjiraplan',
    'viewppt',
    'viewxls',
    'recently-updated-dashboard',
    'spaces',
    'index',
    'contributors-summary',
    'userlister',
    'gallery',
    'viewdoc',
    'chart',
    'related-labels',
    'jiraroadmap'
]);
module.exports["is1PMacro"] = $fa4d787503d7b919$export$1bf1a639d38d3f44;

});

parcelRegister("iKSlH", function(module, exports) {

var $gK2Sc = parcelRequire("gK2Sc");

/**
 * @generated SignedSource<<6e1586c45e5cfa5394ebc0a3a30e26da>>
 * @relayHash f977fe563881123805a0fdb63471bdfa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3a8e0682af7b65b3defbbd85315673efaf3793b23993ee9a16f2a5ced09f39ae
const $dc9c06a2dbe8ab9b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blocklist"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": "RENDERER",
        "kind": "LocalArgument",
        "name": "mode"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "refetchToken"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ], v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "blocklist",
                    "variableName": "blocklist"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "refetchToken",
                    "variableName": "refetchToken"
                }
            ],
            "concreteType": "MacroConnection",
            "kind": "LinkedField",
            "name": "macros",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfoV2",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Macro",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "macroId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "mode",
                                    "variableName": "mode"
                                }
                            ],
                            "concreteType": "RenderedMacro",
                            "kind": "LinkedField",
                            "name": "renderedMacro",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "macroRenderedRepresentation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "macroBodyStorage"
                                },
                                {
                                    "concreteType": "WebResourceDependenciesV2",
                                    "kind": "LinkedField",
                                    "name": "webResource",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "contexts"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "keys"
                                        },
                                        {
                                            "concreteType": "SuperBatchWebResourcesV2",
                                            "kind": "LinkedField",
                                            "name": "superbatch",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "metatags"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "WebResourceTagsV2",
                                            "kind": "LinkedField",
                                            "name": "tags",
                                            "plural": false,
                                            "selections": v6 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "WebResourceUrisV2",
                                            "kind": "LinkedField",
                                            "name": "uris",
                                            "plural": false,
                                            "selections": v6 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "EmbeddedMediaTokenV2",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "multiMacroQueryQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "multiMacroQueryQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "f977fe563881123805a0fdb63471bdfa",
            "id": "3a8e0682af7b65b3defbbd85315673efaf3793b23993ee9a16f2a5ced09f39ae",
            "metadata": {},
            "name": "multiMacroQueryQuery",
            "operationKind": "query",
            "text": "query multiMacroQueryQuery($contentId:ID!,$mode:MacroRendererMode=RENDERER,$blocklist:[String!],$first:Int,$after:String,$refetchToken:String)@allowHigherTimeout{macros(contentId:$contentId,blocklist:$blocklist,first:$first,after:$after,refetchToken:$refetchToken){pageInfo{hasNextPage,endCursor},nodes{macroId,contentId,renderedMacro(mode:$mode){appKey,value,macroRenderedRepresentation,macroBodyStorage,webResource{contexts,keys,superbatch{metatags},tags{css,data,js},uris{css,data,js}},mediaToken{token}}}}}"
        }
    };
}();
$dc9c06a2dbe8ab9b$var$node.hash = "703def250fb7190af954448ab635f2f2";
var $dc9c06a2dbe8ab9b$export$2e2bcd8739ae039 = $dc9c06a2dbe8ab9b$var$node;



var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");


var $9wGTI = parcelRequire("9wGTI");


var $5ZqQS = parcelRequire("5ZqQS");


var $c0rhi = parcelRequire("c0rhi");


var $ld6xp = parcelRequire("ld6xp");

const $45c36e8dcd65ba05$export$cab5f498ed530ce4 = (0, $dc9c06a2dbe8ab9b$export$2e2bcd8739ae039);
const $45c36e8dcd65ba05$export$47b47cc5b34ab476 = (0, $gK2Sc.default);
const $45c36e8dcd65ba05$var$DEFAULT_PRELOAD_PAGE_SIZE = 8;
const $45c36e8dcd65ba05$var$DEFAULT_PAGE_SIZE = 10;
const $45c36e8dcd65ba05$var$NIL_UUID = '00000000-0000-0000-0000-000000000000';
const $45c36e8dcd65ba05$var$DEFAULT_STATIC_PRELOAD_PAGE_SIZE = 8;
const $45c36e8dcd65ba05$var$MAX_STATIC_PAGE_SIZE = 100;
function $45c36e8dcd65ba05$export$98e55c786cb77762(pagesFetched) {
    if (pagesFetched === 0) return $45c36e8dcd65ba05$var$DEFAULT_STATIC_PRELOAD_PAGE_SIZE;
    const size = Math.round($45c36e8dcd65ba05$var$DEFAULT_PAGE_SIZE * Math.pow(1.5, pagesFetched - 1));
    return Math.min(size, $45c36e8dcd65ba05$var$MAX_STATIC_PAGE_SIZE);
}
const $45c36e8dcd65ba05$var$actions = {
    queryMacros: ({ contentId: contentId, cloudId: cloudId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, staticCursor: staticCursor, revision: revision, useServerRenderedData: useServerRenderedData = false, readFragmentInterop: readFragmentInterop })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            // avoid querying if required variables are not yet available
            if (!contentId) return;
            // avoid querying if already in progress
            if (getState().contentId === contentId && getState().revision === revision && getState().cursor === cursor && getState().staticCursor === staticCursor) return;
            let mode = contentRendererMode.toUpperCase();
            mode = window.location.pathname.startsWith('/wiki/pdf/') ? 'PDF' : mode;
            setState({
                contentId: contentId,
                cloudId: cloudId || $45c36e8dcd65ba05$var$NIL_UUID,
                mode: mode,
                revision: revision,
                cursor: cursor,
                staticCursor: staticCursor,
                // Once complete is true (all regular macros fetched), don't flip it back to false
                // just because we're still paginating static macros.
                ...getState().complete ? {} : {
                    complete: false
                }
            });
            const selectedQuery = $45c36e8dcd65ba05$export$47b47cc5b34ab476;
            const queryVariables = {
                contentId: contentId,
                cloudId: cloudId || $45c36e8dcd65ba05$var$NIL_UUID,
                mode: mode,
                blocklist: (0, $ld6xp.getEffectiveMultiMacroQueryBlocklist)(),
                first: !cursor ? $45c36e8dcd65ba05$var$DEFAULT_PRELOAD_PAGE_SIZE : $45c36e8dcd65ba05$var$DEFAULT_PAGE_SIZE,
                after: cursor,
                staticFirst: $45c36e8dcd65ba05$export$98e55c786cb77762(getState().staticPagesFetched),
                staticAfter: staticCursor
            };
            /**
     * Publishes regular-macro results into the content/macro lookup used by renderers.
     * Results are merged because they can arrive in stages: SSR-cached data may be
     * published before a pending query completes, and later pages add more macros. The
     * early merge also keeps nested LCM hydration backed by the same data as the server.
     */ const mergeMacroData = (nodes = [])=>{
                const macros = (nodes ?? []).reduce((nodeMap, node)=>{
                    if (node) {
                        const key = $45c36e8dcd65ba05$var$getMacrosCacheKey(node.contentId || '', node.macroId || '');
                        nodeMap[key] = node.renderedMacro;
                    }
                    return nodeMap;
                }, {});
                setState({
                    macroData: {
                        ...getState().macroData,
                        ...macros
                    }
                });
            };
            // don't include revision if in SSR otherwise it will cause a cache miss between
            // SSR preload where revision is unknown and SSR render when this action is called
            if (!useServerRenderedData) queryVariables.refetchToken = revision;
            let data;
            {
                const shouldUseServerRenderedData = useServerRenderedData && !getState().cursor;
                if (shouldUseServerRenderedData) try {
                    data = readFragmentInterop({
                        id: `$ROOT_QUERY.macros(${JSON.stringify({
                            ...cursor ? {
                                after: cursor
                            } : {},
                            blocklist: queryVariables.blocklist,
                            contentId: contentId,
                            first: queryVariables.first
                        })})`
                    });
                    // have fragment take on same shape as query result
                    if (data) data = {
                        macros: data
                    };
                } catch (e) {
                    //do not report error when query returns empty result in SSR
                    if (e?.message && !e?.message.includes('Invariant Violation: 8')) (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                        attribution: 'backbone'
                    });
                }
                const needsStaticMacrosFetch = (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp') && !data?.staticMacros;
                if (!data || !data?.macros || !shouldUseServerRenderedData || needsStaticMacrosFetch) {
                    // Publish synchronously preloaded regular macros before waiting for any additional
                    // static-macro data so the first client render matches the server-rendered HTML.
                    if (data?.macros && (0, $9wGTI.fg)('confluence_lcm_ssr_nested')) mergeMacroData(data.macros.nodes);
                    const result = await (0, $c0rhi.queryInterop)({
                        query: selectedQuery,
                        variables: queryVariables,
                        context: {
                            allowOnExternalPage: true
                        },
                        __callerPackage__: "fabric-extension-queries"
                    });
                    if (result.error) {
                        (0, $5ZqQS.getMonitoringClient)().submitError(result.error, {
                            attribution: 'backbone'
                        });
                        setState({
                            error: true
                        });
                    }
                    data = result.data;
                }
            }
            const { nodes: nodes = [], pageInfo: pageInfo = {} } = data?.macros;
            mergeMacroData(nodes);
            if ((0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) {
                const { nodes: staticNodes = [], pageInfo: staticPageInfo } = data?.staticMacros ?? {};
                const staticMacros = staticNodes?.reduce((nodeMap, node)=>{
                    if (node?.macroId) nodeMap[node.macroId] = {
                        ...node,
                        localId: node.macroId
                    };
                    return nodeMap;
                }, {});
                const nextStaticPagesFetched = getState().staticPagesFetched + 1;
                setState({
                    staticMacroData: {
                        ...getState().staticMacroData,
                        ...staticMacros
                    },
                    staticPagesFetched: nextStaticPagesFetched
                });
                const regularHasNextPage = pageInfo.hasNextPage;
                const staticHasNextPage = !!staticPageInfo?.hasNextPage;
                if (!regularHasNextPage && !staticHasNextPage) setState({
                    complete: true,
                    staticMacrosComplete: true
                });
                else {
                    if (!regularHasNextPage) setState({
                        complete: true
                    });
                    if (!staticHasNextPage) setState({
                        staticMacrosComplete: true
                    });
                }
                // Fire a single dispatch covering whichever cursors need to advance,
                // avoiding two concurrent dispatches when both lists have more pages.
                if (regularHasNextPage || staticHasNextPage) dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                    contentId: contentId,
                    cloudId: cloudId,
                    contentRendererMode: contentRendererMode,
                    featureFlags: featureFlags,
                    cursor: regularHasNextPage ? pageInfo.endCursor : cursor,
                    staticCursor: staticHasNextPage ? staticPageInfo?.endCursor : staticCursor,
                    revision: revision,
                    readFragmentInterop: readFragmentInterop
                }));
            } else if (pageInfo.hasNextPage) dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                cloudId: cloudId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: pageInfo.endCursor,
                staticCursor: staticCursor,
                revision: revision,
                readFragmentInterop: readFragmentInterop
            }));
            else setState({
                complete: true
            });
        },
    //only for testing
    resetState: ()=>({ setState: setState })=>{
            setState({
                complete: false,
                data: {},
                macroData: {},
                error: false,
                contentId: undefined,
                revision: undefined,
                cursor: undefined,
                staticMacroData: {},
                staticMacrosComplete: false,
                staticCursor: undefined,
                staticPagesFetched: 0
            });
        }
};
const $45c36e8dcd65ba05$var$store = (0, $8s9DV.createStore)({
    initialState: {
        complete: false,
        data: {},
        macroData: {},
        readFragmentInterop: ()=>null,
        staticMacroData: {},
        staticMacrosComplete: false,
        staticPagesFetched: 0
    },
    actions: $45c36e8dcd65ba05$var$actions,
    name: 'MultiMacroQueryStore'
});
const $45c36e8dcd65ba05$export$ad5695738c93511d = (0, $j8on0.createContainer)($45c36e8dcd65ba05$var$store, {
    onInit: ()=>({ dispatch: dispatch }, { contentId: contentId, cloudId: cloudId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, revision: revision, useServerRenderedData: useServerRenderedData, readFragmentInterop: readFragmentInterop })=>{
            dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                cloudId: cloudId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: cursor,
                staticCursor: undefined,
                revision: revision,
                useServerRenderedData: useServerRenderedData,
                readFragmentInterop: readFragmentInterop
            }));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { contentId: contentId, cloudId: cloudId, contentRendererMode: contentRendererMode, featureFlags: featureFlags, cursor: cursor, revision: revision, useServerRenderedData: useServerRenderedData, readFragmentInterop: readFragmentInterop })=>{
            dispatch($45c36e8dcd65ba05$var$actions.queryMacros({
                contentId: contentId,
                cloudId: cloudId,
                contentRendererMode: contentRendererMode,
                featureFlags: featureFlags,
                cursor: cursor,
                staticCursor: undefined,
                revision: revision,
                useServerRenderedData: useServerRenderedData,
                readFragmentInterop: readFragmentInterop
            }));
        }
});
function $45c36e8dcd65ba05$var$getMacrosCacheKey(contentId, macroId) {
    return `${contentId}::${macroId ?? 0}`;
}
function $45c36e8dcd65ba05$var$multiMacroQuerySelector(state, params) {
    const key = $45c36e8dcd65ba05$var$getMacrosCacheKey(params.contentId, params.macroId);
    const macroData = state.macroData?.[key];
    return {
        loading: !macroData && !state.complete,
        error: !macroData && state.error,
        renderedMacro: macroData || null,
        complete: state.complete
    };
}
const $45c36e8dcd65ba05$export$f830af87140a4bfc = (0, $kBr4q.createStateHook)($45c36e8dcd65ba05$var$store, {
    selector: $45c36e8dcd65ba05$var$multiMacroQuerySelector
});
const $45c36e8dcd65ba05$export$9c7903e1ca090053 = (0, $5GOpG.createSubscriber)($45c36e8dcd65ba05$var$store, {
    selector: $45c36e8dcd65ba05$var$multiMacroQuerySelector
});
const $45c36e8dcd65ba05$export$6e231e75b8fd307c = (0, $kBr4q.createHook)($45c36e8dcd65ba05$var$store);
module.exports["MultiMacroQueryContainer"] = $45c36e8dcd65ba05$export$ad5695738c93511d;
module.exports["useMultiMacroQuery"] = $45c36e8dcd65ba05$export$f830af87140a4bfc;
module.exports["MultiMacroQuerySubscriber"] = $45c36e8dcd65ba05$export$9c7903e1ca090053;
module.exports["useMultiMacroQueryStoreHook"] = $45c36e8dcd65ba05$export$6e231e75b8fd307c;

});

parcelRegister("itU2t", function(module, exports) {
$parcel$export(module.exports, "DataSourceProvider", () => (parcelRequire("czge2")).DataSourceProvider);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $czge2 = parcelRequire("czge2");


});

parcelRegister("czge2", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
class $7d2de1579d822851$export$83ebb6424014532f {
    createOrUpdate(id, reference) {
        this.dataSources.set(id, reference);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const requestCallback = window.requestIdleCallback || window.requestAnimationFrame;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cancelCallback = window.cancelIdleCallback || window.cancelAnimationFrame;
        // TODO: ED-26962 - refactor if needed - https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/8012/ed-11927-data-source-provider#comment-206010499
        const callbackId = requestCallback(()=>{
            cancelCallback(callbackId);
            this.notifySubscribers(id, reference);
        });
    }
    notifySubscribers(id, reference) {
        if (this.subscriptions.has(id)) this.subscriptions.get(id)?.forEach((callback)=>{
            callback(reference);
        });
    }
    subscribe(id, callback) {
        if (!this.subscriptions.has(id)) this.subscriptions.set(id, new Set());
        this.subscriptions.get(id)?.add(callback);
    }
    unsubscribe(id, callback) {
        if (!this.subscriptions.has(id)) return;
        this.subscriptions.get(id)?.delete(callback);
    }
    delete(id) {
        this.dataSources.delete(id);
        this.notifySubscribers(id, null);
    }
    get(id) {
        return this.dataSources.get(id) || null;
    }
    clear() {
        this.dataSources.clear();
        this.subscriptions.clear();
    }
    constructor(){
        this.subscriptions = new Map();
        this.dataSources = new Map();
    }
}
module.exports["DataSourceProvider"] = $7d2de1579d822851$export$83ebb6424014532f;

});

parcelRegister("jNKuq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6mKj3 = parcelRequire("6mKj3");


var $jibmA = parcelRequire("jibmA");


var $dPJCf = parcelRequire("dPJCf");


var $h0UOA = parcelRequire("h0UOA");

const $c463773fef1d0188$export$ae5e712ee706ec80 = ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    let t0;
    if ($[0] !== matchRoute || $[1] !== push) {
        t0 = (0, $6mKj3.expValEquals)("confluence_legacy_macro_external_links_new_tab", "isEnabled", true) ? (0, $h0UOA.createLinkEventHandler)({
            push: push,
            matchRoute: matchRoute
        }) : undefined;
        $[0] = matchRoute;
        $[1] = push;
        $[2] = t0;
    } else t0 = $[2];
    const eventHandlers = t0;
    const onSetLinkTarget = $c463773fef1d0188$var$_temp;
    let t1;
    if ($[3] !== eventHandlers) {
        t1 = {
            eventHandlers: eventHandlers,
            onSetLinkTarget: onSetLinkTarget
        };
        $[3] = eventHandlers;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
function $c463773fef1d0188$var$_temp(url) {
    return (0, $jibmA.isExternalLink)(url) && (0, $6mKj3.expValEquals)("confluence_legacy_macro_external_links_new_tab", "isEnabled", true) ? "_blank" : undefined;
}
module.exports["useExternalLinkHandlers"] = $c463773fef1d0188$export$ae5e712ee706ec80;

});

parcelRegister("9tVje", function(module, exports) {
/* MacroComponents.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $I7hWB = parcelRequire("I7hWB");


var $9DHhW = parcelRequire("9DHhW");


var $8y86q = parcelRequire("8y86q");


var $jb2gB = parcelRequire("jb2gB");


var $b8pma = parcelRequire("b8pma");


var $6TaGl = parcelRequire("6TaGl");


var $1VhsF = parcelRequire("1VhsF");


var $i1t43 = parcelRequire("i1t43");


var $9wGTI = parcelRequire("9wGTI");


var $7khND = parcelRequire("7khND");


var $eQyFc = parcelRequire("eQyFc");

const $21c776825c39ac3f$var$i18n = (0, $kSwu1.defineMessages)({
    invalidAnchorMacroLabel: {
        id: "fabric-extension-lib.anchor.placeholder.icon-label",
        defaultMessage: "Invalid anchor link"
    },
    deprecatedExtensionPlaceholderTitle: {
        id: "fabric-extension-lib.deprecated-extension-placeholder.title",
        defaultMessage: "Deprecated macro"
    },
    deprecatedExtensionPlaceholderDescription: {
        id: "fabric-extension-lib.deprecated-extension-placeholder.description",
        defaultMessage: "The {macroName} macro is no longer available in Confluence Cloud."
    },
    deprecatedExtensionPlaceholderLink: {
        id: "fabric-extension-lib.deprecated-extension-placeholder.link",
        defaultMessage: "Learn more."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$ItemBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$descriptionStyledSelector = 'description-styled-selector'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$Description = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzZpcK _3138421Y8M",
            __cmplp.className
        ])
    });
});
$21c776825c39ac3f$var$Description.defaultProps = {
    'data-styled-selector': $21c776825c39ac3f$var$descriptionStyledSelector
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21c776825c39ac3f$var$Item = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditor: isEditor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31flfZc _0bjKvDzXzM _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.isEditor ? "_4FKVYENHnM" : "_4FKVYEPgdg",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$InlineItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fmhAQ _4FKVYE7vqC _0bjKvDzXzM _2sNsIg20Hp _3iDTPbccYA _0hPCNLDIqT _4C05in2ADO",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$ItemIcon = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9aYkv.default)(__cmplp.width, "px"),
            "--_8jvb0j": (0, $9aYkv.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _30huDK9r67 _0bjKvDzXzM _2uo31flfZc _39xV027Ovj _0jFU0VuEhg _24h04i2Njc _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _49oNbq7Ovj _3B3jB1uEhg",
            __cmplp.width > 32 ? "_0adFHs5zaO" : "_0adFHs1Y8M",
            __cmplp.className
        ])
    });
});
const $21c776825c39ac3f$var$anchorMacroPlaceholderStyles = null;
const $21c776825c39ac3f$export$860ffd8664f09722 = (macro, testId)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        testId: testId
    });
};
const $21c776825c39ac3f$export$19993a849e770b01 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0KLXruDMqu _39xV02oWWg _0jFU0VSPN1 _24h04i2Njc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8y86q))), {
        label: intl.formatMessage($21c776825c39ac3f$var$i18n.invalidAnchorMacroLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    }));
};
const $21c776825c39ac3f$var$InlineExtensionPlaceholder = ({ macro: macro, description: description })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "inline-extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$InlineItem, {
        "data-testid": "inline-extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$ItemIcon, {
        width: 16,
        height: 16
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$ItemBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, macro.title, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$Description, null, description)))));
};
const $21c776825c39ac3f$export$9aa94f8845c5044a = ({ macro: macro, description: description, isEditor: isEditor })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$Item, {
        isEditor: isEditor,
        "data-testid": "extension-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$ItemIcon, {
        width: 40,
        height: 40
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7khND.MacroIcon), {
        macro: macro,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$ItemBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, macro.title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$Description, null, description))));
};
const $21c776825c39ac3f$export$58aff0a49290c040 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
    id: "confluence-fabric-editor.extension.placeholder.missing-config",
    defaultMessage: "Edit to setup"
});
const $21c776825c39ac3f$var$PlaceholderWithAnalytics = ({ macro: macro, extension: extension, isEditor: isEditor })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useMemo)(()=>{
        if (createAnalyticsEvent) {
            const { extensionKey: extensionKey, extensionType: extensionType, parameters: parameters } = extension;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'macro',
                    actionSubjectId: 'placeholder',
                    source: isEditor ? 'editor' : 'renderer',
                    attributes: {
                        extensionKey: extensionKey,
                        extensionType: extensionType,
                        isMissingRequiredParameters: !!parameters?.macroParams?.isMissingRequiredParameters
                    }
                }
            }).fire();
        } // NOTE: `extension` node changes on resize so can't use it as dependency
    // A deep check can be done using `extension.macroMetadata.macroId` though not needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        macro,
        isEditor
    ]);
    if (macro.macroName === 'anchor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$export$19993a849e770b01, null);
    if ((0, $eQyFc.getExtensionBodyType)(macro) === 'inlineExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$InlineExtensionPlaceholder, {
        macro: macro,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, "(", $21c776825c39ac3f$export$58aff0a49290c040, ")")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$export$9aa94f8845c5044a, {
        isEditor: isEditor,
        macro: macro,
        description: $21c776825c39ac3f$export$58aff0a49290c040
    });
};
const $21c776825c39ac3f$export$267f67275f4dde5c = (macro, extension, isEditor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$PlaceholderWithAnalytics, {
        macro: macro,
        extension: extension,
        isEditor: isEditor
    }));
const $21c776825c39ac3f$export$cefccc00343a8c80 = (macro, type, isLivePage)=>{
    if (type === 'inlineExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$var$InlineExtensionPlaceholder, {
        macro: macro
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21c776825c39ac3f$export$9aa94f8845c5044a, {
        isEditor: true,
        macro: macro,
        description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "confluence-fabric-editor.extension.placeholder.can-not-render-in-live-page-editor",
            defaultMessage: "The results of this element aren\u2019t visible when editing a live doc. Convert this doc to a page and publish it via the <menuIcon></menuIcon> menu to display it fully.",
            values: {
                menuIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        label: "Icon for publish menu"
                    })
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "confluence-fabric-editor.extension.placeholder.can-not-render-in-editor",
            defaultMessage: "The results of this element aren\u2019t visible when editing. Preview the page or publish it to see how it will look."
        })
    }));
};
const $21c776825c39ac3f$var$deprecatedExtensionPlaceholderStyles = null;
const $21c776825c39ac3f$export$a1346a71a86c0a6f = ({ macroName: macroName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning",
        title: formatMessage($21c776825c39ac3f$var$i18n.deprecatedExtensionPlaceholderTitle),
        testId: "deprecated-extension-placeholder"
    }, formatMessage($21c776825c39ac3f$var$i18n.deprecatedExtensionPlaceholderDescription, {
        macroName: macroName
    }), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: "https://community.atlassian.com/forums/Confluence-articles/Deprecating-infrequently-used-macros-in-Confluence-Cloud/ba-p/2981360"
    }, formatMessage($21c776825c39ac3f$var$i18n.deprecatedExtensionPlaceholderLink)))));
};
module.exports["getIconComponent"] = $21c776825c39ac3f$export$860ffd8664f09722;
module.exports["AnchorMacroPlaceholder"] = $21c776825c39ac3f$export$19993a849e770b01;
module.exports["ExtensionPlaceholder"] = $21c776825c39ac3f$export$9aa94f8845c5044a;
module.exports["editToSetupMessage"] = $21c776825c39ac3f$export$58aff0a49290c040;
module.exports["getMissingConfigPlaceholderComponent"] = $21c776825c39ac3f$export$267f67275f4dde5c;
module.exports["getNonRenderablePlaceholderComponent"] = $21c776825c39ac3f$export$cefccc00343a8c80;
module.exports["DeprecatedExtensionPlaceholder"] = $21c776825c39ac3f$export$a1346a71a86c0a6f;

});

parcelRegister("7khND", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ldJ1U = parcelRequire("ldJ1U");


var $f922E = parcelRequire("f922E");


var $6Ec6w = parcelRequire("6Ec6w");


var $5ZtfK = parcelRequire("5ZtfK");


var $EzOZy = parcelRequire("EzOZy");


var $iITVA = parcelRequire("iITVA");


var $g9ioO = parcelRequire("g9ioO");


var $kTb7m = parcelRequire("kTb7m");


var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");




const $af996b54de444f03$var$baseStyles = null;
const $af996b54de444f03$export$e64a53b8ea246fd3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    const t0 = props.label || undefined;
    const t1 = props.label ? "img" : "presentation";
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1rdFvhG6qS _1pp6NdYbGa _39xV02Uofl _0jFU0VUofl _24fbFs98eZ"
        ]);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6",
            y: "7",
            width: "23",
            height: "18",
            rx: "2",
            fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "9",
            y: "10",
            width: "2",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "13",
            y: "10",
            width: "13",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "9",
            y: "15",
            width: "2",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "13",
            y: "15",
            width: "13",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "9",
            y: "20",
            width: "2",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "13",
            y: "20",
            width: "13",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6",
            y: "2",
            width: "23",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "6",
            y: "28",
            width: "23",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3 3.5L2 2.5",
            stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
            strokeLinecap: "round"
        });
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3 3.5L4 2.5",
            stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
            strokeLinecap: "round"
        });
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3.5 29L2.5 30",
            stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
            strokeLinecap: "round"
        });
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3.5 29L2.5 28",
            stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
            strokeLinecap: "round"
        });
        $[0] = t10;
        $[1] = t11;
        $[2] = t12;
        $[3] = t13;
        $[4] = t14;
        $[5] = t15;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else {
        t10 = $[0];
        t11 = $[1];
        t12 = $[2];
        t13 = $[3];
        t14 = $[4];
        t15 = $[5];
        t2 = $[6];
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
        t7 = $[11];
        t8 = $[12];
        t9 = $[13];
    }
    let t16;
    if ($[14] !== t0 || $[15] !== t1) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "child-macro-icon",
            "aria-label": t0,
            role: t1,
            className: t2
        }, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15);
        $[14] = t0;
        $[15] = t1;
        $[16] = t16;
    } else t16 = $[16];
    return t16;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "child-macro-icon",
        "aria-label": props.label || undefined,
        role: props.label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1rdFvhG6qS _1pp6NdYbGa _39xV02Uofl _0jFU0VUofl _24fbFs98eZ"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "6",
        y: "7",
        width: "23",
        height: "18",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "9",
        y: "10",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "13",
        y: "10",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "9",
        y: "15",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "13",
        y: "15",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "9",
        y: "20",
        width: "2",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "13",
        y: "20",
        width: "13",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "6",
        y: "2",
        width: "23",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "6",
        y: "28",
        width: "23",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3 3.5L2 2.5",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3 3.5L4 2.5",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.5 29L2.5 30",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.5 29L2.5 28",
        stroke: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
        strokeLinecap: "round"
    }));














const $2d33a6ba968a8025$var$baseStyles = null;
const $2d33a6ba968a8025$export$23d9ef6647bbd44d = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(13);
    const t0 = props.label || undefined;
    const t1 = props.label ? "img" : "presentation";
    let t10;
    let t11;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1rdFvhG6qS _1pp6NdYbGa _39xV02Uofl _0jFU0VUofl _24fbFs98eZ"
        ]);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "12",
            y: "8",
            width: "22",
            height: "16",
            rx: "2",
            fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15",
            y: "15",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15",
            y: "11",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15",
            y: "4",
            width: "19",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15",
            y: "30",
            width: "19",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15",
            y: "26",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "15",
            y: "19",
            width: "10",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.8965 12.8966C5.85003 12.943 5.81316 12.9981 5.788 13.0588C5.76285 13.1195 5.7499 13.1845 5.7499 13.2501C5.7499 13.3158 5.76285 13.3808 5.788 13.4415C5.81316 13.5021 5.85003 13.5572 5.8965 13.6036L7.793 15.5001H3C2.86739 15.5001 2.74021 15.5528 2.64645 15.6466C2.55268 15.7404 2.5 15.8675 2.5 16.0001C2.5 16.1328 2.55268 16.2599 2.64645 16.3537C2.74021 16.4475 2.86739 16.5001 3 16.5001H7.793L5.8965 18.3966C5.85003 18.443 5.81316 18.4981 5.788 18.5588C5.76285 18.6195 5.7499 18.6845 5.7499 18.7501C5.7499 18.8158 5.76285 18.8808 5.788 18.9415C5.81316 19.0021 5.85003 19.0572 5.8965 19.1036C6.0915 19.2986 6.4085 19.2986 6.604 19.1036L9.3535 16.3536C9.44405 16.2634 9.49649 16.1419 9.5 16.0141V15.9856C9.49642 15.858 9.44398 15.7367 9.3535 15.6466L6.604 12.8966C6.55756 12.8502 6.50242 12.8133 6.44172 12.7881C6.38102 12.763 6.31596 12.75 6.25025 12.75C6.18454 12.75 6.11948 12.763 6.05878 12.7881C5.99808 12.8133 5.94294 12.8502 5.8965 12.8966V12.8966Z",
            fill: "var(--ds-icon, #292A2E)"
        });
        $[0] = t10;
        $[1] = t11;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
    } else {
        t10 = $[0];
        t11 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
        t8 = $[8];
        t9 = $[9];
    }
    let t12;
    if ($[10] !== t0 || $[11] !== t1) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            viewBox: "0 0 34 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "excerpt-include-macro-icon",
            "aria-label": t0,
            role: t1,
            className: t2
        }, t3, t4, t5, t6, t7, t8, t9, t10, t11);
        $[10] = t0;
        $[11] = t1;
        $[12] = t12;
    } else t12 = $[12];
    return t12;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        viewBox: "0 0 34 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "excerpt-include-macro-icon",
        "aria-label": props.label || undefined,
        role: props.label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1rdFvhG6qS _1pp6NdYbGa _39xV02Uofl _0jFU0VUofl _24fbFs98eZ"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "12",
        y: "8",
        width: "22",
        height: "16",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "15",
        y: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "15",
        y: "11",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "15",
        y: "4",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "15",
        y: "30",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "15",
        y: "26",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "15",
        y: "19",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.8965 12.8966C5.85003 12.943 5.81316 12.9981 5.788 13.0588C5.76285 13.1195 5.7499 13.1845 5.7499 13.2501C5.7499 13.3158 5.76285 13.3808 5.788 13.4415C5.81316 13.5021 5.85003 13.5572 5.8965 13.6036L7.793 15.5001H3C2.86739 15.5001 2.74021 15.5528 2.64645 15.6466C2.55268 15.7404 2.5 15.8675 2.5 16.0001C2.5 16.1328 2.55268 16.2599 2.64645 16.3537C2.74021 16.4475 2.86739 16.5001 3 16.5001H7.793L5.8965 18.3966C5.85003 18.443 5.81316 18.4981 5.788 18.5588C5.76285 18.6195 5.7499 18.6845 5.7499 18.7501C5.7499 18.8158 5.76285 18.8808 5.788 18.9415C5.81316 19.0021 5.85003 19.0572 5.8965 19.1036C6.0915 19.2986 6.4085 19.2986 6.604 19.1036L9.3535 16.3536C9.44405 16.2634 9.49649 16.1419 9.5 16.0141V15.9856C9.49642 15.858 9.44398 15.7367 9.3535 15.6466L6.604 12.8966C6.55756 12.8502 6.50242 12.8133 6.44172 12.7881C6.38102 12.763 6.31596 12.75 6.25025 12.75C6.18454 12.75 6.11948 12.763 6.05878 12.7881C5.99808 12.8133 5.94294 12.8502 5.8965 12.8966V12.8966Z",
        fill: "var(--ds-icon, #292A2E)"
    }));














const $058eb04dbe2ca1ce$var$baseStyles = null;
const $058eb04dbe2ca1ce$export$49f2115fcc129894 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(12);
    const t0 = props.label || undefined;
    const t1 = props.label ? "img" : "presentation";
    let t10;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1rdFvhG6qS _1pp6NdYbGa _39xV02Uofl _0jFU0VUofl _24fbFs98eZ"
        ]);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "5",
            y: "8",
            width: "22",
            height: "16",
            rx: "2",
            fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "8",
            y: "15",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "8",
            y: "11",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "8",
            y: "4",
            width: "19",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "8",
            y: "30",
            width: "19",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "8",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "8",
            y: "26",
            width: "16",
            height: "2",
            rx: "1",
            fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "8",
            y: "19",
            width: "10",
            height: "2",
            rx: "1",
            fill: "var(--ds-link, #1868DB)"
        });
        $[0] = t10;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else {
        t10 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
        t7 = $[6];
        t8 = $[7];
        t9 = $[8];
    }
    let t11;
    if ($[9] !== t0 || $[10] !== t1) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "excerpt-macro-icon",
            "aria-label": t0,
            role: t1,
            className: t2
        }, t3, t4, t5, t6, t7, t8, t9, t10);
        $[9] = t0;
        $[10] = t1;
        $[11] = t11;
    } else t11 = $[11];
    return t11;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "excerpt-macro-icon",
        "aria-label": props.label || undefined,
        role: props.label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1rdFvhG6qS _1pp6NdYbGa _39xV02Uofl _0jFU0VUofl _24fbFs98eZ"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "5",
        y: "8",
        width: "22",
        height: "16",
        rx: "2",
        fill: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "8",
        y: "15",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "8",
        y: "11",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "8",
        y: "4",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "8",
        y: "30",
        width: "19",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "8",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "8",
        y: "26",
        width: "16",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "8",
        y: "19",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-link, #1868DB)"
    }));



var $cb6fO = parcelRequire("cb6fO");

const $efa2272178ef68ba$var$sizeMap = {
    small: 24,
    medium: 32,
    large: 48
};
const $efa2272178ef68ba$var$getSizeInPx = (size)=>$efa2272178ef68ba$var$sizeMap[size];
function $efa2272178ef68ba$export$ead5ed1f51ad51dc({ macro: macro, size: size = 'small', testId: testId }) {
    const { icon: icon, macroName: macroName } = macro;
    switch(macroName){
        case 'children':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af996b54de444f03$export$e64a53b8ea246fd3), {
                label: ""
            });
        case 'excerpt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $058eb04dbe2ca1ce$export$49f2115fcc129894), {
                label: ""
            });
        case 'excerpt-include':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d33a6ba968a8025$export$23d9ef6647bbd44d), {
                label: ""
            });
        case 'recently-updated':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                color: "var(--ds-icon, #292A2E)",
                label: "",
                spacing: "spacious",
                testId: "recently-updated-macro-icon"
            });
        case 'contentbylabel':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($EzOZy))), {
                color: "var(--ds-icon, #292A2E)",
                label: "",
                spacing: "spacious",
                testId: "content-by-label-macro-icon"
            });
        case 'profile-picture':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iITVA))), {
                label: "",
                spacing: "spacious",
                testId: "profile-picture-icon"
            });
        case 'profile':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
                label: "",
                spacing: "spacious",
                testId: "profile-icon"
            });
        case 'toc':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                label: "",
                testId: "toc-icon",
                spacing: "spacious"
            });
        case 'jira':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
                label: "",
                size: "medium",
                "data-testid": testId
            });
        case 'anchor':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "",
                spacing: "spacious",
                testId: "anchor-link-icon"
            });
    }
    if (!icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
        label: "",
        spacing: "spacious",
        testId: "default-icon"
    });
    // connect macros will have absolute urls while others
    // will have relative
    const src = (0, $cb6fO.getContextAwareFullPath)(icon.location, true);
    const sizeInPx = $efa2272178ef68ba$var$getSizeInPx(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: src,
        width: sizeInPx,
        height: sizeInPx,
        alt: "",
        "data-testid": testId
    });
}
const $efa2272178ef68ba$export$6185d2f1146c633c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "4",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$3053c37f1e2867f2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "3.5",
        stroke: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$ae8f25be6d60cbf3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z",
        fill: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9 13.9V16C9 16.5523 9.44772 17 10 17H15C15.5523 17 16 16.5523 16 16V11C16 10.4477 15.5523 10 15 10H12.9C12.5023 11.9591 10.9591 13.5023 9 13.9Z",
        fill: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4 8.99997C4 11.2091 5.79086 13 8 13C10.2091 13 12 11.2091 12 8.99997C12 7.09292 10.6654 5.49757 8.87929 5.09692C8.80495 5.42907 8.69755 5.74873 8.56074 6.05229C9.9496 6.31488 11 7.53476 11 8.99997C11 10.6568 9.65685 12 8 12C6.34315 12 5 10.6568 5 8.99997C5 8.96639 5.00055 8.93293 5.00165 8.89962C4.67803 8.96542 4.34305 8.99997 4 8.99997Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$c4da8a84cd30471c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "10",
        height: "11",
        viewBox: "0 0 10 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.41016 10H4.64062V0.135742H3.41699L0.791992 2.02246V3.32129L3.30078 1.50293H3.41016V10ZM8.22266 10.0684C8.71484 10.0684 9.11133 9.66504 9.11133 9.17969C9.11133 8.6875 8.71484 8.29102 8.22266 8.29102C7.7373 8.29102 7.33398 8.6875 7.33398 9.17969C7.33398 9.66504 7.7373 10.0684 8.22266 10.0684Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$d67733307fd2aff1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "8",
        height: "8",
        rx: "1",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$2be9fd0fc1da44cd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M1.80648 7.77764V9.55542C1.80648 10.2037 2.06826 10.8254 2.53401 11.2837C2.99977 11.7423 3.63154 11.9997 4.2904 11.9997H4.96785V10.6665H4.2904C3.99098 10.6665 3.70384 10.5493 3.49198 10.341C3.28029 10.1327 3.16137 9.85009 3.16137 9.55541V7.77764C3.16011 7.10412 2.87676 6.46084 2.37775 5.99986C2.87674 5.53888 3.16008 4.8956 3.16137 4.22209V2.44431C3.16137 2.14964 3.28029 1.86706 3.49198 1.65873C3.70383 1.45041 3.99097 1.33322 4.2904 1.33322H4.96785V0H4.2904C3.63154 0 2.99977 0.257466 2.53401 0.715975C2.06825 1.17434 1.80648 1.79607 1.80648 2.44431V4.22208C1.80648 4.51675 1.68756 4.79933 1.47587 5.00782C1.26402 5.21615 0.976884 5.33318 0.677452 5.33318H0V6.66656H0.677452C0.976876 6.66656 1.26402 6.78359 1.47587 6.99191C1.68756 7.2004 1.80648 7.48297 1.80648 7.77764Z",
        fill: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.1936 4.2222V2.44443C12.1936 1.79619 11.9318 1.17446 11.4661 0.716097C11.0003 0.257576 10.3685 0.00012207 9.70968 0.00012207H9.03223V1.3335H9.70968V1.33335C10.0091 1.33335 10.2962 1.45053 10.5081 1.65886C10.7198 1.86719 10.8387 2.14976 10.8387 2.44444V4.22221C10.84 4.89573 11.1233 5.53901 11.6223 5.99999C11.1233 6.46097 10.84 7.10425 10.8387 7.77776V9.55554C10.8387 9.85021 10.7198 10.1328 10.5081 10.3411C10.2962 10.5494 10.0091 10.6666 9.70968 10.6666H9.03223V12H9.70968V11.9999C10.3685 11.9999 11.0003 11.7424 11.4661 11.2839C11.9318 10.8255 12.1936 10.2038 12.1936 9.55555V7.77777C12.1936 7.4831 12.3125 7.20052 12.5242 6.99204C12.7361 6.78371 13.0232 6.66668 13.3226 6.66668H14.0001V5.3333H13.3226C13.0232 5.3333 12.7361 5.21627 12.5242 5.00794C12.3125 4.79946 12.1936 4.51688 12.1936 4.2222Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $efa2272178ef68ba$export$4298d94e565d5e99 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "12",
        height: "14",
        viewBox: "0 0 12 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4 1.5H1V12.5H4",
        stroke: "var(--ds-icon, #292A2E)",
        strokeWidth: "1.25"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8 12.5H11L11 1.5H8",
        stroke: "var(--ds-icon, #292A2E)",
        strokeWidth: "1.25"
    }));
const $efa2272178ef68ba$export$2a8d2000f2d39e17 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "2",
        height: "12",
        viewBox: "0 0 2 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("line", {
        x1: "0.625",
        y1: "2.73196e-08",
        x2: "0.624999",
        y2: "12",
        stroke: "var(--ds-icon, #292A2E)",
        strokeWidth: "1.25"
    }));
function $efa2272178ef68ba$export$fae4d9254a21fe54({ icon: icon, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 16,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: 16,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        "data-testId": testId
    }, icon());
}
module.exports["MacroIcon"] = $efa2272178ef68ba$export$ead5ed1f51ad51dc;
module.exports["BulletSVG"] = $efa2272178ef68ba$export$6185d2f1146c633c;
module.exports["CircleSVG"] = $efa2272178ef68ba$export$3053c37f1e2867f2;
module.exports["DiscSVG"] = $efa2272178ef68ba$export$ae8f25be6d60cbf3;
module.exports["NumberedSVG"] = $efa2272178ef68ba$export$c4da8a84cd30471c;
module.exports["SquareSVG"] = $efa2272178ef68ba$export$d67733307fd2aff1;
module.exports["BraceSVG"] = $efa2272178ef68ba$export$2be9fd0fc1da44cd;
module.exports["BracketSVG"] = $efa2272178ef68ba$export$4298d94e565d5e99;
module.exports["PipeSVG"] = $efa2272178ef68ba$export$2a8d2000f2d39e17;
module.exports["DropdownIcon"] = $efa2272178ef68ba$export$fae4d9254a21fe54;

});

parcelRegister("eQyFc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $foRF9 = parcelRequire("foRF9");


var $8pcS0 = parcelRequire("8pcS0");


var $9tVje = parcelRequire("9tVje");


var $e7owm = parcelRequire("e7owm");


var $2E7zk = parcelRequire("2E7zk");

const $60c753854e7a0ebe$export$36f7c0c22d0fa7f7 = (macro)=>macro.alternateId || macro.macroName;
const $60c753854e7a0ebe$export$a508225d9b2c6590 = (macro)=>{
    const { bodyType: bodyType, outputType: outputType } = macro.formDetails.body;
    if (bodyType === 'MULTI_BODY_RICH_TEXT') return 0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE;
    //        none  plain   rich
    // block   ext   ext    body
    // inline  in    in     body
    if (bodyType === 'RICH_TEXT') return 0, $8pcS0.BODIED_EXTENSION_TYPE;
    if (outputType === 'INLINE') return 0, $8pcS0.INLINE_EXTENSION_TYPE;
    return 0, $8pcS0.REGULAR_EXTENSION_TYPE;
};
const $60c753854e7a0ebe$export$4588099541e0954d = (macro)=>{
    return {
        '48': ()=>Promise.resolve(()=>(0, $9tVje.getIconComponent)(macro))
    };
};
const $60c753854e7a0ebe$export$e5e6ffc5fb5056d0 = (macro)=>macro.formDetails && (macro.formDetails.parameters || []).filter((parameter)=>!parameter.hidden) || [];
const $60c753854e7a0ebe$var$hasParameter = (paramName, extension, macro)=>{
    if (extension && extension.parameters && extension.parameters.macroParams) {
        const params = (0, $e7owm.transformParams)('transformBefore', macro, {
            ...extension.parameters.macroParams
        });
        if (paramName in params) {
            let value = params[paramName];
            if (typeof value === 'object' && value !== null && value.hasOwnProperty('value')) value = value.value;
            return (0, $2E7zk.isValueSet)(value);
        }
    }
    return false;
};
const $60c753854e7a0ebe$export$28f78411e8f58606 = (macro, extension)=>macro.formDetails.parameters.some((param)=>param.required && param.defaultValue === null && !param.hidden && !$60c753854e7a0ebe$var$hasParameter(param.name, extension, macro));
const $60c753854e7a0ebe$export$c311b87e097682ae = (macroDefinition, contentId, selectedMacro, intl)=>{
    return (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: {
            name: name,
            body: '',
            params: {},
            ...macroDefinition
        },
        contentId: contentId,
        selectedMacro: selectedMacro,
        intl: intl
    });
};
const $60c753854e7a0ebe$export$40ec622ba9bb94df = (macro)=>{
    switch(macro.macroName){
        case 'pagetree':
            // pagetree is not spa friendly and will only work sometimes
            return false;
        default:
            return true;
    }
};
const $60c753854e7a0ebe$export$34e22dfe340bc2f0 = (macro, excluded = [])=>{
    if (macro.macroName === (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS && (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) // Do not open the legacy macro browser for Team Calendar when the AFM
    // migration is enabled. Macro-browser WRM resources may still load for
    // shared config UI, but updates are saved by wrapping the edited params
    // directly back into ADF instead of round-tripping through the macro browser.
    return false;
    // This is to opt-out a macro quickly from the new experience
    // using the list in `next/packages/editor-features/src/featureFlagsUtils.ts`
    if (excluded.includes(macro.macroName)) return true;
    // Plain text macros are not supported yet
    if (macro.formDetails.body.bodyType === 'PLAIN_TEXT') return true;
    return macro.customConfigEditor;
};
const $60c753854e7a0ebe$export$96720d404c402c6d = (macro)=>{
    // Need to force config for Plain text macros
    if (macro.formDetails.body.bodyType === 'PLAIN_TEXT') return true;
    switch(macro.macroName){
        // CFE-2344: despite not having a required parameter, the children macro should open the macro browser
        // so that the user can select a parent page. Without this, on a brand new page, the children display
        // macro renders a loading state, then completely disappears and looks broken.
        case 'children':
        // CONFDEV-62041: tasks report macro also doesn't have a required parameter, but without any parameters
        // it tries to search the entirety of Confluence for tasks and usually times out, so let's ask for parameters anyway.
        case 'tasks-report-macro':
            // Has issues.
            return true;
        default:
            return macro.customConfigEditor;
    }
};
const $60c753854e7a0ebe$export$b6c9e4779dda4acf = (macro, excludedMacros = [], extension, isEditor)=>// NOTE: Since it's not possible to insert macros without required fields using
    // Macro Browser so there's no point of showing placeholder for them. @see ED-12141
    !$60c753854e7a0ebe$export$34e22dfe340bc2f0(macro, excludedMacros) && // Maintaining the anchor's unique(?) status as a non-rendering-in-publish-view macro
    (isEditor || macro.macroName !== 'anchor') && // Missing required parameters
    $60c753854e7a0ebe$export$28f78411e8f58606(macro, extension);
const $60c753854e7a0ebe$export$d682580434d7a14b = (macro)=>{
    return {
        type: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE,
        key: macro.macroName,
        title: macro.title,
        description: macro.description,
        icons: $60c753854e7a0ebe$export$4588099541e0954d(macro),
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    async preloadRender () {
                    // Intentionally left empty. But the function needs to be defined
                    },
                    renderSync () {
                        return ()=>{
                            const macroTitle = macro.title.replace(' (Deprecated)', '');
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9tVje.DeprecatedExtensionPlaceholder), {
                                macroName: macroTitle
                            });
                        };
                    },
                    async render () {
                        return this.renderSync();
                    }
                }
            }
        }
    };
};
module.exports["safeGetMacroName"] = $60c753854e7a0ebe$export$36f7c0c22d0fa7f7;
module.exports["getExtensionBodyType"] = $60c753854e7a0ebe$export$a508225d9b2c6590;
module.exports["buildIconObject"] = $60c753854e7a0ebe$export$4588099541e0954d;
module.exports["getVisibleParameters"] = $60c753854e7a0ebe$export$e5e6ffc5fb5056d0;
module.exports["isMissingAnyRequiredParameters"] = $60c753854e7a0ebe$export$28f78411e8f58606;
module.exports["prepareMacro"] = $60c753854e7a0ebe$export$c311b87e097682ae;
module.exports["canRenderInTheEditor"] = $60c753854e7a0ebe$export$40ec622ba9bb94df;
module.exports["shouldUseMacroBrowser"] = $60c753854e7a0ebe$export$34e22dfe340bc2f0;
module.exports["needsToForceConfig"] = $60c753854e7a0ebe$export$96720d404c402c6d;
module.exports["shouldShowPlaceholder"] = $60c753854e7a0ebe$export$b6c9e4779dda4acf;

});

parcelRegister("e7owm", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

// These transformers will run for all macros
const $cea6135e7e84bafe$export$6a5670d7122d77e8 = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field.type.name === 'cql' && typeof value === 'string' && value.length) // Required to migrate old macros inserted via Macro Browser since
            // new config doesn't support . [dot] in field name. For more context @see ED-12857
            params[key] = value.replace(/(contributor|creator|mention)\.accountid = /g, '$1 = ');
        });
        return params;
    }
};


const $8af95a90f3d439a2$export$3fb54149990fb5b5 = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            if (field?.type?.name === 'boolean' && params[key] !== undefined) params[key] = params[key] === 'false' ? false : !!params[key];
        });
        return params;
    }
};


const $c7a8c4deae65a41e$export$6a4d6155f720c963 = {
    transformAfter (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            let remove = false;
            if (field && // Ideally required field shouldn't have defaultValue but it's "macro" ¯\_(ツ)_/¯
            !field.required) {
                // Default behavior
                if (field.defaultValue === params[key]) remove = true;
                else if (field.type.name === 'boolean' && (field.defaultValue === 'false' && params[key] === false || field.defaultValue === 'true' && params[key] === true)) remove = true;
                else if (field.type.name === 'string' && field.defaultValue === null && params[key] === '') remove = true;
            }
            if (remove) delete params[key];
        });
        return params;
    }
};


const $12bc2881105e54ac$export$981278bf1b2aa327 = {
    // Transform all empty keys ([""]) to `defaultParameterValue`
    transformBefore (params, metadata) {
        if (params[''] != null) {
            params.defaultParameterValue = params[''];
            metadata.defaultParameterValue = metadata[''];
        }
        return params;
    },
    // Transforming them back to [""] here.
    transformAfter (params, metadata) {
        if (params.defaultParameterValue != null) {
            params[''] = params.defaultParameterValue;
            metadata[''] = metadata.defaultParameterValue;
            delete params.defaultParameterValue;
        }
        return params;
    }
};


const $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX = [
    'username',
    'spacekey',
    'enum',
    'label'
];
const $9fdcf181e9622d09$export$e022d5efa3e02dee = {
    transformBefore (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field?.multiple && value !== undefined && typeof value === 'string' && $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX.includes(field.type.name)) params[key] = value.split(',');
        });
        return params;
    },
    transformAfter (params, metadata) {
        Object.entries(metadata).forEach(([key, field])=>{
            const value = params[key];
            if (field?.multiple && Array.isArray(value) && $9fdcf181e9622d09$var$FIELD_TYPES_TO_FIX.includes(field.type.name)) params[key] = value.join(',');
        });
        return params;
    }
};



var $2E7zk = parcelRequire("2E7zk");

/**
 * There is a transformation on data that is happening for tasks report macro that deletes the combined field of spaceAndPage
 * https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/browse/confluence/next/packages/fabric-extension-lib/src/providers/macros/field-mappings/tasks-report.ts#90
 * This code runs prior to the missingRequiredParameters check at causes the check to fail.
 * To properly check if the field is set we need to check the renamed fields.
 * This check may be used for any other renamed parameters.
 */ const $485f60cc477809b5$var$COMPOUND_FIELD_MAP = {
    spaceAndPage: [
        'space',
        'page'
    ]
};
function $485f60cc477809b5$var$checkValueSet(key, params) {
    if (!$485f60cc477809b5$var$COMPOUND_FIELD_MAP[key]) return (0, $2E7zk.isValueSet)(params[key]);
    return (0, $2E7zk.isValueSet)(params[key]) || $485f60cc477809b5$var$COMPOUND_FIELD_MAP[key].some((subfield)=>(0, $2E7zk.isValueSet)(params[subfield]));
}
const $485f60cc477809b5$export$af7e7c08e5e55c8f = {
    transformAfter (params, metadata) {
        if (Object.entries(metadata).some(([key, field])=>// NOTE: CQL has default value inside `field.options.defaultFields`
            // But it doesn't work now
            field && field.required && field.defaultValue == null && !field.hidden && !$485f60cc477809b5$var$checkValueSet(key, params))) params.isMissingRequiredParameters = true;
        return params;
    }
};


const $35b63f91264cd025$export$d68957b367f91137 = (...transformers)=>({
        transformFields: (fields, pageContext, intl)=>transformers.reduce(async (transformedFields, transformer)=>{
                // We await transformedFields accumulator because transformFields returns a Promise<FieldDefinition[] | DynamicFieldDefinitions>
                const fieldsResult = await transformedFields;
                return transformer.transformFields ? transformer.transformFields({
                    fields: fieldsResult,
                    pageContext: pageContext,
                    intl: intl
                }) // Call transformFields on fields if it exists
                 : transformedFields; // Otherwise, return the original fields with any applied transformations thus far
            }, Promise.resolve(fields)),
        transformBefore: (params, metadata, pageContext)=>transformers.reduce((params, transformer)=>transformer.transformBefore ? transformer.transformBefore(params, metadata, pageContext) : params, params),
        transformAfter: (params, metadata, pageContext)=>transformers.reduce((params, transformer)=>transformer.transformAfter ? transformer.transformAfter(params, metadata, pageContext) : params, params)
    });
const $35b63f91264cd025$export$ba9e5d519bc326ca = $35b63f91264cd025$export$d68957b367f91137((0, $cea6135e7e84bafe$export$6a5670d7122d77e8), (0, $12bc2881105e54ac$export$981278bf1b2aa327), (0, $8af95a90f3d439a2$export$3fb54149990fb5b5), (0, $9fdcf181e9622d09$export$e022d5efa3e02dee), (0, $c7a8c4deae65a41e$export$6a4d6155f720c963), (0, $485f60cc477809b5$export$af7e7c08e5e55c8f));



var $kSwu1 = parcelRequire("kSwu1");




const $b0454047538f87a4$var$i18n = (0, $kSwu1.defineMessages)({
    defaultParameterValueFieldLabel: {
        id: "fabric-extension-lib.anchor.config-panel.name-field.label",
        defaultMessage: "Name"
    },
    defaultParameterValueFieldDescription: {
        id: "fabric-extension-lib.anchor.config-panel.name-field.description",
        defaultMessage: "Give this anchor link a unique name for easy reference."
    }
});
const $b0454047538f87a4$export$2e2992790a6f69a8 = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            if (field.name !== 'defaultParameterValue') return field;
            return {
                ...field,
                type: 'string',
                isRequired: true,
                label: intl.formatMessage($b0454047538f87a4$var$i18n.defaultParameterValueFieldLabel),
                description: intl.formatMessage($b0454047538f87a4$var$i18n.defaultParameterValueFieldDescription)
            };
        });
    },
    // Transforming name that user entered into a valid URI. Not a great experience, need to find a way to inform the user and allow them to pick again.
    transformAfter (params) {
        if (params.defaultParameterValue) {
            // Strip spaces off the beginning and end of the name
            params.defaultParameterValue = params.defaultParameterValue.replace(/^\s+/g, '');
            params.defaultParameterValue = params.defaultParameterValue.replace(/\s+$/g, '');
            // Changing spaces to '-' to match header logic
            params.defaultParameterValue = params.defaultParameterValue.replace(/\s+/g, '-');
            // Stripping out quotes for security (VULN-539679)
            params.defaultParameterValue = params.defaultParameterValue.replace(/["']+/g, '');
            params.defaultParameterValue = params.defaultParameterValue.substr(0, (0, $8pcS0.MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH));
        }
        return params;
    }
};


const $fdf5e213da5d1c5e$export$5ada257c34afac99 = {
    // Converts the "labels" field to be a multi-select
    // which is not supported by the old macro browser
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name !== 'labels') return field;
            return {
                ...field,
                type: 'custom',
                isMultiple: true,
                options: {
                    resolver: {
                        type: 'label'
                    }
                }
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        if (params.labels && typeof params.labels === 'string') params.labels = params.labels.split(',');
        return params;
    },
    // Custom field returns an array, so converting it back to string to store
    transformAfter (params) {
        if (Array.isArray(params.labels)) params.labels = params.labels.join(',');
        return params;
    }
};





const $a51a656fff9da83c$var$i18n = (0, $kSwu1.defineMessages)({
    labelsFieldDescription: {
        id: "fabric-extension-lib.blog-posts.config-panel.labels-field.description",
        defaultMessage: "Add a \u201C-\u201D before any label to exclude blogs with that label.  Add a \u201C+\u201D before any label to require that blogs have that label."
    },
    spacesFieldDescription: {
        id: "fabric-extension-lib.blog-posts.config-panel.spaces-field.description",
        defaultMessage: "Add a \u201C-\u201D before any space to exclude blogs in that space."
    }
});
const $a51a656fff9da83c$var$FIELDS_TO_FIX = [
    'labels',
    'spaces'
];
const $a51a656fff9da83c$export$d09847bb5c97319b = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            let fieldOverrides = {};
            switch(field.name){
                case 'labels':
                    fieldOverrides = {
                        // Remove old description which talks about entering comma-separated syntax.
                        description: intl.formatMessage($a51a656fff9da83c$var$i18n.labelsFieldDescription),
                        // Converts the "labels" field to be a multi-select
                        // which is not supported by the old macro browser
                        type: 'custom',
                        isMultiple: true,
                        options: {
                            resolver: {
                                // Supports adding "+" or "-" prefixes to exclude or require results with certain labels.
                                type: 'labelWithPlusMinusPrefixes'
                            }
                        }
                    };
                    break;
                case 'spaces':
                    fieldOverrides = {
                        description: intl.formatMessage($a51a656fff9da83c$var$i18n.spacesFieldDescription),
                        type: 'custom',
                        isMultiple: true,
                        options: {
                            resolver: {
                                // Supports special space values like @self
                                // as well as adding "-" prefix to exclude results in a space
                                type: 'blogRecentlyUpdatedSpaceWithPlusMinusPrefixes'
                            }
                        }
                    };
                    break;
                case 'author':
                    fieldOverrides = {
                        description: ''
                    };
                    break;
            }
            return {
                ...field,
                ...fieldOverrides
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        $a51a656fff9da83c$var$FIELDS_TO_FIX.forEach((field)=>{
            if (params[field] && typeof params[field] === 'string') params[field] = params[field].split(',');
        });
        return params;
    },
    transformAfter (params) {
        $a51a656fff9da83c$var$FIELDS_TO_FIX.forEach((field)=>{
            if (Array.isArray(params[field])) params[field] = params[field].join(',');
        });
        return params;
    }
};



var $hSoEi = parcelRequire("hSoEi");


var $k5sGX = parcelRequire("k5sGX");


var $f6RxU = parcelRequire("f6RxU");


var $gQEZd = parcelRequire("gQEZd");

function $af44a8b67702937d$export$c6813fa23b09b132(date, dateFormat) {
    return (0, $f6RxU.default)((0, $k5sGX.default)(date), dateFormat);
}
function $af44a8b67702937d$export$f357581637260a(date, dateFormat) {
    return (0, $gQEZd.default)((0, $hSoEi.default)(date, dateFormat, new Date()), {
        representation: 'date'
    });
}
const $af44a8b67702937d$export$3fb54149990fb5b5 = (value)=>{
    if (typeof value === 'boolean') return value;
    return value === 'true';
};


// NOTE: Contributors uses ISO date format so this is only useful when
// the calendar picker will use a different locale.
// Dates must be entered as YYYY/MM/DD
// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
const $f961a585851fa823$var$PUBLISH_DATE_FORMAT = 'yyyy-MM-dd';
const $f961a585851fa823$export$94a431ed9cc1a33c = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            switch(field.name){
                case 'publishDate':
                    return {
                        ...field,
                        description: undefined
                    };
                case 'spaces':
                    return {
                        ...field,
                        options: {
                            resolver: {
                                type: 'contributorsSpaceParamResolver'
                            }
                        }
                    };
                default:
                    return field;
            }
        });
    },
    transformBefore (params) {
        if (params.publishDate?.length) params.publishDate = (0, $af44a8b67702937d$export$f357581637260a)(params.publishDate, $f961a585851fa823$var$PUBLISH_DATE_FORMAT);
        return params;
    },
    transformAfter (params) {
        if (params.publishDate?.length) params.publishDate = (0, $af44a8b67702937d$export$c6813fa23b09b132)(params.publishDate, $f961a585851fa823$var$PUBLISH_DATE_FORMAT);
        return params;
    }
};





const $e537b86479e256a3$var$i18n = (0, $kSwu1.defineMessages)({
    contentIncludeFieldLabel: {
        id: "fabric-extension-lib.field-mappings.include.field.contentInclude.label",
        defaultMessage: "Content to include"
    }
});
const $e537b86479e256a3$export$99920f638bbeb850 = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            if (field.name !== 'defaultParameterValue') return field;
            return {
                ...field,
                type: 'custom',
                label: intl.formatMessage($e537b86479e256a3$var$i18n.contentIncludeFieldLabel),
                // description talks about entering page using SPACEKEY:Page_title syntax
                // which no longer applies as users are now just picking from a dropdown
                description: undefined
            };
        });
    }
};


const $cc7cae6ecd5fddd6$export$7de1d9fa02de756b = {
    transformFields: async ({ fields: fields })=>{
        return fields// Removes the field altogether
        // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/browse/packages/confluence-macro-browser-overrides/src/office-connector/overrides.js#139-153
        .filter((field)=>![
                'date',
                'space'
            ].includes(field.name))// Adds a hidden field so it will keep existing values
        .map((field)=>{
            if (field.name !== 'page') return field;
            return {
                ...field,
                type: 'string',
                isHidden: true
            };
        });
    },
    transformAfter (params) {
        if (!params.page) delete params.page;
        return params;
    }
};






// Dates must be entered as dd-mm-yyyy
// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
const $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT = 'dd-MM-yyyy';
const $ea80d69ac5e0e244$export$5e6ec7c8e2ab7cd0 = {
    // Converts the "spaceAndPage" field to be a custom multi-select
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name === 'spaceAndPage') return {
                ...field,
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'spaceAndPage'
                    }
                }
            };
            else if (field.name === 'createddateFrom') // Remove the description since we are using a date picker now
            return {
                ...field,
                description: undefined
            };
            return field;
        });
    },
    transformBefore (params) {
        // Handle Space and Pages
        // We store { pages: '123', spaces: '~456' } in macroParams
        // but new config field definition has one `spaceAndPage` field
        // containing both `pages` and `spaces` field values joined together
        let spaceAndPage = '';
        if (params.spaces) spaceAndPage += params.spaces;
        if (params.pages) {
            if (spaceAndPage) spaceAndPage += ',';
            spaceAndPage += params.pages;
        }
        if (spaceAndPage) params.spaceAndPage = spaceAndPage;
        delete params.spaces;
        delete params.pages;
        // Handle Date
        if (params.createddateFrom?.length) params.createddateFrom = (0, $af44a8b67702937d$export$f357581637260a)(params.createddateFrom, $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT);
        return params;
    },
    transformAfter (params) {
        // Before passing it back to macro splitting `spaceAndPage` into `spaces` & `pages`
        if (Array.isArray(params.spaceAndPage)) {
            const spaces = params.spaceAndPage.filter((value)=>!(0, $2E7zk.isPageId)(value));
            if (spaces.length > 0) params.spaces = spaces.join(',');
            const pages = params.spaceAndPage.filter((0, $2E7zk.isPageId));
            if (pages.length > 0) params.pages = pages.join(',');
            delete params.spaceAndPage;
        }
        // Handle Date
        if (params.createddateFrom?.length) params.createddateFrom = (0, $af44a8b67702937d$export$c6813fa23b09b132)(params.createddateFrom, $ea80d69ac5e0e244$var$CREATED_DATE_FORMAT);
        return params;
    }
};





const $d936723dbc3f198e$var$i18n = (0, $kSwu1.defineMessages)({
    fieldRootLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.root.label",
        defaultMessage: "Root content"
    },
    fieldSpacesLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.spaces.label",
        defaultMessage: "Restrict to this space key"
    },
    fieldSortLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.sort.label",
        defaultMessage: "Sort content by"
    },
    fieldExcerptLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.excerpt.label",
        defaultMessage: "Include excerpts in content tree"
    },
    fieldReverseLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.reverse.label",
        defaultMessage: "Reverse order"
    },
    fieldReverseDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.reverse.description",
        defaultMessage: "Used only in conjunction with the \u201CSort content by\u201D field."
    },
    fieldSearchBoxLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.searchBox.label",
        defaultMessage: "Include search box above content tree"
    },
    fieldExpandCollapseAllLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.expandCollapseAll.label",
        defaultMessage: "Show expand/collapse links"
    },
    fieldExpandCollapseAllDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.expandCollapseAll.description",
        defaultMessage: "Displays the \u201Cexpand all\u201D and \u201Ccollapse all\u201D links at the top of the content tree."
    },
    fieldStartDepthLabel: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.startDepth.label",
        defaultMessage: "Tree depth"
    },
    fieldStartDepthDescription: {
        id: "fabric-extension-lib.field-mappings.pagetree.field.startDepth.description",
        defaultMessage: "The number of levels of child items displayed."
    }
});
const $d936723dbc3f198e$export$399a6ae8796e7804 = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            let fieldResult = {
                ...field
            };
            if (field.name === 'root') fieldResult = {
                ...fieldResult,
                isMultiple: false,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'rootPage'
                    }
                }
            };
            let newMacroCopies = {};
            switch(field.name){
                case 'root':
                    newMacroCopies = {
                        label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldRootLabel)
                    };
                    break;
                case 'spaces':
                    newMacroCopies = {
                        label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSpacesLabel)
                    };
                    break;
                case 'sort':
                    newMacroCopies = {
                        label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSortLabel)
                    };
                    break;
                case 'excerpt':
                    newMacroCopies = {
                        label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExcerptLabel)
                    };
                    break;
                case 'reverse':
                    newMacroCopies = {
                        label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldReverseLabel),
                        description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldReverseDescription)
                    };
                    break;
                case 'searchBox':
                    newMacroCopies = {
                        label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldSearchBoxLabel)
                    };
                    break;
                case 'expandCollapseAll':
                    newMacroCopies = {
                        label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExpandCollapseAllLabel),
                        description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldExpandCollapseAllDescription)
                    };
                    break;
                case 'startDepth':
                    newMacroCopies = {
                        label: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldStartDepthLabel),
                        description: intl.formatMessage($d936723dbc3f198e$var$i18n.fieldStartDepthDescription)
                    };
                    break;
            }
            fieldResult = {
                ...fieldResult,
                ...newMacroCopies
            };
            return fieldResult;
        });
    }
};



var $gaGUd = parcelRequire("gaGUd");



var $9wGTI = parcelRequire("9wGTI");



var $kTVK2 = parcelRequire("kTVK2");

const $6cbac4da7b29df9c$export$aa84be64c5f7ddf4 = (name, fields, intl, _defaultValue, isLivePage)=>{
    let field;
    switch(name){
        case 'spaces':
            field = {
                ...$6cbac4da7b29df9c$var$getSpacesField(fields['spaces']),
                label: intl.formatMessage((0, $kTVK2.i18n).spaceLabel),
                description: '',
                placeholder: intl.formatMessage((0, $kTVK2.i18n).spacePlaceholder)
            };
            break;
        case 'types':
            field = {
                ...fields['types'],
                label: intl.formatMessage((0, $kTVK2.i18n).typesLabel),
                description: '',
                placeholder: intl.formatMessage((0, $kTVK2.i18n).typePlaceholder),
                type: 'enum',
                style: 'select',
                isMultiple: true,
                items: [
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).allLabel),
                        value: ''
                    },
                    {
                        label: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? intl.formatMessage((0, $kTVK2.i18nTypes).livePageLabel) : intl.formatMessage((0, $kTVK2.i18nTypes).pageLabel),
                        value: 'page'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).blogPostLabel),
                        value: 'blogpost'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).commentLabel),
                        value: 'comment'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTypes).attachmentLabel),
                        value: 'attachment'
                    }
                ]
            };
            break;
        case 'maxToggle':
            field = {
                name: 'maxToggle',
                type: 'boolean',
                style: 'toggle',
                label: intl.formatMessage((0, $kTVK2.i18n).maxToggleLabel),
                description: '',
                defaultValue: false,
                isHidden: false,
                isMultiple: false,
                isRequired: false
            };
            break;
        case 'max':
            field = {
                ...fields['max'],
                label: intl.formatMessage((0, $kTVK2.i18n).maxLabel)
            };
            break;
        case 'theme':
            field = {
                ...fields['theme'],
                label: intl.formatMessage((0, $kTVK2.i18n).themeLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18nTheme).conciseLabel),
                items: [
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).conciseLabel),
                        value: 'concise'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).sidebarLabel),
                        value: 'sidebar'
                    },
                    {
                        label: intl.formatMessage((0, $kTVK2.i18nTheme).socialLabel),
                        value: 'social'
                    }
                ]
            };
            break;
        case 'author':
            field = {
                ...fields['author'],
                label: intl.formatMessage((0, $kTVK2.i18n).authorLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).authorPlaceholder),
                description: ''
            };
            break;
        case 'labels':
            field = {
                ...fields['labels'],
                label: intl.formatMessage((0, $kTVK2.i18n).labelsLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).labelsPlaceholder),
                description: '',
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'label'
                    }
                }
            };
            break;
        case 'width':
            field = {
                ...fields['width'],
                label: intl.formatMessage((0, $kTVK2.i18n).widthLabel),
                placeholder: intl.formatMessage((0, $kTVK2.i18n).widthPlaceholder),
                description: '',
                type: 'custom',
                options: {
                    isCreatable: true,
                    formatCreateLabel: (value)=>{
                        return value;
                    },
                    resolver: {
                        type: 'widthPercentage'
                    }
                }
            };
            break;
        case 'hideHeading':
            field = {
                ...fields['hideHeading'],
                label: intl.formatMessage((0, $kTVK2.i18n).hideHeadingLabel)
            };
            break;
    }
    return field;
};
const $6cbac4da7b29df9c$var$getSpacesField = (field)=>{
    return {
        ...field,
        isMultiple: true,
        type: 'custom',
        options: {
            resolver: {
                type: 'blogRecentlyUpdatedSpace'
            }
        }
    };
};
const $6cbac4da7b29df9c$export$e9aa8a2eb319b54d = (name, fields, intl, currentParams, isLivePage)=>{
    if (name === 'max') {
        const result = [];
        result.push($6cbac4da7b29df9c$export$aa84be64c5f7ddf4('maxToggle', fields, intl, isLivePage));
        if (!(0, $af44a8b67702937d$export$3fb54149990fb5b5)(currentParams?.macroParams?.maxToggle?.value)) result.push($6cbac4da7b29df9c$export$aa84be64c5f7ddf4(name, fields, intl));
        return result;
    }
    return $6cbac4da7b29df9c$export$aa84be64c5f7ddf4(name, fields, intl, isLivePage);
};





const $11540f3edad606fa$var$basicTabFields = [
    'spaces',
    'types',
    'max'
];
const $11540f3edad606fa$var$displayTabFields = [
    'theme',
    'author',
    'labels',
    'width',
    'hideHeading'
];
const $11540f3edad606fa$export$8b4c22b4049c66c3 = {
    transformFields: async ({ fields: fields, intl: intl, createAnalyticsEvent: createAnalyticsEvent, isLivePage: isLivePage })=>{
        const fireErrorAnalytics = (tab, error)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'error',
                    actionSubject: 'transformFields',
                    actionSubjectId: tab,
                    source: 'field-mappings/recently-updated',
                    attributes: {
                        error: error.message,
                        stack: error.stack
                    }
                }
            }).fire();
        };
        const getDynamicFields = (currentParams)=>{
            const fieldsObj = fields.reduce((obj, field)=>{
                obj[field.name] = field;
                return obj;
            }, {});
            return [
                {
                    type: 'tab-group',
                    name: 'tabGroup',
                    label: 'Recent Updates Tab Group',
                    defaultTab: 'basic',
                    fields: [
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $kTVK2.i18n).basicTabLabel),
                            name: 'basic',
                            fields: [
                                ...$11540f3edad606fa$var$basicTabFields.flatMap((fieldName)=>{
                                    try {
                                        return (0, $6cbac4da7b29df9c$export$e9aa8a2eb319b54d)(fieldName, fieldsObj, intl, currentParams, isLivePage);
                                    } catch (error) {
                                        fireErrorAnalytics('basicTab', error);
                                        return [];
                                    }
                                })
                            ]
                        },
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $kTVK2.i18n).displayTabLabel),
                            name: 'display',
                            fields: [
                                ...$11540f3edad606fa$var$displayTabFields.map((fieldName)=>{
                                    try {
                                        return (0, $6cbac4da7b29df9c$export$aa84be64c5f7ddf4)(fieldName, fieldsObj, intl);
                                    } catch (error) {
                                        fireErrorAnalytics('displayTab', error);
                                        return [];
                                    }
                                })
                            ]
                        }
                    ]
                }
            ];
        };
        return getDynamicFields;
    },
    transformBefore (params, _metadata, _pageContext) {
        // Convert "Include in list" string to array for FE enum field
        if (params.types) params.types = params.types.split(/[ ,]+/);
        else params.types = [
            ''
        ];
        // Convert labels param from string to array for FE custom field
        if (params.labels) params.labels = params.labels.split(/[ ,]+/);
        // We are hiding "Show User Profile Pictures" checkbox
        // In the BE if this was checked, it sets theme to "social" and overrides the "theme" param
        // So if an existing macro had this checked, set theme to "social" (results in no change to macro view)
        if ((0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.showProfilePic)) {
            params.theme = 'social';
            params.showProfilePic = 'false';
        }
        return params;
    },
    transformAfter (params, _metadata, _pageContext) {
        // "Include in list" param behavior: Default is "All" which is mutually exclusive with other options.
        // i.e. selection in this field can be either "All" by itself, or any content types (but no "All").
        // Also converts array to string for BE field data type
        if (params.types) {
            const types = params.types;
            if (types[types.length - 1] === '') // "All" was just chosen, remove all other selections
            params.types = '';
            else if (types.some((type)=>type === '')) {
                // A content type was selected but "All" exists in the list, so remove "All"
                types.splice(types.indexOf(''), 1);
                params.types = types.join();
            } else params.types = types.join();
        }
        // If "Show all updates" toggle is on, set max param to highest allowed from BE
        const showAll = (0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.maxToggle);
        if (showAll) params.max = 250;
        // Convert labels param from array to string for BE field definition
        if (params.labels) params.labels = params.labels.join();
        return params;
    }
};


const $88990a4623f29192$export$fdb887e9b25aa392 = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            if (field.name === 'spaces') return {
                ...field,
                isMultiple: true,
                type: 'custom',
                options: {
                    resolver: {
                        type: 'recentlyUpdatedDashboardSpaceKeyResolver'
                    }
                }
            };
            return field;
        });
    }
};



var $gw2T1 = parcelRequire("gw2T1");

const $a9bebca19b89c955$var$isNumber = (contentId)=>/^[0-9]+$/.test(contentId);
const $a9bebca19b89c955$export$f0ecb46e90798741 = {
    transformFields: async ({ fields: fields, pageContext: pageContext, params: params })=>{
        let templates = [];
        const resolver = (0, $gw2T1.getTemplateResolver)(params?.spaceKey ? params : pageContext);
        if (resolver) templates = await resolver('', '');
        const newFields = fields.map((field)=>{
            if (field.name === 'templateName') return {
                ...field,
                type: 'enum',
                items: templates,
                isRequired: true
            };
            else if (field.name === 'spaceKey') return {
                ...field,
                defaultValue: pageContext.spaceKey,
                isRequired: false
            };
            return field;
        });
        const spaceKeyIndex = newFields.findIndex(({ name: name })=>name === 'spaceKey');
        const templateIndex = newFields.findIndex(({ name: name })=>name === 'templateName');
        newFields.unshift(newFields.splice(templateIndex, 1)[0]);
        newFields.unshift(newFields.splice(spaceKeyIndex, 1)[0]);
        return newFields;
    },
    transformAfter (params) {
        const { templateName: templateName } = params;
        if (templateName) {
            if ($a9bebca19b89c955$var$isNumber(templateName)) {
                params.templateId = templateName;
                delete params.contentBlueprintId;
            } else {
                params.contentBlueprintId = templateName;
                delete params.templateId;
            }
        }
        return params;
    }
};






const $862710ac50c04301$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    pageLabel: {
        id: "fabric-extension-lib.children.field.page.label",
        defaultMessage: "Parent item"
    },
    pagePlaceholder: {
        id: "fabric-extension-lib.children.field.page.placeholder",
        defaultMessage: "Current"
    },
    allChildren: {
        id: "fabric-extension-lib.children.field.allChildren.label",
        defaultMessage: "Show all child items"
    },
    allLabel: {
        id: "fabric-extension-lib.children.field.all.label",
        defaultMessage: "Show all levels"
    },
    depthLabel: {
        id: "fabric-extension-lib.children.field.depth.label",
        defaultMessage: "Max number of levels"
    },
    excerptTypeLabel: {
        id: "fabric-extension-lib.children.field.excerptType.label",
        defaultMessage: "Display preview"
    },
    excerptTypeDescription: {
        id: "fabric-extension-lib.children.field.excerptType.description",
        defaultMessage: "Lists can display a preview of the top of a child item, or the content of its excerpt."
    },
    firstLabel: {
        id: "fabric-extension-lib.children.field.first.label",
        defaultMessage: "Max number in list"
    },
    sortLabel: {
        id: "fabric-extension-lib.children.field.sort.label",
        defaultMessage: "Sort order"
    },
    styleLabel: {
        id: "fabric-extension-lib.children.field.style.label",
        defaultMessage: "List style"
    },
    basicTabLabel: {
        id: "fabric-extension-lib.config.tab.basic.label",
        defaultMessage: "Basic"
    },
    displayTabLabel: {
        id: "fabric-extension-lib.config.tab.display.label",
        defaultMessage: "Display"
    }
});
const $862710ac50c04301$export$e7de9fb1789252ba = (0, $kSwu1.defineMessages)({
    one: {
        id: "fabric-extension-lib.children.field.depth.item.one",
        defaultMessage: "1 level"
    },
    two: {
        id: "fabric-extension-lib.children.field.depth.item.two",
        defaultMessage: "2 levels"
    },
    three: {
        id: "fabric-extension-lib.children.field.depth.item.three",
        defaultMessage: "3 levels"
    },
    four: {
        id: "fabric-extension-lib.children.field.depth.item.four",
        defaultMessage: "4 levels"
    },
    five: {
        id: "fabric-extension-lib.children.field.depth.item.five",
        defaultMessage: "5 levels"
    },
    six: {
        id: "fabric-extension-lib.children.field.depth.item.six",
        defaultMessage: "6 levels"
    },
    seven: {
        id: "fabric-extension-lib.children.field.depth.item.seven",
        defaultMessage: "7 levels"
    },
    eight: {
        id: "fabric-extension-lib.children.field.depth.item.eight",
        defaultMessage: "8 levels"
    },
    nine: {
        id: "fabric-extension-lib.children.field.depth.item.nine",
        defaultMessage: "9 levels"
    }
});
const $862710ac50c04301$export$22a6a8b908f4792e = (0, $kSwu1.defineMessages)({
    titleGroup: {
        id: "fabric-extension-lib.children.field.sort.group.title",
        defaultMessage: "Title"
    },
    titleItem: {
        id: "fabric-extension-lib.children.field.sort.item.title",
        defaultMessage: "A \u2192 Z"
    },
    titleReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.titlereverse",
        defaultMessage: "Z \u2192 A"
    },
    creationGroup: {
        id: "fabric-extension-lib.children.field.sort.group.creation",
        defaultMessage: "Created"
    },
    creationItem: {
        id: "fabric-extension-lib.children.field.sort.item.creation",
        defaultMessage: "Newest \u2192 Oldest"
    },
    creationReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.creationreverse",
        defaultMessage: "Oldest \u2192 Newest"
    },
    modifiedGroup: {
        id: "fabric-extension-lib.children.field.sort.group.modified",
        defaultMessage: "Modified"
    },
    modifiedItem: {
        id: "fabric-extension-lib.children.field.sort.item.modified",
        defaultMessage: "Old \u2192 Recent"
    },
    modifiedReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.modifiednreverse",
        defaultMessage: "Recent \u2192 Old"
    },
    defaultGroup: {
        id: "fabric-extension-lib.children.field.sort.group.default",
        defaultMessage: "Content Tree"
    },
    defaultItem: {
        id: "fabric-extension-lib.children.field.sort.item.default",
        defaultMessage: "Current"
    },
    defaultReverseItem: {
        id: "fabric-extension-lib.children.field.sort.item.defaultreverse",
        defaultMessage: "Reverse"
    }
});
const $862710ac50c04301$export$937ee27e4f72fd9f = (0, $kSwu1.defineMessages)({
    default: {
        id: "fabric-extension-lib.children.field.style.item.default",
        defaultMessage: "Bulleted"
    },
    h1: {
        id: "fabric-extension-lib.children.field.style.item.h1",
        defaultMessage: "H1"
    },
    h2: {
        id: "fabric-extension-lib.children.field.style.item.h2",
        defaultMessage: "H2"
    },
    h3: {
        id: "fabric-extension-lib.children.field.style.item.h3",
        defaultMessage: "H3"
    },
    h4: {
        id: "fabric-extension-lib.children.field.style.item.h4",
        defaultMessage: "H4"
    },
    h5: {
        id: "fabric-extension-lib.children.field.style.item.h5",
        defaultMessage: "H5"
    },
    h6: {
        id: "fabric-extension-lib.children.field.style.item.h6",
        defaultMessage: "H6"
    }
});
const $862710ac50c04301$export$981659feafe35cff = (0, $kSwu1.defineMessages)({
    none: {
        id: "fabric-extension-lib.children.field.excerptType.item.none",
        defaultMessage: "None"
    },
    richContent: {
        id: "fabric-extension-lib.children.field.excerptType.item.richContent",
        defaultMessage: "Preview content"
    },
    simple: {
        id: "fabric-extension-lib.children.field.excerptType.item.simple",
        defaultMessage: "Excerpt preview"
    }
});




const $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7 = (name, fields, intl, defaultValue)=>{
    let field;
    switch(name){
        case 'page':
            field = {
                ...fields['page'],
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).pageLabel),
                placeholder: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).pagePlaceholder),
                description: ''
            };
            break;
        case 'allChildren':
            field = {
                name: 'allChildren',
                type: 'boolean',
                style: 'toggle',
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).allChildren),
                description: '',
                defaultValue: defaultValue,
                isHidden: false,
                isMultiple: false,
                isRequired: false
            };
            break;
        case 'first':
            field = {
                ...fields['first'],
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).firstLabel),
                description: ''
            };
            break;
        case 'all':
            field = {
                ...fields['all'],
                style: 'toggle',
                defaultValue: 'false',
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).allLabel)
            };
            break;
        case 'depth':
            field = {
                ...fields['depth'],
                type: 'enum',
                style: 'select',
                defaultValue: '1',
                isMultiple: false,
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).depthLabel),
                items: [
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).one),
                        value: '1'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).two),
                        value: '2'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).three),
                        value: '3'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).four),
                        value: '4'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).five),
                        value: '5'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).six),
                        value: '6'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).seven),
                        value: '7'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).eight),
                        value: '8'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$e7de9fb1789252ba).nine),
                        value: '9'
                    }
                ]
            };
            break;
        case 'sort':
            field = {
                ...fields['sort'],
                name: 'sortAndReverse',
                type: 'enum',
                style: 'select',
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).sortLabel),
                defaultValue: '',
                items: [
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).defaultGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).defaultItem),
                                value: ''
                            },
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).defaultReverseItem),
                                value: '.true'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).titleGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).titleItem),
                                value: 'title'
                            },
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).titleReverseItem),
                                value: 'title.true'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).creationGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).creationItem),
                                value: 'creation.true'
                            },
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).creationReverseItem),
                                value: 'creation'
                            }
                        ]
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).modifiedGroup),
                        options: [
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).modifiedReverseItem),
                                value: 'modified.true'
                            },
                            {
                                label: intl.formatMessage((0, $862710ac50c04301$export$22a6a8b908f4792e).modifiedItem),
                                value: 'modified'
                            }
                        ]
                    }
                ]
            };
            break;
        case 'style':
            field = {
                ...fields['style'],
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).styleLabel),
                defaultValue: '',
                items: [
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).default),
                        value: ''
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h1),
                        value: 'h1'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h2),
                        value: 'h2'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h3),
                        value: 'h3'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h4),
                        value: 'h4'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h5),
                        value: 'h5'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$937ee27e4f72fd9f).h6),
                        value: 'h6'
                    }
                ]
            };
            break;
        case 'excerptType':
            field = {
                ...fields['excerptType'],
                label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).excerptTypeLabel),
                description: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).excerptTypeDescription),
                items: [
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$981659feafe35cff).none),
                        value: 'none'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$981659feafe35cff).richContent),
                        value: 'rich content'
                    },
                    {
                        label: intl.formatMessage((0, $862710ac50c04301$export$981659feafe35cff).simple),
                        value: 'simple'
                    }
                ]
            };
            break;
    }
    return field;
};
const $8b7d499a5aa031b6$export$d0c9dc351b89eb65 = (all, depth)=>{
    if (all && depth > 0) return false;
    return all;
};
const $8b7d499a5aa031b6$export$e9aa8a2eb319b54d = (name, fields, intl, currentParams)=>{
    if (name === 'page') return $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('page', fields, intl);
    const result = [];
    if (name === 'first') {
        // "Max number in list" field
        // Add an FE-only toggle field `allChildren` to conditionally display the "Max # in list" (`first`) field
        // Since it's an FE-only param, dynamically set its defaultValue depending on `first` param's current value
        // Toggle is TRUE if `first` is undefined or 0, i.e. no child page limit
        const defaultValue = !currentParams?.macroParams?.first?.value || parseInt(currentParams.macroParams.first.value) === 0 ? 'true' : 'false';
        result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('allChildren', fields, intl, defaultValue));
        // If param is null (i.e. on initial load), manually update its state
        if (currentParams?.macroParams && !currentParams.macroParams.allChildren) currentParams.macroParams.allChildren = {
            value: defaultValue
        };
        // Only render "Max number in list" field when toggle is FALSE
        if (!(0, $af44a8b67702937d$export$3fb54149990fb5b5)(currentParams?.macroParams?.allChildren?.value)) result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('first', fields, intl));
    }
    if (name === 'all') {
        // "Show all levels" toggle
        result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('all', fields, intl));
        // Only render "Max number of levels" field when `all` toggle is FALSE
        // (or edge case described in validateDepthFields)
        if (!$8b7d499a5aa031b6$export$d0c9dc351b89eb65((0, $af44a8b67702937d$export$3fb54149990fb5b5)(currentParams?.macroParams?.all?.value), parseInt(currentParams?.macroParams?.depth?.value ?? ''))) result.push($8b7d499a5aa031b6$export$4c39dc4ba3b26bb7('depth', fields, intl));
    }
    return result;
};


const $2ed2a9038132d075$var$basicTabFields = [
    'page',
    'first',
    'all'
];
const $2ed2a9038132d075$var$displayTabFields = [
    'sort',
    'style',
    'excerptType'
];
const $2ed2a9038132d075$export$bacb5cc5a11aef16 = {
    transformFields: async ({ fields: fields, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>{
        const fireErrorAnalytics = (tab, error)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'error',
                    actionSubject: 'transformFields',
                    actionSubjectId: tab,
                    source: 'field-mappings/children',
                    attributes: {
                        error: error.message,
                        stack: error.stack
                    }
                }
            }).fire();
        };
        const getDynamicFields = (currentParams)=>{
            const fieldsObj = fields.reduce((obj, field)=>{
                obj[field.name] = field;
                return obj;
            }, {});
            return [
                {
                    type: 'tab-group',
                    name: 'tabGroup',
                    label: 'Child Pages Tab Group',
                    defaultTab: 'basic',
                    fields: [
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).basicTabLabel),
                            name: 'basic',
                            fields: [
                                ...$2ed2a9038132d075$var$basicTabFields.flatMap((fieldName)=>{
                                    try {
                                        return (0, $8b7d499a5aa031b6$export$e9aa8a2eb319b54d)(fieldName, fieldsObj, intl, currentParams);
                                    } catch (error) {
                                        fireErrorAnalytics('basicTab', error);
                                        return [];
                                    }
                                })
                            ]
                        },
                        {
                            type: 'tab',
                            label: intl.formatMessage((0, $862710ac50c04301$export$a7357cdd1f0b0168).displayTabLabel),
                            name: 'display',
                            fields: [
                                ...$2ed2a9038132d075$var$displayTabFields.map((fieldName)=>{
                                    try {
                                        return (0, $8b7d499a5aa031b6$export$4c39dc4ba3b26bb7)(fieldName, fieldsObj, intl);
                                    } catch (error) {
                                        fireErrorAnalytics('displayTab', error);
                                        return [];
                                    }
                                })
                            ]
                        }
                    ]
                }
            ];
        };
        return getDynamicFields;
    },
    transformBefore (params) {
        // We need to update 'Show all levels' toggle here as well to align param state with UI
        params.all = (0, $8b7d499a5aa031b6$export$d0c9dc351b89eb65)((0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.all), typeof params.depth === 'number' ? params.depth : parseInt(params.depth ?? ''));
        // `sort` and `reverse` params have been combined into a single `sortAndReverse` field
        // so we need to combine their values into one to pass into the new enum field
        params.sortAndReverse = params.sort ?? '';
        if ((0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.reverse)) params.sortAndReverse += '.true';
        return params;
    },
    transformAfter (params) {
        // 'Show all child pages' toggle field
        const allChildren = (0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.allChildren);
        if (allChildren) params.first = 0; // 'Max number in list' field
        if (!allChildren && !params.first) params.first = 10; // set some non-0 value
        // 'Show all levels' depth toggle field
        const allLevels = (0, $af44a8b67702937d$export$3fb54149990fb5b5)(params.all);
        if (allLevels) params.depth = 0;
        if (!allLevels && params.depth === 0) params.depth = 1;
        // Convert sort/reverse field back to manifest definition for BE handling
        [params.sort = '', params.reverse] = (params.sortAndReverse ?? '').split('.');
        if (!params.sort) delete params.sort;
        return params;
    }
};


const $0f335227b4c76418$export$f8e8f85027c88e59 = {
    transformFields: async ({ fields: fields })=>{
        return fields.map((field)=>{
            // Mark this field as required in the FE to display the UI red asterisk, but we will not
            // enforce it in the backend as this breaks existing untitled excerpts
            if (field.name === 'name') return {
                ...field,
                isRequired: true
            };
            return field;
        });
    }
};





const $2d464ae24baf1d6f$var$i18n = (0, $kSwu1.defineMessages)({
    fieldIdLabel: {
        id: "fabric-extension-lib.field-mappings.details.field.id.label",
        defaultMessage: "Content properties ID (optional)"
    },
    fieldIdDescription: {
        id: "fabric-extension-lib.field-mappings.details.field.id.description",
        defaultMessage: "Specify an ID if you have multiple content properties macros on this page or doc and want to report on them separately."
    },
    fieldHiddenLabel: {
        id: "fabric-extension-lib.field-mappings.details.field.hidden.label",
        defaultMessage: "Hide from view"
    },
    fieldHiddenDescription: {
        id: "fabric-extension-lib.field-mappings.details.field.hidden.description",
        defaultMessage: "Hide macro contents from view, but continue to display them in the Content Properties Report macro."
    }
});
const $2d464ae24baf1d6f$export$41ee12f6f6f05843 = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            if (field.name === 'id') return {
                ...field,
                label: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldIdLabel),
                description: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldIdDescription)
            };
            if (field.name === 'hidden') return {
                ...field,
                label: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldHiddenLabel),
                description: intl.formatMessage($2d464ae24baf1d6f$var$i18n.fieldHiddenDescription)
            };
            return field;
        });
    }
};


const $763d528574677310$var$makeObject = (xs)=>xs.reduce((obj, x)=>{
        obj[x.name] = x;
        return obj;
    }, {});
const $763d528574677310$export$78a98cfbfc91bcb5 = ()=>({
        attachments: $fdf5e213da5d1c5e$export$5ada257c34afac99,
        'blog-posts': (0, $a51a656fff9da83c$export$d09847bb5c97319b),
        calendar: $gaGUd.calendar,
        children: $2ed2a9038132d075$export$bacb5cc5a11aef16,
        contributors: $f961a585851fa823$export$94a431ed9cc1a33c,
        'contributors-summary': (0, $f961a585851fa823$export$94a431ed9cc1a33c),
        'create-from-template': (0, $a9bebca19b89c955$export$f0ecb46e90798741),
        details: $2d464ae24baf1d6f$export$41ee12f6f6f05843,
        excerpt: // content properties (page properties) macro
        $0f335227b4c76418$export$f8e8f85027c88e59,
        include: $e537b86479e256a3$export$99920f638bbeb850,
        pagetree: $d936723dbc3f198e$export$399a6ae8796e7804,
        viewpdf: (0, $cc7cae6ecd5fddd6$export$7de1d9fa02de756b),
        viewdoc: (0, $cc7cae6ecd5fddd6$export$7de1d9fa02de756b),
        viewxls: (0, $cc7cae6ecd5fddd6$export$7de1d9fa02de756b),
        viewppt: (0, $cc7cae6ecd5fddd6$export$7de1d9fa02de756b),
        'tasks-report-macro': (0, $ea80d69ac5e0e244$export$5e6ec7c8e2ab7cd0),
        anchor: $b0454047538f87a4$export$2e2992790a6f69a8,
        'recently-updated': (0, $11540f3edad606fa$export$8b4c22b4049c66c3),
        'recently-updated-dashboard': (0, $88990a4623f29192$export$fdb887e9b25aa392)
    });
const $763d528574677310$export$5a5c6ccdb287233d = async ({ macroName: macroName }, fields, pageContext, intl, params, createAnalyticsEvent, isLivePage)=>{
    const transformFields = $763d528574677310$export$78a98cfbfc91bcb5()[macroName]?.transformFields;
    const alwaysFn = (0, $35b63f91264cd025$export$ba9e5d519bc326ca)?.transformFields;
    if (macroName === 'create-from-template') return transformFields ? transformFields({
        fields: fields,
        pageContext: pageContext,
        intl: intl,
        params: params,
        createAnalyticsEvent: createAnalyticsEvent,
        isLivePage: isLivePage
    }) : fields;
    else {
        let newFields;
        if (transformFields) try {
            newFields = await transformFields({
                fields: fields,
                pageContext: pageContext,
                intl: intl,
                params: params,
                createAnalyticsEvent: createAnalyticsEvent,
                isLivePage: isLivePage
            });
        } catch (error) {
            if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(macroName)) $763d528574677310$var$fireErrorAnalytics(macroName, 'transformFields', error, createAnalyticsEvent);
        }
        else newFields = fields;
        return alwaysFn ? alwaysFn(newFields, pageContext, intl) : newFields;
    }
};
const $763d528574677310$export$db6c1732c1c4814c = (transformType, macro, params, pageContext, createAnalyticsEvent)=>{
    const { macroName: macroName, formDetails: formDetails } = macro;
    const metadata = $763d528574677310$var$makeObject(formDetails.parameters);
    const transformFn = $763d528574677310$export$78a98cfbfc91bcb5()[macroName]?.[transformType];
    const alwaysFn = (0, $35b63f91264cd025$export$ba9e5d519bc326ca)?.[transformType];
    let newParams;
    if (transformFn) try {
        newParams = transformFn(params, metadata, pageContext);
    } catch (error) {
        if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(macroName)) $763d528574677310$var$fireErrorAnalytics(macroName, transformType, error, createAnalyticsEvent);
    }
    else newParams = params;
    return alwaysFn ? alwaysFn(newParams, metadata, pageContext) : newParams;
};
const $763d528574677310$var$fireErrorAnalytics = (macroName, fn, error, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: fn,
            actionSubjectId: macroName,
            source: 'field-mappings',
            attributes: {
                error: error.message,
                stack: error.stack
            }
        }
    }).fire();
};
module.exports["remapCustomFields"] = $763d528574677310$export$5a5c6ccdb287233d;
module.exports["transformParams"] = $763d528574677310$export$db6c1732c1c4814c;

});

parcelRegister("2E7zk", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $cozmU = parcelRequire("cozmU");


var $6Ec6w = parcelRequire("6Ec6w");


var $gxI48 = parcelRequire("gxI48");


var $dimUV = parcelRequire("dimUV");


var $ijkxh = parcelRequire("ijkxh");


var $hAgam = parcelRequire("hAgam");


var $3PHGt = parcelRequire("3PHGt");


var $iAaYd = parcelRequire("iAaYd");


var $gaHi2 = parcelRequire("gaHi2");


var $bD3fd = parcelRequire("bD3fd");


var $6mKj3 = parcelRequire("6mKj3");


var $9Cbhx = parcelRequire("9Cbhx");


var $f7B1p = parcelRequire("f7B1p");


var $1xpoY = parcelRequire("1xpoY");


var $fgbpl = parcelRequire("fgbpl");


var $8pcS0 = parcelRequire("8pcS0");


var $eQyFc = parcelRequire("eQyFc");


var $kSwu1 = parcelRequire("kSwu1");


var $kyKWe = parcelRequire("kyKWe");











var $8nJmU = parcelRequire("8nJmU");

const $d0bc3858ac41d947$var$isOfficeMacroMetricsEnabled = (macro)=>{
    try {
        return (0, $8nJmU.OfficeMacroExperienceTrackerSupport).isTrackable({
            macroName: macro.macroName
        });
    } catch  {
        return false;
    }
};
const $d0bc3858ac41d947$var$safelyRunOfficeMacroTelemetry = (track)=>{
    try {
        track();
    } catch  {
    // Telemetry must never block or alter macro insertion behaviour.
    }
};
const $d0bc3858ac41d947$export$a227ee5fd63d822 = (macro, action)=>{
    if (!$d0bc3858ac41d947$var$isOfficeMacroMetricsEnabled(macro)) return action;
    return async (extensionAPI)=>{
        const data = {
            macroName: macro.macroName
        };
        $d0bc3858ac41d947$var$safelyRunOfficeMacroTelemetry(()=>(0, $8nJmU.OfficeMacroExperienceTrackerSupport).start(data));
        let result;
        try {
            result = await action(extensionAPI);
        } catch (error) {
            $d0bc3858ac41d947$var$safelyRunOfficeMacroTelemetry(()=>(0, $8nJmU.OfficeMacroExperienceTrackerSupport).fail(error instanceof Error ? error : new Error('Office macro action failed')));
            throw error;
        }
        $d0bc3858ac41d947$var$safelyRunOfficeMacroTelemetry(()=>(0, $8nJmU.OfficeMacroExperienceTrackerSupport).succeed());
        return result;
    };
};



var $2E7zk = parcelRequire("2E7zk");




const $7b3d41287d889ce8$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    excerptPlaceholder: {
        id: "fabric-extension-lib.excerpt.placeholder",
        defaultMessage: "Type or paste something here to turn it into an excerpt."
    },
    tocZonePlaceholder: {
        id: "fabric-extension-lib.toc.zone.placeholder",
        defaultMessage: "A table of contents based on the headings within this frame will appear here."
    },
    pagePropertiesKeyTablePlaceholder: {
        id: "fabric-extension-lib.page.properties.table.key.placeholder",
        defaultMessage: "List \u2018keys\u2019 in this column - these will be the column headings in your report table"
    },
    pagePropertiesValueTablePlaceholder: {
        id: "fabric-extension-lib.page.properties.table.value.placeholder",
        defaultMessage: "List the \u2018value\u2019 for each key in this column - these will populate the rows in your report table"
    }
});
const $7b3d41287d889ce8$var$maybeGetGadgetUrl = (macro)=>macro.macroName === 'gadget' && macro?.formDetails?.parameters?.[0]?.defaultValue && {
        gadgetUrl: new URL(// This is gross, but this is the only way to get the URL of the
        // the gadget. We use the same url in the view event to know
        // which gadget was actually inserted, thus track gadget usage
        macro.formDetails.parameters[0].defaultValue, // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        location.origin).pathname
    };
const $7b3d41287d889ce8$var$createBaseMacroAction = (macro, pageContext, intl, createAnalyticsEvent, isLivePage = false)=>async ()=>{
        const node = await (0, $eQyFc.prepareMacro)({
            name: macro.macroName
        }, pageContext.contentId, null, intl);
        if (macro.macroName === 'excerpt') (0, $2E7zk.insertMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.excerptPlaceholder));
        if (macro.macroName === 'details') (0, $2E7zk.insertContentPropertiesMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.pagePropertiesKeyTablePlaceholder), intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.pagePropertiesValueTablePlaceholder));
        if (macro.macroName === 'toc-zone') (0, $2E7zk.insertMacroPlaceholder)(node, intl.formatMessage($7b3d41287d889ce8$export$a7357cdd1f0b0168.tocZonePlaceholder));
        const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
        if (createAnalyticsEvent) {
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
        return node;
    };
const $7b3d41287d889ce8$var$createActionForMacrosThatRequireMacroBrowser = (macro, openMacroBrowserForInitialConfiguration, editorAPI, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage = false)=>async ()=>{
        if (!macroBrowserConfig) throw new Error(`Macro Browser Config is missing`);
        if (!editorActions) throw new Error(`editorActions is missing`);
        const macroFilter = undefined;
        const extensionAnalyticsInfo = {
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: macroBrowserConfig.contentId
        };
        const updateMacro = (node)=>{
            const selectedNode = (0, $2E7zk.getSelectedBodiedExtensionNode)(editorActions);
            if (selectedNode) editorAPI?.extension?.actions?.editSelectedExtension();
            else {
                // initial insert of the roadmap macro
                editorActions.replaceSelection(node);
                editorAPI?.extension?.actions?.editSelectedExtension();
            }
        };
        const node = await openMacroBrowserForInitialConfiguration(macro, macroBrowserConfig, macroFilter, extensionAnalyticsInfo, onCompleteCallback, updateMacro);
        const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
        if (editorActions.replaceSelection(node) && createAnalyticsEvent) {
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        inputMethod: 'macroBrowser',
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
    };
const $7b3d41287d889ce8$var$createActionForMacrosThatCanUseNewConfig = (macro, pageContext, intl, editorAPI, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage = false)=>async ()=>{
        if (!editorActions) throw new Error(`editorActions is missing`);
        const getNode = $7b3d41287d889ce8$var$createBaseMacroAction(macro, pageContext, intl, undefined, isLivePage);
        const node = await getNode();
        // Default the TOC style to none
        if (node?.attrs?.extensionKey === 'toc') {
            if (node?.attrs?.parameters?.macroParams) node.attrs.parameters.macroParams['style'] = {
                value: 'none'
            };
        }
        // Default the anchor macro name to a random UUID
        if (node?.attrs?.extensionKey === 'anchor') {
            if (node?.attrs?.parameters?.macroParams) node.attrs.parameters.macroParams[''] = {
                value: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
            };
        }
        // Add a param to show that the macro is missing required parameters
        const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = node.attrs;
        if ((0, $eQyFc.isMissingAnyRequiredParameters)(macro, {
            extensionType: extensionType,
            extensionKey: extensionKey,
            parameters: parameters
        })) {
            if (node.attrs.parameters?.macroParams) node.attrs.parameters.macroParams['isMissingRequiredParameters'] = {
                // Need to be `string` to be able to persist
                value: 'true'
            };
        }
        if (editorActions.replaceSelection(node) && createAnalyticsEvent) {
            const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(macro.macroName, node.attrs.parameters?.macroParams?.['serverId']?.value);
            const isSupportedMacro = await $7b3d41287d889ce8$export$f3046997f1755ab7(macro.macroName);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'inserted',
                    actionSubject: 'macro',
                    actionSubjectId: macro.macroName,
                    source: 'quick insert menu',
                    attributes: {
                        inputMethod: 'configPanel',
                        extensionType: node?.type,
                        appKey: (0, $2E7zk.getConnectAppKey)(macro.moduleKey),
                        isLivePage: isLivePage,
                        jiraHostingOption: jiraHostingOption,
                        ...isLivePage && isSupportedMacro !== undefined && {
                            isSupportedMacro: isSupportedMacro
                        },
                        ...$7b3d41287d889ce8$var$maybeGetGadgetUrl(macro)
                    }
                }
            }).fire();
        }
        editorAPI?.extension?.actions?.editSelectedExtension();
        onCompleteCallback?.({
            macro: macro.macroName,
            isBodiedExtension: (0, $fgbpl.isBodiedExtension)(node?.type)
        });
    };
const $7b3d41287d889ce8$export$5f32dd5e0bdce03 = (macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage)=>{
    const { enabled: isConfigPanelEnabled, optedOut: excludedMacros } = pageContext.features.configPanel || {};
    // using the detailed legacy macro manifest list, the attributes `anyParameterRequired` and `alwaysShowConfig` are not available so we need to calculate ourselves
    const hasRequiredParameter = macro.anyParameterRequired || macro.formDetails.parameters.some((param)=>param.required && param.defaultValue === null);
    const useNewConfigExperience = isConfigPanelEnabled && !(0, $eQyFc.shouldUseMacroBrowser)(macro, excludedMacros);
    const showInitialConfig = // always show the config panel if we are using the new config experience
    useNewConfigExperience || hasRequiredParameter || macro.alwaysShowConfig || (0, $eQyFc.needsToForceConfig)(macro);
    if (showInitialConfig) {
        if (!useNewConfigExperience) {
            const action = $7b3d41287d889ce8$var$createActionForMacrosThatRequireMacroBrowser(macro, openMacroBrowserForInitialConfiguration, editorAPI, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage);
            return (0, $6mKj3.expVal)('confluence_frontend_macro_slo_metrics', 'isEnabled', false) ? (0, $d0bc3858ac41d947$export$a227ee5fd63d822)(macro, action) : action;
        } else {
            const action = $7b3d41287d889ce8$var$createActionForMacrosThatCanUseNewConfig(macro, pageContext, intl, editorAPI, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage);
            return (0, $6mKj3.expVal)('confluence_frontend_macro_slo_metrics', 'isEnabled', false) ? (0, $d0bc3858ac41d947$export$a227ee5fd63d822)(macro, action) : action;
        }
    } else {
        const action = $7b3d41287d889ce8$var$createBaseMacroAction(macro, pageContext, intl, createAnalyticsEvent, isLivePage);
        return (0, $6mKj3.expVal)('confluence_frontend_macro_slo_metrics', 'isEnabled', false) ? (0, $d0bc3858ac41d947$export$a227ee5fd63d822)(macro, action) : action;
    }
};
const $7b3d41287d889ce8$export$f3046997f1755ab7 = async (macroKey)=>{
    if (!macroKey) return undefined;
    const macroFallbackUiAllowlist = (0, $1xpoY.default).getStringList('confluence_frontend_macro_fallback_ui_allowlist', []);
    if (macroFallbackUiAllowlist.length === 0) return undefined;
    else if (macroFallbackUiAllowlist[0] === 'ALLOW_ALL') return true;
    const macros = macroFallbackUiAllowlist.map((m)=>m.trim().toLowerCase());
    return macros.includes(macroKey.toLowerCase());
};



var $9tVje = parcelRequire("9tVje");

const $7dade95d99fee536$var$pageIdRegex = /^[0-9]+$/;
const $7dade95d99fee536$var$EMBED_CATEGORY = 'embed';
const $7dade95d99fee536$var$IFRAME_MACRO = 'iframe';
const $7dade95d99fee536$var$IFRAME_EMBED_PRIORITY = -200;
const $7dade95d99fee536$var$mediaQuickInsertMacros = new Set([
    'roadmap',
    'profile-picture',
    'attachments'
]);
const $7dade95d99fee536$var$appIconQuickInsertMacros = new Set([
    'include',
    'toc-zone',
    'opsgenie-incident-timeline-prod-jsm-issue-activity-macro',
    'opsgenie-incident-timeline-eu-jsm-issue-activity-macro',
    'opsgenie-incident-timeline-prod-macro',
    'opsgenie-incident-timeline-eu-macro',
    'viewpdf',
    'widget',
    'sharelinks-urlmacro',
    'jirachart'
]);
const $7dade95d99fee536$var$otherQuickInsertMacros = new Set([
    'excerpt',
    'excerpt-include',
    'include',
    'jirachart',
    'jira',
    'portfolioforjiraplan',
    'opsgenie-incident-timeline-prod-jsm-issue-activity-macro',
    'opsgenie-incident-timeline-eu-jsm-issue-activity-macro',
    'opsgenie-incident-timeline-eu-macro',
    'opsgenie-incident-timeline-prod-macro',
    'sharelinks-urlmacro',
    'toc-zone',
    'viewpdf',
    'viewxls',
    'widget'
]);
const $7dade95d99fee536$var$otherQuickInsertMacroPriorities = {
    excerpt: -4400,
    'excerpt-include': -4300,
    include: -4200,
    'toc-zone': -4100,
    jira: -4000,
    portfolioforjiraplan: -3900,
    'opsgenie-incident-timeline-prod-jsm-issue-activity-macro': -3800,
    'opsgenie-incident-timeline-eu-jsm-issue-activity-macro': -3700,
    'opsgenie-incident-timeline-prod-macro': -3600,
    'opsgenie-incident-timeline-eu-macro': -3500,
    viewxls: -3400,
    viewpdf: -3300,
    widget: -3200,
    'sharelinks-urlmacro': -3100,
    jirachart: -1900
};
const $7dade95d99fee536$var$gadgetQuickInsertMacroPriorities = {
    'com.atlassian.streams.streams-jira-plugin:activitystream-gadget': -3000,
    'com.pyxis.greenhopper.jira:greenhopper-gadget-rapid-view': -2900,
    'com.atlassian.jira.gadgets:assigned-to-me-gadget': -2800,
    'com.atlassian.jira.gadgets:average-age-chart-gadget': -2700,
    'com.atlassian.jira.ext.charting:numberoftimesinstatus-gadget': -2600,
    'com.atlassian.jira.ext.charting:timeinstatus-gadget': -2500,
    'com.atlassian.jira.gadgets:created-vs-resolved-issues-chart-gadget': -2400,
    'com.pyxis.greenhopper.jira:greenhopper-gadget-sprint-days-remaining': -2300,
    'com.atlassian.jira.gadgets:filter-results-gadget': -2200,
    'com.atlassian.jira.gadgets:heat-map-gadget': -2100,
    'com.atlassian.jira.gadgets:in-progress-gadget': -2000,
    'com.atlassian.jira.ext.calendar:issuescalendar-gadget': -1800,
    'com.atlassian.jira.gadgets:road-map-gadget': -1700,
    'com.atlassian.jira.gadgets:labels-gadget': -1600,
    'com.atlassian.jira.gadgets:pie-chart-gadget': -1500,
    'com.atlassian.jira.gadgets:quicklinks-gadget': -1400,
    'com.atlassian.jira.gadgets:recently-created-chart-gadget': -1300,
    'com.atlassian.jira.gadgets:resolution-time-gadget': -1200,
    'com.pyxis.greenhopper.jira:greenhopper-gadget-sprint-burndown': -1100,
    'com.pyxis.greenhopper.jira:greenhopper-gadget-sprint-health': -1000,
    'com.atlassian.jira.gadgets:favourite-filters-gadget': -900,
    'com.atlassian.jira.gadgets:time-since-chart-gadget': -800,
    'com.atlassian.jira.ext.charting:firstresponse-gadget': -700,
    'com.atlassian.jira.gadgets:two-dimensional-stats-gadget': -600,
    'com.pyxis.greenhopper.jira:greenhopper-gadget-version-report': -500,
    'com.atlassian.jira.gadgets:voted-gadget': -400,
    'com.atlassian.jira.gadgets:watched-gadget': -300,
    'com.atlassian.jira.gadgets:stats-gadget': -200,
    'com.atlassian.jira.ext.charting:workloadpie-gadget': -100
};
const $7dade95d99fee536$var$mediaQuickInsertMacroPriorities = {
    roadmap: -400,
    'profile-picture': -300,
    attachments: -200
};
const $7dade95d99fee536$var$gadgetModulePathPrefix = '/rest/gadgets/1.0/g/';
const $7dade95d99fee536$var$getGadgetQuickInsertPriority = (macro)=>{
    const gadgetUrl = macro.formDetails.parameters.find((parameter)=>parameter.name === 'url')?.defaultValue;
    const gadgetModulePath = gadgetUrl?.split($7dade95d99fee536$var$gadgetModulePathPrefix)[1];
    const gadgetModuleKey = gadgetModulePath?.split('/')[0];
    return gadgetModuleKey ? $7dade95d99fee536$var$gadgetQuickInsertMacroPriorities[gadgetModuleKey] : undefined;
};
const $7dade95d99fee536$var$dataAndChartsQuickInsertMacroPriorities = {
    children: -900,
    livesearch: -800,
    'recently-updated': -700,
    details: -600,
    detailssummary: -500,
    contentbylabel: -400,
    pagetree: -300,
    pagetreesearch: -200,
    'blog-posts': -100,
    'content-report-table': 0,
    'tasks-report-macro': 100,
    decisionreport: 200,
    contributors: 300,
    'change-history': 400,
    profile: 500,
    userlister: 600,
    listlabels: 700,
    'popular-labels': 800,
    spaces: 900,
    calendar: 1000,
    'questionslist-macro-native': 1100
};
const $7dade95d99fee536$var$isSpacesGadget = (macro)=>macro.macroName === 'gadget' && macro.title === 'Spaces';
const $7dade95d99fee536$var$isDataAndChartsAppMacro = (macro)=>macro.categories.some((category)=>{
        const normalizedCategory = category.trim().toLowerCase();
        return normalizedCategory === 'reporting' || normalizedCategory === 'development';
    });
const $7dade95d99fee536$var$getQuickInsertIcon = (macro, macroName)=>{
    if ((0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command')) {
        if (macro.macroName === 'gadget' || $7dade95d99fee536$var$appIconQuickInsertMacros.has(macroName)) return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                label: ''
            });
        switch(macroName){
            case 'attachments':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($gxI48))), {
                        label: ''
                    });
            case 'children':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($3PHGt))), {
                        label: ''
                    });
            case 'livesearch':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                        label: ''
                    });
            case 'roadmap':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($ijkxh))), {
                        label: ''
                    });
            case 'tasks-report-macro':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))), {
                        label: ''
                    });
            case 'decisionreport':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
                        label: ''
                    });
            case 'spaces':
            case 'calendar':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                        label: ''
                    });
            case 'excerpt':
            case 'excerpt-include':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($gaHi2))), {
                        label: ''
                    });
            case 'portfolioforjiraplan':
                return ()=>(0, $cozmU.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($bD3fd))), {
                        label: ''
                    });
        }
    }
    return ()=>(0, $9tVje.getIconComponent)(macro);
};
const $7dade95d99fee536$export$aa5c8863a9a118cf = (macro)=>Boolean($7dade95d99fee536$export$b57d0f2bae8a9afe(macro.moduleKey)) && macro.categories.includes('external-content');
const $7dade95d99fee536$export$a1337ae19b5dbc53 = (id)=>$7dade95d99fee536$var$pageIdRegex.test(id);
const $7dade95d99fee536$export$ab1c71053e82e441 = (editorActions)=>{
    const editorView = editorActions?._privateGetEditorView();
    if (editorView) {
        let maybeNode = editorView.state.selection.node;
        if (!maybeNode || !(0, $fgbpl.isBodiedExtension)(maybeNode.type.name)) {
            const { $head: $head } = editorView.state.selection;
            // If current selection isn't bodied extension traverse upward
            for(let i = $head.depth; i > 0; i--){
                const node = $head.node(i);
                if ((0, $fgbpl.isBodiedExtension)(node.type.name)) maybeNode = node;
            }
        }
        return maybeNode?.toJSON();
    }
};
const $7dade95d99fee536$export$aa7156f87802b87e = (value)=>(value === 0 || value === false || !!value) && (!Array.isArray(value) || value.length > 0);
const $7dade95d99fee536$export$5a7dd19f9c5b2580 = (macroParams)=>{
    const id = macroParams?.id;
    const value = typeof id === 'object' && id !== null && 'value' in id ? id.value : id;
    return typeof value === 'string' && value.trim() !== '';
};
const $7dade95d99fee536$export$80b5cdf6b2ae3720 = (macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, externalContentAppMacroPriority)=>{
    // Hidden macros don't appear in the slash menu
    // but still need to be defined in a manifest so old pages can show them
    if (macro.hidden) return [];
    const macroName = (0, $eQyFc.safeGetMacroName)(macro);
    const isEmbedQuickInsertMacro = macroName === $7dade95d99fee536$var$IFRAME_MACRO || $7dade95d99fee536$export$aa5c8863a9a118cf(macro);
    const isOtherQuickInsertMacro = macro.macroName === 'gadget' && !$7dade95d99fee536$var$isSpacesGadget(macro) || $7dade95d99fee536$var$otherQuickInsertMacros.has(macroName);
    const dataAndChartsPriority = $7dade95d99fee536$var$dataAndChartsQuickInsertMacroPriorities[macroName] ?? ($7dade95d99fee536$var$isSpacesGadget(macro) ? 900 : undefined);
    const category = !(0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command') ? undefined : isEmbedQuickInsertMacro ? $7dade95d99fee536$var$EMBED_CATEGORY : isOtherQuickInsertMacro ? 'other' : $7dade95d99fee536$var$mediaQuickInsertMacros.has(macroName) ? 'media' : dataAndChartsPriority !== undefined || $7dade95d99fee536$var$isDataAndChartsAppMacro(macro) ? 'data-and-charts' : undefined;
    const priority = !(0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command') ? undefined : macroName === $7dade95d99fee536$var$IFRAME_MACRO ? $7dade95d99fee536$var$IFRAME_EMBED_PRIORITY : isEmbedQuickInsertMacro ? externalContentAppMacroPriority : isOtherQuickInsertMacro ? macro.macroName === 'gadget' ? $7dade95d99fee536$var$getGadgetQuickInsertPriority(macro) : $7dade95d99fee536$var$otherQuickInsertMacroPriorities[macroName] : $7dade95d99fee536$var$mediaQuickInsertMacroPriorities[macroName] ?? dataAndChartsPriority;
    const icon = $7dade95d99fee536$var$getQuickInsertIcon(macro, macroName);
    try {
        const action = (0, $7b3d41287d889ce8$export$5f32dd5e0bdce03)(macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage);
        return [
            {
                key: macroName,
                title: macro.title,
                description: macro.description,
                keywords: [
                    macro.macroName,
                    ...macro.aliases
                ],
                ...category ? {
                    category: category
                } : {},
                ...priority !== undefined ? {
                    priority: priority
                } : {},
                categories: macro.categories,
                icon: async ()=>icon,
                featured: pageContext.features.elementBrowser && (0, $8pcS0.allowedMacrosForInsertMenu).includes(macroName),
                action: action
            }
        ];
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return [];
    }
};
const $7dade95d99fee536$export$b57d0f2bae8a9afe = (macroKey)=>{
    if (!macroKey || !macroKey.startsWith('com.atlassian.plugins.atlassian-connect-plugin')) return '';
    const chunks = macroKey.split('__');
    if (chunks.length !== 3) return '';
    return chunks[1];
};
const $7dade95d99fee536$export$7ea0c9b6e4a8ed9f = (node, placeholderText)=>{
    node.content = [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'placeholder',
                    attrs: {
                        text: placeholderText
                    }
                }
            ]
        }
    ];
};
const $7dade95d99fee536$export$907c23452d19a3a0 = (node, keyPlaceholderHeading, valuePlaceholderHeading)=>{
    node.content = [
        {
            type: 'table',
            attrs: {
                isNumberColumnEnabled: false,
                layout: 'default',
                localId: (0, $9Cbhx.getMacroId)(null),
                width: 760
            },
            content: [
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'placeholder',
                                            attrs: {
                                                text: keyPlaceholderHeading
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {
                                background: '#ffffff'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'placeholder',
                                            attrs: {
                                                text: valuePlaceholderHeading
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: '#f4f5f7'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'tableRow',
                    content: [
                        {
                            type: 'tableHeader',
                            attrs: {
                                background: '#f4f5f7'
                            },
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        },
                        {
                            type: 'tableCell',
                            attrs: {},
                            content: [
                                {
                                    type: 'paragraph',
                                    content: []
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
};
const $7dade95d99fee536$var$getMatchingAppLinkForViewPage = async (selectedServerId)=>{
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/jiraanywhere/1.0/servers');
        const appLinks = await res.json();
        return appLinks.find((appLink)=>appLink.id === selectedServerId);
    } catch  {}
};
const $7dade95d99fee536$var$isCloudAppLinkFromUrl = (url)=>{
    if (!url) return;
    return url.includes('atlassian.net') || url.includes('jira-dev.com');
};
const $7dade95d99fee536$export$e907759e00918f39 = async (macroName, selectedServerId = '', isViewPage = false)=>{
    if (macroName !== 'jira') return;
    let isCloudAppLink;
    if (isViewPage) {
        const selectedServerObject = await $7dade95d99fee536$var$getMatchingAppLinkForViewPage(selectedServerId);
        isCloudAppLink = $7dade95d99fee536$var$isCloudAppLinkFromUrl(selectedServerObject?.url) || $7dade95d99fee536$var$isCloudAppLinkFromUrl(selectedServerObject?.rpcUrl);
    } else try {
        // module is only available on edit page
        const ApplinksBridge = window.require('confluence/jim/jira/applinks-bridge-for-spa');
        isCloudAppLink = await ApplinksBridge.isCloudAppLinkFromServerId(selectedServerId);
    } catch  {}
    if (isCloudAppLink === undefined) return 'unknown';
    return isCloudAppLink ? 'cloud' : 'server';
};
const $7dade95d99fee536$export$b44fac35bec9acb1 = new Set([
    'anchor',
    'attachments',
    'calendar',
    'children',
    'contentbylabel',
    'content-report-table',
    'create-from-template',
    'decisionreport',
    'detailssummary',
    'gadget',
    'excerpt',
    'excerpt-include',
    'expand',
    'iframe',
    'include',
    'jira',
    'listlabels',
    'pagetree',
    'pagetreesearch',
    'panel',
    'popular-labels',
    'profile',
    'recently-updated-dashboard',
    'roadmap',
    'spaces',
    'tasks-report-macro',
    'toc',
    'toc-zone',
    'userlister',
    'viewpdf',
    'viewxls'
]);
const $7dade95d99fee536$export$30d8e5826b733890 = (macros, hideMacrosOptions)=>{
    const newMacros = [];
    const macrosToHideLivePage = new Set((0, $1xpoY.default).getStringList('confluence_frontend_hide_selected_macros', []));
    for (const macro of macros){
        const hideCompanyHubMacro = hideMacrosOptions?.isCompanyHub && $7dade95d99fee536$export$b44fac35bec9acb1.has(macro?.macroName);
        const hideLivePageMacro = hideMacrosOptions?.isLivePage && macrosToHideLivePage.has(macro?.macroName);
        if (hideCompanyHubMacro || hideLivePageMacro) {
            const hiddenMacro = {
                ...macro,
                hidden: true
            };
            newMacros.push(hiddenMacro);
        } else newMacros.push(macro);
    }
    return newMacros;
};
module.exports["isExternalContentAppMacro"] = $7dade95d99fee536$export$aa5c8863a9a118cf;
module.exports["getConnectAppKey"] = $7dade95d99fee536$export$b57d0f2bae8a9afe;
module.exports["isPageId"] = $7dade95d99fee536$export$a1337ae19b5dbc53;
module.exports["getSelectedBodiedExtensionNode"] = $7dade95d99fee536$export$ab1c71053e82e441;
module.exports["isValueSet"] = $7dade95d99fee536$export$aa7156f87802b87e;
module.exports["hasConfiguredTeamCalendar"] = $7dade95d99fee536$export$5a7dd19f9c5b2580;
module.exports["createQuickInsertModule"] = $7dade95d99fee536$export$80b5cdf6b2ae3720;
module.exports["insertMacroPlaceholder"] = $7dade95d99fee536$export$7ea0c9b6e4a8ed9f;
module.exports["insertContentPropertiesMacroPlaceholder"] = $7dade95d99fee536$export$907c23452d19a3a0;
module.exports["getJiraHostingOption"] = $7dade95d99fee536$export$e907759e00918f39;
module.exports["filterOutHiddenMacros"] = $7dade95d99fee536$export$30d8e5826b733890;

});

parcelRegister("gaGUd", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $836a8b250eda6583$var$i18n = (0, $kSwu1.defineMessages)({
    searchCalendarPlaceholder: {
        id: "fabric-extension-lib.field-mappings.calendar.field.search.placeholder",
        defaultMessage: "Begin typing to search your calendars"
    }
});
const $836a8b250eda6583$export$eccbcd2c005b0561 = (params)=>{
    const normalizedParams = {
        ...params
    };
    if (Array.isArray(normalizedParams.id)) normalizedParams.id = normalizedParams.id.join(',');
    [
        'width',
        'height'
    ].forEach((key)=>{
        const value = normalizedParams[key];
        if (value === undefined || value === null || value === '') {
            delete normalizedParams[key];
            return;
        }
        normalizedParams[key] = String(value);
    });
    if (typeof normalizedParams.hideWeekends === 'boolean') normalizedParams.hideWeekends = String(normalizedParams.hideWeekends);
    return normalizedParams;
};
const $836a8b250eda6583$export$56bbcdb8aca31149 = {
    transformFields: async ({ fields: fields, intl: intl })=>{
        return fields.map((field)=>{
            if (field.name !== 'id') return field;
            return {
                ...field,
                type: 'custom',
                isMultiple: true,
                options: {
                    resolver: {
                        type: 'calendar'
                    }
                },
                placeholder: intl.formatMessage($836a8b250eda6583$var$i18n.searchCalendarPlaceholder)
            };
        });
    },
    // Custom field receives an array
    transformBefore (params) {
        if (params.id && typeof params.id === 'string') params.id = params.id.split(',');
        return params;
    },
    // Custom field returns an array, so converting it back to string to store
    transformAfter (params) {
        if (Array.isArray(params.id)) params.id = params.id.join(',');
        return params;
    }
};
module.exports["normalizeNonLegacyCalendarMacroParams"] = $836a8b250eda6583$export$eccbcd2c005b0561;
module.exports["calendar"] = $836a8b250eda6583$export$56bbcdb8aca31149;

});

parcelRegister("kTVK2", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $735a35f26a402a9b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    basicTabLabel: {
        id: "fabric-extension-lib.recently-updated.tab.basic.label",
        defaultMessage: "Basic"
    },
    displayTabLabel: {
        id: "fabric-extension-lib.recently-updated.tab.display.label",
        defaultMessage: "Display"
    },
    spaceLabel: {
        id: "fabric-extension-lib.recently-updated.field.spaces.label",
        defaultMessage: "Space"
    },
    spacePlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.spaces.placeholder",
        defaultMessage: "Search and select by name"
    },
    typesLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.label",
        defaultMessage: "Include in list"
    },
    typePlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.types.placeholder",
        defaultMessage: "Select one or several"
    },
    maxToggleLabel: {
        id: "fabric-extension-lib.recently-updated.field.maxToggle.label",
        defaultMessage: "Show all updates"
    },
    maxLabel: {
        id: "fabric-extension-lib.recently-updated.field.max.label",
        defaultMessage: "Max number of updates"
    },
    themeLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.label",
        defaultMessage: "List style"
    },
    authorLabel: {
        id: "fabric-extension-lib.recently-updated.field.author.label",
        defaultMessage: "Filter by user"
    },
    authorPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.author.placeholder",
        defaultMessage: "Search and select user(s)"
    },
    labelsLabel: {
        id: "fabric-extension-lib.recently-updated.field.labels.label",
        defaultMessage: "Filter by label"
    },
    labelsPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.labels.placeholder",
        defaultMessage: "Search and select label(s)"
    },
    widthLabel: {
        id: "fabric-extension-lib.recently-updated.field.width.label",
        defaultMessage: "List width"
    },
    widthPlaceholder: {
        id: "fabric-extension-lib.recently-updated.field.width.placeholder",
        defaultMessage: "Select or enter width"
    },
    hideHeadingLabel: {
        id: "fabric-extension-lib.recently-updated.field.hideHeading.label",
        defaultMessage: "Hide list header"
    }
});
const $735a35f26a402a9b$export$e89c4678ffd2a62b = (0, $kSwu1.defineMessages)({
    allLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.all",
        defaultMessage: "All"
    },
    pageLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.page",
        defaultMessage: "Pages"
    },
    livePageLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.live-page",
        defaultMessage: "Live docs"
    },
    blogPostLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.blogpost",
        defaultMessage: "Blog posts"
    },
    commentLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.comment",
        defaultMessage: "Comments"
    },
    attachmentLabel: {
        id: "fabric-extension-lib.recently-updated.field.types.item.attachment",
        defaultMessage: "Attachments"
    }
});
const $735a35f26a402a9b$export$cfae297845436803 = (0, $kSwu1.defineMessages)({
    conciseLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.concise",
        defaultMessage: "Title + user name"
    },
    sidebarLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.sidebar",
        defaultMessage: "Title"
    },
    socialLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.social",
        defaultMessage: "User name + profile picture"
    }
});
const $735a35f26a402a9b$export$9227588ce3953cff = (0, $kSwu1.defineMessages)({
    fullLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.full",
        defaultMessage: "100% of frame"
    },
    threeQuartersLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.threeQuarters",
        defaultMessage: "75% of frame"
    },
    halfLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.half",
        defaultMessage: "50% of frame"
    },
    quarterLabel: {
        id: "fabric-extension-lib.recently-updated.field.theme.item.quarter",
        defaultMessage: "25% of frame"
    }
});
module.exports["i18n"] = $735a35f26a402a9b$export$a7357cdd1f0b0168;
module.exports["i18nTypes"] = $735a35f26a402a9b$export$e89c4678ffd2a62b;
module.exports["i18nTheme"] = $735a35f26a402a9b$export$cfae297845436803;
module.exports["i18nWidth"] = $735a35f26a402a9b$export$9227588ce3953cff;

});

parcelRegister("gw2T1", function(module, exports) {
/**
 * @generated SignedSource<<d820b086d4cf1cb12ee0335700a66d33>>
 * @relayHash 4fbd860d4d6da48d54a328b64149e3bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 268b2a62b6cf4cee678c07c4bdbd3f41e88e3c16fe516a9c329fed07a193a565
const $379eb7e1c064528b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortingScheme"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "sortingScheme",
                    "variableName": "sortingScheme"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "darkModeIconURL"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "templateResolverQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "templateResolverQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "4fbd860d4d6da48d54a328b64149e3bf",
            "id": "268b2a62b6cf4cee678c07c4bdbd3f41e88e3c16fe516a9c329fed07a193a565",
            "metadata": {},
            "name": "templateResolverQuery",
            "operationKind": "query",
            "text": "query templateResolverQuery($spaceKey:String!,$sortingScheme:String!){allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme){nodes{name,description,templateId,contentBlueprintId,iconURL,darkModeIconURL}}}"
        }
    };
}();
$379eb7e1c064528b$var$node.hash = "2ea84112b2cb458fa4b2fa24c60d9b43";
var $379eb7e1c064528b$export$2e2bcd8739ae039 = $379eb7e1c064528b$var$node;



var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $c0rhi = parcelRequire("c0rhi");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $c2cyb = parcelRequire("c2cyb");


var $2DGtt = parcelRequire("2DGtt");


var $10Oe6 = parcelRequire("10Oe6");

var $dcac0b0097aba21f$var$SortOrder = /*#__PURE__*/ function(SortOrder) {
    SortOrder["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    return SortOrder;
}($dcac0b0097aba21f$var$SortOrder || {});
// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- file name contains hyphens, incompatible with GraphQL naming
const $dcac0b0097aba21f$var$templateResolverQuery = (0, $379eb7e1c064528b$export$2e2bcd8739ae039);
const $dcac0b0097aba21f$var$loadLegacyTemplateStyles = (0, $dOBRD.default)((0, $2DGtt.requireStyleClassResourcesForTemplates));
const $dcac0b0097aba21f$var$getAllTemplates = async (spaceKey)=>{
    const allTemplatesData = await (0, $c0rhi.queryInterop)({
        query: $dcac0b0097aba21f$var$templateResolverQuery,
        variables: {
            spaceKey: spaceKey,
            sortingScheme: "web.item.sorting.scheme.relevancy"
        },
        __callerPackage__: "fabric-extension-lib"
    });
    return allTemplatesData?.data.allTemplates?.nodes;
};
const $dcac0b0097aba21f$var$search = async (spaceKey)=>{
    try {
        const templates = await $dcac0b0097aba21f$var$getAllTemplates(spaceKey);
        return templates.map((template)=>({
                label: template.name,
                description: template.description,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2cyb.TemplateIcon), {
                    size: "small",
                    template: template
                }),
                value: (0, $10Oe6.getTemplateId)(template)
            }));
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Failed to fetch templates from template resolver in macro config panel with error: ${error}`), {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        return [];
    }
};
const $dcac0b0097aba21f$export$a95dc440d0d8d0bc = (spaceKey)=>async (_searchTerm, _selectedValue)=>{
        return spaceKey ? $dcac0b0097aba21f$var$search(spaceKey) : [];
    };
const $dcac0b0097aba21f$export$e9ae85abdbcb00ec = ({ spaceKey: spaceKey })=>{
    $dcac0b0097aba21f$var$loadLegacyTemplateStyles();
    return $dcac0b0097aba21f$export$a95dc440d0d8d0bc(spaceKey);
};
module.exports["getTemplateResolver"] = $dcac0b0097aba21f$export$e9ae85abdbcb00ec;

});

parcelRegister("2DGtt", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $19aF3 = parcelRequire("19aF3");


var $6Ywr0 = parcelRequire("6Ywr0");


var $cpjd2 = parcelRequire("cpjd2");

const $86243521f2d43c3e$export$8a6adc80de847409 = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!com.atlassian.plugins.atlassian-connect-plugin:blueprint-css-resources',
        'wrc!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources'
    ], ()=>{
        // Although we've included 'wr!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources' here
        // The 'link-style-css' may have been executed somewhere else previously.
        // Requiring it again will not have effect. Here we are going to manually initialize it.
        (0, $6Ywr0.waitForRequiredModule)({
            listener: 'TemplateList',
            module: 'ac/confluence/style/link-style-css'
        }, ()=>{
            const linkStyleCSS = (0, $19aF3.globalRequire)('ac/confluence/style/link-style-css');
            if (linkStyleCSS && typeof linkStyleCSS.addLinkTags === 'function') linkStyleCSS.addLinkTags();
        });
    }, ()=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error('Style classes cannot be initialized when WRM is disabled.'), {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    });
};
module.exports["requireStyleClassResourcesForTemplates"] = $86243521f2d43c3e$export$8a6adc80de847409;

});

parcelRegister("ebUME", function(module, exports) {
/* eslint-disable react/jsx-no-bind */ 
var $cozmU = parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");


var $4bVKh = parcelRequire("4bVKh");


var $8pcS0 = parcelRequire("8pcS0");


var $2E7zk = parcelRequire("2E7zk");


var $kuTjv = parcelRequire("kuTjv");


var $eS4Za = parcelRequire("eS4Za");





var $5kjCz = parcelRequire("5kjCz");


var $hEeUR = parcelRequire("hEeUR");


var $jmjWc = parcelRequire("jmjWc");


const $c355983162ed69aa$export$5ede1339770bf1de = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "bVpgR",
    name: "TabsRenderer",
    loader: async ()=>(await (parcelRequire("lsmcG"))).TabsRenderer
});



var $56j2k = parcelRequire("56j2k");


var $5a4cC = parcelRequire("5a4cC");


var $9m03g = parcelRequire("9m03g");





const $b1a7e5c95fc93776$export$773b7fe42d6786b7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XSLOH",
    name: "PageTreeSSRExtensionHandler",
    loader: async ()=>(await (parcelRequire("gZaBo"))).PageTreeSSRExtensionHandler
});



var $hU8XU = parcelRequire("hU8XU");


var $4EIU1 = parcelRequire("4EIU1");


var $kRkqT = parcelRequire("kRkqT");


var $bBRJy = parcelRequire("bBRJy");


var $56y8A = parcelRequire("56y8A");


var $1UHWj = parcelRequire("1UHWj");


var $aG1nm = parcelRequire("aG1nm");


var $9K8Oh = parcelRequire("9K8Oh");


var $lJs0a = parcelRequire("lJs0a");


var $3bvCJ = parcelRequire("3bvCJ");


var $bJaqz = parcelRequire("bJaqz");


var $cTOQy = parcelRequire("cTOQy");


var $n9ft3 = parcelRequire("n9ft3");


var $jaHkh = parcelRequire("jaHkh");


var $fxgwG = parcelRequire("fxgwG");


var $CbxlN = parcelRequire("CbxlN");





const $8bb5329d9fc6676b$export$682885b7d6415d72 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OEXuM",
    name: "ExcerptIncludeSSRExtensionHandler",
    loader: async ()=>(await (parcelRequire("23Uhb"))).ExcerptIncludeSSRExtensionHandler
});



var $afWPV = parcelRequire("afWPV");


var $fQztD = parcelRequire("fQztD");


var $hCfPO = parcelRequire("hCfPO");


var $9e5dj = parcelRequire("9e5dj");


var $lE7FD = parcelRequire("lE7FD");


var $1aGr8 = parcelRequire("1aGr8");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ceVeI = parcelRequire("ceVeI");


var $bDgLe = parcelRequire("bDgLe");





var $6mEZ3 = parcelRequire("6mEZ3");


var $l7BGZ = parcelRequire("l7BGZ");

const $3f248c73bf14394e$export$e8ac5007ab7a695a = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { macroDefaultProps: macroDefaultProps } = t0;
    const { node: node } = macroDefaultProps;
    let t1;
    if ($[0] !== node) {
        t1 = (0, $6mEZ3.extensionToADF)(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const macroNode = t1;
    let t2;
    if ($[2] !== macroNode) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7BGZ.LiveSearchLoader), {
            macroNode: macroNode
        });
        $[2] = macroNode;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};









var $dwS6P = parcelRequire("dwS6P");

const $13135e29d0f1ffa1$export$cf1c26fcb7e6ff9f = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { macroDefaultProps: macroDefaultProps, adf: adf, cloudId: cloudId, userId: userId } = t0;
    let t1;
    if ($[0] !== adf || $[1] !== cloudId || $[2] !== macroDefaultProps || $[3] !== userId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dwS6P.TableOfContentsLoader), {
            userId: userId,
            cloudId: cloudId,
            adf: adf,
            macroDefaultProps: macroDefaultProps
        });
        $[0] = adf;
        $[1] = cloudId;
        $[2] = macroDefaultProps;
        $[3] = userId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};









var $cYJC5 = parcelRequire("cYJC5");

const $3211097f4985a15f$export$30c773822372f598 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, ssrButtonLabel: ssrButtonLabel } = t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== macroDefaultProps || $[2] !== ssrButtonLabel || $[3] !== userId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
            userId: userId,
            cloudId: cloudId,
            macroDefaultProps: macroDefaultProps,
            ssrButtonLabel: ssrButtonLabel
        });
        $[0] = cloudId;
        $[1] = macroDefaultProps;
        $[2] = ssrButtonLabel;
        $[3] = userId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};









var $7yhDb = parcelRequire("7yhDb");

const $632bd65baaea62ea$export$451d9dea974456b4 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { extension: extension } = t0;
    const macroId = extension?.parameters?.macroMetadata?.macroId?.value;
    const t1 = extension?.parameters;
    const t2 = macroId ? `native-embed-${macroId}` : undefined;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7yhDb.NativeEmbedInitialPlaceholder), {
            firstPaint: true,
            parameters: t1,
            placeholderId: t2,
            testId: "native-embed-ssr-placeholder"
        });
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
};



var $989nU = parcelRequire("989nU");


var $9ijui = parcelRequire("9ijui");


var $9Lixm = parcelRequire("9Lixm");

const $dff9e4cf0075d57c$export$be8c01ded2deab2c = ({ adf: adf, contentId: contentId, contentMode: contentMode, spaceKey: spaceKey, cloudId: cloudId, userId: userId, macroRenderedOutput: macroRenderedOutput, includeSuperbatch: includeSuperbatch, mediaToken: mediaToken, releaseEmptyMacrosToManifest: releaseEmptyMacrosToManifest = false })=>{
    const handlers = {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $dff9e4cf0075d57c$var$getMacroExtensionHandlerForRenderer({
            adf: adf,
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId,
            userId: userId,
            macroRenderedOutput: macroRenderedOutput,
            includeSuperbatch: includeSuperbatch,
            mediaToken: mediaToken,
            releaseEmptyMacrosToManifest: releaseEmptyMacrosToManifest
        }),
        // `nestedLcmSsrEnabled` is intentionally not passed: the handler resolves the gate per node so
        // only pages that actually contain an LCM are exposed to it.
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $9ijui.getSsrMigrationExtHandlerForRenderer)({
            contentId: contentId,
            contentMode: contentMode,
            getLcmNestedExtensionHandlers: ()=>handlers
        }),
        // The deliberately-empty handlers are omitted from the releasing set rather than being made to
        // return `null`: an absent key and a `null` result take the same branch in `ExtensionRenderer`,
        // and omitting them keeps it obvious that these types are owned by the manifest.
        ...releaseEmptyMacrosToManifest ? {} : {
            [(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES]: $dff9e4cf0075d57c$var$getEmptyHandlers(),
            [(0, $8pcS0.EXTENSION_TYPE).TEMPLATE]: $dff9e4cf0075d57c$var$getEmptyHandlers()
        },
        ...(0, $6mKj3.expVal)('confluence_native_tabs_experiment', 'isEnabled', false) ? {
            [(0, $8pcS0.EXTENSION_TYPE).NATIVE]: $dff9e4cf0075d57c$var$getNativeExtensionHandlerForRenderer()
        } : releaseEmptyMacrosToManifest ? {} : {
            [(0, $8pcS0.EXTENSION_TYPE).NATIVE]: $dff9e4cf0075d57c$var$getEmptyHandlers()
        }
    };
    return handlers;
};
const $dff9e4cf0075d57c$var$getEmptyHandlers = ()=>(0, $eS4Za.createMacroExtensionHandler)(()=>null);
const $dff9e4cf0075d57c$var$getNativeExtensionHandlerForRenderer = ()=>(extension, _doc, actions)=>{
        if (extension.extensionKey === (0, $56j2k.EXTENSION_KEY) && actions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c355983162ed69aa$export$5ede1339770bf1de), {
            node: extension,
            actions: actions
        });
        return null;
    };
const $dff9e4cf0075d57c$export$d3d0d63f461591f5 = ({ macroDefaultProps: macroDefaultProps, extension: extension, cloudId: cloudId, contentId: contentId, spaceKey: spaceKey, userId: userId, adf: adf, mediaToken: mediaToken })=>{
    function getSsrButtonLabel() {
        const { buttonLabel: buttonLabel, createButtonLabel: createButtonLabel } = macroDefaultProps.node.parameters.macroParams;
        const labelText = buttonLabel?.value || createButtonLabel?.value;
        return labelText || undefined;
    }
    return {
        [(0, $8pcS0.EXTENSION_KEY).TOC]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13135e29d0f1ffa1$export$cf1c26fcb7e6ff9f), {
                macroDefaultProps: macroDefaultProps,
                adf: adf,
                cloudId: cloudId,
                userId: userId
            }),
        [(0, $8pcS0.EXTENSION_KEY).CREATE_FROM_TEMPLATE]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3211097f4985a15f$export$30c773822372f598), {
                macroDefaultProps: macroDefaultProps,
                cloudId: cloudId,
                userId: userId,
                ssrButtonLabel: getSsrButtonLabel()
            }),
        [(0, $8pcS0.EXTENSION_KEY).LIVE_SEARCH]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3f248c73bf14394e$export$e8ac5007ab7a695a), {
                macroDefaultProps: macroDefaultProps
            }),
        [(0, $8pcS0.EXTENSION_KEY).DETAILS]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5dj.DetailsExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXPAND]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fQztD.ExpandExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXCERPT]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hCfPO.ExcerptExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                isLegacyRenderer: false,
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c,
                mediaToken: mediaToken
            }),
        [(0, $8pcS0.EXTENSION_KEY).ANCHOR]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afWPV.AnchorExtensionHandler), {
                ...macroDefaultProps,
                isSSR: true
            }),
        [(0, $8pcS0.EXTENSION_KEY).EXCERPT_INCLUDE]: ()=>{
            if (contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bb5329d9fc6676b$export$682885b7d6415d72), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            });
            else return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).PAGE_TREE]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).PAGE_TREE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1a7e5c95fc93776$export$773b7fe42d6786b7), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).PAGE_TREE_SEARCH]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).PAGE_TREE_SEARCH)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU8XU.PageTreeSearchMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).RECENTLY_UPDATED]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).RECENTLY_UPDATED)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n9ft3.RecentlyUpdatedMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: {
                    ...extension?.parameters?.macroParams,
                    currentSpaceKey: spaceKey
                }
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).PROFILE_PICTURE]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            }),
        [(0, $8pcS0.EXTENSION_KEY).PROFILE]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            }),
        [(0, $8pcS0.EXTENSION_KEY).CONTRIBUTORS]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CONTRIBUTORS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4EIU1.ContributorsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).POPULAR_LABELS]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).POPULAR_LABELS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBRJy.PopularLabelsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: {
                    ...extension?.parameters?.macroParams,
                    currentSpaceKey: spaceKey
                }
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).LIST_LABELS]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).LIST_LABELS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kRkqT.ListLabelsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: {
                    ...extension?.parameters?.macroParams,
                    currentSpaceKey: spaceKey
                }
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).VIEWPDF]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).VIEWPDF)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56y8A.ViewPdfMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).VIEWXLS]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).VIEWXLS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1UHWj.ViewXlsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).WIDGET]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).WIDGET)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aG1nm.WidgetMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).IFRAME]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).IFRAME)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9K8Oh.IFrameMacroRenderer), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).CONTENT_BY_LABEL]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CONTENT_BY_LABEL)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lJs0a.ContentByLabelSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).INCLUDE]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).INCLUDE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bvCJ.PageIncludeSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).ATTACHMENTS]: ()=>(0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).ATTACHMENTS) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJaqz.AttachmentsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            }) : null,
        [(0, $8pcS0.EXTENSION_KEY).BLOG_POSTS]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).BLOG_POSTS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTOQy.BlogPostsSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $dff9e4cf0075d57c$export$be8c01ded2deab2c
            });
            return null;
        },
        'content-report-table': ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jaHkh.ContentReportTableMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: {
                    ...extension?.parameters?.macroParams,
                    currentSpaceKey: spaceKey
                }
            });
        },
        [(0, $8pcS0.EXTENSION_KEY).TASKS_REPORT_MACRO]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)('tasks-report-macro')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxgwG.TasksReportMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).CHANGE_HISTORY]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CHANGE_HISTORY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $CbxlN.ChangeHistoryMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        [(0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY]: ()=>{
            if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lE7FD.DetailsSummaryExtensionHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            return null;
        },
        /**
     * When flag is off, return FabricLegacyMacrosServerRenderer
     * When flag is on and the calendar ID is absent, return an empty SSR wrapper until the
     * client extension provider renders the missing-configuration placeholder.
     */ ...(0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true) ? {
            [(0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS]: ()=>{
                if (!(0, $2E7zk.hasConfiguredTeamCalendar)(extension.parameters?.macroParams)) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kuTjv.TeamCalendarMacroLoader), {
                    extensionNode: extension,
                    macroDefaultProps: macroDefaultProps
                });
            }
        } : {},
        // the hide macro should render nothing in renderer
        ...(0, $6mKj3.expVal)('platform_editor_hide_extension_renderer_support', 'isEnabled', false) ? {
            [(0, $8pcS0.EXTENSION_KEY).HIDE]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-extension-key": "hide"
                })
        } : {},
        /* These macros have React implementation on SPA */ [(0, $8pcS0.EXTENSION_KEY).REDACTED_MACRO_PLACEHOLDER]: ()=>null,
        [(0, $8pcS0.EXTENSION_KEY).CONFLUENCE_DATABASES]: ()=>null,
        // Native-embed extensions use dynamic keys (e.g. 'native-embed:whiteboard',
        // 'native-embed:db'). When the current extension is a native-embed, add an
        // SSR placeholder entry so the map lookup succeeds and we avoid the legacy
        // macro renderer (which would show "Unknown macro").
        ...extension?.extensionKey?.startsWith((0, $8pcS0.EXTENSION_KEY).NATIVE_EMBED) ? {
            [extension.extensionKey]: ()=>(0, $9wGTI.fg)('native_embeds_ssr_placeholder_killswitch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-testid": "native-embed-ssr-placeholder"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $632bd65baaea62ea$export$451d9dea974456b4), {
                    extension: extension
                })
        } : {},
        ...extension?.extensionKey === (0, $8pcS0.EXTENSION_KEY).AGENT_MANAGED_BLOCK && (0, $6mKj3.expVal)('agent-managed_blocks_mvp', 'isEnabled', false) ? {
            [(0, $8pcS0.EXTENSION_KEY).AGENT_MANAGED_BLOCK]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4bVKh.AgentManagedBodiedExtensionRenderer), {
                    node: extension,
                    readOnly: true
                })
        } : {}
    };
};
const $dff9e4cf0075d57c$var$getMacroExtensionHandlerForRenderer = ({ adf: adf, contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId, includeSuperbatch: includeSuperbatch, macroRenderedOutput: macroRenderedOutput, mediaToken: mediaToken, releaseEmptyMacrosToManifest: releaseEmptyMacrosToManifest = false })=>{
    const renderMacro = (extension)=>{
        const { type: type, extensionKey: extensionKey } = extension;
        const macroId = extension?.parameters?.macroMetadata?.macroId?.value;
        const macroDefaultProps = {
            node: extension,
            contentId: contentId,
            spaceKey: spaceKey,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey
        };
        // This callback won't be available on a recursive call for handlers from bodied macros
        // but it only needs to be called on the top level of recursion.
        if (includeSuperbatch) includeSuperbatch();
        const serverExtensionHandlersMap = $dff9e4cf0075d57c$export$d3d0d63f461591f5({
            adf: adf,
            userId: userId,
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId,
            extension: extension,
            macroDefaultProps: macroDefaultProps,
            mediaToken: mediaToken
        });
        const handlerContent = serverExtensionHandlersMap[extensionKey];
        const content = typeof handlerContent === 'function' ? handlerContent() : // When early webpanel initialization is enabled, Connect resources are preloaded during SSR.
        // To prevent flickering during React hydration, we need to hide Connect macros in the SSR phase
        // by setting renderedByProvider=false. After hydration, when macros are re-rendered through
        // the provider flow (LegacyMacroRendererComponent), they will have renderedByProvider=true
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $989nU.FabricLegacyMacrosServerRenderer), {
            macroRenderedOutput: macroRenderedOutput,
            macroDefaultProps: macroDefaultProps,
            macroOutput: extension?.parameters?.macroOutput,
            renderedByProvider: !(0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)
        });
        // A mapped handler that produced nothing is declining the node, not rendering an empty macro.
        // Only the releasing set acts on that; the page set keeps returning the placeholder wrapper so
        // the server markup and its hydration are untouched.
        if (releaseEmptyMacrosToManifest && content === null) return null;
        // This boundary is not directly used but it provides reference for fixing nested div under span.
        // See next/packages/ssr-scripts-utils/src/fixUnbalancedPlaceholderCommentMarkers.ts for details
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
            placeholderId: `legacy-macro-container-${macroId}`
        }, // Mimic the logic in platform/packages/editor/renderer/src/ui/ExtensionRenderer.tsx
        // We don't update the platform code for 2 reasons:
        // 1. Backwards compatibility. I don't know if other product supplies this wrapper already (unlikely)
        // 2. More importantly this needs to be inside the legacy-macro-container-${macroId} boundary.
        //    Inline macros has <span> nested in <div> problem. We are using the boundary as guide to fix them.
        //    See next/packages/ssr-scripts-utils/src/fixUnbalancedPlaceholderCommentMarkers.ts
        type === 'inlineExtension' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Lixm.PlaceholderAwareInlineNodeRendererWrapper), {
            macroId: macroId
        }, content) : content));
    };
    return releaseEmptyMacrosToManifest ? (0, $eS4Za.createDeclinableMacroExtensionHandler)(renderMacro) : (0, $eS4Za.createMacroExtensionHandler)(renderMacro);
};
module.exports["getSsrExtensionHandlers"] = $dff9e4cf0075d57c$export$be8c01ded2deab2c;

});

parcelRegister("4bVKh", function(module, exports) {
/* render-bodied-extension.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $2lPWP = parcelRequire("2lPWP");


var $aPdNQ = parcelRequire("aPdNQ");


var $3BY7M = parcelRequire("3BY7M");


var $hRnS5 = parcelRequire("hRnS5");


var $dM4cY = parcelRequire("dM4cY");

const $456625dd94dd28be$var$jsonTransformer = new (0, $2lPWP.JSONTransformer)(); /**
                                                * Renderer/view-only renderer for the agent-managed bodied extension. Body content is supplied
                                                * via `node.content` (ADF JSON or PM `Fragment`) and rendered with `<ReactRenderer>`.
                                                *
                                                * This render path intentionally does not fetch AIMO metadata. Owner, execution metadata, and
                                                * config hydration are configuration-popup concerns; view-only rendering must be driven by the
                                                * persisted body ADF.
                                                */ 
const $456625dd94dd28be$export$1a29a712140d8f35 = ({ node: node, providerFactory: providerFactory, isSelected: isSelected, readOnly: readOnly })=>{
    // ---------------------------------------------------------------------------
    // Body content
    // ---------------------------------------------------------------------------
    const doc = (0, $cozmU.useMemo)(()=>{
        let content;
        if (Array.isArray(node.content)) content = node.content;
        else if (node.content instanceof (0, $aPdNQ.Fragment)) {
            // Already PM nodes — encode directly to ADF JSON
            content = [];
            node.content.forEach((child)=>{
                content.push($456625dd94dd28be$var$jsonTransformer.encodeNode(child));
            });
        } else content = [
            {
                type: 'paragraph'
            }
        ];
        // This is already valid ADF — just wrap it as a doc
        return {
            version: 1,
            type: 'doc',
            content: content
        };
    }, [
        node.content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dM4cY.AgentManagedExtensionView), {
        isSelected: isSelected,
        readOnly: readOnly
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: doc,
        appearance: "full-width",
        dataProviders: providerFactory
    })));
};
module.exports["AgentManagedBodiedExtensionRenderer"] = $456625dd94dd28be$export$1a29a712140d8f35;

});

parcelRegister("dM4cY", function(module, exports) {
/* AgentManagedExtensionView.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gC0KQ = parcelRequire("gC0KQ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

/* AnimatedBorder.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $9kbTQ = parcelRequire("9kbTQ");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $227019d9bb73a30a$var$LIGHT_COLORS = [
    '#FCA700',
    '#6A9A23',
    '#1868DB',
    '#AF59E0'
];
const $227019d9bb73a30a$var$DARK_COLORS = [
    '#FCA700',
    '#82B536',
    '#357DE8',
    '#BF63F3'
];
const $227019d9bb73a30a$var$svgStrokeAnimation = null;
const $227019d9bb73a30a$var$styles = {
    overlay: "_2fBhtekUgz _1mT5xdWVPG _1ZB6UydnbC _2I62gzdnbC _1OKFqYdnbC _3iC0zddnbC _1pp6NdYbGa _1EXLIo7dHp",
    svg: "_1mT5xdWVPG _2I62gzdnbC _3iC0zddnbC _1rdFvhjOvk"
};
const $227019d9bb73a30a$var$emptyBorderSize = {
    height: 0,
    perimeter: 0,
    width: 0
};
const $227019d9bb73a30a$var$getBorderSize = (element)=>{
    const rect = element.getBoundingClientRect();
    const height = Math.round(Math.max(rect.height, element.scrollHeight));
    const width = Math.round(Math.max(rect.width, element.scrollWidth));
    return {
        height: height,
        perimeter: (height + width) * 2,
        width: width
    };
};
const $227019d9bb73a30a$export$3bfefaa89ceb40fc = ({ borderRadius: borderRadius = true, containerElement: containerElement, isExecuting: isExecuting = false })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const colors = colorMode === 'dark' ? $227019d9bb73a30a$var$DARK_COLORS : $227019d9bb73a30a$var$LIGHT_COLORS;
    const [borderSize, setBorderSize] = (0, $cozmU.useState)($227019d9bb73a30a$var$emptyBorderSize);
    (0, $cozmU.useEffect)(()=>{
        if (!containerElement || !isExecuting) {
            setBorderSize($227019d9bb73a30a$var$emptyBorderSize);
            return;
        }
        if (typeof window === 'undefined') return;
        let rafId;
        const updateBorderSize = ()=>{
            if (rafId !== undefined) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(()=>{
                setBorderSize($227019d9bb73a30a$var$getBorderSize(containerElement));
                rafId = undefined;
            });
        };
        updateBorderSize();
        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', updateBorderSize);
            return ()=>{
                if (rafId !== undefined) cancelAnimationFrame(rafId);
                window.removeEventListener('resize', updateBorderSize);
            };
        }
        const resizeObserver = new ResizeObserver(updateBorderSize);
        resizeObserver.observe(containerElement);
        return ()=>{
            if (rafId !== undefined) cancelAnimationFrame(rafId);
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        isExecuting
    ]);
    const calculateDashArray = (0, $cozmU.useCallback)((renderPosition)=>{
        if (renderPosition === 0) return 0;
        const dashArrayLength = Math.round(borderSize.perimeter / colors.length * (colors.length - renderPosition));
        const dashOffset = borderSize.perimeter - dashArrayLength;
        return `${dashArrayLength} ${dashOffset}`;
    }, [
        borderSize.perimeter,
        colors
    ]);
    if (!containerElement || !isExecuting || borderSize.height === 0 || borderSize.width === 0) return null;
    const overlayStyle = {
        '--stroke-perimeter': borderSize.perimeter,
        height: borderSize.height,
        width: borderSize.width
    };
    const rectHeight = Math.max(borderSize.height - 2, 0);
    const rectWidth = Math.max(borderSize.width - 2, 0);
    return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: overlayStyle,
        className: (0, $hekY6.default)([
            $227019d9bb73a30a$var$styles.overlay
        ])
    }, colors.map((color, index)=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
            key: color
        }, /*#__PURE__*/ $cozmU.createElement("svg", {
            height: borderSize.height,
            width: borderSize.width,
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $hekY6.default)([
                $227019d9bb73a30a$var$styles.svg
            ])
        }, /*#__PURE__*/ $cozmU.createElement("rect", {
            "data-testid": `animated-${color}`,
            height: rectHeight,
            rx: borderRadius ? '4' : '0',
            ry: borderRadius ? '4' : '0',
            stroke: color,
            strokeDasharray: calculateDashArray(index),
            strokeWidth: "var(--ds-space-025, 2px)",
            width: rectWidth,
            x: "1",
            y: "1"
        }))))), containerElement);
};


/* NoBodyExecutionLoading.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $9GVkD = parcelRequire("9GVkD");

const $14f3c05429e29b71$var$GRAPHIC_COUNT = 3;
const $14f3c05429e29b71$var$GRAPHIC_INTERVAL_MS = 1200;
const $14f3c05429e29b71$var$GRAPHIC_BODY_HEIGHT = '152px';
const $14f3c05429e29b71$var$LINE_HEIGHT = '12px';
const $14f3c05429e29b71$var$CHIP_SIZE = '24px';
const $14f3c05429e29b71$var$styles = {
    wrapper: "_4c065UNHnM _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _4kiQYAJrQY",
    panel: "_2mHwu88HPE _3iDTPbgBM8 _0GwItXDIqT _0jFU0VJrQY _39xV02N91d _1EqgXlgs9g",
    row: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    line: "_0bjKvDS5Zs _0jFU0VxpxF _0KLXruGsB2",
    lineLong: "_39xV02CAAg",
    lineMedium: "_39xV02lIjS",
    lineShort: "_39xV02Lsv4",
    chip: "_0bjKvDS5Zs _39xV02oWWg _0jFU0VoWWg _0KLXruB8KG _3YEZNOdnbC",
    chart: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLF05b _0jFU0VFFh0",
    bar: "_0bjKvDKxmn _39xV02bnhY _0KLXrup9dS",
    barShort: "_0jFU0Ve65H",
    barMedium: "_0jFU0VAqsq",
    barTall: "_0jFU0VY4tC",
    cardGrid: "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2Lmr7",
    card: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0jFU0VmpvA _0KLXruo126"
};
const $14f3c05429e29b71$var$DocumentGraphic = ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.panel
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.line,
            $14f3c05429e29b71$var$styles.lineLong
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.line,
            $14f3c05429e29b71$var$styles.lineMedium
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.line,
            $14f3c05429e29b71$var$styles.lineLong
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.line,
            $14f3c05429e29b71$var$styles.lineShort
        ])
    }));
const $14f3c05429e29b71$var$ListGraphic = ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.panel
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.row
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.chip
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.line,
            $14f3c05429e29b71$var$styles.lineLong
        ])
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.row
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.chip
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.line,
            $14f3c05429e29b71$var$styles.lineMedium
        ])
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.row
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.chip
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.line,
            $14f3c05429e29b71$var$styles.lineShort
        ])
    })));
const $14f3c05429e29b71$var$ChartGraphic = ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.panel
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.chart
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.bar,
            $14f3c05429e29b71$var$styles.barMedium
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.bar,
            $14f3c05429e29b71$var$styles.barTall
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.bar,
            $14f3c05429e29b71$var$styles.barShort
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.bar,
            $14f3c05429e29b71$var$styles.barMedium
        ])
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.cardGrid
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.card
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.card
        ])
    })));
const $14f3c05429e29b71$export$89d3599a7c1e6f39 = ({ label: label })=>{
    const [graphicIndex, setGraphicIndex] = (0, $cozmU.useState)(0);
    (0, $cozmU.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            setGraphicIndex((currentIndex)=>(currentIndex + 1) % $14f3c05429e29b71$var$GRAPHIC_COUNT);
        }, $14f3c05429e29b71$var$GRAPHIC_INTERVAL_MS);
        return ()=>clearInterval(intervalId);
    }, []);
    const graphic = graphicIndex === 0 ? /*#__PURE__*/ $cozmU.createElement($14f3c05429e29b71$var$DocumentGraphic, null) : graphicIndex === 1 ? /*#__PURE__*/ $cozmU.createElement($14f3c05429e29b71$var$ListGraphic, null) : /*#__PURE__*/ $cozmU.createElement($14f3c05429e29b71$var$ChartGraphic, null);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "agent-managed-extension-no-body-loading",
        role: "status",
        className: (0, $hekY6.default)([
            $14f3c05429e29b71$var$styles.wrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, label), graphic);
};



var $jHZ78 = parcelRequire("jHZ78");


var $uia0q = parcelRequire("uia0q");

/* NoBodyExecutionError.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $ad7Ou = parcelRequire("ad7Ou");


var $hz2oZ = parcelRequire("hz2oZ");




var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");




const $6fdfe1763647f0bd$var$styles = {
    body: "_4c065U8HPE _2Y7lL48HPE",
    hiddenEditableBody: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VdnbC _0fKRyPnQyn",
    noBodyError: "_4kiQYAT0NC"
};
const $6fdfe1763647f0bd$export$89773c162ac03eca = ({ children: children, contentRef: contentRef, onRetry: onRetry })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6fdfe1763647f0bd$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.100",
        testId: "agent-managed-extension-no-body-error",
        xcss: $6fdfe1763647f0bd$var$styles.noBodyError,
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "center",
        color: "color.text.danger"
    }, intl.formatMessage((0, $uia0q.messages).blockContentsFetchError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($hz2oZ))),
        isDisabled: !onRetry,
        onClick: onRetry,
        spacing: "compact"
    }, intl.formatMessage((0, $uia0q.messages).retryBlockExecution))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6fdfe1763647f0bd$var$styles.hiddenEditableBody,
        ref: contentRef
    }, children));
};


const $a34fc81537fc4268$var$styles = {
    wrapper: "_0bjKvDKxmn _23rrnHYyC4 _1mT5xdRAKS _39xV02N91d _24h04i2Njc _2zndICNvrM _497WNw6wH8 _2xIroYjOvk _3e6OgrdnbC _3gEqZj9r67",
    wrapperSelected: "_2xIroYnXvL _3gEqZjnXvL",
    wrapperError: "_2xIroYnod9 _3gEqZjnod9",
    label: "_0bjKvDKxmn _2sNsIg7NXe _23rrnHKlYM _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1mT5xdWVPG _2IhTonB0rP _4ApkO22ADO _42Yu6B7dHp _0Of8r2FQfX _1ZnuxbgVvo _1wydGWFQfX _2Zuz6QgVvo _0KLXrulfZc _1UtDYzZpcK _1pp6NdYbGa _20VacPYbGa _1YKVNsdnbC",
    labelVisible: "_1YKVNs7dHp",
    labelSelected: "_3vBAKHrzt2 _1YKVNs7dHp _0KLXruY9q9 _1UtDYzjTy9",
    labelError: "_3vBAKHnod9 _1YKVNs7dHp _0KLXruhH7k _1UtDYzAyGJ",
    body: "_4c065U8HPE _2Y7lL48HPE",
    bodyNoBodyLoading: "_4c065UdnbC _2Y7lL4dnbC",
    hiddenEditableBody: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VdnbC _0fKRyPnQyn"
};
const $a34fc81537fc4268$export$1e7d7813fa68c4f3 = ({ lifecycleState: lifecycleState })=>lifecycleState === 'execution-error'; /**
                                                      * Custom chrome vs extension default: hover-/selection-revealed Rovo lozenge in the top-right,
                                                      * subtle border on hover, focused border when selected, read-only body.
                                                      */ 
const $a34fc81537fc4268$export$6353c1f65c6273ee = ({ isSelected: isSelected, children: children, contentDOM: contentDOM, hasGeneratedBodyContent: hasGeneratedBodyContent, lifecycleState: lifecycleState, onRetry: onRetry, readOnly: readOnly })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isInteracted, setIsInteracted] = (0, $cozmU.useState)(false);
    const [wrapperElement, setWrapperElement] = (0, $cozmU.useState)(null);
    const bodyRef = (0, $cozmU.useRef)(null);
    const handleEnter = (0, $cozmU.useCallback)(()=>setIsInteracted(true), []);
    const handleLeave = (0, $cozmU.useCallback)(()=>setIsInteracted(false), []);
    const handleWrapperRef = (0, $cozmU.useCallback)((element)=>{
        setWrapperElement(element);
    }, []); /* Intentionally run after every render. React can remount the wrapper while ProseMirror keeps the same contentDOM node alive, so this reattaches the editor-managed body whenever the wrapper changes.
           */ 
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!contentDOM || !bodyRef.current || contentDOM.parentElement === bodyRef.current) return;
        bodyRef.current.appendChild(contentDOM);
    });
    if (readOnly) {
        // In view-only contexts (e.g. classic page renderer), render just the body
        // without any interactive chrome (hover border, label, selection state).
        if (contentDOM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: bodyRef
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    }
    const isExecuting = (0, $jHZ78.isExecutingLifecycleState)(lifecycleState);
    const isNoBodyExecuting = lifecycleState === 'no-body-executing';
    const isExecutionError = lifecycleState === 'execution-error';
    const isNoBodyExecutionError = isExecutionError && !hasGeneratedBodyContent;
    const showErrorChrome = $a34fc81537fc4268$export$1e7d7813fa68c4f3({
        lifecycleState: lifecycleState
    });
    const showLabel = isInteracted || isSelected || isExecuting || showErrorChrome;
    const showBorderSelected = isSelected && !isExecuting && !showErrorChrome;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: handleWrapperRef,
        onMouseEnter: handleEnter,
        onMouseLeave: handleLeave,
        onFocus: handleEnter,
        onBlur: handleLeave,
        className: (0, $hekY6.default)([
            $a34fc81537fc4268$var$styles.wrapper,
            showBorderSelected && $a34fc81537fc4268$var$styles.wrapperSelected,
            showErrorChrome && $a34fc81537fc4268$var$styles.wrapperError
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $227019d9bb73a30a$export$3bfefaa89ceb40fc), {
        containerElement: wrapperElement,
        isExecuting: isExecuting
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $a34fc81537fc4268$var$styles.label,
            showLabel && $a34fc81537fc4268$var$styles.labelVisible,
            (isSelected || isExecuting) && $a34fc81537fc4268$var$styles.labelSelected,
            showErrorChrome && $a34fc81537fc4268$var$styles.labelError
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
        label: "",
        size: "small"
    }), intl.formatMessage((0, $uia0q.messages).blockLabel))), isNoBodyExecuting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $a34fc81537fc4268$var$styles.body,
            $a34fc81537fc4268$var$styles.bodyNoBodyLoading
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14f3c05429e29b71$export$89d3599a7c1e6f39), {
        label: intl.formatMessage((0, $uia0q.messages).loadingBlockContents)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: bodyRef,
        className: (0, $hekY6.default)([
            $a34fc81537fc4268$var$styles.hiddenEditableBody
        ])
    }, children)) : isNoBodyExecutionError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6fdfe1763647f0bd$export$89773c162ac03eca), {
        contentRef: bodyRef,
        onRetry: onRetry
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: bodyRef,
        className: (0, $hekY6.default)([
            $a34fc81537fc4268$var$styles.body
        ])
    }, children));
};
module.exports["AgentManagedExtensionView"] = $a34fc81537fc4268$export$6353c1f65c6273ee;

});

parcelRegister("jHZ78", function(module, exports) {
const $a74ffb4beb6c74ef$export$689f86cb42320756 = (lifecycleState)=>lifecycleState === 'no-body-executing' || lifecycleState === 'existing-body-executing';
const $a74ffb4beb6c74ef$export$c6f91e7591690bd6 = (node)=>{
    if (node.childCount === 0) return false;
    if (node.childCount !== 1) return true;
    // If only one child that's a paragraph, don't count it
    const onlyChild = node.child(0);
    return !(onlyChild.type.name === 'paragraph' && onlyChild.childCount === 0);
};
const $a74ffb4beb6c74ef$export$1441c7c8743fa33e = (node)=>$a74ffb4beb6c74ef$export$c6f91e7591690bd6(node) ? 'existing-body-executing' : 'no-body-executing';
const $a74ffb4beb6c74ef$export$296a7b86617dad4e = ({ hasLocalExecutionError: hasLocalExecutionError, node: node, transientLifecycleState: transientLifecycleState })=>{
    if ($a74ffb4beb6c74ef$export$689f86cb42320756(transientLifecycleState)) return transientLifecycleState;
    if (hasLocalExecutionError) return 'execution-error';
    return $a74ffb4beb6c74ef$export$c6f91e7591690bd6(node) ? 'generated' : 'idle';
};
module.exports["isExecutingLifecycleState"] = $a74ffb4beb6c74ef$export$689f86cb42320756;
module.exports["hasGeneratedBodyContent"] = $a74ffb4beb6c74ef$export$c6f91e7591690bd6;
module.exports["getExecutionLifecycleState"] = $a74ffb4beb6c74ef$export$1441c7c8743fa33e;
module.exports["getAgentManagedBlockLifecycleState"] = $a74ffb4beb6c74ef$export$296a7b86617dad4e;

});

parcelRegister("uia0q", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $95ca0a1683d3a71b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    insertTitle: {
        id: "fabric.editor.agentManagedExtension.insert.title.non-final",
        defaultMessage: "AI Block"
    },
    insertDescription: {
        id: "fabric.editor.agentManagedExtension.insert.description.non-final",
        defaultMessage: "Configure a block to your desired output and let Rovo keep it updated"
    },
    insertExecutiveSummaryTitle: {
        id: "fabric.editor.agentManagedExtension.insert.executiveSummary.title.ai-non-final",
        defaultMessage: "Executive summary [AI Block]"
    },
    insertExecutiveSummaryDescription: {
        id: "fabric.editor.agentManagedExtension.insert.executiveSummary.description.ai-non-final",
        defaultMessage: "Summarize the current page and linked sources in a Rovo-updated panel"
    },
    insertMeetingRecapTitle: {
        id: "fabric.editor.agentManagedExtension.insert.meetingRecap.title.ai-non-final",
        defaultMessage: "Meeting recap [AI Block]"
    },
    insertMeetingRecapDescription: {
        id: "fabric.editor.agentManagedExtension.insert.meetingRecap.description.ai-non-final",
        defaultMessage: "Recap highlights, decisions, and action items from the current page"
    },
    insertDecisionRegisterTitle: {
        id: "fabric.editor.agentManagedExtension.insert.decisionRegister.title.ai-non-final",
        defaultMessage: "Decision register [AI Block]"
    },
    insertDecisionRegisterDescription: {
        id: "fabric.editor.agentManagedExtension.insert.decisionRegister.description.ai-non-final",
        defaultMessage: "Track decisions from sources you choose in a Rovo-updated table"
    },
    customize: {
        id: "fabric.editor.agentManagedExtension.toolbar.customize.non-final",
        defaultMessage: "Customize"
    },
    autoUpdateInterval: {
        id: "fabric.editor.agentManagedExtension.toolbar.autoUpdateInterval.ai-non-final",
        defaultMessage: "Auto-update interval"
    },
    noAutoUpdate: {
        id: "fabric.editor.agentManagedExtension.toolbar.noAutoUpdate.ai-non-final",
        defaultMessage: "No auto-update"
    },
    regenerate: {
        id: "fabric.editor.agentManagedExtension.toolbar.regenerate.non-final",
        defaultMessage: "Regenerate"
    },
    owner: {
        id: "fabric.editor.agentManagedExtension.config.owner.non-final",
        defaultMessage: "Owner"
    },
    lastSuccessfulExecution: {
        id: "fabric.editor.agentManagedExtension.config.lastSuccessfulExecution.non-final",
        defaultMessage: "Updated"
    },
    loadingBlockContents: {
        id: "fabric.editor.agentManagedExtension.loadingBlockContents.non-final",
        defaultMessage: "Executing block contents"
    },
    loadingConfiguration: {
        id: "fabric.editor.agentManagedExtension.loadingConfiguration.ai-non-final",
        defaultMessage: "Loading block configuration"
    },
    failedToLoadConfiguration: {
        id: "fabric.editor.agentManagedExtension.failedToLoadConfiguration.ai-non-final",
        defaultMessage: "Failed to load configuration"
    },
    retryConfigurationLoad: {
        id: "fabric.editor.agentManagedExtension.retryConfigurationLoad.ai-non-final",
        defaultMessage: "Retry"
    },
    blockContentsFetchError: {
        id: "fabric.editor.agentManagedExtension.blockContentsFetchError.non-final",
        defaultMessage: "There was an error generating the block's content"
    },
    retryBlockExecution: {
        id: "fabric.editor.agentManagedExtension.retryBlockExecution.non-final",
        defaultMessage: "Retry"
    },
    configureBlock: {
        id: "fabric.editor.agentManagedExtension.config.title.non-final",
        defaultMessage: "Customize AI Block"
    },
    customInstructionsLabel: {
        id: "fabric.editor.agentManagedExtension.config.customInstructionsLabel.non-final",
        defaultMessage: "Custom instructions"
    },
    customInstructionsPlaceholder: {
        id: "fabric.editor.agentManagedExtension.config.customInstructionsPlaceholder.non-final",
        defaultMessage: "Tell the agent what this block should contain. For example: \"Summarise the latest takeaways from my meetings with Team A and write a short summary that...\""
    },
    save: {
        id: "fabric.editor.agentManagedExtension.config.save.non-final",
        defaultMessage: "Save"
    },
    cancel: {
        id: "fabric.editor.agentManagedExtension.config.cancel.non-final",
        defaultMessage: "Cancel"
    },
    blockLabel: {
        id: "fabric.editor.agentManagedExtension.blockLabel.non-final",
        defaultMessage: "AI Block"
    },
    fetchError: {
        id: "fabric.editor.agentManagedExtension.fetchError.non-final",
        defaultMessage: "Unable to load this AI Block. It may have been deleted or you may not have permission to view it."
    },
    saveError: {
        id: "fabric.editor.agentManagedExtension.config.saveError.non-final",
        defaultMessage: "There was an error saving the block configuration"
    },
    invalidDesiredUpdateFrequency: {
        id: "fabric.editor.agentManagedExtension.config.invalidDesiredUpdateFrequency.ai-non-final",
        defaultMessage: "Choose how often this block should update."
    },
    missingOutputFormat: {
        id: "fabric.editor.agentManagedExtension.config.missingOutputFormat.ai-non-final",
        defaultMessage: "Choose an output format."
    },
    missingSources: {
        id: "fabric.editor.agentManagedExtension.config.missingSources.ai-non-final",
        defaultMessage: "Add at least one source."
    },
    emptyPrompt: {
        id: "fabric.editor.agentManagedExtension.config.emptyPrompt.ai-non-final",
        defaultMessage: "Custom instructions cannot be empty."
    },
    missingGoal: {
        id: "fabric.editor.agentManagedExtension.config.missingGoal.ai-non-final",
        defaultMessage: "Choose what this block should create."
    },
    configurationAriaLabel: {
        id: "fabric.editor.agentManagedExtension.config.ariaLabel.non-final",
        defaultMessage: "AI Block configuration"
    },
    configurationModeLabel: {
        id: "fabric.editor.agentManagedExtension.config.configurationModeLabel.ai-non-final",
        defaultMessage: "Customization mode"
    },
    configurationModeConfig: {
        id: "fabric.editor.agentManagedExtension.config.configurationModeConfig.ai-non-final",
        defaultMessage: "Configuration"
    },
    configurationModePrompt: {
        id: "fabric.editor.agentManagedExtension.config.configurationModePrompt.ai-non-final",
        defaultMessage: "Manual prompt"
    },
    contentGoalLabel: {
        id: "fabric.editor.agentManagedExtension.config.contentGoalLabel.ai-non-final",
        defaultMessage: "Content"
    },
    goalExecutiveSummary: {
        id: "fabric.editor.agentManagedExtension.config.goalExecutiveSummary.ai-non-final",
        defaultMessage: "Executive summary"
    },
    goalDecisionRegister: {
        id: "fabric.editor.agentManagedExtension.config.goalDecisionRegister.ai-non-final",
        defaultMessage: "Decision register"
    },
    goalSystemDesign: {
        id: "fabric.editor.agentManagedExtension.config.goalSystemDesign.ai-non-final",
        defaultMessage: "System design"
    },
    goalMeetingRecap: {
        id: "fabric.editor.agentManagedExtension.config.goalMeetingRecap.ai-non-final",
        defaultMessage: "Meeting recap"
    },
    outputFormatLabel: {
        id: "fabric.editor.agentManagedExtension.config.outputFormatLabel.ai-non-final",
        defaultMessage: "Format"
    },
    outputFormatText: {
        id: "fabric.editor.agentManagedExtension.config.outputFormatText.ai-non-final",
        defaultMessage: "Text"
    },
    outputFormatTextIcon: {
        id: "fabric.editor.agentManagedExtension.config.outputFormatTextIcon.ai-non-final",
        defaultMessage: "A"
    },
    outputFormatList: {
        id: "fabric.editor.agentManagedExtension.config.outputFormatList.ai-non-final",
        defaultMessage: "List"
    },
    outputFormatTable: {
        id: "fabric.editor.agentManagedExtension.config.outputFormatTable.ai-non-final",
        defaultMessage: "Table"
    },
    outputFormatPanel: {
        id: "fabric.editor.agentManagedExtension.config.outputFormatPanel.ai-non-final",
        defaultMessage: "Panel"
    },
    outputFormatDiagram: {
        id: "fabric.editor.agentManagedExtension.config.outputFormatDiagram.ai-non-final",
        defaultMessage: "Diagram"
    },
    sourcesLabel: {
        id: "fabric.editor.agentManagedExtension.config.sourcesLabel.ai-non-final",
        defaultMessage: "Sources"
    },
    sourcesModeManual: {
        id: "fabric.editor.agentManagedExtension.config.sourcesModeManual.ai-non-final",
        defaultMessage: "Provide a list of sources"
    },
    sourcesModeCurrentPage: {
        id: "fabric.editor.agentManagedExtension.config.sourcesModeCurrentPage.ai-non-final",
        defaultMessage: "Current page and linked sources"
    },
    sourcesPlaceholder: {
        id: "fabric.editor.agentManagedExtension.config.sourcesPlaceholder.ai-non-final",
        defaultMessage: "Paste a link"
    },
    sourceDisclaimerCopy: {
        id: "fabric.editor.agentManagedExtension.config.sourceDisclaimerCopy.ai-non-final",
        defaultMessage: "Content visibility is based on your permissions. Please verify your source and page security settings to keep data safe."
    },
    sourceRequiredError: {
        id: "fabric.editor.agentManagedExtension.config.sourceRequiredError.ai-non-final",
        defaultMessage: "Add at least one valid source link."
    },
    sourcePendingError: {
        id: "fabric.editor.agentManagedExtension.config.sourcePendingError.ai-non-final",
        defaultMessage: "Wait for source links to finish resolving."
    },
    sourceInvalidError: {
        id: "fabric.editor.agentManagedExtension.config.sourceInvalidError.ai-non-final",
        defaultMessage: "Fix or remove sources that are invalid."
    },
    sourceLimitError: {
        id: "fabric.editor.agentManagedExtension.config.sourceLimitError.ai-non-final",
        defaultMessage: "You can add up to 10 source links."
    },
    sourceResolving: {
        id: "fabric.editor.agentManagedExtension.config.sourceResolving.ai-non-final",
        defaultMessage: "Resolving link"
    },
    sourceInvalid: {
        id: "fabric.editor.agentManagedExtension.config.sourceInvalid.ai-non-final",
        defaultMessage: "Unable to resolve link"
    },
    sourceInvalidUrl: {
        id: "fabric.editor.agentManagedExtension.config.sourceInvalidUrl.ai-non-final",
        defaultMessage: "Enter a valid URL."
    },
    sourceNotFound: {
        id: "fabric.editor.agentManagedExtension.config.sourceNotFound.ai-non-final",
        defaultMessage: "Not Found"
    },
    sourceUnauthorized: {
        id: "fabric.editor.agentManagedExtension.config.sourceUnauthorized.ai-non-final",
        defaultMessage: "Unauthorized"
    },
    sourceUnavailable: {
        id: "fabric.editor.agentManagedExtension.config.sourceUnavailable.ai-non-final",
        defaultMessage: "Unavailable"
    },
    retrySourceLabel: {
        id: "fabric.editor.agentManagedExtension.config.retrySourceLabel.ai-non-final",
        defaultMessage: "Retry {source}"
    },
    sourceLinksLabel: {
        id: "fabric.editor.agentManagedExtension.config.sourceLinksLabel.ai-non-final",
        defaultMessage: "Source links"
    },
    removeSourceLabel: {
        id: "fabric.editor.agentManagedExtension.config.removeSourceLabel.ai-non-final",
        defaultMessage: "Remove {source}"
    },
    additionalContextLabel: {
        id: "fabric.editor.agentManagedExtension.config.additionalContextLabel.ai-non-final",
        defaultMessage: "Additional Context"
    },
    additionalContextDetailsLabel: {
        id: "fabric.editor.agentManagedExtension.config.additionalContextDetailsLabel.ai-non-final",
        defaultMessage: "Additional Context details"
    },
    additionalContextPlaceholder: {
        id: "fabric.editor.agentManagedExtension.config.additionalContextPlaceholder.ai-non-final",
        defaultMessage: "Add details the agent should consider when creating this block."
    },
    additionalContextRequiredError: {
        id: "fabric.editor.agentManagedExtension.config.additionalContextRequiredError.ai-non-final",
        defaultMessage: "Provide additional context or uncheck this option."
    },
    additionalContextCharactersRemaining: {
        id: "fabric.editor.agentManagedExtension.config.additionalContextCharactersRemaining.ai-non-final",
        defaultMessage: "{remaining} characters left"
    },
    promptToggleLabel: {
        id: "fabric.editor.agentManagedExtension.config.promptToggleLabel.ai-non-final",
        defaultMessage: "Describe what you want"
    },
    updateIntervalLabel: {
        id: "fabric.editor.agentManagedExtension.config.updateIntervalLabel.ai-non-final",
        defaultMessage: "Preferred update interval"
    },
    updateIntervalShort: {
        id: "fabric.editor.agentManagedExtension.config.updateIntervalShort.ai-non-final",
        defaultMessage: "Short"
    },
    updateIntervalMedium: {
        id: "fabric.editor.agentManagedExtension.config.updateIntervalMedium.ai-non-final",
        defaultMessage: "Medium"
    },
    updateIntervalLong: {
        id: "fabric.editor.agentManagedExtension.config.updateIntervalLong.ai-non-final",
        defaultMessage: "Long"
    }
});
module.exports["messages"] = $95ca0a1683d3a71b$export$defe85febe8b728c;

});

parcelRegister("kuTjv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $3Dja5 = parcelRequire("3Dja5");

const $15b6d7f8ea897e41$export$7b7a0d746113dc04 = (0, $3Dja5.TeamCalendarMacroSsrPlaceholder);

const $15b6d7f8ea897e41$export$dfcad3bc49f3c2bf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "cHonf",
    name: "TeamCalendarMacroLoader",
    loader: async ()=>(await (parcelRequire("ewo0G"))).TeamCalendarMacro,
    loading: $15b6d7f8ea897e41$export$7b7a0d746113dc04
});
module.exports["TeamCalendarMacroLoader"] = $15b6d7f8ea897e41$export$dfcad3bc49f3c2bf;

});

parcelRegister("3Dja5", function(module, exports) {
/* TeamCalendarMacroSsrPlaceholder.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $gXegP = parcelRequire("gXegP");

const $e24f7b91258e007d$var$styles = {
    dimensions: "_4bt5LAnQyn _2WAcuGnQyn",
    skeleton: "_0bjKvDKxmn _39xV02N91d _0jFU0VN91d _4kiQYAdnbC _24h04i2Njc _0KLXrunmFW"
};
const $e24f7b91258e007d$export$9218ddb934e8c910 = ({ extensionNode: extensionNode })=>{
    const macroParams = (0, $gXegP.getMacroParams)(extensionNode);
    const macroOptions = (0, $gXegP.getMacroOptions)(macroParams);
    const macroDimensions = (0, $gXegP.getMacroDimensions)(macroParams, macroOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "calendar-macro-ssr-placeholder",
        style: {
            width: macroDimensions.width,
            height: macroDimensions.height
        },
        className: (0, $hekY6.default)([
            $e24f7b91258e007d$var$styles.dimensions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "aria-hidden": true,
        "data-testid": "team-calendar-macro-ssr-placeholder",
        className: (0, $hekY6.default)([
            $e24f7b91258e007d$var$styles.skeleton
        ])
    }));
};
module.exports["TeamCalendarMacroSsrPlaceholder"] = $e24f7b91258e007d$export$9218ddb934e8c910;

});

parcelRegister("gXegP", function(module, exports) {

var $4eJH6 = parcelRequire("4eJH6");

/**
 * Maps the legacy macro `defaultView` parameter value to a FullCalendar view.
 *
 * Legacy values: 'month', 'week', 'list', 'upcoming', 'timeline'.
 * 'upcoming' is treated as 'list' (matching legacy behavior).
 */ const $192da96e74cb3ff5$var$MACRO_VIEW_TO_CALENDAR_VIEW = {
    month: (0, $4eJH6.CalendarView).dayGridMonth,
    week: (0, $4eJH6.CalendarView).timeGridWeek,
    list: (0, $4eJH6.CalendarView).listMonth,
    upcoming: (0, $4eJH6.CalendarView).listMonth,
    timeline: (0, $4eJH6.CalendarView).timeline
};
const $192da96e74cb3ff5$var$VALID_LEGEND_POSITIONS = new Set([
    'bottom',
    'right',
    'none'
]);
const $192da96e74cb3ff5$var$DEFAULT_MACRO_WIDTH = '100%';
const $192da96e74cb3ff5$var$DEFAULT_MACRO_HEIGHT = '920px';
const $192da96e74cb3ff5$var$DEFAULT_MACRO_TIMELINE_HEIGHT = '500px';
const $192da96e74cb3ff5$var$DEFAULT_LIST_VIEW_HEIGHT = '360px';
// The macro toolbar is 32px with a 4px bottom margin.
const $192da96e74cb3ff5$var$MACRO_TOOLBAR_RESERVED_HEIGHT = '36px';
const $192da96e74cb3ff5$var$MACRO_BOTTOM_LEGEND_RESERVED_HEIGHT = '150px';
function $192da96e74cb3ff5$export$a02be1bb81b9c448(extensionNode) {
    const parameters = extensionNode?.parameters;
    return parameters?.macroParams;
}
/**
 * Normalizes a dimension value to a valid CSS string.
 * If the value is purely numeric, appends 'px'. Otherwise returns as-is
 * (e.g. '100%', '50vw'). When a fallback is provided, returns it if value is empty.
 */ function $192da96e74cb3ff5$var$toCssDimension(value, fallback) {
    if (!value) return fallback;
    return /^\d+$/.test(value) ? `${value}px` : value;
}
function $192da96e74cb3ff5$var$getMacroWidth(width) {
    return $192da96e74cb3ff5$var$toCssDimension(width, $192da96e74cb3ff5$var$DEFAULT_MACRO_WIDTH);
}
function $192da96e74cb3ff5$var$getMacroLegendPosition(legendPosition, calendarView) {
    // Legacy list-style macro views do not render the calendar legend; an undefined view
    // still uses the default legend position.
    if (calendarView === (0, $4eJH6.CalendarView).listMonth) return 'none';
    return legendPosition && $192da96e74cb3ff5$var$VALID_LEGEND_POSITIONS.has(legendPosition) ? legendPosition : 'bottom';
}
function $192da96e74cb3ff5$var$getHideWeekends(calendarView, hideWeekends) {
    return hideWeekends === 'true' && // Missing defaultView renders as month in TeamCalendarContainer
    (calendarView === undefined || calendarView === (0, $4eJH6.CalendarView).dayGridMonth || calendarView === (0, $4eJH6.CalendarView).timeGridWeek);
}
function $192da96e74cb3ff5$var$getMacroHeight(calendarView, savedHeight, legendPosition) {
    if (calendarView === (0, $4eJH6.CalendarView).listMonth) return $192da96e74cb3ff5$var$DEFAULT_LIST_VIEW_HEIGHT;
    if (calendarView !== (0, $4eJH6.CalendarView).timeline) return $192da96e74cb3ff5$var$DEFAULT_MACRO_HEIGHT;
    const height = $192da96e74cb3ff5$var$toCssDimension(savedHeight, $192da96e74cb3ff5$var$DEFAULT_MACRO_TIMELINE_HEIGHT);
    if (legendPosition === 'bottom') return `calc(${height} + ${$192da96e74cb3ff5$var$MACRO_TOOLBAR_RESERVED_HEIGHT} + ${$192da96e74cb3ff5$var$MACRO_BOTTOM_LEGEND_RESERVED_HEIGHT})`;
    return `calc(${height} + ${$192da96e74cb3ff5$var$MACRO_TOOLBAR_RESERVED_HEIGHT})`;
}
function $192da96e74cb3ff5$export$ca199381d185246f(macroParams) {
    const savedDefaultView = macroParams?.defaultView?.value;
    const calendarView = savedDefaultView ? $192da96e74cb3ff5$var$MACRO_VIEW_TO_CALENDAR_VIEW[savedDefaultView] : undefined;
    const legendPosition = macroParams?.showLegend?.value;
    return {
        subCalendarId: macroParams?.id?.value,
        calendarView: calendarView,
        legendPosition: $192da96e74cb3ff5$var$getMacroLegendPosition(legendPosition, calendarView),
        hideWeekends: $192da96e74cb3ff5$var$getHideWeekends(calendarView, macroParams?.hideWeekends?.value)
    };
}
function $192da96e74cb3ff5$export$8aa047df908bce32(macroParams, macroOptions) {
    return {
        width: $192da96e74cb3ff5$var$getMacroWidth(macroParams?.width?.value),
        height: $192da96e74cb3ff5$var$getMacroHeight(macroOptions.calendarView, macroParams?.height?.value, macroOptions.legendPosition)
    };
}
module.exports["getMacroParams"] = $192da96e74cb3ff5$export$a02be1bb81b9c448;
module.exports["getMacroOptions"] = $192da96e74cb3ff5$export$ca199381d185246f;
module.exports["getMacroDimensions"] = $192da96e74cb3ff5$export$8aa047df908bce32;

});

parcelRegister("ewo0G", function(module, exports) {

let $a926adb7611d883d$var$load = (parcelRequire("6dFT0"))(5);



module.exports = Promise.all([
    $a926adb7611d883d$var$load("i7f39"),
    $a926adb7611d883d$var$load("hwJJ4"),
    $a926adb7611d883d$var$load("hhss7"),
    $a926adb7611d883d$var$load("cjpt9"),
    $a926adb7611d883d$var$load("6wr18"),
    $a926adb7611d883d$var$load("bm0oR"),
    $a926adb7611d883d$var$load("61Bv2"),
    (parcelRequire("aZWbq"))((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve("jL45t"), 5)),
    $a926adb7611d883d$var$load("c831e"),
    $a926adb7611d883d$var$load("9pso5"),
    $a926adb7611d883d$var$load("5oU5X"),
    $a926adb7611d883d$var$load("1vpKj"),
    $a926adb7611d883d$var$load("5zHCN"),
    $a926adb7611d883d$var$load("4fYzp"),
    $a926adb7611d883d$var$load("fVexC"),
    $a926adb7611d883d$var$load("kUuw5"),
    $a926adb7611d883d$var$load("bOwpR"),
    $a926adb7611d883d$var$load("eOkWq"),
    $a926adb7611d883d$var$load("1gATC"),
    $a926adb7611d883d$var$load("BKxAI"),
    $a926adb7611d883d$var$load("251nM"),
    $a926adb7611d883d$var$load("8ZQ6W"),
    $a926adb7611d883d$var$load("k0Z8C"),
    $a926adb7611d883d$var$load("eUsnQ"),
    $a926adb7611d883d$var$load("6C7Vr"),
    $a926adb7611d883d$var$load("fKQ9j"),
    $a926adb7611d883d$var$load("Wowvf"),
    $a926adb7611d883d$var$load("bOOzQ"),
    $a926adb7611d883d$var$load("ffEVr"),
    $a926adb7611d883d$var$load("alL67"),
    $a926adb7611d883d$var$load("hOyQU")
]).then(()=>parcelRequire('7CXUE'));

});

parcelRegister("aZWbq", function(module, exports) {
"use strict";

var $87Wxe = parcelRequire("87Wxe");

module.exports = $87Wxe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("87Wxe", function(module, exports) {
"use strict";
let $5eac61fceb5317f9$var$cachedBundles = {};
let $5eac61fceb5317f9$var$cachedPreloads = {};
let $5eac61fceb5317f9$var$cachedPrefetches = {};
function $5eac61fceb5317f9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $5eac61fceb5317f9$var$cachedPreloads;
        case 'prefetch':
            return $5eac61fceb5317f9$var$cachedPrefetches;
        default:
            return $5eac61fceb5317f9$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $5eac61fceb5317f9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("eS4Za", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3KymM = parcelRequire("3KymM");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $hp2SH = parcelRequire("hp2SH");

const $b665af2ad4850853$export$399071cd24abe8c9 = (extensionHandler)=>(extension, ...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3KymM.ApolloProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                value: sessionData
            }, extensionHandler(extension, args)))));
const $b665af2ad4850853$export$315a24ca028edad3 = (extensionHandler)=>(extension, ...args)=>{
        const content = extensionHandler(extension, args);
        if (content === null) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3KymM.ApolloProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                value: sessionData
            }, content))));
    };
module.exports["createMacroExtensionHandler"] = $b665af2ad4850853$export$399071cd24abe8c9;
module.exports["createDeclinableMacroExtensionHandler"] = $b665af2ad4850853$export$315a24ca028edad3;

});

parcelRegister("lsmcG", function(module, exports) {

let $f9ed6fa94020948e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f9ed6fa94020948e$var$load("aIWH7"),
    $f9ed6fa94020948e$var$load("5d9j0"),
    $f9ed6fa94020948e$var$load("i7f39"),
    $f9ed6fa94020948e$var$load("hwJJ4"),
    $f9ed6fa94020948e$var$load("6wr18"),
    $f9ed6fa94020948e$var$load("fE5au"),
    $f9ed6fa94020948e$var$load("1xDdE"),
    $f9ed6fa94020948e$var$load("1fGjB"),
    $f9ed6fa94020948e$var$load("bxj2D"),
    $f9ed6fa94020948e$var$load("Wowvf"),
    $f9ed6fa94020948e$var$load("ffEVr"),
    $f9ed6fa94020948e$var$load("03rqT")
]).then(()=>parcelRequire('5p9jx'));

});

parcelRegister("56j2k", function(module, exports) {
const $3d4ca9eac7d4ca53$export$2400baf28368a887 = 'com.atlassian.confluence.native';
const $3d4ca9eac7d4ca53$export$f9804d409e73a2cd = 'native-tabs';
const $3d4ca9eac7d4ca53$export$a7101a6af68ca580 = 2;
const $3d4ca9eac7d4ca53$export$a50894142f3121af = (index)=>`Tab ${index + 1}`;
module.exports["EXTENSION_TYPE"] = $3d4ca9eac7d4ca53$export$2400baf28368a887;
module.exports["EXTENSION_KEY"] = $3d4ca9eac7d4ca53$export$f9804d409e73a2cd;
module.exports["DEFAULT_TAB_COUNT"] = $3d4ca9eac7d4ca53$export$a7101a6af68ca580;
module.exports["getDefaultTabTitle"] = $3d4ca9eac7d4ca53$export$a50894142f3121af;

});

parcelRegister("5a4cC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f06d0ac854f743bf$export$6e074cbc05db83c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HdoLX",
    name: "UserProfileMacroHandler",
    loader: async ()=>(await (parcelRequire("9eVKP"))).UserProfileMacroRenderer
});
module.exports["UserProfileMacroHandler"] = $f06d0ac854f743bf$export$6e074cbc05db83c0;

});

parcelRegister("9eVKP", function(module, exports) {

let $6ba238ac3be53f4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6ba238ac3be53f4e$var$load("iGaRG"),
    $6ba238ac3be53f4e$var$load("kJ1vX"),
    $6ba238ac3be53f4e$var$load("6wr18"),
    $6ba238ac3be53f4e$var$load("1GCFv"),
    $6ba238ac3be53f4e$var$load("dZsGY"),
    $6ba238ac3be53f4e$var$load("ffEVr"),
    $6ba238ac3be53f4e$var$load("1a9Rr")
]).then(()=>parcelRequire('7fnEu'));

});

parcelRegister("9m03g", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3a1aa0d1408c31a1$export$ef74c28fadeef856 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9VP6s",
    name: "ProfilePictureMacroHandler",
    loader: async ()=>(await (parcelRequire("iaG5E"))).ProfilePictureMacroRenderer
});
module.exports["ProfilePictureMacroHandler"] = $3a1aa0d1408c31a1$export$ef74c28fadeef856;

});

parcelRegister("iaG5E", function(module, exports) {

let $d3a9cf619a5bf75c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d3a9cf619a5bf75c$var$load("iGaRG"),
    $d3a9cf619a5bf75c$var$load("kJ1vX"),
    $d3a9cf619a5bf75c$var$load("dZsGY"),
    $d3a9cf619a5bf75c$var$load("1mjYg")
]).then(()=>parcelRequire('lhP7Q'));

});

parcelRegister("gZaBo", function(module, exports) {

let $c5da91348c7341c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5da91348c7341c2$var$load("cCZEH").then(()=>parcelRequire('bW5ug'));

});

parcelRegister("hU8XU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c644f5052a4090a4$export$5e1fb74a89636b6f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2pHj1",
    name: "PageTreeSearchMacroHandler",
    loader: async ()=>(await (parcelRequire("6RAP6"))).PageTreeSearchMacroRenderer
});
module.exports["PageTreeSearchMacroHandler"] = $c644f5052a4090a4$export$5e1fb74a89636b6f;

});

parcelRegister("6RAP6", function(module, exports) {

let $4ff441a63cb99515$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4ff441a63cb99515$var$load("Wowvf"),
    $4ff441a63cb99515$var$load("7ycBx")
]).then(()=>parcelRequire('3vsgC'));

});

parcelRegister("4EIU1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ca91a7add9b68235$export$6e2b74536a36d352 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "uqLR8",
    name: "ContributorsMacroHandler",
    loader: async ()=>(await (parcelRequire("l4qba"))).ContributorsMacroRenderer
});
module.exports["ContributorsMacroHandler"] = $ca91a7add9b68235$export$6e2b74536a36d352;

});

parcelRegister("l4qba", function(module, exports) {

let $f56e4757a78c99dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f56e4757a78c99dd$var$load("4Vi6H").then(()=>parcelRequire('6z74O'));

});

parcelRegister("kRkqT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8ca3f59df1aa2ae7$export$f349f88b8aa49061 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "S3ezO",
    name: "ListLabelsMacroHandler",
    loader: async ()=>(await (parcelRequire("bTjIN"))).ListLabelsMacroRenderer
});
module.exports["ListLabelsMacroHandler"] = $8ca3f59df1aa2ae7$export$f349f88b8aa49061;

});

parcelRegister("bTjIN", function(module, exports) {

let $8a8421078f685d21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a8421078f685d21$var$load("ijN0a").then(()=>parcelRequire('2p61G'));

});

parcelRegister("bBRJy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bb729e1e68aa918a$export$534a4ed828af76a3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "bHeuy",
    name: "PopularLabelsMacroHandler",
    loader: async ()=>(await (parcelRequire("escjo"))).PopularLabelsMacroRenderer
});
module.exports["PopularLabelsMacroHandler"] = $bb729e1e68aa918a$export$534a4ed828af76a3;

});

parcelRegister("escjo", function(module, exports) {

let $a85d3b13fea932b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a85d3b13fea932b8$var$load("jafIc").then(()=>parcelRequire('6Q7Aj'));

});

parcelRegister("56y8A", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $6d72f0122f453df0$export$8891c9419b26f49f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "_8UTJ",
    name: "ViewPdfMacroHandler",
    loader: async ()=>(await (parcelRequire("9XOl8"))).ViewPdfMacroRenderer
});
module.exports["ViewPdfMacroHandler"] = $6d72f0122f453df0$export$8891c9419b26f49f;

});

parcelRegister("9XOl8", function(module, exports) {

let $7410ac3516419165$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7410ac3516419165$var$load("6wr18"),
    $7410ac3516419165$var$load("1lNFf"),
    $7410ac3516419165$var$load("60PUI"),
    $7410ac3516419165$var$load("1xeJ3"),
    $7410ac3516419165$var$load("4bzNN"),
    $7410ac3516419165$var$load("hhss7"),
    $7410ac3516419165$var$load("ffEVr"),
    $7410ac3516419165$var$load("1jZEp")
]).then(()=>parcelRequire('guhEN'));

});

parcelRegister("1UHWj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $869f9905a34f4e38$export$326eda97f06c6611 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PNGs6",
    name: "ViewXlsMacroHandler",
    loader: async ()=>(await (parcelRequire("4CRhQ"))).ViewXlsMacroRenderer
});
module.exports["ViewXlsMacroHandler"] = $869f9905a34f4e38$export$326eda97f06c6611;

});

parcelRegister("4CRhQ", function(module, exports) {

let $35e40ba95008d42d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $35e40ba95008d42d$var$load("1lNFf"),
    $35e40ba95008d42d$var$load("hhss7"),
    $35e40ba95008d42d$var$load("k33XE")
]).then(()=>parcelRequire('8f2ji'));

});

parcelRegister("aG1nm", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2afa4f522c4b10c4$export$5e653d7c9395c99d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EHfR8",
    name: "WidgetMacroHandler",
    loader: async ()=>(await (parcelRequire("hRj8s"))).WidgetMacroRenderer
});
module.exports["WidgetMacroHandler"] = $2afa4f522c4b10c4$export$5e653d7c9395c99d;

});

parcelRegister("hRj8s", function(module, exports) {

let $d0063acc000d73c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0063acc000d73c2$var$load("6CcO4").then(()=>parcelRequire('27fbe'));

});

parcelRegister("9K8Oh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $e3b1e2ba71b8a3ba$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $e3b1e2ba71b8a3ba$var$NEWLINE_REGEX = /\n/g;
var $e3b1e2ba71b8a3ba$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $e3b1e2ba71b8a3ba$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $e3b1e2ba71b8a3ba$var$COLON_REGEX = /^:\s*/;
var $e3b1e2ba71b8a3ba$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $e3b1e2ba71b8a3ba$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $e3b1e2ba71b8a3ba$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $e3b1e2ba71b8a3ba$var$NEWLINE = '\n';
var $e3b1e2ba71b8a3ba$var$FORWARD_SLASH = '/';
var $e3b1e2ba71b8a3ba$var$ASTERISK = '*';
var $e3b1e2ba71b8a3ba$var$EMPTY_STRING = '';
// types
var $e3b1e2ba71b8a3ba$var$TYPE_COMMENT = 'comment';
var $e3b1e2ba71b8a3ba$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ function $e3b1e2ba71b8a3ba$export$2e2bcd8739ae039(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($e3b1e2ba71b8a3ba$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($e3b1e2ba71b8a3ba$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($e3b1e2ba71b8a3ba$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($e3b1e2ba71b8a3ba$var$FORWARD_SLASH != style.charAt(0) || $e3b1e2ba71b8a3ba$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($e3b1e2ba71b8a3ba$var$EMPTY_STRING != style.charAt(i) && ($e3b1e2ba71b8a3ba$var$ASTERISK != style.charAt(i) || $e3b1e2ba71b8a3ba$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($e3b1e2ba71b8a3ba$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $e3b1e2ba71b8a3ba$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($e3b1e2ba71b8a3ba$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($e3b1e2ba71b8a3ba$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($e3b1e2ba71b8a3ba$var$VALUE_REGEX);
        var ret = pos({
            type: $e3b1e2ba71b8a3ba$var$TYPE_DECLARATION,
            property: $e3b1e2ba71b8a3ba$var$trim(prop[0].replace($e3b1e2ba71b8a3ba$var$COMMENT_REGEX, $e3b1e2ba71b8a3ba$var$EMPTY_STRING)),
            value: val ? $e3b1e2ba71b8a3ba$var$trim(val[0].replace($e3b1e2ba71b8a3ba$var$COMMENT_REGEX, $e3b1e2ba71b8a3ba$var$EMPTY_STRING)) : $e3b1e2ba71b8a3ba$var$EMPTY_STRING
        });
        // ;
        match($e3b1e2ba71b8a3ba$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
}
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $e3b1e2ba71b8a3ba$var$trim(str) {
    return str ? str.replace($e3b1e2ba71b8a3ba$var$TRIM_REGEX, $e3b1e2ba71b8a3ba$var$EMPTY_STRING) : $e3b1e2ba71b8a3ba$var$EMPTY_STRING;
}
 //# sourceMappingURL=index.mjs.map


/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $efaa8720c63cb618$export$2e2bcd8739ae039(style, iterator) {
    let styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    const declarations = (0, $e3b1e2ba71b8a3ba$export$2e2bcd8739ae039)(style);
    const hasIterator = typeof iterator === 'function';
    declarations.forEach((declaration)=>{
        if (declaration.type !== 'declaration') return;
        const { property: property, value: value } = declaration;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}
 //# sourceMappingURL=index.mjs.map


/**
 * Converts the legacy iframe macro's inline CSS `style` string into a React style object.
 *
 * The legacy macro renders the iframe as raw HTML, so its `style` param is a CSS string
 * (e.g. `"width: 560px; height: 315px; border: 4px solid red;"`). React's `style` prop expects
 * an object (`{ width: '560px', ... }`), so the migrated macro has to parse the string.
 *
 * Tokenizing CSS correctly is deceptively hard — values legitimately contain `;` inside quotes,
 * `url(...)`, and `/* ... *‍/` comments — so rather than hand-roll a tokenizer we delegate that
 * to `style-to-object` (built on `inline-style-parser`, the same parser the remark/rehype and
 * `html-react-parser` ecosystems use). It returns raw kebab-case / vendor-prefixed property
 * names, which we then map to React style keys via {@link toReactStyleName}.
 */ // Legacy parity: strip declarations that could let embedded content escape its container or
// stack above the rest of the page. These are removed before parsing, not parsed and dropped.
const $c55d453dfdcf0abb$var$Z_INDEX_PATTERN = /z-index\s*:\s*-?\d+(?:\.\d+)?\s*(?:!\s*important)?\s*;?/gi;
const $c55d453dfdcf0abb$var$POSITION_PATTERN = /position\s*:\s*(absolute|fixed)\s*(?:!\s*important)?\s*;?/gi;
const $c55d453dfdcf0abb$export$335460a25fd63ea1 = (style)=>{
    const sanitised = style?.replace($c55d453dfdcf0abb$var$Z_INDEX_PATTERN, '').replace($c55d453dfdcf0abb$var$POSITION_PATTERN, '').trim();
    return sanitised || undefined;
};
/**
 * Converts a CSS property name to its React style key (e.g. `border-radius` -> `borderRadius`,
 * `-ms-overflow-style` -> `msOverflowStyle`). CSS custom properties (`--foo`) are passed through
 * unchanged by the caller.
 */ const $c55d453dfdcf0abb$var$toReactStyleName = (name)=>{
    const camelCaseName = name.toLowerCase().replace(/-([a-z])/g, (_match, letter)=>letter.toUpperCase());
    return camelCaseName.startsWith('Ms') ? `ms${camelCaseName.slice(2)}` : camelCaseName;
};
const $c55d453dfdcf0abb$export$e13dc740254f53d7 = (style)=>{
    const sanitisedStyle = $c55d453dfdcf0abb$export$335460a25fd63ea1(style);
    if (!sanitisedStyle) return undefined;
    let parsedDeclarations;
    try {
        parsedDeclarations = (0, $efaa8720c63cb618$export$2e2bcd8739ae039)(sanitisedStyle);
    } catch  {
        return undefined;
    }
    if (!parsedDeclarations) return undefined;
    const styleEntries = {};
    for (const [propertyName, propertyValue] of Object.entries(parsedDeclarations)){
        const reactPropertyName = propertyName.startsWith('--') ? propertyName : $c55d453dfdcf0abb$var$toReactStyleName(propertyName);
        styleEntries[reactPropertyName] = propertyValue;
    }
    return Object.keys(styleEntries).length ? styleEntries : undefined;
};





const $c6527a6791adfb8d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    embeddedContentTitle: {
        id: "iframe-macro.embedded-content-title",
        defaultMessage: "Embedded iframe content"
    },
    error: {
        id: "iframe-macro.error",
        defaultMessage: "We're unable to display the iframe. Refresh to try again"
    }
});


// Legacy parity: this combines allow-same-origin with allow-scripts, which weakens sandbox
// isolation because same-origin framed content can remove its sandbox attribute. Follow up on
// whether allow-same-origin can be removed without breaking legacy iframe macro content.
const $096beb8776f0e106$var$SANDBOX_ALLOW_LIST = 'allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation-by-user-activation';
const $096beb8776f0e106$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c6527a6791adfb8d$export$a7357cdd1f0b0168).error);
const $096beb8776f0e106$var$getParamValue = (param)=>{
    if (param?.value === null || param?.value === undefined) return undefined;
    if (param.value === '') return undefined;
    return String(param.value);
};
const $096beb8776f0e106$var$getNumberParamValue = (param)=>{
    const value = $096beb8776f0e106$var$getParamValue(param);
    if (value === undefined) return undefined;
    const numberValue = Number(value);
    return Number.isNaN(numberValue) ? undefined : numberValue;
};
const $096beb8776f0e106$export$9a4c980db5b1b148 = (frameBorder)=>!frameBorder || frameBorder === 'show' ? '1' : '0';
const $096beb8776f0e106$export$74ca6e45ec6209a0 = (allowFullScreen)=>Boolean(allowFullScreen && allowFullScreen !== 'false');
const $096beb8776f0e106$var$IFrameMacroRendererInner = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const intl = (0, $kSwu1.useIntl)();
    const macroId = macroDefaultProps?.attributes?.macroId;
    const title = $096beb8776f0e106$var$getParamValue(macroParams?.title) || intl.formatMessage((0, $c6527a6791adfb8d$export$a7357cdd1f0b0168).embeddedContentTitle);
    const longDescription = $096beb8776f0e106$var$getParamValue(macroParams?.longdesc);
    const marginWidth = $096beb8776f0e106$var$getNumberParamValue(macroParams?.marginwidth);
    const style = (0, $c55d453dfdcf0abb$export$e13dc740254f53d7)($096beb8776f0e106$var$getParamValue(macroParams?.style));
    const marginHeight = $096beb8776f0e106$var$getNumberParamValue(macroParams?.marginheight);
    const className = $096beb8776f0e106$var$getParamValue(macroParams?.class);
    const align = $096beb8776f0e106$var$getParamValue(macroParams?.align);
    const iframeAttributes = {
        src: $096beb8776f0e106$var$getParamValue(macroParams?.src),
        dir: $096beb8776f0e106$var$getParamValue(macroParams?.dir),
        scrolling: $096beb8776f0e106$var$getParamValue(macroParams?.scrolling),
        name: $096beb8776f0e106$var$getParamValue(macroParams?.name),
        width: $096beb8776f0e106$var$getParamValue(macroParams?.width),
        id: $096beb8776f0e106$var$getParamValue(macroParams?.id),
        height: $096beb8776f0e106$var$getParamValue(macroParams?.height),
        lang: $096beb8776f0e106$var$getParamValue(macroParams?.lang),
        frameBorder: $096beb8776f0e106$export$9a4c980db5b1b148($096beb8776f0e106$var$getParamValue(macroParams?.frameborder)),
        allowFullScreen: $096beb8776f0e106$export$74ca6e45ec6209a0($096beb8776f0e106$var$getParamValue(macroParams?.allowfullscreen)),
        sandbox: $096beb8776f0e106$var$SANDBOX_ALLOW_LIST,
        loading: 'lazy',
        ...align ? {
            align: align
        } : {},
        ...longDescription ? {
            longdesc: longDescription
        } : {},
        ...marginWidth !== undefined ? {
            marginWidth: marginWidth
        } : {},
        ...style ? {
            style: style
        } : {},
        ...marginHeight !== undefined ? {
            marginHeight: marginHeight
        } : {},
        ...className ? {
            className: className
        } : {}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "iframe-macro",
        "data-fabric-macro": macroId,
        "data-macro-body": ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        title: title,
        ...iframeAttributes
    }));
};
const $096beb8776f0e106$export$3b40b07e6d71440c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $096beb8776f0e106$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($096beb8776f0e106$var$IFrameMacroRendererInner, props));
module.exports["IFrameMacroRenderer"] = $096beb8776f0e106$export$3b40b07e6d71440c;

});

parcelRegister("lJs0a", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aP3K1 = parcelRequire("aP3K1");


var $jCoeB = parcelRequire("jCoeB");

const $164ad4b09b7281c3$export$1f919be8bd8e4808 = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, getExtensionHandlers: getExtensionHandlers, macroParams: macroParams } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== extensionKey || $[2] !== macroParams || $[3] !== mode || $[4] !== node || $[5] !== spaceKey) {
        t1 = (RendererWrapper)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aP3K1.ContentByLabelMacroHandler), {
                macroDefaultProps: {
                    contentId: contentId,
                    extensionKey: extensionKey,
                    mode: mode,
                    node: node,
                    spaceKey: spaceKey
                },
                macroParams: macroParams ?? node?.parameters?.macroParams,
                RendererWrapper: RendererWrapper
            });
        $[0] = contentId;
        $[1] = extensionKey;
        $[2] = macroParams;
        $[3] = mode;
        $[4] = node;
        $[5] = spaceKey;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== Renderer || $[8] !== appearance || $[9] !== getExtensionHandlers || $[10] !== showTemplateInputInPreview || $[11] !== showTemplateVariablesInPreview || $[12] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jCoeB.NestedAdfSSRRendererWrapperProvider), {
            appearance: appearance,
            Renderer: Renderer,
            getExtensionHandlers: getExtensionHandlers,
            showTemplateInputInPreview: showTemplateInputInPreview,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview
        }, t1);
        $[7] = Renderer;
        $[8] = appearance;
        $[9] = getExtensionHandlers;
        $[10] = showTemplateInputInPreview;
        $[11] = showTemplateVariablesInPreview;
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};
module.exports["ContentByLabelSSRExtensionHandler"] = $164ad4b09b7281c3$export$1f919be8bd8e4808;

});

parcelRegister("aP3K1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $38169255f90ed52c$export$a73c49fb1eea9ca1 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "kI21K",
    name: "ContentByLabelMacroHandler",
    loader: async ()=>(await (parcelRequire("dN6Ko"))).ContentByLabelMacroRenderer
});
module.exports["ContentByLabelMacroHandler"] = $38169255f90ed52c$export$a73c49fb1eea9ca1;

});

parcelRegister("dN6Ko", function(module, exports) {

let $a0a515d1c7f6d170$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a0a515d1c7f6d170$var$load("6wr18"),
    $a0a515d1c7f6d170$var$load("ffEVr"),
    $a0a515d1c7f6d170$var$load("98x6Z")
]).then(()=>parcelRequire('86upE'));

});

parcelRegister("jCoeB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");


var $2w2Hu = parcelRequire("2w2Hu");

var $3GQl6 = parcelRequire("3GQl6");


var $dF6Hu = parcelRequire("dF6Hu");

const $db6537c320edf782$export$3740cbf49551dbf1 = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { appearance: appearance, Renderer: Renderer, getExtensionHandlers: getExtensionHandlers, showTemplateInputInPreview: showTemplateInputInPreview, showTemplateVariablesInPreview: showTemplateVariablesInPreview, children: children } = t0;
    (0, $3GQl6.mustPreloadWhenRenderingSPA)([
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicRendererLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader
    ]);
    let t1;
    if ($[0] !== Renderer || $[1] !== appearance || $[2] !== getExtensionHandlers || $[3] !== showTemplateInputInPreview || $[4] !== showTemplateVariablesInPreview) {
        t1 = (t2)=>{
            const { adf: adf, targetContentId: targetContentId, targetSpaceKey: targetSpaceKey, mediaToken: mediaToken, headingIdPrefix: headingIdPrefix } = t2;
            const document = (0, $dF6Hu.createNestedAdfDocument)(adf);
            const extensionHandlers = getExtensionHandlers({
                adf: document,
                contentId: targetContentId,
                spaceKey: targetSpaceKey,
                appearance: appearance,
                showTemplateInputInPreview: showTemplateInputInPreview,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Renderer, {
                contentId: targetContentId,
                document: document,
                hasInlineComments: false,
                showTemplateInputInPreview: showTemplateInputInPreview,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview,
                extensionHandlers: extensionHandlers,
                appearance: appearance || "default",
                spaceKey: targetSpaceKey,
                mediaToken: mediaToken,
                headingIdPrefix: headingIdPrefix
            }));
        };
        $[0] = Renderer;
        $[1] = appearance;
        $[2] = getExtensionHandlers;
        $[3] = showTemplateInputInPreview;
        $[4] = showTemplateVariablesInPreview;
        $[5] = t1;
    } else t1 = $[5];
    const RendererWrapper = t1;
    let t2;
    if ($[6] !== RendererWrapper || $[7] !== children) {
        t2 = children(RendererWrapper);
        $[6] = RendererWrapper;
        $[7] = children;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
};
module.exports["NestedAdfSSRRendererWrapperProvider"] = $db6537c320edf782$export$3740cbf49551dbf1;

});

parcelRegister("3bvCJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b4889398ce59e88b$export$2d6c44ffbbe19ecf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Tgsgg",
    name: "PageIncludeSSRExtensionHandler",
    loader: async ()=>(await (parcelRequire("5cco7"))).PageIncludeSSRExtensionHandler
});
module.exports["PageIncludeSSRExtensionHandler"] = $b4889398ce59e88b$export$2d6c44ffbbe19ecf;

});

parcelRegister("5cco7", function(module, exports) {

let $3c87aec0a017f267$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c87aec0a017f267$var$load("8O117").then(()=>parcelRequire('8ICFG'));

});

parcelRegister("bJaqz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2eb3e95c7ce89a73$export$d9dc98b71ab468d7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xGyjo",
    name: "AttachmentsMacroHandler",
    loader: async ()=>(await (parcelRequire("2ET1X"))).AttachmentsMacroRenderer
});
module.exports["AttachmentsMacroHandler"] = $2eb3e95c7ce89a73$export$d9dc98b71ab468d7;

});

parcelRegister("2ET1X", function(module, exports) {

let $1efa0119169df774$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1efa0119169df774$var$load("iGaRG"),
    $1efa0119169df774$var$load("kJ1vX"),
    $1efa0119169df774$var$load("bPYfd"),
    $1efa0119169df774$var$load("1GCFv"),
    $1efa0119169df774$var$load("dZsGY"),
    $1efa0119169df774$var$load("90ymC"),
    $1efa0119169df774$var$load("jOE2W"),
    $1efa0119169df774$var$load("cuNBo"),
    $1efa0119169df774$var$load("2XRLb"),
    $1efa0119169df774$var$load("gkVge"),
    $1efa0119169df774$var$load("io0qR"),
    $1efa0119169df774$var$load("3MJxZ"),
    $1efa0119169df774$var$load("e3OZZ"),
    $1efa0119169df774$var$load("cL682"),
    $1efa0119169df774$var$load("4MePG"),
    $1efa0119169df774$var$load("aaRXj"),
    $1efa0119169df774$var$load("fHlIz"),
    $1efa0119169df774$var$load("4QwAJ"),
    $1efa0119169df774$var$load("3i44s"),
    $1efa0119169df774$var$load("geXPZ"),
    $1efa0119169df774$var$load("5JWJI"),
    $1efa0119169df774$var$load("fGNl7"),
    $1efa0119169df774$var$load("lnKog"),
    $1efa0119169df774$var$load("9TmRc")
]).then(()=>parcelRequire('go76J'));

});

parcelRegister("cTOQy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1fa6633bf0e88929$export$d92a178c6c95211f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "-7yv0",
    name: "BlogPostsSSRExtensionHandler",
    loader: async ()=>(await (parcelRequire("hDAvJ"))).BlogPostsSSRExtensionHandler
});
module.exports["BlogPostsSSRExtensionHandler"] = $1fa6633bf0e88929$export$d92a178c6c95211f;

});

parcelRegister("hDAvJ", function(module, exports) {

let $cd72667cc6f24d16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd72667cc6f24d16$var$load("7eef4").then(()=>parcelRequire('7MaHq'));

});

parcelRegister("n9ft3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $402fa49bac3d1313$export$31265ba23ce1c150 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "o3Q0f",
    name: "RecentlyUpdatedMacroHandler",
    loader: async ()=>(await (parcelRequire("kUjst"))).RecentlyUpdatedMacroRendererHandler
});
module.exports["RecentlyUpdatedMacroHandler"] = $402fa49bac3d1313$export$31265ba23ce1c150;

});

parcelRegister("kUjst", function(module, exports) {

let $f388219ce5438984$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f388219ce5438984$var$load("6wr18"),
    $f388219ce5438984$var$load("ffEVr"),
    $f388219ce5438984$var$load("gzwBT")
]).then(()=>parcelRequire('cCE4B'));

});

parcelRegister("jaHkh", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f75b272caa077402$export$e3054beb9a9b8cf7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "V-QVV",
    name: "ContentReportTableMacroHandler",
    loader: async ()=>(await (parcelRequire("hWYEk"))).ContentReportTableMacroRenderer
});
module.exports["ContentReportTableMacroHandler"] = $f75b272caa077402$export$e3054beb9a9b8cf7;

});

parcelRegister("hWYEk", function(module, exports) {

let $d116e62a87431eba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d116e62a87431eba$var$load("6wr18"),
    $d116e62a87431eba$var$load("ilUG7"),
    $d116e62a87431eba$var$load("efUj2"),
    $d116e62a87431eba$var$load("ffEVr"),
    $d116e62a87431eba$var$load("9iPes")
]).then(()=>parcelRequire('bM9UF'));

});

parcelRegister("fxgwG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f9be1fb5731895fb$export$e229a034449f88fe = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XG-1M",
    name: "TasksReportMacroHandler",
    loader: async ()=>(await (parcelRequire("5DAU3"))).TasksReportMacroRenderer
});
module.exports["TasksReportMacroHandler"] = $f9be1fb5731895fb$export$e229a034449f88fe;

});

parcelRegister("5DAU3", function(module, exports) {

let $41ad386f0bbc3a19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41ad386f0bbc3a19$var$load("6wr18"),
    $41ad386f0bbc3a19$var$load("ilUG7"),
    $41ad386f0bbc3a19$var$load("efUj2"),
    $41ad386f0bbc3a19$var$load("ffEVr"),
    $41ad386f0bbc3a19$var$load("d6DuA"),
    $41ad386f0bbc3a19$var$load("56un6")
]).then(()=>parcelRequire('bKsCn'));

});

parcelRegister("CbxlN", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9d0b262ef952c6d9$export$5035625498b1f654 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "25QZT",
    name: "ChangeHistoryMacroHandler",
    loader: async ()=>(await (parcelRequire("3cVGA"))).ChangeHistoryMacroRenderer
});
module.exports["ChangeHistoryMacroHandler"] = $9d0b262ef952c6d9$export$5035625498b1f654;

});

parcelRegister("3cVGA", function(module, exports) {

let $255f3d47c6341e04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $255f3d47c6341e04$var$load("iGaRG"),
    $255f3d47c6341e04$var$load("kJ1vX"),
    $255f3d47c6341e04$var$load("1GCFv"),
    $255f3d47c6341e04$var$load("dZsGY"),
    $255f3d47c6341e04$var$load("75HZb")
]).then(()=>parcelRequire('gY9Xv'));

});

parcelRegister("23Uhb", function(module, exports) {

let $180783dcb71f64c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $180783dcb71f64c1$var$load("1auMQ").then(()=>parcelRequire('8BBIU'));

});

parcelRegister("afWPV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a83c069c9a6481c7$export$d5c71aa37ef97617 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CC6_N",
    name: "AnchorExtensionHandler",
    loader: async ()=>(await (parcelRequire("etheA"))).AnchorExtensionHandler
});
module.exports["AnchorExtensionHandler"] = $a83c069c9a6481c7$export$d5c71aa37ef97617;

});

parcelRegister("etheA", function(module, exports) {

let $a891247b021451b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a891247b021451b3$var$load("19Y7i").then(()=>parcelRequire('l86Zj'));

});

parcelRegister("fQztD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3997fe39cf5d8269$export$633f4824b681947a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "F2NJ3",
    name: "ExpandExtensionHandler",
    loader: async ()=>(await (parcelRequire("ao2RX"))).ExpandExtensionHandler
});
module.exports["ExpandExtensionHandler"] = $3997fe39cf5d8269$export$633f4824b681947a;

});

parcelRegister("ao2RX", function(module, exports) {

let $78fe5f106b21a7fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78fe5f106b21a7fb$var$load("2RXNd").then(()=>parcelRequire('6v9Za'));

});

parcelRegister("hCfPO", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $592d35ed7690943f$export$32fd79437615e824 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3ZdKv",
    name: "ExcerptExtensionHandler",
    loader: async ()=>(await (parcelRequire("aG5vh"))).ExcerptExtensionHandler
});
module.exports["ExcerptExtensionHandler"] = $592d35ed7690943f$export$32fd79437615e824;

});

parcelRegister("aG5vh", function(module, exports) {

let $7c62187d78ef5f77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c62187d78ef5f77$var$load("gcpEH").then(()=>parcelRequire('2LCBF'));

});

parcelRegister("9e5dj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $656873abe55ed6cc$export$5a0ddb4204896541 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YU9S2",
    name: "DetailsExtensionHandler",
    loader: async ()=>(await (parcelRequire("9BLwJ"))).DetailsExtensionHandler
});
module.exports["DetailsExtensionHandler"] = $656873abe55ed6cc$export$5a0ddb4204896541;

});

parcelRegister("9BLwJ", function(module, exports) {

let $6fec6f9857ef1736$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fec6f9857ef1736$var$load("lCorI").then(()=>parcelRequire('hKeSi'));

});

parcelRegister("lE7FD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $71227bcffe7d1ab9$export$53c6ffd7d2d07a9a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fg8xl",
    name: "DetailsSummaryExtensionHandler",
    loader: async ()=>(await (parcelRequire("als09"))).DetailsSummaryExtensionHandler
});
module.exports["DetailsSummaryExtensionHandler"] = $71227bcffe7d1ab9$export$53c6ffd7d2d07a9a;

});

parcelRegister("als09", function(module, exports) {

let $7881960fd16ad625$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7881960fd16ad625$var$load("g41HJ").then(()=>parcelRequire('iVLlf'));

});

parcelRegister("cYJC5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1c34d439a5f73ff$export$d9cdb53348aba8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "BS09z",
    name: "CreateFromTemplateLoader",
    loader: async ()=>(await (parcelRequire("8V6oA"))).CreateFromTemplate
});

const $c1c34d439a5f73ff$export$3ecbbe8a82bf4f99 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ikblw",
    name: "LazyCreateFromTemplateLoader",
    loader: async ()=>(await (parcelRequire("8V6oA"))).CreateFromTemplate
});
module.exports["CreateFromTemplateLoader"] = $c1c34d439a5f73ff$export$d9cdb53348aba8;
module.exports["LazyCreateFromTemplateLoader"] = $c1c34d439a5f73ff$export$3ecbbe8a82bf4f99;

});

parcelRegister("8V6oA", function(module, exports) {

let $67e89b9d3b9bd621$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $67e89b9d3b9bd621$var$load("fq1gG"),
    $67e89b9d3b9bd621$var$load("4WTdS"),
    $67e89b9d3b9bd621$var$load("ezYRV"),
    $67e89b9d3b9bd621$var$load("el56J"),
    $67e89b9d3b9bd621$var$load("9cpj1"),
    $67e89b9d3b9bd621$var$load("b1vDf")
]).then(()=>parcelRequire('6JR3B'));

});

parcelRegister("9ijui", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");


var $8pcS0 = parcelRequire("8pcS0");


var $eS4Za = parcelRequire("eS4Za");


var $9wGTI = parcelRequire("9wGTI");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $aJPUt = parcelRequire("aJPUt");


var $lrmHr = parcelRequire("lrmHr");


var $1aGr8 = parcelRequire("1aGr8");


var $jmjWc = parcelRequire("jmjWc");


const $32ac87da7e80bcce$export$801658e2183fcdd6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "woK3v",
    name: "LegacyContentExtensionHandlerPaint",
    loader: async ()=>(await (parcelRequire("5kmaW"))).LegacyContentExtensionHandler
});



var $j7jtS = parcelRequire("j7jtS");


var $9Lixm = parcelRequire("9Lixm");

const $10f699a561b7c8ad$export$4481a29084474468 = ({ contentId: contentId, contentMode: contentMode, clientAnnotationProvider: clientAnnotationProvider, clientHydrationReady: clientHydrationReady, getLcmClientExtensionHandlers: getLcmClientExtensionHandlers, getLcmNestedExtensionHandlers: getLcmNestedExtensionHandlers, nestedLcmSsrEnabled: nestedLcmSsrEnabled })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        if (!extension) return null;
        const { type: type, extensionKey: extensionKey, parameters: parameters } = extension;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const macroId = attributes?.macroId;
        const defaultProps = {
            contentId: contentId,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            node: extension
        };
        let content = null;
        if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE) {
            const inlineExternalImageProps = parameters;
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
                name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                contentId: contentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lrmHr.InlineExternalImage), {
                ...inlineExternalImageProps,
                ...defaultProps
            })));
        }
        // Resolved only for LCM nodes so that pages without one are never exposed to the nested gate.
        const nestedSsrEnabled = (0, $j7jtS.isLegacyContentExtension)(extension) ? nestedLcmSsrEnabled ?? (0, $9wGTI.fg)('confluence_lcm_ssr_nested') : false;
        // When nested SSR is enabled every LCM qualifies; otherwise only content without nested
        // extensions is eligible.
        if ((0, $j7jtS.isLegacyContentExtension)(extension) && (nestedSsrEnabled || (0, $j7jtS.isInitialLcmSsrEligible)(extension))) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32ac87da7e80bcce$export$801658e2183fcdd6), {
            clientAnnotationProvider: clientHydrationReady ? clientAnnotationProvider : undefined,
            clientExtensionHandlers: clientHydrationReady ? getLcmClientExtensionHandlers?.() : undefined,
            clientHydrationReady: clientHydrationReady,
            contentId: contentId,
            contentMode: contentMode,
            enableHydrationBridge: nestedSsrEnabled,
            extensionHandlers: nestedSsrEnabled ? getLcmNestedExtensionHandlers?.() : undefined,
            node: extension
        });
        // This boundary is not directly used but it provides reference for fixing nested div under span.
        // See next/packages/ssr-scripts-utils/src/fixUnbalancedPlaceholderCommentMarkers.ts for details
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
            placeholderId: `migration-ext-container-${macroId}`
        }, type === 'inlineExtension' ? // Mimic the logic in platform/packages/editor/renderer/src/ui/ExtensionRenderer.tsx
        // We don't update the platform code for 2 reasons:
        // 1. Backwards compatibility. I don't know if other product supplies this wrapper already (unlikely)
        // 2. More importantly this needs to be inside the migration-ext-container-${macroId} boundary.
        //    Inline macros has <span> nested in <div> problem. We are using the boundary as guide to fix them.
        //    See next/packages/ssr-scripts-utils/src/fixUnbalancedPlaceholderCommentMarkers.ts
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Lixm.PlaceholderAwareInlineNodeRendererWrapper), {
            macroId: macroId
        }, content) : content);
    });
module.exports["getSsrMigrationExtHandlerForRenderer"] = $10f699a561b7c8ad$export$4481a29084474468;

});

parcelRegister("lrmHr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1bcc685f2f6e55b9$export$4eba1572aa6d0aed = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LEdEz",
    name: "InlineExternalImage",
    loader: async ()=>(await (parcelRequire("6Fz57"))).InlineExternalImage
});
module.exports["InlineExternalImage"] = $1bcc685f2f6e55b9$export$4eba1572aa6d0aed;

});

parcelRegister("6Fz57", function(module, exports) {

let $4db1c8db7664092b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4db1c8db7664092b$var$load("DCnH9").then(()=>parcelRequire('fPNzj'));

});

parcelRegister("5kmaW", function(module, exports) {

let $3e10059cd74fce55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3e10059cd74fce55$var$load("6MdJu"),
    $3e10059cd74fce55$var$load("1Pi84"),
    $3e10059cd74fce55$var$load("8LtYa"),
    $3e10059cd74fce55$var$load("4t77a"),
    $3e10059cd74fce55$var$load("8rgnV")
]).then(()=>parcelRequire('2PQ94'));

});

parcelRegister("j7jtS", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $24b8629a324f46ba$var$MAX_NODES_TO_ANALYZE = 100000;
const $24b8629a324f46ba$var$EXTENSION_NODE_TYPES = new Set([
    'extension',
    'inlineExtension',
    'bodiedExtension',
    'multiBodiedExtension'
]);
const $24b8629a324f46ba$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $24b8629a324f46ba$export$ae607f800f514e24 = (extension)=>extension.extensionType === (0, $8pcS0.EXTENSION_TYPE).MIGRATION && extension.extensionKey === (0, $8pcS0.EXTENSION_KEY).LEGACY_CONTENT;
const $24b8629a324f46ba$var$appendNodes = (nodes, children)=>{
    for (const child of children)nodes.push(child);
};
function $24b8629a324f46ba$export$2e616ec6b6a7a957(extension) {
    if (!$24b8629a324f46ba$export$ae607f800f514e24(extension)) return false;
    const nestedContent = extension.parameters?.nestedContent;
    if (nestedContent == null) return true;
    if (!$24b8629a324f46ba$var$isObject(nestedContent) || nestedContent.type !== 'doc' || !Array.isArray(nestedContent.content)) return false;
    const nodes = [
        nestedContent
    ];
    const visited = new WeakSet();
    let visitedNodeCount = 0;
    while(nodes.length > 0){
        const current = nodes.pop();
        if (!$24b8629a324f46ba$var$isObject(current) || visited.has(current)) return false;
        visited.add(current);
        visitedNodeCount++;
        if (visitedNodeCount > $24b8629a324f46ba$var$MAX_NODES_TO_ANALYZE) return false;
        const node = current;
        if (typeof node.type === 'string' && $24b8629a324f46ba$var$EXTENSION_NODE_TYPES.has(node.type)) return false;
        if (node.content !== undefined) {
            if (!Array.isArray(node.content)) return false;
            if (visitedNodeCount + nodes.length + node.content.length > $24b8629a324f46ba$var$MAX_NODES_TO_ANALYZE) return false;
            $24b8629a324f46ba$var$appendNodes(nodes, node.content);
        }
        const nestedDocument = node.attrs?.parameters?.nestedContent;
        if (nestedDocument !== undefined) {
            if (!$24b8629a324f46ba$var$isObject(nestedDocument) || nestedDocument.type !== 'doc' || !Array.isArray(nestedDocument.content)) return false;
            nodes.push(nestedDocument);
        }
    }
    return true;
}
module.exports["isLegacyContentExtension"] = $24b8629a324f46ba$export$ae607f800f514e24;
module.exports["isInitialLcmSsrEligible"] = $24b8629a324f46ba$export$2e616ec6b6a7a957;

});

parcelRegister("3Btfb", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4o1RV = parcelRequire("4o1RV");

function $fa7a566b22788032$export$a039e57df2bba181(InnerComponent) {
    function WithNavigationPolicy(props) {
        const $ = (0, $bDgLe.c)(3);
        const navigationPolicy = (0, $4o1RV.useNavigationPolicy)();
        const t0 = props;
        let t1;
        if ($[0] !== navigationPolicy || $[1] !== t0) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                ...t0,
                navigationPolicy: navigationPolicy
            });
            $[0] = navigationPolicy;
            $[1] = t0;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    WithNavigationPolicy.displayName = `withNavigationPolicy(${InnerComponent.displayName || InnerComponent.name})`;
    return WithNavigationPolicy;
}
module.exports["withNavigationPolicy"] = $fa7a566b22788032$export$a039e57df2bba181;

});

parcelRegister("giS6h", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a6c7790f33c3e831$export$bbe9955f93d6ed27 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
module.exports["ClassicEditorContext"] = $a6c7790f33c3e831$export$bbe9955f93d6ed27;

});

parcelRegister("9rgEf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $730c064714609652$export$4842845a3bdb74f6 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $730c064714609652$export$aa899bf2529ccb2 = $730c064714609652$export$4842845a3bdb74f6.Provider;
module.exports["PageDocumentContext"] = $730c064714609652$export$4842845a3bdb74f6;
module.exports["PageDocumentProvider"] = $730c064714609652$export$aa899bf2529ccb2;

});

parcelRegister("gnzsm", function(module, exports) {
const $fb43f474e41c0e5b$export$5a7bc2ce53981a17 = (getHeadingLinkPath, headingId)=>{
    const path = getHeadingLinkPath?.();
    if (!path) return undefined;
    // `window.location` is not available during SSR; heading links are only meaningful client-side.
    if (typeof window.location === 'undefined') return undefined;
    const url = new URL(window.location.origin + path);
    url.hash = encodeURIComponent(headingId);
    return url.toString();
};
module.exports["createHeadingLink"] = $fb43f474e41c0e5b$export$5a7bc2ce53981a17;

});

parcelRegister("aQw7y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");


var $j0gZR = parcelRequire("j0gZR");


var $1xpoY = parcelRequire("1xpoY");

const $9d7353a17557989b$export$27f1b40a08e363aa = (extensionKey, isBodiedExtension)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    return (0, $cozmU.useMemo)(()=>{
        if (!extensionKey) return false;
        const is2PNonBodied = !(0, $j0gZR.is1PMacro)(extensionKey) && !isBodiedExtension;
        if (is2PNonBodied || isLivePage) return true;
        const extensionsToHideOverlays = (0, $1xpoY.default).getStringList('confluence_frontend_extension_overlay_removal_list', []);
        if (extensionsToHideOverlays.length === 0) return false;
        if (extensionsToHideOverlays[0] === 'ALLOW_ALL') return true;
        const extensionKeys = extensionsToHideOverlays.map((ext)=>ext.trim().toLowerCase());
        return extensionKeys.includes(extensionKey.toLowerCase());
    }, [
        extensionKey,
        isLivePage,
        isBodiedExtension
    ]);
};
module.exports["useShouldHideOverlay"] = $9d7353a17557989b$export$27f1b40a08e363aa;

});

parcelRegister("gHCIk", function(module, exports) {
const $9fa754652de9cba0$var$replacer = (_, value)=>value !== null && typeof value === 'object' && !(value instanceof Array) ? Object.keys(value).sort().reduce((sorted, key)=>{
        sorted[key] = value[key];
        return sorted;
    }, {}) : value;
const $9fa754652de9cba0$export$af78762ebd645d38 = (adf)=>JSON.stringify(adf, $9fa754652de9cba0$var$replacer);
module.exports["serializeExtensionADF"] = $9fa754652de9cba0$export$af78762ebd645d38;

});

parcelRegister("8nJmU", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $a1085037bd721dca$var$OFFICE_MACRO_NAMES = new Set([
    'word',
    'powerpoint',
    'excel',
    'viewdoc',
    'viewppt',
    'viewxls'
]);
const $a1085037bd721dca$var$safelyTrackOfficeMacroExperience = (track)=>{
    try {
        track();
    } catch  {
    // Telemetry must never block or alter macro rendering or insertion behaviour.
    }
};
const $a1085037bd721dca$export$2d689b21ec8c8934 = new class OfficeMacroExperienceTrackerSupport {
    isTrackable(data) {
        const normalizedMacroName = data?.macroName?.toLowerCase();
        return Boolean(normalizedMacroName && $a1085037bd721dca$var$OFFICE_MACRO_NAMES.has(normalizedMacroName));
    }
    start(data) {
        $a1085037bd721dca$var$safelyTrackOfficeMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.OFFICE_MACRO_RENDER_EXPERIENCE),
                attributes: {
                    macroName: data?.macroName
                }
            });
        });
    }
    succeed() {
        $a1085037bd721dca$var$safelyTrackOfficeMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.OFFICE_MACRO_RENDER_EXPERIENCE)
            });
        });
    }
    fail(error) {
        $a1085037bd721dca$var$safelyTrackOfficeMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.OFFICE_MACRO_RENDER_EXPERIENCE),
                error: error
            });
        });
    }
    abort(reason) {
        $a1085037bd721dca$var$safelyTrackOfficeMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.OFFICE_MACRO_RENDER_EXPERIENCE),
                reason: reason
            });
        });
    }
}();
module.exports["OfficeMacroExperienceTrackerSupport"] = $a1085037bd721dca$export$2d689b21ec8c8934;

});

parcelRegister("989nU", function(module, exports) {
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $kksmx = parcelRequire("kksmx");


var $8pcS0 = parcelRequire("8pcS0");


var $6mEZ3 = parcelRequire("6mEZ3");


var $4JC0x = parcelRequire("4JC0x");


var $l6Xaz = parcelRequire("l6Xaz");


var $bQm3c = parcelRequire("bQm3c");


var $9tVje = parcelRequire("9tVje");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $6AplS = parcelRequire("6AplS");


var $iaRmR = parcelRequire("iaRmR");


var $KcDWk = parcelRequire("KcDWk");


var $bYtfC = parcelRequire("bYtfC");


var $3o0Dr = parcelRequire("3o0Dr");


var $jP1nY = parcelRequire("jP1nY");


var $lqWPF = parcelRequire("lqWPF");


var $ji0Re = parcelRequire("ji0Re");


var $ebUME = parcelRequire("ebUME");

const $fc5bf07eec92d197$export$4f1d7d3b9a74b4f8 = ({ macroRenderedOutput: macroRenderedOutput, macroDefaultProps: macroDefaultProps, containerRef: containerRef, macroOutput: rawMacroOutput, reuseSSRedElement: reuseSSRedElement, renderedByProvider: renderedByProvider = false })=>{
    // NOTE: `featureFlags` object here is prop-drilled down through layers
    // of legacy code so the usage of deprecated attribute is retained here.
    const { featureFlags: featureFlags, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const macroOutput = rawMacroOutput;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { node: node, contentId: contentId, mode: mode, extensionKey: extensionKey, isConnectMacro: isConnectMacro } = macroDefaultProps;
    const { viewportHeight: viewportHeight } = (0, $bYtfC.useConnectExtensionViewportSize)(node);
    const keys = Object.keys(node);
    keys.forEach((key)=>{
        if (node[key] === undefined || node[key] === null) delete node[key];
    });
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const isMissingMacroParameters = node.parameters?.macroParams?.isMissingRequiredParameters?.value;
    (0, $cozmU.useEffect)(()=>{
        if (macroOutput) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro.with.macroOutput',
                source: 'FabricLegacyMacrosServerRenderer',
                attributes: {
                    extensionKey: extensionKey,
                    contentId: contentId
                }
            }
        }).fire();
    }, [
        macroOutput,
        createAnalyticsEvent,
        extensionKey,
        contentId
    ]);
    const macroData = (0, $ji0Re.useMacroContentData)(contentId, node);
    const ssredElement = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    const containsMacro = macroRenderedOutput ? macroRenderedOutput.filter((macro)=>macro?.key === macroId) : [];
    let macroHtml = macroData?.macroBodyRenderer?.value || containsMacro[0]?.value?.value || macroOutput;
    if (extensionKey && macroRenderedOutput) // If a Tiny page with Style Macro gets converted to Fabric, need to Scope the CSS
    // Not limiting extensionKey to "style" only because the Style Macro can be nested in other macros
    macroHtml = (0, $6AplS.scopeCSS)(macroHtml, (0, $6AplS.mainContentSelector)).contentWithScopedCSS;
    const dataMacroBody = (0, $lqWPF.useDataMacroBody)(node, contentId);
    /**
   * "tasks-report-macro" has no actually required macro parameters.
   * Required parameter was introduced for UI only so the macro doesn't try to render all tasks in the instance when it's inserted in editor,
   *
   * Due to a bug https://product-fabric.atlassian.net/browse/COMMENTS-177
   * it has polluted database with wrong isMissingMacroParameters and it prevents SSRing of this particular (and popular) macro.
   * This check should be removed when we fix the property editor and clean up the DB.
   */ const isActuallyMissingMacroParameters = isMissingMacroParameters && extensionKey !== 'tasks-report-macro';
    (0, $jP1nY.useConnectStaticMacroSSRExperienceTracking)({
        contentId: contentId,
        extensionKey: extensionKey,
        isActuallyMissingMacroParameters: isActuallyMissingMacroParameters,
        isConnectMacro: isConnectMacro,
        macroHtml: macroHtml,
        macroId: macroId
    });
    //To match the placeholder from SPA
    if (isMissingMacroParameters && extensionKey === 'tasks-report-macro' && !node.parameters?.macroParams?.pages && !node.parameters?.macroParams?.spaces) {
        const macro_0 = {
            title: 'Task report',
            macroName: extensionKey,
            icon: {
                height: 80,
                location: '/download/resources/com.atlassian.confluence.plugins.confluence-inline-tasks/tasks-report-image-resources/task-report.png',
                relative: true,
                width: 80
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9tVje.ExtensionPlaceholder), {
            isEditor: false,
            macro: macro_0,
            description: (0, $9tVje.editToSetupMessage)
        });
    }
    /**
   *
   * skip check if macroOutput exists, as it contains all the html
   * required to render the macro
   */ if (!macroOutput && isActuallyMissingMacroParameters) return null;
    const preloadingDataPresent = macroData && !dataMacroBody.missing || macroData?.macroBodyStorageFormat;
    // If there's no data and no macro data from preloading to render - resort to standard macro preloading
    if (!macroOutput && containsMacro.length === 0 && !preloadingDataPresent) {
        (0, $4JC0x.markMissingMacroData)(macroId, extensionKey);
        // This logic is applicable to the cases when there's no server output for given macro
        // and therefore macro data loading is deferred till client code takes over. The idea is
        // when macro data is unavailable we attempt preloading it through the query preloader.
        //
        // NOTE: there's a lot of logic around what query to use (see LegacyMacroRendererQuery)
        // and the fact that we may want to THROTTLE macro loading to not overwhelm the backend.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3o0Dr.FabricLegacyMacrosServerLoader), macroDefaultProps);
    }
    // Continue showing the placeholder for the first render if the macro marked during SSR to prevent hydration mismatches
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    renderServerPlaceholder && window.__MISSING_DATA_MACROS__?.includes(macroId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3o0Dr.FabricLegacyMacrosServerLoader), macroDefaultProps);
    if (!macroHtml) return null;
    // Continue showing the null for the first render if the macro was not SSRed to prevent hydration mismatches
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    renderServerPlaceholder && !window.__MISSING_DATA_MACROS__?.includes(macroId) && !window.__LEGACY_MACRO_SSRED__?.[macroId]) return null;
    const css = macroData?.macroBodyRenderer?.webResourceDependencies?.tags?.css || macroData?.macroBodyRenderer?.webResource?.tags?.css || containsMacro[0]?.value?.webresource?.tags?.css;
    const js = macroData?.macroBodyRenderer?.webResourceDependencies?.tags?.js || macroData?.macroBodyRenderer?.webResource?.tags?.js || containsMacro[0]?.value?.webresource?.tags?.js;
    const adf = (0, $6mEZ3.extensionToADF)(macroDefaultProps.node);
    const isInline = adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE);
    const macroDataProps = {
        'data-fabric-macro': macroId,
        'data-macro-body': macroData?.macroBodyStorageFormat?.value || dataMacroBody.value,
        'data-macro-parameters': (0, $6mEZ3.getParametersString)(node),
        'data-skate-created': undefined
    };
    const nodeProps = {
        // ref will be passed in only for SPA in order to load default WRM modules
        ref: containerRef || null
    };
    let macroRepresentation = macroData?.macroBodyRenderer?.representation || containsMacro[0]?.value?.representation || 'view';
    if (macroData?.macroBodyRenderer?.macroRenderedRepresentation && extensionKey === 'include') macroRepresentation = macroData?.macroBodyRenderer?.macroRenderedRepresentation;
    const mediaToken = macroData?.macroBodyRenderer?.mediaToken?.token;
    // In case of ADF format there might be nested macro(s)
    // so we have to pass extensionHandlers to dispatch them
    const extensionHandlers = macroRepresentation === 'atlas_doc_format' ? (0, $ebUME.getSsrExtensionHandlers)({
        adf: macroHtml,
        contentId: contentId,
        userId: userId,
        cloudId: cloudId,
        mediaToken: mediaToken
    }) : undefined;
    const elementProps = {
        adf: adf,
        isInline: isInline,
        contentId: contentId,
        mode: mode,
        extensionKey: extensionKey,
        macroRepresentation: macroRepresentation,
        macroDataProps: macroDataProps,
        macroRenderedOutput: macroHtml,
        featureFlags: featureFlags,
        nodeProps: nodeProps,
        mediaToken: mediaToken,
        headingIdPrefix: extensionKey === 'include' && (0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true) ? macroId : undefined,
        extensionHandlers: extensionHandlers,
        ssredElement: ssredElement,
        delayIframe: true,
        height: viewportHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, css && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        key: "css-container",
        "data-testid": "macro_css",
        dangerouslySetInnerHTML: {
            __html: css
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
        renderedByProvider: renderedByProvider,
        ...elementProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kksmx.ExtensionSSRMark), {
        macroId: macroId,
        renderType: (0, $kksmx.getRenderType)(macroOutput, macroData)
    }), js && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "macro_js",
        dangerouslySetInnerHTML: {
            __html: `${(0, $l6Xaz.deferScript)(js)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }));
};
module.exports["FabricLegacyMacrosServerRenderer"] = $fc5bf07eec92d197$export$4f1d7d3b9a74b4f8;

});

parcelRegister("9Lixm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aZS5C = parcelRequire("aZS5C");


var $e4o8D = parcelRequire("e4o8D");

function $91e6b8d2baf46122$export$3ecdc0417ec1be45(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, macroId: macroId } = t0;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] !== macroId || $[1] !== renderServerPlaceholder) {
        t1 = renderServerPlaceholder ? {
            ssrPlaceholder: macroId
        } : {
            ssrPlaceholderReplace: macroId
        };
        $[0] = macroId;
        $[1] = renderServerPlaceholder;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== children || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZS5C.InlineNodeRendererWrapper), t1, children);
        $[3] = children;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
}
module.exports["PlaceholderAwareInlineNodeRendererWrapper"] = $91e6b8d2baf46122$export$3ecdc0417ec1be45;

});

parcelRegister("iaRmR", function(module, exports) {
/* LegacyMacroStyledElement.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable check-react-ssr-usage/guard-browser-globals -- Pre-existing usages; this file is client-only via Loadable. */ /* SSR is also using the same elements to prevent duplication and risk for getting out of sync. Moved to fabric extension to
 prevent circular dependency with fabric-extension-handler and content-renderer */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $hEeUR = parcelRequire("hEeUR");


var $jNKuq = parcelRequire("jNKuq");


var $adbKg = parcelRequire("adbKg");


var $9wGTI = parcelRequire("9wGTI");


var $3DNeP = parcelRequire("3DNeP");


var $1aGr8 = parcelRequire("1aGr8");


var $5kjCz = parcelRequire("5kjCz");


var $iHLZT = parcelRequire("iHLZT");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $gEtAQ = parcelRequire("gEtAQ");


var $KcDWk = parcelRequire("KcDWk");

'use no memo';
const $442661c5ce449806$var$findMacroElementWithoutConnectIframe = (macroId)=>{
    if ((0, $6mKj3.expValEquals)('confluence-not-valid-selector', 'isEnabled', true)) {
        const elements = Array.from(document.querySelectorAll(`[data-fabric-macro="${macroId}"][data-skate-created]`));
        for (const el of elements){
            // Exclude elements that contain Connect iframe script or container
            if (!el.querySelector('.ap-iframe-body-script') && !el.querySelector('.ap-iframe-container')) return el;
        }
        return null;
    } else return document.querySelector(`[data-fabric-macro="${macroId}"][data-skate-created]:not(:has(.ap-iframe-body-script)):not(:has(.ap-iframe-container))`);
};
const $442661c5ce449806$var$hasMacroBeenHydrated = {};
const $442661c5ce449806$var$InjectedMacroHtml = ({ ElementTag: ElementTag, className: className, elementStyle: elementStyle, macroHtml: macroHtml, nodeProps: nodeProps, macroDataProps: macroDataProps, delayIframe: delayIframe, extensionKey: extensionKey, renderServerPlaceholder: renderServerPlaceholder, macroId: macroId })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_legacy_macro_external_links_new_tab', 'isEnabled', true)) return;
        (0, $3DNeP.ensureExternalLinksOpenInNewTab)(containerRef.current);
    }, [
        macroHtml
    ]); // Merge our ref with any parent ref from nodeProps so neither is clobbered.
    const setContainerRef = (0, $cozmU.useCallback)((element)=>{
        containerRef.current = element;
        const parentRef = nodeProps?.ref;
        if (typeof parentRef === 'function') parentRef(element);
        else if (parentRef) parentRef.current = element;
    }, [
        nodeProps?.ref
    ]);
    const { ref: _ignoredNodePropsRef, ...nodePropsWithoutRef } = nodeProps ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: elementStyle,
        dangerouslySetInnerHTML: {
            __html: macroHtml ?? ''
        },
        ...nodePropsWithoutRef,
        ...macroDataProps,
        ref: setContainerRef,
        ...delayIframe ? {
            'data-delay-iframe': '1'
        } : {},
        "data-testid": "legacy-macro-element",
        "data-vc": `legacy-macro-element_${extensionKey || 'no-extension-key-provided'}`,
        "data-vc-ignore-if-no-layout-shift": true,
        ...renderServerPlaceholder ? {
            'data-ssr-placeholder': macroId
        } : {
            'data-ssr-placeholder-replace': macroId
        }
    });
};
function $442661c5ce449806$var$LegacyMacroDOMManipulatedByJQuery({ macroId: macroId, content: content, containerRef: containerRef, isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized, renderedByProvider: renderedByProvider }) {
    const [hydrated, setHydrated] = (0, $cozmU.useState)($442661c5ce449806$var$hasMacroBeenHydrated[macroId]);
    if (!hydrated) // This needs to happen before rendering.
    // Collect the real DOM before replacing it with placeholder (LoadablePlaceholderClient)
    (0, $KcDWk.collectSSRedLegacyMacro)(macroId);
    const ref = (0, $cozmU.useRef)(null);
    const domElement = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (hydrated) {
            const markerElement = ref.current;
            if (markerElement && domElement) {
                markerElement.insertAdjacentElement('afterend', domElement); // When early webpanel initialization is enabled, the SSR-rendered Connect iframe
                // was rendered with renderedByProvider=false, which applied inline styles to hide it.
                // After hydration, we need to directly update those inline styles on the DOM element.
                if (isConnectIframeEarlyInitialized && renderedByProvider === false) {
                    if (domElement instanceof HTMLElement) {
                        // Directly update the inline styles to match renderedByProvider=true
                        domElement.style.visibility = 'visible';
                        domElement.style.display = 'revert';
                    }
                } // Set this callback is important because it signals setIsMacroResourcesLoaded in LegacyMacroRendererComponent
                // Which updates LegacyMacroRendererComponentResourcesSSR UFOLoadHold
                if (containerRef && typeof containerRef === 'function') containerRef(domElement);
                return ()=>{
                    // We inserted domElement above which is outside the React lifecycle
                    // When the actual macro is rendered, this component will unmount.
                    // At that point, we need to remove the inserted element to avoid duplication
                    try {
                        domElement.parentNode?.removeChild(domElement);
                    } catch  {}
                };
            }
        } else {
            // External state instead of ref because the ancestor of this component
            // will change from FabricLegacyMacrosServerRenderer to PageContentRendererFabric
            // The external state is used to keep state between re-mounts.
            $442661c5ce449806$var$hasMacroBeenHydrated[macroId] = true; // Local state is used to trigger re-render
            setHydrated(true);
        }
    }, [
        hydrated,
        macroId,
        domElement,
        containerRef,
        isConnectIframeEarlyInitialized,
        renderedByProvider
    ]);
    // If we didn't save the real DOM for whatever reason just render again.
    // We will get flicker but at least we will not break the page.
    if (!domElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content);
     /**
     * There are certain SSRed macros that have jquery DOM manipulation.
     * For those macros hydration is not going to work as React don't know about the DOM changes.
     * If we put macroHtml on the page it will flip back to the initial state. eg page tree macro.
     *
     * - We display the SSR rendered result. This is when hydrated = false. This is to ensure React don't freak out in hydration.
     * - However because LoadablePlaceholderClient converts DOM elements to React component on the fly. Click handlers are going to get lost.
     * - We will later replace it with collected real DOM element. This is when hydrated = true.
     * - Because the ancestor will change from FabricLegacyMacrosServerRenderer to PageContentRendererFabric all local state will be lost. hasMacroBeenHydrated will ensure we still use the real DOM with PageContentRendererFabric.
     */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hydrated ? // don't render this on the first paint to avoid breaking hydration
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        ref: ref,
        "data-legacy-macro-placeholder-ref": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aGr8.LoadablePlaceholderClient), {
        placeholderId: `legacy-macro-${macroId}`,
        clientPlaceholder: ()=>content,
        uniquePlaceholderId: true
    }));
}
const $442661c5ce449806$var$getExtensionElementStyle = (isConnectIframeEarlyInitialized, renderedByProvider, macroRenderedOutput, isInline, style, nodeHeight)=>{
    if (!isConnectIframeEarlyInitialized) return style;
    const iframeHeightMatch = macroRenderedOutput?.match(/"h":\s*"(\d+(?:%|px)?)"/);
    const shouldUseNodeHeight = (0, $9wGTI.fg)('confluence_connect_renderer_height_preset') && nodeHeight;
    return {
        ...style,
        /**
     * The height of an extension (or Connect iframe) can come from the app's descriptor returned in macroRenderedOutput
     * or could be in macroParams on the node itself. To reduce CLS, we ideally pick the extension height from the
     * node itself and fallback to the descriptor height, if any of the aforementioned values are declared. Long term, we
     * want to rely on the node itself to declare the height it should be for SSR. A similar flow is reflected in
     * @atlaskit/editor/renderer/src/react/nodes/extension.tsx
     */ ...shouldUseNodeHeight && {
            minHeight: nodeHeight
        },
        height: iframeHeightMatch?.[1] || '',
        // There are two render paths for Connect iframes as detailed in ExtensionRenderer, which both use
        // this component. First is with getSSRExtensionHandlers which renders in SSR + SPA before providers have
        // loaded, and then using getNodeRenderer after providers have loaded. If connect resources have been preloaded,
        // this means iframe will render in non-provider flow as well. We want to hide connect iframe during this time in
        // order to prevent users from seeing a flicker when iframe gets recreated during provider flow.
        visibility: !renderedByProvider ? 'hidden' : 'visible',
        // If height is NOT provided in macroRenderedOutput, we don't want to display the iframe at all during
        // non-provider flow so dynamic height/width of hidden iframe doesn't cause CLS in DOM. We also hide with any inline
        // macro due to existing bug on Connect side width being set as an html attribute with dev supplied width, and 100%
        // width in style attribute.
        display: !renderedByProvider && (!iframeHeightMatch?.[1] || isInline) ? 'none' : 'revert'
    };
};
const $442661c5ce449806$export$2b189d249f2bce2b = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, className: className, isInline: isInline, nodeProps: nodeProps, macroDataProps: macroDataProps, macroRepresentation: macroRepresentation, macroRenderedOutput: macroRenderedOutput, style: style, children: children, featureFlags: featureFlags, extensionHandlers: extensionHandlers, mediaToken: mediaToken, headingIdPrefix: headingIdPrefix, ssredElement: ssredElement, delayIframe: delayIframe, extensionKey: extensionKey, renderedByProvider: renderedByProvider, isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized = false, height: height })=>{
    const ElementTag = isInline ? 'span' : 'div';
    const macroId = macroDataProps?.['data-fabric-macro'];
    const containerRef = nodeProps?.ref;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { eventHandlers: adfEventHandlers, onSetLinkTarget: onSetLinkTarget } = (0, $jNKuq.useExternalLinkHandlers)();
    const elementStyle = (0, $cozmU.useMemo)(()=>$442661c5ce449806$var$getExtensionElementStyle(isConnectIframeEarlyInitialized, renderedByProvider, macroRenderedOutput, isInline, style, height), [
        isConnectIframeEarlyInitialized,
        renderedByProvider,
        macroRenderedOutput,
        isInline,
        style,
        height
    ]);
    (0, $adbKg.useDelayedIframe)(delayIframe, ssredElement);
    if (macroRenderedOutput?.includes('transform-error') && isInline) return null;
    if (children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        ...nodeProps,
        ...macroDataProps
    }, children);
    if (macroRepresentation === 'atlas_doc_format') return macroRenderedOutput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ElementTag // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        ...nodeProps,
        ...macroDataProps,
        "data-testid": "legacy-macro-adf",
        "data-vc": `legacy-macro-element_${extensionKey || 'no-extension-key-provided'}`,
        "data-vc-ignore-if-no-layout-shift": true,
        ...renderServerPlaceholder ? {
            'data-ssr-placeholder': macroId
        } : {
            'data-ssr-placeholder-replace': macroId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
        document: JSON.parse(macroRenderedOutput),
        contentId: contentId,
        featureFlags: featureFlags ?? {},
        extensionHandlers: extensionHandlers,
        mediaToken: mediaToken,
        appearance: "full-width",
        eventHandlers: adfEventHandlers,
        onSetLinkTarget: onSetLinkTarget,
        headingIdPrefix: headingIdPrefix
    })) : null;
    else {
        const macroHtml = delayIframe ? (0, $adbKg.delayIframeLoading)(macroRenderedOutput) : macroRenderedOutput;
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($442661c5ce449806$var$InjectedMacroHtml, {
            ElementTag: ElementTag,
            className: className,
            elementStyle: elementStyle,
            macroHtml: macroHtml,
            nodeProps: nodeProps,
            macroDataProps: macroDataProps,
            delayIframe: delayIframe,
            extensionKey: extensionKey,
            renderServerPlaceholder: renderServerPlaceholder,
            macroId: macroId
        });
        if (window.__SSR_RENDERED__ && // If the macro is server rendered
        macroHtml?.includes(`data-macro-id="${macroId}"`) && // When hydrating, DOM contains element that was manipulated by jQuery
        // Exclude connect init script or connect iframe
        // There is no point of copy iframe because there is no way to move it without reloading the iframe content.
        ($442661c5ce449806$var$findMacroElementWithoutConnectIframe(macroId) || // When we hydrated the macro, replacing the placeholder with the saved real DOM element
        document.querySelector('[data-legacy-macro-placeholder-ref]'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($442661c5ce449806$var$LegacyMacroDOMManipulatedByJQuery, {
            macroId: macroId,
            content: content,
            containerRef: containerRef,
            isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized,
            renderedByProvider: renderedByProvider
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aGr8.LoadablePlaceholderServer), {
            placeholderId: `legacy-macro-${macroId}`
        }, content);
    }
});
const $442661c5ce449806$var$createClassnameForExtension = (adf)=>{
    const macroParams = adf?.attrs?.parameters?.macroParams || {};
    const extensionKey = adf?.attrs?.extensionKey || '';
    let key = `macro${extensionKey}`;
    if (extensionKey === 'jira') {
        if (!macroParams.key && !macroParams.count) key += 'Table';
        else if (adf?.type === 'inlineExtension') key += 'SingleIssue';
    }
    return key;
};
const $442661c5ce449806$var$LegacyMacroStyledElementBaseStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementJiraTableStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementIncludeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementJiraSingleIssueStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementEditorModeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementRendererModeStyles = null;
const $442661c5ce449806$var$LegacyMacroStyledElementInlineStyles = null;
const $442661c5ce449806$export$e9dd081c6786d35c = ({ adf: adf, mode: mode, isInline: isInline, ...props })=>{
    const hasMacroJiraTable = $442661c5ce449806$var$createClassnameForExtension(adf) === 'macrojiraTable';
    const hasMacroInclude = $442661c5ce449806$var$createClassnameForExtension(adf) === 'macroinclude';
    const hasMacroJiraSingleIssue = $442661c5ce449806$var$createClassnameForExtension(adf) === 'macrojiraSingleIssue';
    const isConnectIframeEarlyInitialized = props.macroRenderedOutput?.includes('ap-iframe-body-script') && (0, $gEtAQ.isSpaceOverview)() && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false); // Include connect web resources html in case there is a Connect iframe on the page.
    if (isConnectIframeEarlyInitialized) {
        (0, $iHLZT.superbatchJSRecorder).includeConnectWebResources();
        (0, $iHLZT.superbatchCSSRecorder).includeConnectWebResources();
    } // Check if this contains Connect iframe content that should be wrapped in UFOThirdPartySegment
    const hasConnectIframe = props.macroRenderedOutput?.includes('ap-iframe-body-script') || props.macroRenderedOutput?.includes('ap-iframe-container');
    const macroElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($442661c5ce449806$export$2b189d249f2bce2b, {
        adf: adf,
        mode: mode,
        isInline: isInline,
        isConnectIframeEarlyInitialized: isConnectIframeEarlyInitialized,
        ...props,
        className: (0, $hekY6.default)([
            "_1ANEUSzUZr _2uxTLTZSoF _1wca99OiJt _0PRsUeOiJt _1IvcqnOiJt _2sqTDpOiJt _0ohm36zUZr _4qg81NPgdg _1XcWV6Pgdg _02MiEz8HPE _1E45C28HPE",
            hasMacroJiraTable && "_3iDTPbvLZJ _1EqgXlN91d _4bt5LAIZbP _3dqVlhTTQh _3NAmMbzUZr",
            hasMacroInclude && "_4i70rEgVvo _2wRL0vPgdg _0iOba7Pgdg _3dqVlhTTQh _1bpsr4Pgdg _26SohvPgdg",
            hasMacroJiraSingleIssue && "_12o62LdC7N",
            mode === (0, $5kjCz.EDITOR) && "_1mT5xdRAKS _20VacPYbGa",
            isInline && "_2uxTLTYbGa",
            mode === (0, $5kjCz.RENDERER) && isInline && "_4FKVYEFQfX _3iDTPbvbI6"
        ])
    }); // Wrap Connect iframe content in UFOThirdPartySegment to exclude from TTVC calculations
    return hasConnectIframe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
        name: `legacy-macro-${props.extensionKey || 'connect-iframe'}`
    }, macroElement) : macroElement;
};
module.exports["LegacyMacroStyledElement"] = $442661c5ce449806$export$e9dd081c6786d35c;

});

parcelRegister("bYtfC", function(module, exports) {
/**
 * Currently, very few legacy (connect) macros provide their expected rendered height/width
 * values in their macro parameters. Of those that do, there's a slight but consistent
 * margin of error for the height value. Others that don't render dynamic content we can
 * set a default height for (such as Miro embed).
 *
 * Any changes here should be reflected in @confluence/fabric-extension-legacy-macro-renderer
 */ const $f6824b7afd9ef7c7$var$DRAW_IO_HEIGHT_OFFSET = 52;
const $f6824b7afd9ef7c7$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT = 79;
const $f6824b7afd9ef7c7$var$PLANTUML_OFFSET_HEIGHT = 40;
// Default sizes
const $f6824b7afd9ef7c7$var$MIRO_EMBED_DEFAULT_HEIGHT = 450;
const $f6824b7afd9ef7c7$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT = 47;
const $f6824b7afd9ef7c7$var$MATH_BLOCK_DEFAULT_HEIGHT = 58;
const $f6824b7afd9ef7c7$var$PAGE_SIGNATURES_DEFAULT_HEIGHT = 23;
const $f6824b7afd9ef7c7$var$QUESTIONS_LIST_DEFAULT_HEIGHT = 800;
const $f6824b7afd9ef7c7$var$JIRA_ROADMAP_DEFAULT_HEIGHT = 600;
const $f6824b7afd9ef7c7$var$LUCID_CHART_DEFAULT_HEIGHT = 500;
const $f6824b7afd9ef7c7$var$GLIFFY_DEFAULT_HEIGHT = 150;
const $f6824b7afd9ef7c7$var$AURA_DIVIDER_DEFAULT_HEIGHT = 21;
const $f6824b7afd9ef7c7$var$AURA_CARDS_DEFAULT_HEIGHT = 226;
const $f6824b7afd9ef7c7$var$getHeightFromParams = (node)=>{
    if (!node) return;
    const extensionKey = node.extensionKey;
    const params = node.parameters?.macroParams;
    /**
   * DrawIo will resize diagrams based on the viewport they are rendered in
   * if the diagram's width is greater than 530px. This means that the natural dimensions
   * provided in macro parameters could be the incorrect height to reserve so we will
   * conservatively exclude them.
   */ if (extensionKey === 'drawio' || extensionKey === 'inc-drawio' || extensionKey === 'drawio-sketch') {
        const diagramWidth = Number(params?.width?.value);
        const zoomFactor = Number(params?.zoom?.value);
        if (diagramWidth && diagramWidth > 530 || zoomFactor !== 1) // Exclude wide diagrams due to allow resizing by vendor
        return;
    }
    if (extensionKey === 'plantumlcloud') return params?.originalHeight?.value;
    return params?.height?.value;
};
const $f6824b7afd9ef7c7$export$1a33580c6521db41 = (node)=>{
    const macroHeight = $f6824b7afd9ef7c7$var$getHeightFromParams(node);
    const extensionKey = node?.extensionKey;
    let height = Number(macroHeight);
    if (!Number.isNaN(height)) // for extensions that provide a number, add their offset
    switch(extensionKey){
        case 'drawio':
        case 'inc-drawio':
        case 'drawio-sketch':
            height += $f6824b7afd9ef7c7$var$DRAW_IO_HEIGHT_OFFSET;
            break;
        case 'lref-gdrive-embedded-file':
            height += $f6824b7afd9ef7c7$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT;
            break;
        case 'plantumlcloud':
            height += $f6824b7afd9ef7c7$var$PLANTUML_OFFSET_HEIGHT;
            break;
        default:
            break;
    }
    else // for extensions that don't resize based on their content, we can set a default height
    switch(extensionKey){
        case 'gliffy':
            height = $f6824b7afd9ef7c7$var$GLIFFY_DEFAULT_HEIGHT;
            break;
        case 'aura-divider':
            height = $f6824b7afd9ef7c7$var$AURA_DIVIDER_DEFAULT_HEIGHT;
            break;
        case 'aura-cards':
            height = $f6824b7afd9ef7c7$var$AURA_CARDS_DEFAULT_HEIGHT;
            break;
        case 'miro-macro-resizing':
            height = $f6824b7afd9ef7c7$var$MIRO_EMBED_DEFAULT_HEIGHT;
            break;
        case 'easy-math-block':
            height = $f6824b7afd9ef7c7$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT;
            break;
        case 'mathblock':
            height = $f6824b7afd9ef7c7$var$MATH_BLOCK_DEFAULT_HEIGHT;
            break;
        case 'page-signatures':
            height = $f6824b7afd9ef7c7$var$PAGE_SIGNATURES_DEFAULT_HEIGHT;
            break;
        case 'questionslist-macro':
            height = $f6824b7afd9ef7c7$var$QUESTIONS_LIST_DEFAULT_HEIGHT;
            break;
        case 'jiraroadmap':
            height = $f6824b7afd9ef7c7$var$JIRA_ROADMAP_DEFAULT_HEIGHT;
            break;
        case 'lucidchart':
            height = $f6824b7afd9ef7c7$var$LUCID_CHART_DEFAULT_HEIGHT;
            break;
        default:
            height = undefined;
            break;
    }
    return {
        viewportHeight: height
    };
};
module.exports["useConnectExtensionViewportSize"] = $f6824b7afd9ef7c7$export$1a33580c6521db41;

});

parcelRegister("3o0Dr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");



var $eczvQ = parcelRequire("eczvQ");

const $1c95b3b9276df843$var$THROTTLE_MACROS_QUERY_THRESHOLD = 8;
const $1c95b3b9276df843$export$b5cf65c5c3b73c3f = ({ node: node, mode: mode, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
        node: node
    });
};
module.exports["FabricLegacyMacrosServerLoader"] = $1c95b3b9276df843$export$b5cf65c5c3b73c3f;

});

parcelRegister("jP1nY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $LUTdp = parcelRequire("LUTdp");

const $c13902e0c77cb2e5$export$271d03a7283d2077 = ({ contentId: contentId, extensionKey: extensionKey, isActuallyMissingMacroParameters: isActuallyMissingMacroParameters, isConnectMacro: isConnectMacro, macroHtml: macroHtml, macroId: macroId })=>{
    const connectStaticMacroSSRExperienceStarted = (0, $cozmU.useRef)(false);
    const connectStaticMacroSSRExperienceResolved = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.expVal)('confluence_frontend_macro_slo_metrics', 'isEnabled', false)) return undefined;
        const connectStaticMacroSSRData = {
            contentId: contentId,
            extensionKey: extensionKey,
            macroId: macroId,
            isConnectMacro: isConnectMacro
        };
        let shouldTrackConnectStaticMacroSSR = false;
        try {
            shouldTrackConnectStaticMacroSSR = (0, $LUTdp.ConnectStaticMacroSSRExperienceTrackerSupport).isTrackable(connectStaticMacroSSRData);
        } catch  {
            shouldTrackConnectStaticMacroSSR = false;
        }
        if (!shouldTrackConnectStaticMacroSSR) return undefined;
        if (!connectStaticMacroSSRExperienceStarted.current) try {
            (0, $LUTdp.ConnectStaticMacroSSRExperienceTrackerSupport).start(connectStaticMacroSSRData);
        } catch  {
        // Telemetry must never block or alter macro rendering behaviour.
        } finally{
            connectStaticMacroSSRExperienceStarted.current = true;
        }
        if (connectStaticMacroSSRExperienceResolved.current) return undefined;
        if (macroHtml && !isActuallyMissingMacroParameters) try {
            (0, $LUTdp.ConnectStaticMacroSSRExperienceTrackerSupport).succeed();
        } catch  {
        // Telemetry must never block or alter macro rendering behaviour.
        } finally{
            connectStaticMacroSSRExperienceResolved.current = true;
        }
        else if (isActuallyMissingMacroParameters) try {
            (0, $LUTdp.ConnectStaticMacroSSRExperienceTrackerSupport).fail(new Error('Connect static macro SSR render failed because required macro parameters are missing'));
        } catch  {
        // Telemetry must never block or alter macro rendering behaviour.
        } finally{
            connectStaticMacroSSRExperienceResolved.current = true;
        }
        return ()=>{
            if (connectStaticMacroSSRExperienceStarted.current && !connectStaticMacroSSRExperienceResolved.current) try {
                (0, $LUTdp.ConnectStaticMacroSSRExperienceTrackerSupport).abort('FabricLegacyMacrosServerRenderer unmounted before Connect static macro SSR experience resolved');
            } catch  {
            // Telemetry must never block or alter macro rendering behaviour.
            }
        };
    }, [
        contentId,
        extensionKey,
        isActuallyMissingMacroParameters,
        isConnectMacro,
        macroHtml,
        macroId
    ]);
};
module.exports["useConnectStaticMacroSSRExperienceTracking"] = $c13902e0c77cb2e5$export$271d03a7283d2077;

});

parcelRegister("lqWPF", function(module, exports) {

var $gPxp5 = parcelRequire("gPxp5");


var $8pcS0 = parcelRequire("8pcS0");


var $92uc5 = parcelRequire("92uc5");


var $jMyy4 = parcelRequire("jMyy4");

function $8ed303578fdef1ee$export$d2c0db192704879b(node, contentId) {
    'use no memo';
    const bodyContentParam = node.parameters?.macroParams?.__bodyContent;
    const isPlainText = node.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) && Boolean(bodyContentParam);
    const isRichTextMacro = node.type === (0, $8pcS0.BODIED_EXTENSION_TYPE);
    const contentConverterQueryResult = (0, $jMyy4.useQueryInterop)((0, $gPxp5.default), {
        variables: (0, $92uc5.getContentConverterVariables)({
            content: node.content,
            contentId: contentId
        }),
        fetchPolicy: 'cache-only',
        skip: !isRichTextMacro,
        __callerPackage__: "content-renderer-legacy-macros"
    });
    if (isRichTextMacro) return contentConverterQueryResult.data ? {
        value: contentConverterQueryResult.data.contentConverter?.value
    } : {
        missing: true
    };
    if (isPlainText) return {
        value: bodyContentParam?.value || ''
    };
    return {
        value: ''
    };
}
module.exports["useDataMacroBody"] = $8ed303578fdef1ee$export$d2c0db192704879b;

});

parcelRegister("ji0Re", function(module, exports) {

var $ld6xp = parcelRequire("ld6xp");


var $iKSlH = parcelRequire("iKSlH");


var $8mIlz = parcelRequire("8mIlz");


var $eqB7W = parcelRequire("eqB7W");


var $b1ypt = parcelRequire("b1ypt");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $f467909144d22250$export$9f73be5695bf7530 = (contentId, node)=>{
    const { isMacroContentAndBody: isMacroContentAndBody, ...rest } = (0, $8mIlz.getMacroQueryVariables)({
        node: node,
        contentId: contentId
    });
    const MacroQuery = isMacroContentAndBody ? (0, $eqB7W.default) : (0, $b1ypt.default);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types -- preserving original behavior
    const { data: data } = (0, $jMyy4.useQueryInterop)(MacroQuery, {
        fetchPolicy: 'cache-only',
        variables: rest,
        __callerPackage__: "content-renderer-legacy-macros"
    });
    return data;
};
const $f467909144d22250$export$60af9684eedb3caa = (contentId, node)=>{
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const { renderedMacro: renderedMacro } = (0, $iKSlH.useMultiMacroQuery)({
        contentId: contentId,
        macroId: macroId
    });
    return {
        macroBodyRenderer: renderedMacro,
        representation: renderedMacro?.macroRenderedRepresentation,
        mediaToken: renderedMacro?.mediaToken,
        webResourceDependencies: renderedMacro?.webResource,
        macroBodyStorageFormat: {
            value: renderedMacro?.macroBodyStorage
        }
    };
};
const $f467909144d22250$export$6bb3728261293af5 = (contentId, node)=>{
    return (0, $ld6xp.canUseMultiMacroQuery)(node.extensionKey) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $f467909144d22250$export$60af9684eedb3caa(contentId, node) : // eslint-disable-next-line react-hooks/rules-of-hooks
    $f467909144d22250$export$9f73be5695bf7530(contentId, node);
};
module.exports["useMacroContentData"] = $f467909144d22250$export$6bb3728261293af5;

});

parcelRegister("adbKg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4995ce58a287dd32$var$iframeSrcRegex = /(<iframe.*)\ssrc=((?:".*?")|(?:'.*?'))(.*>)/gim;
const $4995ce58a287dd32$var$iframeTagRegex = /<iframe/gi;
const $4995ce58a287dd32$export$79f3459501b856f9 = (extensionHTML)=>{
    if (!extensionHTML) return extensionHTML;
    // Account for multiple iframes in the input, to make non-advised Regex-based HTML
    // handling more robust in this particular case.
    return extensionHTML.split($4995ce58a287dd32$var$iframeTagRegex).map((fragment, index)=>{
        return index === 0 ? fragment : `<iframe${fragment}`.replace($4995ce58a287dd32$var$iframeSrcRegex, `$1 data-delayed-src=$2$3`);
    }).join('');
};
const $4995ce58a287dd32$export$1a181571c396c997 = (delayIframe, extensionElement)=>{
    (0, $cozmU.useLayoutEffect)(()=>{
        if (extensionElement) {
            if (delayIframe) extensionElement.setAttribute('data-delay-iframe', 'true');
            else extensionElement.removeAttribute('data-delay-iframe');
        }
    }, [
        extensionElement,
        delayIframe
    ]);
    (0, $cozmU.useEffect)(()=>{
        const srcAttr = 'src';
        const delayedSrcAttr = 'data-delayed-src';
        if (extensionElement) {
            const iframe = extensionElement.querySelector('iframe');
            if (iframe && !delayIframe) {
                const delayedSrc = iframe.getAttribute(delayedSrcAttr);
                if (delayedSrc) {
                    iframe.setAttribute(srcAttr, delayedSrc);
                    iframe.removeAttribute(delayedSrcAttr);
                }
            }
        }
    }, [
        extensionElement,
        delayIframe
    ]);
};
module.exports["delayIframeLoading"] = $4995ce58a287dd32$export$79f3459501b856f9;
module.exports["useDelayedIframe"] = $4995ce58a287dd32$export$1a181571c396c997;

});

parcelRegister("3DNeP", function(module, exports) {

var $jibmA = parcelRequire("jibmA");

// Adds `noopener`/`noreferrer` while preserving existing rel tokens (e.g. `nofollow`).
const $1bc917138cf1826a$var$addSecurityRelTokens = (link)=>{
    const relTokens = new Set((link.getAttribute('rel') ?? '').split(/\s+/).filter(Boolean));
    relTokens.add('noopener');
    relTokens.add('noreferrer');
    link.setAttribute('rel', Array.from(relTokens).join(' '));
};
const $1bc917138cf1826a$export$ba94f32e99d93d76 = (container)=>{
    if (!container) return;
    const links = container.querySelectorAll('a[href]');
    links.forEach((link)=>{
        // Use the reflected `href` property (absolute URL) so relative and
        // protocol-relative hrefs resolve consistently before classification.
        if (!(0, $jibmA.isExternalLink)(link.href)) return;
        const existingTarget = link.getAttribute('target');
        if (existingTarget === null) {
            // No author-set target: open in a new tab with security rel tokens.
            link.setAttribute('target', '_blank');
            $1bc917138cf1826a$var$addSecurityRelTokens(link);
        } else if (existingTarget === '_blank') // Author already opens in a new tab: don't change the target, but
        // guarantee the rel tokens are present to prevent tab-napping.
        $1bc917138cf1826a$var$addSecurityRelTokens(link);
    // Any other author-set target (e.g. _self, named frame) is left as-is.
    });
};
module.exports["ensureExternalLinksOpenInNewTab"] = $1bc917138cf1826a$export$ba94f32e99d93d76;

});

parcelRegister("eczvQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $lfoFx = parcelRequire("lfoFx");


var $ieeJu = parcelRequire("ieeJu");


var $9wGTI = parcelRequire("9wGTI");


var $hMB4W = parcelRequire("hMB4W");


var $bYtfC = parcelRequire("bYtfC");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3207d6ccf725790$var$InlineSkeletonOld = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKTcp _4FKVYE1Y8M _3iDTPbvbI6 _0KLXruGsB2 _4ouGXIHMkp _0jFU0VrIqH",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f3207d6ccf725790$var$InlineSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKTcp _4FKVYE1Y8M _24h04i2Njc _3iDTPbvbI6 _0KLXruGsB2 _4ouGXIHMkp _0jFU0VXjOh _1RrJLit2nV",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f3207d6ccf725790$var$ExtensionSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_10ib6lf": (0, $9aYkv.default)(__cmplp.height, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_0bjKvDKTcp _4FKVYE1Y8M _3iDTPbvLZJ _0KLXruGsB2 _39xV02N91d _4ouGXIfI2J _24h04i2Njc",
                __cmplp.height ? "_0jFU0VQtZt" : "_0jFU0VrIqH",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f3207d6ccf725790$export$ba91725a812e7aea = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { showSpinner: showSpinner, node: node } = t0;
    const { viewportHeight: viewportHeight } = (0, $bYtfC.useConnectExtensionViewportSize)(node);
    const displayAsInline = (0, $hMB4W.shouldDisplayExtensionAsInline)(node) && (0, $ieeJu.expValEquals)("platform_editor_render_bodied_extension_as_inline", "isEnabled", true);
    if (node && (node.type === "inlineExtension" || displayAsInline)) {
        let t1;
        if ($[0] !== showSpinner) {
            t1 = (0, $ieeJu.expValEquals)("platform_editor_render_bodied_extension_as_inline", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f3207d6ccf725790$var$InlineSkeleton, {
                "data-testid": "ext-skeleton"
            }, showSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "small",
                interactionName: "legacy-macro-inline-skeleton"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f3207d6ccf725790$var$InlineSkeletonOld, {
                "data-testid": "ext-skeleton"
            }, showSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "small",
                interactionName: "legacy-macro-inline-skeleton"
            }));
            $[0] = showSpinner;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== viewportHeight) {
        t1 = (0, $9wGTI.fg)("confluence_connect_macro_preset_height") ? viewportHeight : undefined;
        $[2] = viewportHeight;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== showSpinner) {
        t2 = showSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            interactionName: "legacy-macro-extension-skeleton"
        });
        $[4] = showSpinner;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f3207d6ccf725790$var$ExtensionSkeleton, {
            "data-testid": "ext-skeleton",
            height: t1
        }, t2);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
};
module.exports["LegacyMacroRendererShadow"] = $f3207d6ccf725790$export$ba91725a812e7aea;

});

parcelRegister("LUTdp", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $a784a2e661da31f7$var$safelyTrackConnectStaticMacroSSRExperience = (track)=>{
    try {
        track();
    } catch  {
    // Telemetry must never block or alter macro rendering behaviour.
    }
};
const $a784a2e661da31f7$export$37e6e66b9431c8b6 = new class ConnectStaticMacroSSRExperienceTrackerSupport {
    isTrackable(data) {
        return Boolean(data?.contentId) && Boolean(data?.extensionKey) && Boolean(data?.macroId) && Boolean(data?.isConnectMacro);
    }
    start(data) {
        $a784a2e661da31f7$var$safelyTrackConnectStaticMacroSSRExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_SSR_EXPERIENCE),
                attributes: {
                    contentId: data?.contentId,
                    extensionKey: data?.extensionKey,
                    macroId: data?.macroId
                }
            });
        });
    }
    succeed() {
        $a784a2e661da31f7$var$safelyTrackConnectStaticMacroSSRExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_SSR_EXPERIENCE)
            });
        });
    }
    fail(error) {
        $a784a2e661da31f7$var$safelyTrackConnectStaticMacroSSRExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_SSR_EXPERIENCE),
                error: error
            });
        });
    }
    abort(reason) {
        $a784a2e661da31f7$var$safelyTrackConnectStaticMacroSSRExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_SSR_EXPERIENCE),
                reason: reason
            });
        });
    }
}();
module.exports["ConnectStaticMacroSSRExperienceTrackerSupport"] = $a784a2e661da31f7$export$37e6e66b9431c8b6;

});

parcelRegister("gPxp5", function(module, exports) {
/**
 * @generated SignedSource<<1d74acd7a1f54481033fdc6180b9311e>>
 * @relayHash 56e42d5e2c1d8f0edfe99c508579f470
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f3677a4399037c11ec7caf2f751c3658bacaded633e1f205ce79bf2748029b9
const $a746b9d5ae509975$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "content"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "from"
    }, v3 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "spaceKeyContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "to"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "content",
                    "variableName": "content"
                },
                {
                    "kind": "Variable",
                    "name": "contentIdContext",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "from",
                    "variableName": "from"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKeyContext",
                    "variableName": "spaceKeyContext"
                },
                {
                    "kind": "Variable",
                    "name": "to",
                    "variableName": "to"
                }
            ],
            "concreteType": "ConfluenceBody",
            "kind": "LinkedField",
            "name": "contentConverter",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useDataMacroBodyContentConverterQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useDataMacroBodyContentConverterQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "56e42d5e2c1d8f0edfe99c508579f470",
            "id": "2f3677a4399037c11ec7caf2f751c3658bacaded633e1f205ce79bf2748029b9",
            "metadata": {},
            "name": "useDataMacroBodyContentConverterQuery",
            "operationKind": "query",
            "text": "query useDataMacroBodyContentConverterQuery($content:String!,$contentId:ID!,$from:String!,$to:String!,$spaceKeyContext:String=\"\"){contentConverter(from:$from,to:$to,content:$content,contentIdContext:$contentId,spaceKeyContext:$spaceKeyContext){value}}"
        }
    };
}();
$a746b9d5ae509975$var$node.hash = "d7a05ea0544a617dbda390e788d71eb7";
var $a746b9d5ae509975$export$2e2bcd8739ae039 = $a746b9d5ae509975$var$node;
module.exports["default"] = $a746b9d5ae509975$export$2e2bcd8739ae039;

});


$parcel$global.rlb("6wiGY")
//# sourceMappingURL=FullPageEditorComponent.439d13ef.js.map
